var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/app/index.ts
import { z as z2 } from "zod";

// src/app/auth-exceptions.enum.ts
import { z } from "zod";
var AuthExceptionValues = [
  "TOKEN_EXPIRED",
  "INVALID_TOKEN",
  "UNAUTHORIZED"
];
var AuthExceptionEnumObj = z.enum(AuthExceptionValues);
var EAuthExceptionEnum = AuthExceptionEnumObj.enum;

// src/app/index.ts
var AppNameValues = [
  "PROGRAMS",
  "FIT",
  "RYC",
  "MEMBERS",
  "HELP_CENTER",
  "NOTIFICATION"
];
var AppNameEnumObj = z2.enum(AppNameValues);
var EAppNameEnum = AppNameEnumObj.enum;
var AppKeySchema = z2.string();
var sanitizeAppName = /* @__PURE__ */ __name((appName) => {
  return appName.replace(/<[^>]*>/g, "").replace(/[®™©]/g, "").replace(/[^a-zA-Z0-9\s]/g, " ").replace(/\s+/g, " ").trim().toUpperCase().replace(/\s+/g, "_");
}, "sanitizeAppName");

// src/auth/magic-link.ts
import { z as z3 } from "zod";
var MagicLinkEmailSchema = z3.object({
  email: z3.string().email("Enter a valid email")
});
var RequestMagicLinkSchema = z3.object({
  email: z3.string().email(),
  redirectUrl: z3.string().url(),
  returnUrl: z3.string().optional(),
  returnApp: z3.string().optional()
});

// src/auth/otp-login.ts
import { z as z4 } from "zod";
var OTP_LOGIN_CODE_LENGTH = 6;
var OtpEmailSchema = z4.string().trim().email("Enter a valid email").transform((value) => value.toLowerCase());
var RequestOtpLoginSchema = z4.object({
  email: OtpEmailSchema
});
var VerifyOtpLoginSchema = z4.object({
  email: OtpEmailSchema,
  code: z4.string().trim().regex(new RegExp(`^\\d{${OTP_LOGIN_CODE_LENGTH}}$`), `Enter the ${OTP_LOGIN_CODE_LENGTH}-digit code`)
});

// src/auth/ott.ts
import { z as z5 } from "zod";
var TargetAppEnum = z5.enum([
  EAppNameEnum.FIT,
  EAppNameEnum.RYC,
  EAppNameEnum.PROGRAMS,
  EAppNameEnum.MEMBERS,
  "HELP_CENTER",
  "DASHBOARD",
  "WORDPRESS"
]);
var ETargetApp = TargetAppEnum.enum;
var GenerateOttSchema = z5.object({
  email: z5.string().email(),
  targetApp: TargetAppEnum,
  redirectUrl: z5.string().url(),
  /** Optional in-app path the SSO page should navigate to after the session is established (e.g. a deep link). */
  redirectTo: z5.string().optional()
});
var GenerateOttUserSchema = z5.object({
  targetApp: TargetAppEnum,
  redirectUrl: z5.string().url(),
  /** Optional in-app path the SSO page should navigate to after the session is established (e.g. a deep link). */
  redirectTo: z5.string().optional()
});
var ValidateOttSchema = z5.object({
  token: z5.string().uuid()
});
var ConsumeOttSchema = z5.object({
  token: z5.string().uuid()
});

// src/auth/provider.ts
import { z as z6 } from "zod";
var AuthProviderEnumObj = z6.enum([
  "wordpress",
  "supabase"
]);
var AuthProviderEnum = AuthProviderEnumObj.enum;
var AUTH_PROVIDER_HEADER = "x-auth-provider";
var FEATURE_FLAGS_STORAGE_KEY = "featureFlags";

// src/auth/sb-database.types.ts
var Constants = {
  public: {
    Enums: {
      app_type: [
        "SPACE",
        "MINI",
        "SPECIAL"
      ],
      pro_directory_revision_status: [
        "pending",
        "approved",
        "rejected",
        "draft"
      ],
      status_type_enum: [
        "active",
        "inactive"
      ],
      teacher_directory_revision_status: [
        "pending",
        "approved",
        "rejected"
      ]
    }
  }
};

// src/auth/sso-context.ts
var EAuthType = /* @__PURE__ */ function(EAuthType2) {
  EAuthType2["supabase"] = "supabase";
  EAuthType2["wordpress"] = "wordpress";
  return EAuthType2;
}({});
var SSO_CONTEXT_PARAM = "auth_type";
var LC_SSO_CONTEXT_VALUE = "supabase";
var LC_SSO_CONTEXT_QUERY = `${SSO_CONTEXT_PARAM}=${LC_SSO_CONTEXT_VALUE}`;

// src/auth/supabase-auth.ts
import { z as z7 } from "zod";
var SupabaseLoginSchema = z7.object({
  email: z7.string().email(),
  password: z7.string().min(1)
});
var RefreshTokenSchema = z7.object({
  refresh_token: z7.string().min(1)
});
var WpLoginSchema = z7.object({
  email: z7.string().email(),
  password: z7.string().min(1)
});
var MembersLoginSchema = z7.object({
  identifier: z7.string().min(1).transform((v) => v.toLowerCase().trim()),
  password: z7.string().min(1)
});
var SupabaseJwtPayloadSchema = z7.object({
  aud: z7.union([
    z7.string(),
    z7.array(z7.string())
  ]).optional(),
  exp: z7.number(),
  iat: z7.number().optional(),
  iss: z7.string().optional(),
  sub: z7.string(),
  email: z7.string(),
  phone: z7.string().optional(),
  app_metadata: z7.object({
    provider: z7.string().optional(),
    providers: z7.array(z7.string()).optional()
  }).passthrough(),
  user_metadata: z7.record(z7.unknown()),
  role: z7.string(),
  aal: z7.string().optional(),
  amr: z7.array(z7.object({
    method: z7.string(),
    timestamp: z7.number()
  })).optional(),
  session_id: z7.string(),
  is_anonymous: z7.boolean().optional()
}).passthrough();

// src/badges/entity.ts
import { object, z as z9 } from "zod";

// src/badges/meta.ts
import { z as z8 } from "zod";
var BadgeMetaSchemaBE = z8.object({
  autoRedeemed: z8.boolean().default(true).describe("Whether the badge was auto redeemed")
});
var defaultBadgeMetaValuesBE = JSON.stringify({
  autoRedeemed: true
});

// src/badges/entity.ts
var BadgeTypeArray = [
  "CHALLENGE",
  "MILESTONE"
];
var BadgeTypeEnumObject = z9.enum(BadgeTypeArray);
var EBadgeType = BadgeTypeEnumObject.enum;
var ChallengeBadgeNameArray = [
  "CHALLENGE_VIDEO",
  "CHALLENGE_DAY"
];
var ChallengeBadgeNameEnumObject = z9.enum(ChallengeBadgeNameArray);
var EChallengeBadgeName = ChallengeBadgeNameEnumObject.enum;
var MilestoneBadgeNameArray = [
  "CHALLENGE_CHAMPION",
  "DAILY_DEDICATION",
  "LIVE_CLASS",
  "COMMENTS",
  "WORKOUTS"
];
var MilestoneBadgeNameEnumObject = z9.enum(MilestoneBadgeNameArray);
var EMilestoneBadgeName = MilestoneBadgeNameEnumObject.enum;
var BadgeWeightEnum = z9.enum([
  "10",
  "25",
  "50",
  "100",
  "250",
  "500",
  "1000",
  "2500"
]);
var BadgeNameEnum = z9.enum([
  ...ChallengeBadgeNameEnumObject.options,
  ...MilestoneBadgeNameEnumObject.options
]);
var BaseBadgeFields = {
  id: z9.coerce.number(),
  userId: z9.string(),
  createdAt: z9.string(),
  updatedAt: z9.string(),
  meta: BadgeMetaSchemaBE
};
var ChallengeBadgeSchema = z9.object(__spreadProps(__spreadValues({}, BaseBadgeFields), {
  type: z9.literal(EBadgeType.CHALLENGE),
  badgeName: ChallengeBadgeNameEnumObject,
  challengeContentId: z9.string().nullable(),
  challengeId: z9.string(),
  challengeDayIndex: z9.number().nullable()
}));
var MilestoneBadgeSchema = z9.object(__spreadProps(__spreadValues({}, BaseBadgeFields), {
  type: z9.literal(EBadgeType.MILESTONE),
  badgeName: MilestoneBadgeNameEnumObject,
  badgeWeight: BadgeWeightEnum.optional().nullable(),
  challengeContentId: z9.null(),
  challengeId: z9.null()
}));
var BadgeSchema = z9.discriminatedUnion("type", [
  ChallengeBadgeSchema,
  MilestoneBadgeSchema
]);
var BadgeTypeNameSchema = z9.discriminatedUnion("type", [
  object({
    type: z9.literal(EBadgeType.CHALLENGE),
    badgeName: ChallengeBadgeNameEnumObject
  }),
  object({
    type: z9.literal(EBadgeType.MILESTONE),
    badgeName: MilestoneBadgeNameEnumObject
  })
]);
var GetBadgesQuerySchema = z9.object({
  type: BadgeTypeEnumObject.optional()
});
var GetUserBadgesParamsSchema = z9.object({
  userId: z9.string().min(1, "User ID is required")
});
var CommonCreateBadgeSchema = z9.object({
  userId: z9.string().min(1, "User ID is required")
});
var CreateChallengeBadgeSchema = CommonCreateBadgeSchema.extend({
  type: z9.literal(EBadgeType.CHALLENGE),
  badgeName: ChallengeBadgeNameEnumObject,
  challengeContentId: z9.string().min(1, "Challenge content ID is required").nullable(),
  challengeId: z9.string().min(1, "Challenge ID is required"),
  challengeDayIndex: z9.number().nullable()
});
var CreateMilestoneBadgeSchema = CommonCreateBadgeSchema.extend({
  type: z9.literal(EBadgeType.MILESTONE),
  badgeName: MilestoneBadgeNameEnumObject,
  badgeWeight: BadgeWeightEnum.optional(),
  challengeId: z9.string().min(1, "Challenge ID is required").or(z9.null())
});
var CreateBadgeSchema = z9.discriminatedUnion("type", [
  CreateChallengeBadgeSchema,
  CreateMilestoneBadgeSchema
]);
var BadgesResponseSchema = z9.object({
  badges: z9.array(BadgeSchema),
  total: z9.number()
});

// src/common/boolean.schema.ts
import { z as z10 } from "zod";
var StringToBooleanSchema = z10.union([
  z10.boolean(),
  z10.string(),
  z10.number()
]).transform((val) => {
  if (typeof val === "boolean") {
    return val;
  }
  if (typeof val === "number") {
    return val !== 0;
  }
  if (typeof val === "string") {
    const lower = val.toLowerCase().trim();
    return lower === "true" || lower === "1";
  }
  return false;
});

// src/common/cache-keys.enum.ts
var GlobalCacheKeyEnum = /* @__PURE__ */ function(GlobalCacheKeyEnum2) {
  GlobalCacheKeyEnum2["MENTION_USER_PROFILES"] = "mention-user-profiles";
  return GlobalCacheKeyEnum2;
}({});

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/errors.js
var _a;
var LuxonError = (_a = class extends Error {
}, __name(_a, "LuxonError"), _a);
var _InvalidDateTimeError = class _InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
};
__name(_InvalidDateTimeError, "InvalidDateTimeError");
var InvalidDateTimeError = _InvalidDateTimeError;
var _InvalidIntervalError = class _InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
};
__name(_InvalidIntervalError, "InvalidIntervalError");
var InvalidIntervalError = _InvalidIntervalError;
var _InvalidDurationError = class _InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
};
__name(_InvalidDurationError, "InvalidDurationError");
var InvalidDurationError = _InvalidDurationError;
var _ConflictingSpecificationError = class _ConflictingSpecificationError extends LuxonError {
};
__name(_ConflictingSpecificationError, "ConflictingSpecificationError");
var ConflictingSpecificationError = _ConflictingSpecificationError;
var _InvalidUnitError = class _InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
};
__name(_InvalidUnitError, "InvalidUnitError");
var InvalidUnitError = _InvalidUnitError;
var _InvalidArgumentError = class _InvalidArgumentError extends LuxonError {
};
__name(_InvalidArgumentError, "InvalidArgumentError");
var InvalidArgumentError = _InvalidArgumentError;
var _ZoneIsAbstractError = class _ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
};
__name(_ZoneIsAbstractError, "ZoneIsAbstractError");
var ZoneIsAbstractError = _ZoneIsAbstractError;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/formats.js
var n = "numeric";
var s = "short";
var l = "long";
var DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
var DATE_MED = {
  year: n,
  month: s,
  day: n
};
var DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
var DATE_FULL = {
  year: n,
  month: l,
  day: n
};
var DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
var TIME_SIMPLE = {
  hour: n,
  minute: n
};
var TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
var TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
var TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s
};
var TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l
};
var DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
var DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
var DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
var DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zone.js
var _Zone = class _Zone {
  /**
  * The type of zone
  * @abstract
  * @type {string}
  */
  get type() {
    throw new ZoneIsAbstractError();
  }
  /**
  * The name of this zone.
  * @abstract
  * @type {string}
  */
  get name() {
    throw new ZoneIsAbstractError();
  }
  /**
  * The IANA name of this zone.
  * Defaults to `name` if not overwritten by a subclass.
  * @abstract
  * @type {string}
  */
  get ianaName() {
    return this.name;
  }
  /**
  * Returns whether the offset is known to be fixed for the whole year.
  * @abstract
  * @type {boolean}
  */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }
  /**
  * Returns the offset's common name (such as EST) at the specified timestamp
  * @abstract
  * @param {number} ts - Epoch milliseconds for which to get the name
  * @param {Object} opts - Options to affect the format
  * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
  * @param {string} opts.locale - What locale to return the offset name in.
  * @return {string}
  */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Returns the offset's value as a string
  * @abstract
  * @param {number} ts - Epoch milliseconds for which to get the offset
  * @param {string} format - What style of offset to return.
  *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
  * @return {string}
  */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Return the offset in minutes for this zone at the specified timestamp.
  * @abstract
  * @param {number} ts - Epoch milliseconds for which to compute the offset
  * @return {number}
  */
  offset(ts) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Return whether this Zone is equal to another zone
  * @abstract
  * @param {Zone} otherZone - the zone to compare
  * @return {boolean}
  */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Return whether this Zone is valid.
  * @abstract
  * @type {boolean}
  */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
};
__name(_Zone, "Zone");
var Zone = _Zone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/systemZone.js
var singleton = null;
var _SystemZone = class _SystemZone extends Zone {
  /**
  * Get a singleton instance of the local zone
  * @return {SystemZone}
  */
  static get instance() {
    if (singleton === null) {
      singleton = new _SystemZone();
    }
    return singleton;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale);
  }
  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }
  /** @override **/
  get isValid() {
    return true;
  }
};
__name(_SystemZone, "SystemZone");
var SystemZone = _SystemZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/IANAZone.js
var dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    });
  }
  return dtfCache[zone];
}
__name(makeDTF, "makeDTF");
var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(dtf, date2) {
  const formatted = dtf.format(date2).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [
    fYear,
    fMonth,
    fDay,
    fadOrBc,
    fHour,
    fMinute,
    fSecond
  ];
}
__name(hackyOffset, "hackyOffset");
function partsOffset(dtf, date2) {
  const formatted = dtf.formatToParts(date2);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type, value } = formatted[i];
    const pos = typeToPos[type];
    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
__name(partsOffset, "partsOffset");
var ianaZoneCache = {};
var _IANAZone = class _IANAZone extends Zone {
  /**
  * @param {string} name - Zone name
  * @return {IANAZone}
  */
  static create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new _IANAZone(name);
    }
    return ianaZoneCache[name];
  }
  /**
  * Reset local caches. Should only be necessary in testing scenarios.
  * @return {void}
  */
  static resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }
  /**
  * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
  * @param {string} s - The string to check validity on
  * @example IANAZone.isValidSpecifier("America/New_York") //=> true
  * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
  * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
  * @return {boolean}
  */
  static isValidSpecifier(s2) {
    return this.isValidZone(s2);
  }
  /**
  * Returns whether the provided string identifies a real zone
  * @param {string} zone - The string to check
  * @example IANAZone.isValidZone("America/New_York") //=> true
  * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
  * @example IANAZone.isValidZone("Sport~~blorp") //=> false
  * @return {boolean}
  */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", {
        timeZone: zone
      }).format();
      return true;
    } catch (e) {
      return false;
    }
  }
  constructor(name) {
    super();
    this.zoneName = name;
    this.valid = _IANAZone.isValidZone(name);
  }
  /**
  * The type of zone. `iana` for all instances of `IANAZone`.
  * @override
  * @type {string}
  */
  get type() {
    return "iana";
  }
  /**
  * The name of this zone (i.e. the IANA zone name).
  * @override
  * @type {string}
  */
  get name() {
    return this.zoneName;
  }
  /**
  * Returns whether the offset is known to be fixed for the whole year:
  * Always returns false for all IANA zones.
  * @override
  * @type {boolean}
  */
  get isUniversal() {
    return false;
  }
  /**
  * Returns the offset's common name (such as EST) at the specified timestamp
  * @override
  * @param {number} ts - Epoch milliseconds for which to get the name
  * @param {Object} opts - Options to affect the format
  * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
  * @param {string} opts.locale - What locale to return the offset name in.
  * @return {string}
  */
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }
  /**
  * Returns the offset's value as a string
  * @override
  * @param {number} ts - Epoch milliseconds for which to get the offset
  * @param {string} format - What style of offset to return.
  *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
  * @return {string}
  */
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /**
  * Return the offset in minutes for this zone at the specified timestamp.
  * @override
  * @param {number} ts - Epoch milliseconds for which to compute the offset
  * @return {number}
  */
  offset(ts) {
    const date2 = new Date(ts);
    if (isNaN(date2)) return NaN;
    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date2) : hackyOffset(dtf, date2);
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }
    const adjustedHour = hour === 24 ? 0 : hour;
    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0
    });
    let asTS = +date2;
    const over = asTS % 1e3;
    asTS -= over >= 0 ? over : 1e3 + over;
    return (asUTC - asTS) / (60 * 1e3);
  }
  /**
  * Return whether this Zone is equal to another zone
  * @override
  * @param {Zone} otherZone - the zone to compare
  * @return {boolean}
  */
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  /**
  * Return whether this Zone is valid.
  * @override
  * @type {boolean}
  */
  get isValid() {
    return this.valid;
  }
};
__name(_IANAZone, "IANAZone");
var IANAZone = _IANAZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/locale.js
var intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([
    locString,
    opts
  ]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}
__name(getCachedLF, "getCachedLF");
var intlDTCache = {};
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([
    locString,
    opts
  ]);
  let dtf = intlDTCache[key];
  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }
  return dtf;
}
__name(getCachedDTF, "getCachedDTF");
var intlNumCache = {};
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([
    locString,
    opts
  ]);
  let inf = intlNumCache[key];
  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }
  return inf;
}
__name(getCachedINF, "getCachedINF");
var intlRelCache = {};
function getCachedRTF(locString, opts = {}) {
  const _a5 = opts, { base } = _a5, cacheKeyOpts = __objRest(_a5, ["base"]);
  const key = JSON.stringify([
    locString,
    cacheKeyOpts
  ]);
  let inf = intlRelCache[key];
  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }
  return inf;
}
__name(getCachedRTF, "getCachedRTF");
var sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}
__name(systemLocale, "systemLocale");
var weekInfoCache = {};
function getCachedWeekInfo(locString) {
  let data = weekInfoCache[locString];
  if (!data) {
    const locale = new Intl.Locale(locString);
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    weekInfoCache[locString] = data;
  }
  return data;
}
__name(getCachedWeekInfo, "getCachedWeekInfo");
function parseLocaleString(localeStr) {
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [
      localeStr
    ];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    const { numberingSystem, calendar } = options;
    return [
      selectedStr,
      numberingSystem,
      calendar
    ];
  }
}
__name(parseLocaleString, "parseLocaleString");
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }
    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
__name(intlConfigString, "intlConfigString");
function mapMonths(f) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = DateTime.utc(2009, i, 1);
    ms.push(f(dt));
  }
  return ms;
}
__name(mapMonths, "mapMonths");
function mapWeekdays(f) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}
__name(mapWeekdays, "mapWeekdays");
function listStuff(loc, length, englishFn, intlFn) {
  const mode = loc.listingMode();
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}
__name(listStuff, "listStuff");
function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
  }
}
__name(supportsFastNumbers, "supportsFastNumbers");
var _a2;
var PolyNumberFormatter = (_a2 = class {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
    const _a5 = opts, { padTo, floor } = _a5, otherOpts = __objRest(_a5, ["padTo", "floor"]);
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = __spreadValues({
        useGrouping: false
      }, opts);
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }
  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
}, __name(_a2, "PolyNumberFormatter"), _a2);
var _a3;
var PolyDateFormatter = (_a3 = class {
  constructor(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = void 0;
    let z178 = void 0;
    if (this.opts.timeZone) {
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z178 = offsetZ;
        this.dt = dt;
      } else {
        z178 = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
          minutes: dt.offset
        });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z178 = dt.zone.name;
    } else {
      z178 = "UTC";
      this.dt = dt.setZone("UTC").plus({
        minutes: dt.offset
      });
      this.originalZone = dt.zone;
    }
    const intlOpts = __spreadValues({}, this.opts);
    intlOpts.timeZone = intlOpts.timeZone || z178;
    this.dtf = getCachedDTF(intl, intlOpts);
  }
  format() {
    if (this.originalZone) {
      return this.formatToParts().map(({ value }) => value).join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map((part) => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName
          });
          return __spreadProps(__spreadValues({}, part), {
            value: offsetName
          });
        } else {
          return part;
        }
      });
    }
    return parts;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}, __name(_a3, "PolyDateFormatter"), _a3);
var _a4;
var PolyRelFormatter = (_a4 = class {
  constructor(intl, isEnglish, opts) {
    this.opts = __spreadValues({
      style: "long"
    }, opts);
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }
  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }
  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
}, __name(_a4, "PolyRelFormatter"), _a4);
var fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [
    6,
    7
  ]
};
var _Locale = class _Locale {
  static fromOpts(opts) {
    return _Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
  }
  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new _Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }
  static resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  }
  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return _Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  }
  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = {
      format: {},
      standalone: {}
    };
    this.monthsCache = {
      format: {},
      standalone: {}
    };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }
    return this.fastNumbersCached;
  }
  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }
  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return _Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    }
  }
  redefaultToEN(alts = {}) {
    return this.clone(__spreadProps(__spreadValues({}, alts), {
      defaultToEN: true
    }));
  }
  redefaultToSystem(alts = {}) {
    return this.clone(__spreadProps(__spreadValues({}, alts), {
      defaultToEN: false
    }));
  }
  months(length, format = false) {
    return listStuff(this, length, months, () => {
      const intl = format ? {
        month: length,
        day: "numeric"
      } : {
        month: length
      }, formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        this.monthsCache[formatStr][length] = mapMonths((dt) => this.extract(dt, intl, "month"));
      }
      return this.monthsCache[formatStr][length];
    });
  }
  weekdays(length, format = false) {
    return listStuff(this, length, weekdays, () => {
      const intl = format ? {
        weekday: length,
        year: "numeric",
        month: "long",
        day: "numeric"
      } : {
        weekday: length
      }, formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays((dt) => this.extract(dt, intl, "weekday"));
      }
      return this.weekdaysCache[formatStr][length];
    });
  }
  meridiems() {
    return listStuff(this, void 0, () => meridiems, () => {
      if (!this.meridiemCache) {
        const intl = {
          hour: "numeric",
          hourCycle: "h12"
        };
        this.meridiemCache = [
          DateTime.utc(2016, 11, 13, 9),
          DateTime.utc(2016, 11, 13, 19)
        ].map((dt) => this.extract(dt, intl, "dayperiod"));
      }
      return this.meridiemCache;
    });
  }
  eras(length) {
    return listStuff(this, length, eras, () => {
      const intl = {
        era: length
      };
      if (!this.eraCache[length]) {
        this.eraCache[length] = [
          DateTime.utc(-40, 1, 1),
          DateTime.utc(2017, 1, 1)
        ].map((dt) => this.extract(dt, intl, "era"));
      }
      return this.eraCache[length];
    });
  }
  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }
  numberFormatter(opts = {}) {
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }
  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }
  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }
  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
};
__name(_Locale, "Locale");
var Locale = _Locale;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/fixedOffsetZone.js
var singleton2 = null;
var _FixedOffsetZone = class _FixedOffsetZone extends Zone {
  /**
  * Get a singleton instance of UTC
  * @return {FixedOffsetZone}
  */
  static get utcInstance() {
    if (singleton2 === null) {
      singleton2 = new _FixedOffsetZone(0);
    }
    return singleton2;
  }
  /**
  * Get an instance with a specified offset
  * @param {number} offset - The offset in minutes
  * @return {FixedOffsetZone}
  */
  static instance(offset2) {
    return offset2 === 0 ? _FixedOffsetZone.utcInstance : new _FixedOffsetZone(offset2);
  }
  /**
  * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
  * @param {string} s - The offset string to parse
  * @example FixedOffsetZone.parseSpecifier("UTC+6")
  * @example FixedOffsetZone.parseSpecifier("UTC+06")
  * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
  * @return {FixedOffsetZone}
  */
  static parseSpecifier(s2) {
    if (s2) {
      const r = s2.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new _FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }
    return null;
  }
  constructor(offset2) {
    super();
    this.fixed = offset2;
  }
  /**
  * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
  * @override
  * @type {string}
  */
  get type() {
    return "fixed";
  }
  /**
  * The name of this zone.
  * All fixed zones' names always start with "UTC" (plus optional offset)
  * @override
  * @type {string}
  */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }
  /**
  * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
  *
  * @override
  * @type {string}
  */
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }
  /**
  * Returns the offset's common name at the specified timestamp.
  *
  * For fixed offset zones this equals to the zone name.
  * @override
  */
  offsetName() {
    return this.name;
  }
  /**
  * Returns the offset's value as a string
  * @override
  * @param {number} ts - Epoch milliseconds for which to get the offset
  * @param {string} format - What style of offset to return.
  *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
  * @return {string}
  */
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }
  /**
  * Returns whether the offset is known to be fixed for the whole year:
  * Always returns true for all fixed offset zones.
  * @override
  * @type {boolean}
  */
  get isUniversal() {
    return true;
  }
  /**
  * Return the offset in minutes for this zone at the specified timestamp.
  *
  * For fixed offset zones, this is constant and does not depend on a timestamp.
  * @override
  * @return {number}
  */
  offset() {
    return this.fixed;
  }
  /**
  * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
  * @override
  * @param {Zone} otherZone - the zone to compare
  * @return {boolean}
  */
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  /**
  * Return whether this Zone is valid:
  * All fixed offset zones are valid.
  * @override
  * @type {boolean}
  */
  get isValid() {
    return true;
  }
};
__name(_FixedOffsetZone, "FixedOffsetZone");
var FixedOffsetZone = _FixedOffsetZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/invalidZone.js
var _InvalidZone = class _InvalidZone extends Zone {
  constructor(zoneName) {
    super();
    this.zoneName = zoneName;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return false;
  }
  /** @override **/
  get isValid() {
    return false;
  }
};
__name(_InvalidZone, "InvalidZone");
var InvalidZone = _InvalidZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/zoneUtil.js
function normalizeZone(input, defaultZone2) {
  let offset2;
  if (isUndefined(input) || input === null) {
    return defaultZone2;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone2;
    else if (lowered === "local" || lowered === "system") return SystemZone.instance;
    else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
    else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    return input;
  } else {
    return new InvalidZone(input);
  }
}
__name(normalizeZone, "normalizeZone");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/digits.js
var numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d"
};
var numberingSystemsUTF16 = {
  arab: [
    1632,
    1641
  ],
  arabext: [
    1776,
    1785
  ],
  bali: [
    6992,
    7001
  ],
  beng: [
    2534,
    2543
  ],
  deva: [
    2406,
    2415
  ],
  fullwide: [
    65296,
    65303
  ],
  gujr: [
    2790,
    2799
  ],
  khmr: [
    6112,
    6121
  ],
  knda: [
    3302,
    3311
  ],
  laoo: [
    3792,
    3801
  ],
  limb: [
    6470,
    6479
  ],
  mlym: [
    3430,
    3439
  ],
  mong: [
    6160,
    6169
  ],
  mymr: [
    4160,
    4169
  ],
  orya: [
    2918,
    2927
  ],
  tamldec: [
    3046,
    3055
  ],
  telu: [
    3174,
    3183
  ],
  thai: [
    3664,
    3673
  ],
  tibt: [
    3872,
    3881
  ]
};
var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min, max] = numberingSystemsUTF16[key];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}
__name(parseDigits, "parseDigits");
var digitRegexCache = {};
function resetDigitRegexCache() {
  digitRegexCache = {};
}
__name(resetDigitRegexCache, "resetDigitRegexCache");
function digitRegex({ numberingSystem }, append = "") {
  const ns = numberingSystem || "latn";
  if (!digitRegexCache[ns]) {
    digitRegexCache[ns] = {};
  }
  if (!digitRegexCache[ns][append]) {
    digitRegexCache[ns][append] = new RegExp(`${numberingSystems[ns]}${append}`);
  }
  return digitRegexCache[ns][append];
}
__name(digitRegex, "digitRegex");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/settings.js
var now = /* @__PURE__ */ __name(() => Date.now(), "now");
var defaultZone = "system";
var defaultLocale = null;
var defaultNumberingSystem = null;
var defaultOutputCalendar = null;
var twoDigitCutoffYear = 60;
var throwOnInvalid;
var defaultWeekSettings = null;
var _Settings = class _Settings {
  /**
  * Get the callback for returning the current timestamp.
  * @type {function}
  */
  static get now() {
    return now;
  }
  /**
  * Set the callback for returning the current timestamp.
  * The function should return a number, which will be interpreted as an Epoch millisecond count
  * @type {function}
  * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
  * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
  */
  static set now(n2) {
    now = n2;
  }
  /**
  * Set the default time zone to create DateTimes in. Does not affect existing instances.
  * Use the value "system" to reset this value to the system's time zone.
  * @type {string}
  */
  static set defaultZone(zone) {
    defaultZone = zone;
  }
  /**
  * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
  * The default value is the system's time zone (the one set on the machine that runs this code).
  * @type {Zone}
  */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }
  /**
  * Get the default locale to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static get defaultLocale() {
    return defaultLocale;
  }
  /**
  * Set the default locale to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }
  /**
  * Get the default numbering system to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }
  /**
  * Set the default numbering system to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }
  /**
  * Get the default output calendar to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }
  /**
  * Set the default output calendar to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }
  /**
  * @typedef {Object} WeekSettings
  * @property {number} firstDay
  * @property {number} minimalDays
  * @property {number[]} weekend
  */
  /**
  * @return {WeekSettings|null}
  */
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }
  /**
  * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
  * how many days are required in the first week of a year.
  * Does not affect existing instances.
  *
  * @param {WeekSettings|null} weekSettings
  */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = validateWeekSettings(weekSettings);
  }
  /**
  * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
  * @type {number}
  */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }
  /**
  * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
  * @type {number}
  * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
  * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
  * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
  * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
  * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
  */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }
  /**
  * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
  * @type {boolean}
  */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }
  /**
  * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
  * @type {boolean}
  */
  static set throwOnInvalid(t) {
    throwOnInvalid = t;
  }
  /**
  * Reset Luxon's global caches. Should only be necessary in testing scenarios.
  * @return {void}
  */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
    DateTime.resetCache();
    resetDigitRegexCache();
  }
};
__name(_Settings, "Settings");
var Settings = _Settings;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/invalid.js
var _Invalid = class _Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
};
__name(_Invalid, "Invalid");
var Invalid = _Invalid;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/conversions.js
var nonLeapLadder = [
  0,
  31,
  59,
  90,
  120,
  151,
  181,
  212,
  243,
  273,
  304,
  334
];
var leapLadder = [
  0,
  31,
  60,
  91,
  121,
  152,
  182,
  213,
  244,
  274,
  305,
  335
];
function unitOutOfRange(unit, value) {
  return new Invalid("unit out of range", `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`);
}
__name(unitOutOfRange, "unitOutOfRange");
function dayOfWeek(year, month, day) {
  const d = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }
  const js = d.getUTCDay();
  return js === 0 ? 7 : js;
}
__name(dayOfWeek, "dayOfWeek");
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
__name(computeOrdinal, "computeOrdinal");
function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table.findIndex((i) => i < ordinal), day = ordinal - table[month0];
  return {
    month: month0 + 1,
    day
  };
}
__name(uncomputeOrdinal, "uncomputeOrdinal");
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
__name(isoWeekdayToLocal, "isoWeekdayToLocal");
function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { year, month, day } = gregObj, ordinal = computeOrdinal(year, month, day), weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
  let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return __spreadValues({
    weekYear,
    weekNumber,
    weekday
  }, timeObject(gregObj));
}
__name(gregorianToWeek, "gregorianToWeek");
function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { weekYear, weekNumber, weekday } = weekData, weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear(weekYear);
  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return __spreadValues({
    year,
    month,
    day
  }, timeObject(weekData));
}
__name(weekToGregorian, "weekToGregorian");
function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return __spreadValues({
    year,
    ordinal
  }, timeObject(gregData));
}
__name(gregorianToOrdinal, "gregorianToOrdinal");
function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return __spreadValues({
    year,
    month,
    day
  }, timeObject(ordinalData));
}
__name(ordinalToGregorian, "ordinalToGregorian");
function usesLocalWeekValues(obj, loc) {
  const hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
    }
    if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek()
    };
  } else {
    return {
      minDaysInFirstWeek: 4,
      startOfWeek: 1
    };
  }
}
__name(usesLocalWeekValues, "usesLocalWeekValues");
function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = isInteger(obj.weekYear), validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = integerBetween(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
__name(hasInvalidWeekData, "hasInvalidWeekData");
function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
__name(hasInvalidOrdinalData, "hasInvalidOrdinalData");
function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
__name(hasInvalidGregorianData, "hasInvalidGregorianData");
function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}
__name(hasInvalidTimeData, "hasInvalidTimeData");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/util.js
function isUndefined(o) {
  return typeof o === "undefined";
}
__name(isUndefined, "isUndefined");
function isNumber(o) {
  return typeof o === "number";
}
__name(isNumber, "isNumber");
function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}
__name(isInteger, "isInteger");
function isString(o) {
  return typeof o === "string";
}
__name(isString, "isString");
function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}
__name(isDate, "isDate");
function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}
__name(hasRelative, "hasRelative");
function hasLocaleWeekInfo() {
  try {
    return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch (e) {
    return false;
  }
}
__name(hasLocaleWeekInfo, "hasLocaleWeekInfo");
function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [
    thing
  ];
}
__name(maybeArray, "maybeArray");
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return void 0;
  }
  return arr.reduce((best, next) => {
    const pair = [
      by(next),
      next
    ];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
__name(bestBy, "bestBy");
function pick(obj, keys) {
  return keys.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}
__name(pick, "pick");
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
__name(hasOwnProperty, "hasOwnProperty");
function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v) => !integerBetween(v, 1, 7))) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend)
    };
  }
}
__name(validateWeekSettings, "validateWeekSettings");
function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}
__name(integerBetween, "integerBetween");
function floorMod(x, n2) {
  return x - n2 * Math.floor(x / n2);
}
__name(floorMod, "floorMod");
function padStart(input, n2 = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n2, "0");
  } else {
    padded = ("" + input).padStart(n2, "0");
  }
  return padded;
}
__name(padStart, "padStart");
function parseInteger(string84) {
  if (isUndefined(string84) || string84 === null || string84 === "") {
    return void 0;
  } else {
    return parseInt(string84, 10);
  }
}
__name(parseInteger, "parseInteger");
function parseFloating(string84) {
  if (isUndefined(string84) || string84 === null || string84 === "") {
    return void 0;
  } else {
    return parseFloat(string84);
  }
}
__name(parseFloating, "parseFloating");
function parseMillis(fraction) {
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return void 0;
  } else {
    const f = parseFloat("0." + fraction) * 1e3;
    return Math.floor(f);
  }
}
__name(parseMillis, "parseMillis");
function roundTo(number37, digits, towardZero = false) {
  const factor = __pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number37 * factor) / factor;
}
__name(roundTo, "roundTo");
function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
__name(isLeapYear, "isLeapYear");
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
__name(daysInYear, "daysInYear");
function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [
      31,
      null,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31
    ][modMonth - 1];
  }
}
__name(daysInMonth, "daysInMonth");
function objToLocalTS(obj) {
  let d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}
__name(objToLocalTS, "objToLocalTS");
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}
__name(firstWeekOffset, "firstWeekOffset");
function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
__name(weeksInWeekYear, "weeksInWeekYear");
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2e3 + year;
}
__name(untruncateYear, "untruncateYear");
function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date2 = new Date(ts), intlOpts = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  const modified = __spreadValues({
    timeZoneName: offsetFormat
  }, intlOpts);
  const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date2).find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}
__name(parseZoneInfo, "parseZoneInfo");
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}
__name(signedOffset, "signedOffset");
function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}
__name(asNumber, "asNumber");
function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (hasOwnProperty(obj, u)) {
      const v = obj[u];
      if (v === void 0 || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}
__name(normalizeObject, "normalizeObject");
function formatOffset(offset2, format) {
  const hours = Math.trunc(Math.abs(offset2 / 60)), minutes = Math.trunc(Math.abs(offset2 % 60)), sign = offset2 >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}
__name(formatOffset, "formatOffset");
function timeObject(obj) {
  return pick(obj, [
    "hour",
    "minute",
    "second",
    "millisecond"
  ]);
}
__name(timeObject, "timeObject");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/english.js
var monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
var monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
var monthsNarrow = [
  "J",
  "F",
  "M",
  "A",
  "M",
  "J",
  "J",
  "A",
  "S",
  "O",
  "N",
  "D"
];
function months(length) {
  switch (length) {
    case "narrow":
      return [
        ...monthsNarrow
      ];
    case "short":
      return [
        ...monthsShort
      ];
    case "long":
      return [
        ...monthsLong
      ];
    case "numeric":
      return [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
      ];
    case "2-digit":
      return [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
      ];
    default:
      return null;
  }
}
__name(months, "months");
var weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];
var weekdaysShort = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun"
];
var weekdaysNarrow = [
  "M",
  "T",
  "W",
  "T",
  "F",
  "S",
  "S"
];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [
        ...weekdaysNarrow
      ];
    case "short":
      return [
        ...weekdaysShort
      ];
    case "long":
      return [
        ...weekdaysLong
      ];
    case "numeric":
      return [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7"
      ];
    default:
      return null;
  }
}
__name(weekdays, "weekdays");
var meridiems = [
  "AM",
  "PM"
];
var erasLong = [
  "Before Christ",
  "Anno Domini"
];
var erasShort = [
  "BC",
  "AD"
];
var erasNarrow = [
  "B",
  "A"
];
function eras(length) {
  switch (length) {
    case "narrow":
      return [
        ...erasNarrow
      ];
    case "short":
      return [
        ...erasShort
      ];
    case "long":
      return [
        ...erasLong
      ];
    default:
      return null;
  }
}
__name(eras, "eras");
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
__name(meridiemForDateTime, "meridiemForDateTime");
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
__name(weekdayForDateTime, "weekdayForDateTime");
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
__name(monthForDateTime, "monthForDateTime");
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
__name(eraForDateTime, "eraForDateTime");
function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: [
      "year",
      "yr."
    ],
    quarters: [
      "quarter",
      "qtr."
    ],
    months: [
      "month",
      "mo."
    ],
    weeks: [
      "week",
      "wk."
    ],
    days: [
      "day",
      "day",
      "days"
    ],
    hours: [
      "hour",
      "hr."
    ],
    minutes: [
      "minute",
      "min."
    ],
    seconds: [
      "second",
      "sec."
    ]
  };
  const lastable = [
    "hours",
    "minutes",
    "seconds"
  ].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
      default:
    }
  }
  const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
__name(formatRelativeTime, "formatRelativeTime");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/formatter.js
function stringifyTokens(splits, tokenToString) {
  let s2 = "";
  for (const token of splits) {
    if (token.literal) {
      s2 += token.val;
    } else {
      s2 += tokenToString(token.val);
    }
  }
  return s2;
}
__name(stringifyTokens, "stringifyTokens");
var macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
var _Formatter = class _Formatter {
  static create(locale, opts = {}) {
    return new _Formatter(locale, opts);
  }
  static parseFormat(fmt) {
    let current = null, currentFull = "", bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
          });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({
            literal: /^\s+$/.test(currentFull),
            val: currentFull
          });
        }
        currentFull = c;
        current = c;
      }
    }
    if (currentFull.length > 0) {
      splits.push({
        literal: bracketed || /^\s+$/.test(currentFull),
        val: currentFull
      });
    }
    return splits;
  }
  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }
  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, __spreadValues(__spreadValues({}, this.opts), opts));
    return df.format();
  }
  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, __spreadValues(__spreadValues({}, this.opts), opts));
  }
  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }
  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }
  formatInterval(interval, opts) {
    const df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }
  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }
  num(n2, p = 0) {
    if (this.opts.forceSimple) {
      return padStart(n2, p);
    }
    const opts = __spreadValues({}, this.opts);
    if (p > 0) {
      opts.padTo = p;
    }
    return this.loc.numberFormatter(opts).format(n2);
  }
  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string84 = /* @__PURE__ */ __name((opts, extract) => this.loc.extract(dt, opts, extract), "string"), formatOffset2 = /* @__PURE__ */ __name((opts) => {
      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
        return "Z";
      }
      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
    }, "formatOffset"), meridiem = /* @__PURE__ */ __name(() => knownEnglish ? meridiemForDateTime(dt) : string84({
      hour: "numeric",
      hourCycle: "h12"
    }, "dayperiod"), "meridiem"), month = /* @__PURE__ */ __name((length, standalone) => knownEnglish ? monthForDateTime(dt, length) : string84(standalone ? {
      month: length
    } : {
      month: length,
      day: "numeric"
    }, "month"), "month"), weekday = /* @__PURE__ */ __name((length, standalone) => knownEnglish ? weekdayForDateTime(dt, length) : string84(standalone ? {
      weekday: length
    } : {
      weekday: length,
      month: "long",
      day: "numeric"
    }, "weekday"), "weekday"), maybeMacro = /* @__PURE__ */ __name((token) => {
      const formatOpts = _Formatter.macroTokenToFormatOpts(token);
      if (formatOpts) {
        return this.formatWithSystemDefault(dt, formatOpts);
      } else {
        return token;
      }
    }, "maybeMacro"), era = /* @__PURE__ */ __name((length) => knownEnglish ? eraForDateTime(dt, length) : string84({
      era: length
    }, "era"), "era"), tokenToString = /* @__PURE__ */ __name((token) => {
      switch (token) {
        // ms
        case "S":
          return this.num(dt.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(dt.millisecond, 3);
        // seconds
        case "s":
          return this.num(dt.second);
        case "ss":
          return this.num(dt.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(dt.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(dt.millisecond / 100));
        // minutes
        case "m":
          return this.num(dt.minute);
        case "mm":
          return this.num(dt.minute, 2);
        // hours
        case "h":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
        case "hh":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
        case "H":
          return this.num(dt.hour);
        case "HH":
          return this.num(dt.hour, 2);
        // offset
        case "Z":
          return formatOffset2({
            format: "narrow",
            allowZ: this.opts.allowZ
          });
        case "ZZ":
          return formatOffset2({
            format: "short",
            allowZ: this.opts.allowZ
          });
        case "ZZZ":
          return formatOffset2({
            format: "techie",
            allowZ: this.opts.allowZ
          });
        case "ZZZZ":
          return dt.zone.offsetName(dt.ts, {
            format: "short",
            locale: this.loc.locale
          });
        case "ZZZZZ":
          return dt.zone.offsetName(dt.ts, {
            format: "long",
            locale: this.loc.locale
          });
        // zone
        case "z":
          return dt.zoneName;
        // meridiems
        case "a":
          return meridiem();
        // dates
        case "d":
          return useDateTimeFormatter ? string84({
            day: "numeric"
          }, "day") : this.num(dt.day);
        case "dd":
          return useDateTimeFormatter ? string84({
            day: "2-digit"
          }, "day") : this.num(dt.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(dt.weekday);
        case "ccc":
          return weekday("short", true);
        case "cccc":
          return weekday("long", true);
        case "ccccc":
          return weekday("narrow", true);
        // weekdays - format
        case "E":
          return this.num(dt.weekday);
        case "EEE":
          return weekday("short", false);
        case "EEEE":
          return weekday("long", false);
        case "EEEEE":
          return weekday("narrow", false);
        // months - standalone
        case "L":
          return useDateTimeFormatter ? string84({
            month: "numeric",
            day: "numeric"
          }, "month") : this.num(dt.month);
        case "LL":
          return useDateTimeFormatter ? string84({
            month: "2-digit",
            day: "numeric"
          }, "month") : this.num(dt.month, 2);
        case "LLL":
          return month("short", true);
        case "LLLL":
          return month("long", true);
        case "LLLLL":
          return month("narrow", true);
        // months - format
        case "M":
          return useDateTimeFormatter ? string84({
            month: "numeric"
          }, "month") : this.num(dt.month);
        case "MM":
          return useDateTimeFormatter ? string84({
            month: "2-digit"
          }, "month") : this.num(dt.month, 2);
        case "MMM":
          return month("short", false);
        case "MMMM":
          return month("long", false);
        case "MMMMM":
          return month("narrow", false);
        // years
        case "y":
          return useDateTimeFormatter ? string84({
            year: "numeric"
          }, "year") : this.num(dt.year);
        case "yy":
          return useDateTimeFormatter ? string84({
            year: "2-digit"
          }, "year") : this.num(dt.year.toString().slice(-2), 2);
        case "yyyy":
          return useDateTimeFormatter ? string84({
            year: "numeric"
          }, "year") : this.num(dt.year, 4);
        case "yyyyyy":
          return useDateTimeFormatter ? string84({
            year: "numeric"
          }, "year") : this.num(dt.year, 6);
        // eras
        case "G":
          return era("short");
        case "GG":
          return era("long");
        case "GGGGG":
          return era("narrow");
        case "kk":
          return this.num(dt.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(dt.weekYear, 4);
        case "W":
          return this.num(dt.weekNumber);
        case "WW":
          return this.num(dt.weekNumber, 2);
        case "n":
          return this.num(dt.localWeekNumber);
        case "nn":
          return this.num(dt.localWeekNumber, 2);
        case "ii":
          return this.num(dt.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(dt.localWeekYear, 4);
        case "o":
          return this.num(dt.ordinal);
        case "ooo":
          return this.num(dt.ordinal, 3);
        case "q":
          return this.num(dt.quarter);
        case "qq":
          return this.num(dt.quarter, 2);
        case "X":
          return this.num(Math.floor(dt.ts / 1e3));
        case "x":
          return this.num(dt.ts);
        default:
          return maybeMacro(token);
      }
    }, "tokenToString");
    return stringifyTokens(_Formatter.parseFormat(fmt), tokenToString);
  }
  formatDurationFromString(dur, fmt) {
    const tokenToField = /* @__PURE__ */ __name((token) => {
      switch (token[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, "tokenToField"), tokenToString = /* @__PURE__ */ __name((lildur) => (token) => {
      const mapped = tokenToField(token);
      if (mapped) {
        return this.num(lildur.get(mapped), token.length);
      } else {
        return token;
      }
    }, "tokenToString"), tokens = _Formatter.parseFormat(fmt), realTokens = tokens.reduce((found, { literal: literal3, val }) => literal3 ? found : found.concat(val), []), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t) => t));
    return stringifyTokens(tokens, tokenToString(collapsed));
  }
};
__name(_Formatter, "Formatter");
var Formatter = _Formatter;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/regexParser.js
var ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r) => f + r.source, "");
  return RegExp(`^${full}$`);
}
__name(combineRegexes, "combineRegexes");
function combineExtractors(...extractors) {
  return (m) => extractors.reduce(([mergedVals, mergedZone, cursor], ex) => {
    const [val, zone, next] = ex(m, cursor);
    return [
      __spreadValues(__spreadValues({}, mergedVals), val),
      zone || mergedZone,
      next
    ];
  }, [
    {},
    null,
    1
  ]).slice(0, 2);
}
__name(combineExtractors, "combineExtractors");
function parse(s2, ...patterns) {
  if (s2 == null) {
    return [
      null,
      null
    ];
  }
  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s2);
    if (m) {
      return extractor(m);
    }
  }
  return [
    null,
    null
  ];
}
__name(parse, "parse");
function simpleParse(...keys) {
  return (match2, cursor) => {
    const ret = {};
    let i;
    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match2[cursor + i]);
    }
    return [
      ret,
      null,
      cursor + i
    ];
  };
}
__name(simpleParse, "simpleParse");
var offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
var isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
var isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`);
var isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
var extractISOOrdinalData = simpleParse("year", "ordinal");
var sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/;
var sqlTimeRegex = RegExp(`${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`);
var sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int(match2, pos, fallback) {
  const m = match2[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}
__name(int, "int");
function extractISOYmd(match2, cursor) {
  const item = {
    year: int(match2, cursor),
    month: int(match2, cursor + 1, 1),
    day: int(match2, cursor + 2, 1)
  };
  return [
    item,
    null,
    cursor + 3
  ];
}
__name(extractISOYmd, "extractISOYmd");
function extractISOTime(match2, cursor) {
  const item = {
    hours: int(match2, cursor, 0),
    minutes: int(match2, cursor + 1, 0),
    seconds: int(match2, cursor + 2, 0),
    milliseconds: parseMillis(match2[cursor + 3])
  };
  return [
    item,
    null,
    cursor + 4
  ];
}
__name(extractISOTime, "extractISOTime");
function extractISOOffset(match2, cursor) {
  const local = !match2[cursor] && !match2[cursor + 1], fullOffset = signedOffset(match2[cursor + 1], match2[cursor + 2]), zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [
    {},
    zone,
    cursor + 3
  ];
}
__name(extractISOOffset, "extractISOOffset");
function extractIANAZone(match2, cursor) {
  const zone = match2[cursor] ? IANAZone.create(match2[cursor]) : null;
  return [
    {},
    zone,
    cursor + 1
  ];
}
__name(extractIANAZone, "extractIANAZone");
var isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);
var isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match2) {
  const [s2, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match2;
  const hasNegativePrefix = s2[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";
  const maybeNegate = /* @__PURE__ */ __name((num, force = false) => num !== void 0 && (force || num && hasNegativePrefix) ? -num : num, "maybeNegate");
  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
    }
  ];
}
__name(extractISODuration, "extractISODuration");
var obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr) result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }
  return result;
}
__name(fromStrings, "fromStrings");
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr, obsOffset, milOffset, offHourStr, offMinuteStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  let offset2;
  if (obsOffset) {
    offset2 = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset2 = 0;
  } else {
    offset2 = signedOffset(offHourStr, offMinuteStr);
  }
  return [
    result,
    new FixedOffsetZone(offset2)
  ];
}
__name(extractRFC2822, "extractRFC2822");
function preprocessRFC2822(s2) {
  return s2.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
__name(preprocessRFC2822, "preprocessRFC2822");
var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/;
var rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/;
var ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [
    result,
    FixedOffsetZone.utcInstance
  ];
}
__name(extractRFC1123Or850, "extractRFC1123Or850");
function extractASCII(match2) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [
    result,
    FixedOffsetZone.utcInstance
  ];
}
__name(extractASCII, "extractASCII");
var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
var extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOOrdinalDateAndTime = combineExtractors(extractISOOrdinalData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseISODate(s2) {
  return parse(s2, [
    isoYmdWithTimeExtensionRegex,
    extractISOYmdTimeAndOffset
  ], [
    isoWeekWithTimeExtensionRegex,
    extractISOWeekTimeAndOffset
  ], [
    isoOrdinalWithTimeExtensionRegex,
    extractISOOrdinalDateAndTime
  ], [
    isoTimeCombinedRegex,
    extractISOTimeAndOffset
  ]);
}
__name(parseISODate, "parseISODate");
function parseRFC2822Date(s2) {
  return parse(preprocessRFC2822(s2), [
    rfc2822,
    extractRFC2822
  ]);
}
__name(parseRFC2822Date, "parseRFC2822Date");
function parseHTTPDate(s2) {
  return parse(s2, [
    rfc1123,
    extractRFC1123Or850
  ], [
    rfc850,
    extractRFC1123Or850
  ], [
    ascii,
    extractASCII
  ]);
}
__name(parseHTTPDate, "parseHTTPDate");
function parseISODuration(s2) {
  return parse(s2, [
    isoDuration,
    extractISODuration
  ]);
}
__name(parseISODuration, "parseISODuration");
var extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s2) {
  return parse(s2, [
    isoTimeOnly,
    extractISOTimeOnly
  ]);
}
__name(parseISOTimeOnly, "parseISOTimeOnly");
var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
var extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseSQL(s2) {
  return parse(s2, [
    sqlYmdWithTimeExtensionRegex,
    extractISOYmdTimeAndOffset
  ], [
    sqlTimeCombinedRegex,
    extractISOTimeOffsetAndIANAZone
  ]);
}
__name(parseSQL, "parseSQL");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/duration.js
var INVALID = "Invalid Duration";
var lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: {
    minutes: 60,
    seconds: 60 * 60,
    milliseconds: 60 * 60 * 1e3
  },
  minutes: {
    seconds: 60,
    milliseconds: 60 * 1e3
  },
  seconds: {
    milliseconds: 1e3
  }
};
var casualMatrix = __spreadValues({
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  }
}, lowOrderMatrix);
var daysInYearAccurate = 146097 / 400;
var daysInMonthAccurate = 146097 / 4800;
var accurateMatrix = __spreadValues({
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1e3
  }
}, lowOrderMatrix);
var orderedUnits = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
];
var reverseUnits = orderedUnits.slice(0).reverse();
function clone(dur, alts, clear = false) {
  const conf = {
    values: clear ? alts.values : __spreadValues(__spreadValues({}, dur.values), alts.values || {}),
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix
  };
  return new Duration(conf);
}
__name(clone, "clone");
function durationToMillis(matrix, vals) {
  var _a5;
  let sum = (_a5 = vals.milliseconds) != null ? _a5 : 0;
  for (const unit of reverseUnits.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}
__name(durationToMillis, "durationToMillis");
function normalizeValues(matrix, vals) {
  const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
  orderedUnits.reduceRight((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);
  orderedUnits.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}
__name(normalizeValues, "normalizeValues");
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}
__name(removeZeroes, "removeZeroes");
var _Duration = class _Duration {
  /**
  * @private
  */
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;
    if (config.matrix) {
      matrix = config.matrix;
    }
    this.values = config.values;
    this.loc = config.loc || Locale.create();
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    this.invalid = config.invalid || null;
    this.matrix = matrix;
    this.isLuxonDuration = true;
  }
  /**
  * Create Duration from a number of milliseconds.
  * @param {number} count of milliseconds
  * @param {Object} opts - options for parsing
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @return {Duration}
  */
  static fromMillis(count, opts) {
    return _Duration.fromObject({
      milliseconds: count
    }, opts);
  }
  /**
  * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
  * If this object is empty then a zero milliseconds duration is returned.
  * @param {Object} obj - the object to create the DateTime from
  * @param {number} obj.years
  * @param {number} obj.quarters
  * @param {number} obj.months
  * @param {number} obj.weeks
  * @param {number} obj.days
  * @param {number} obj.hours
  * @param {number} obj.minutes
  * @param {number} obj.seconds
  * @param {number} obj.milliseconds
  * @param {Object} [opts=[]] - options for creating this Duration
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
  * @param {string} [opts.matrix=Object] - the custom conversion system to use
  * @return {Duration}
  */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(`Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`);
    }
    return new _Duration({
      values: normalizeObject(obj, _Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix
    });
  }
  /**
  * Create a Duration from DurationLike.
  *
  * @param {Object | number | Duration} durationLike
  * One of:
  * - object with keys like 'years' and 'hours'.
  * - number representing milliseconds
  * - Duration instance
  * @return {Duration}
  */
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return _Duration.fromMillis(durationLike);
    } else if (_Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return _Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(`Unknown duration argument ${durationLike} of type ${typeof durationLike}`);
    }
  }
  /**
  * Create a Duration from an ISO 8601 duration string.
  * @param {string} text - text to parse
  * @param {Object} opts - options for parsing
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
  * @param {string} [opts.matrix=Object] - the preset conversion system to use
  * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
  * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
  * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
  * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
  * @return {Duration}
  */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return _Duration.fromObject(parsed, opts);
    } else {
      return _Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
  * Create a Duration from an ISO 8601 time string.
  * @param {string} text - text to parse
  * @param {Object} opts - options for parsing
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
  * @param {string} [opts.matrix=Object] - the conversion system to use
  * @see https://en.wikipedia.org/wiki/ISO_8601#Times
  * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
  * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @return {Duration}
  */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return _Duration.fromObject(parsed, opts);
    } else {
      return _Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
  * Create an invalid Duration.
  * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
  * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
  * @return {Duration}
  */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new _Duration({
        invalid
      });
    }
  }
  /**
  * @private
  */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }
  /**
  * Check if an object is a Duration. Works across context boundaries
  * @param {object} o
  * @return {boolean}
  */
  static isDuration(o) {
    return o && o.isLuxonDuration || false;
  }
  /**
  * Get  the locale of a Duration, such 'en-GB'
  * @type {string}
  */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
  * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
  *
  * @type {string}
  */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
  * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
  * * `S` for milliseconds
  * * `s` for seconds
  * * `m` for minutes
  * * `h` for hours
  * * `d` for days
  * * `w` for weeks
  * * `M` for months
  * * `y` for years
  * Notes:
  * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
  * * Tokens can be escaped by wrapping with single quotes.
  * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
  * @param {string} fmt - the format string
  * @param {Object} opts - options
  * @param {boolean} [opts.floor=true] - floor numerical values
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
  * @return {string}
  */
  toFormat(fmt, opts = {}) {
    const fmtOpts = __spreadProps(__spreadValues({}, opts), {
      floor: opts.round !== false && opts.floor !== false
    });
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID;
  }
  /**
  * Returns a string representation of a Duration with all units included.
  * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
  * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
  * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
  * @example
  * ```js
  * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
  * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
  * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
  * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
  * ```
  */
  toHuman(opts = {}) {
    if (!this.isValid) return INVALID;
    const l2 = orderedUnits.map((unit) => {
      const val = this.values[unit];
      if (isUndefined(val)) {
        return null;
      }
      return this.loc.numberFormatter(__spreadProps(__spreadValues({
        style: "unit",
        unitDisplay: "long"
      }, opts), {
        unit: unit.slice(0, -1)
      })).format(val);
    }).filter((n2) => n2);
    return this.loc.listFormatter(__spreadValues({
      type: "conjunction",
      style: opts.listStyle || "narrow"
    }, opts)).format(l2);
  }
  /**
  * Returns a JavaScript object with this Duration's values.
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
  * @return {Object}
  */
  toObject() {
    if (!this.isValid) return {};
    return __spreadValues({}, this.values);
  }
  /**
  * Returns an ISO 8601-compliant string representation of this Duration.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
  * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
  * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
  * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
  * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
  * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
  * @return {string}
  */
  toISO() {
    if (!this.isValid) return null;
    let s2 = "P";
    if (this.years !== 0) s2 += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s2 += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s2 += this.weeks + "W";
    if (this.days !== 0) s2 += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s2 += "T";
    if (this.hours !== 0) s2 += this.hours + "H";
    if (this.minutes !== 0) s2 += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      s2 += roundTo(this.seconds + this.milliseconds / 1e3, 3) + "S";
    if (s2 === "P") s2 += "T0S";
    return s2;
  }
  /**
  * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
  * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Times
  * @param {Object} opts - options
  * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
  * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
  * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
  * @return {string}
  */
  toISOTime(opts = {}) {
    if (!this.isValid) return null;
    const millis = this.toMillis();
    if (millis < 0 || millis >= 864e5) return null;
    opts = __spreadProps(__spreadValues({
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended"
    }, opts), {
      includeOffset: false
    });
    const dateTime = DateTime.fromMillis(millis, {
      zone: "UTC"
    });
    return dateTime.toISOTime(opts);
  }
  /**
  * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
  * @return {string}
  */
  toJSON() {
    return this.toISO();
  }
  /**
  * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
  * @return {string}
  */
  toString() {
    return this.toISO();
  }
  /**
  * Returns a string representation of this Duration appropriate for the REPL.
  * @return {string}
  */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
  * Returns an milliseconds value of this Duration.
  * @return {number}
  */
  toMillis() {
    if (!this.isValid) return NaN;
    return durationToMillis(this.matrix, this.values);
  }
  /**
  * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
  * @return {number}
  */
  valueOf() {
    return this.toMillis();
  }
  /**
  * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
  * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  * @return {Duration}
  */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = _Duration.fromDurationLike(duration), result = {};
    for (const k of orderedUnits) {
      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }
    return clone(this, {
      values: result
    }, true);
  }
  /**
  * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
  * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  * @return {Duration}
  */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = _Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }
  /**
  * Scale this Duration by the specified amount. Return a newly-constructed Duration.
  * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
  * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
  * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
  * @return {Duration}
  */
  mapUnits(fn) {
    if (!this.isValid) return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = asNumber(fn(this.values[k], k));
    }
    return clone(this, {
      values: result
    }, true);
  }
  /**
  * Get the value of unit.
  * @param {string} unit - a unit such as 'minute' or 'day'
  * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
  * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
  * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
  * @return {number}
  */
  get(unit) {
    return this[_Duration.normalizeUnit(unit)];
  }
  /**
  * "Set" the values of specified units. Return a newly-constructed Duration.
  * @param {Object} values - a mapping of units to numbers
  * @example dur.set({ years: 2017 })
  * @example dur.set({ hours: 8, minutes: 30 })
  * @return {Duration}
  */
  set(values) {
    if (!this.isValid) return this;
    const mixed = __spreadValues(__spreadValues({}, this.values), normalizeObject(values, _Duration.normalizeUnit));
    return clone(this, {
      values: mixed
    });
  }
  /**
  * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
  * @example dur.reconfigure({ locale: 'en-GB' })
  * @return {Duration}
  */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({
      locale,
      numberingSystem
    });
    const opts = {
      loc,
      matrix,
      conversionAccuracy
    };
    return clone(this, opts);
  }
  /**
  * Return the length of the duration in the specified unit.
  * @param {string} unit - a unit such as 'minutes' or 'days'
  * @example Duration.fromObject({years: 1}).as('days') //=> 365
  * @example Duration.fromObject({years: 1}).as('months') //=> 12
  * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
  * @return {number}
  */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  /**
  * Reduce this Duration to its canonical representation in its current units.
  * Assuming the overall value of the Duration is positive, this means:
  * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
  * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
  *   the overall value would be negative, see third example)
  * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
  *
  * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
  * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
  * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
  * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
  * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
  * @return {Duration}
  */
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone(this, {
      values: vals
    }, true);
  }
  /**
  * Rescale units to its largest representation
  * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
  * @return {Duration}
  */
  rescale() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone(this, {
      values: vals
    }, true);
  }
  /**
  * Convert this Duration into its representation in a different set of units.
  * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
  * @return {Duration}
  */
  shiftTo(...units) {
    if (!this.isValid) return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map((u) => _Duration.normalizeUnit(u));
    const built = {}, accumulated = {}, vals = this.toObject();
    let lastUnit;
    for (const k of orderedUnits) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        let own = 0;
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }
        if (isNumber(vals[k])) {
          own += vals[k];
        }
        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1e3 - i * 1e3) / 1e3;
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    normalizeValues(this.matrix, built);
    return clone(this, {
      values: built
    }, true);
  }
  /**
  * Shift this Duration to all available units.
  * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
  * @return {Duration}
  */
  shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
  }
  /**
  * Return the negative of this Duration.
  * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
  * @return {Duration}
  */
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone(this, {
      values: negated
    }, true);
  }
  /**
  * Get the years.
  * @type {number}
  */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
  * Get the quarters.
  * @type {number}
  */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
  * Get the months.
  * @type {number}
  */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
  * Get the weeks
  * @type {number}
  */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
  * Get the days.
  * @type {number}
  */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
  * Get the hours.
  * @type {number}
  */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
  * Get the minutes.
  * @type {number}
  */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
  * Get the seconds.
  * @return {number}
  */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
  * Get the milliseconds.
  * @return {number}
  */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
  * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
  * on invalid DateTimes or Intervals.
  * @return {boolean}
  */
  get isValid() {
    return this.invalid === null;
  }
  /**
  * Returns an error code if this Duration became invalid, or null if the Duration is valid
  * @return {string}
  */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
  * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
  * @type {string}
  */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
  * Equality check
  * Two Durations are equal iff they have the same units and the same values for each unit.
  * @param {Duration} other
  * @return {boolean}
  */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq(v1, v2) {
      if (v1 === void 0 || v1 === 0) return v2 === void 0 || v2 === 0;
      return v1 === v2;
    }
    __name(eq, "eq");
    for (const u of orderedUnits) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
};
__name(_Duration, "Duration");
var Duration = _Duration;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/interval.js
var INVALID2 = "Invalid Interval";
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid("end before start", `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`);
  } else {
    return null;
  }
}
__name(validateStartEnd, "validateStartEnd");
var _Interval = class _Interval {
  /**
  * @private
  */
  constructor(config) {
    this.s = config.start;
    this.e = config.end;
    this.invalid = config.invalid || null;
    this.isLuxonInterval = true;
  }
  /**
  * Create an invalid Interval.
  * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
  * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
  * @return {Interval}
  */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new _Interval({
        invalid
      });
    }
  }
  /**
  * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
  * @param {DateTime|Date|Object} start
  * @param {DateTime|Date|Object} end
  * @return {Interval}
  */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start), builtEnd = friendlyDateTime(end);
    const validateError = validateStartEnd(builtStart, builtEnd);
    if (validateError == null) {
      return new _Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }
  /**
  * Create an Interval from a start DateTime and a Duration to extend to.
  * @param {DateTime|Date|Object} start
  * @param {Duration|Object|number} duration - the length of the Interval.
  * @return {Interval}
  */
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(start);
    return _Interval.fromDateTimes(dt, dt.plus(dur));
  }
  /**
  * Create an Interval from an end DateTime and a Duration to extend backwards to.
  * @param {DateTime|Date|Object} end
  * @param {Duration|Object|number} duration - the length of the Interval.
  * @return {Interval}
  */
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(end);
    return _Interval.fromDateTimes(dt.minus(dur), dt);
  }
  /**
  * Create an Interval from an ISO 8601 string.
  * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
  * @param {string} text - the ISO string to parse
  * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @return {Interval}
  */
  static fromISO(text, opts) {
    const [s2, e] = (text || "").split("/", 2);
    if (s2 && e) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s2, opts);
        startIsValid = start.isValid;
      } catch (e2) {
        startIsValid = false;
      }
      let end, endIsValid;
      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e2) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return _Interval.fromDateTimes(start, end);
      }
      if (startIsValid) {
        const dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return _Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s2, opts);
        if (dur.isValid) {
          return _Interval.before(end, dur);
        }
      }
    }
    return _Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }
  /**
  * Check if an object is an Interval. Works across context boundaries
  * @param {object} o
  * @return {boolean}
  */
  static isInterval(o) {
    return o && o.isLuxonInterval || false;
  }
  /**
  * Returns the start of the Interval
  * @type {DateTime}
  */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
  * Returns the end of the Interval
  * @type {DateTime}
  */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
  * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
  * @type {boolean}
  */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
  * Returns an error code if this Interval is invalid, or null if the Interval is valid
  * @type {string}
  */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
  * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
  * @type {string}
  */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
  * Returns the length of the Interval in the specified unit.
  * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
  * @return {number}
  */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[
      unit
    ]).get(unit) : NaN;
  }
  /**
  * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
  * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
  * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
  * @param {string} [unit='milliseconds'] - the unit of time to count.
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
  * @return {number}
  */
  count(unit = "milliseconds", opts) {
    if (!this.isValid) return NaN;
    const start = this.start.startOf(unit, opts);
    let end;
    if (opts == null ? void 0 : opts.useLocaleWeeks) {
      end = this.end.reconfigure({
        locale: start.locale
      });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }
  /**
  * Returns whether this Interval's start and end are both in the same unit of time
  * @param {string} unit - the unit of time to check sameness on
  * @return {boolean}
  */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  /**
  * Return whether this Interval has the same start and end DateTimes.
  * @return {boolean}
  */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
  * Return whether this Interval's start is after the specified DateTime.
  * @param {DateTime} dateTime
  * @return {boolean}
  */
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }
  /**
  * Return whether this Interval's end is before the specified DateTime.
  * @param {DateTime} dateTime
  * @return {boolean}
  */
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }
  /**
  * Return whether this Interval contains the specified DateTime.
  * @param {DateTime} dateTime
  * @return {boolean}
  */
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  /**
  * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
  * @param {Object} values - the values to set
  * @param {DateTime} values.start - the starting DateTime
  * @param {DateTime} values.end - the ending DateTime
  * @return {Interval}
  */
  set({ start, end } = {}) {
    if (!this.isValid) return this;
    return _Interval.fromDateTimes(start || this.s, end || this.e);
  }
  /**
  * Split this Interval at each of the specified DateTimes
  * @param {...DateTime} dateTimes - the unit of time to count.
  * @return {Array}
  */
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes.map(friendlyDateTime).filter((d) => this.contains(d)).sort((a, b) => a.toMillis() - b.toMillis()), results = [];
    let { s: s2 } = this, i = 0;
    while (s2 < this.e) {
      const added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
      results.push(_Interval.fromDateTimes(s2, next));
      s2 = next;
      i += 1;
    }
    return results;
  }
  /**
  * Split this Interval into smaller Intervals, each of the specified length.
  * Left over time is grouped into a smaller interval
  * @param {Duration|Object|number} duration - The length of each resulting interval.
  * @return {Array}
  */
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    let { s: s2 } = this, idx = 1, next;
    const results = [];
    while (s2 < this.e) {
      const added = this.start.plus(dur.mapUnits((x) => x * idx));
      next = +added > +this.e ? this.e : added;
      results.push(_Interval.fromDateTimes(s2, next));
      s2 = next;
      idx += 1;
    }
    return results;
  }
  /**
  * Split this Interval into the specified number of smaller intervals.
  * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
  * @return {Array}
  */
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  /**
  * Return whether this Interval overlaps with the specified Interval
  * @param {Interval} other
  * @return {boolean}
  */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  /**
  * Return whether this Interval's end is adjacent to the specified Interval's start.
  * @param {Interval} other
  * @return {boolean}
  */
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }
  /**
  * Return whether this Interval's start is adjacent to the specified Interval's end.
  * @param {Interval} other
  * @return {boolean}
  */
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }
  /**
  * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
  * @param {Interval} other
  * @return {boolean}
  */
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }
  /**
  * Return whether this Interval has the same start and end as the specified Interval.
  * @param {Interval} other
  * @return {boolean}
  */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  /**
  * Return an Interval representing the intersection of this Interval and the specified Interval.
  * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
  * Returns null if the intersection is empty, meaning, the intervals don't intersect.
  * @param {Interval} other
  * @return {Interval}
  */
  intersection(other) {
    if (!this.isValid) return this;
    const s2 = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
    if (s2 >= e) {
      return null;
    } else {
      return _Interval.fromDateTimes(s2, e);
    }
  }
  /**
  * Return an Interval representing the union of this Interval and the specified Interval.
  * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
  * @param {Interval} other
  * @return {Interval}
  */
  union(other) {
    if (!this.isValid) return this;
    const s2 = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
    return _Interval.fromDateTimes(s2, e);
  }
  /**
  * Merge an array of Intervals into a equivalent minimal set of Intervals.
  * Combines overlapping and adjacent Intervals.
  * @param {Array} intervals
  * @return {Array}
  */
  static merge(intervals) {
    const [found, final] = intervals.sort((a, b) => a.s - b.s).reduce(([sofar, current], item) => {
      if (!current) {
        return [
          sofar,
          item
        ];
      } else if (current.overlaps(item) || current.abutsStart(item)) {
        return [
          sofar,
          current.union(item)
        ];
      } else {
        return [
          sofar.concat([
            current
          ]),
          item
        ];
      }
    }, [
      [],
      null
    ]);
    if (final) {
      found.push(final);
    }
    return found;
  }
  /**
  * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
  * @param {Array} intervals
  * @return {Array}
  */
  static xor(intervals) {
    let start = null, currentCount = 0;
    const results = [], ends = intervals.map((i) => [
      {
        time: i.s,
        type: "s"
      },
      {
        time: i.e,
        type: "e"
      }
    ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a, b) => a.time - b.time);
    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(_Interval.fromDateTimes(start, i.time));
        }
        start = null;
      }
    }
    return _Interval.merge(results);
  }
  /**
  * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
  * @param {...Interval} intervals
  * @return {Array}
  */
  difference(...intervals) {
    return _Interval.xor([
      this
    ].concat(intervals)).map((i) => this.intersection(i)).filter((i) => i && !i.isEmpty());
  }
  /**
  * Returns a string representation of this Interval appropriate for debugging.
  * @return {string}
  */
  toString() {
    if (!this.isValid) return INVALID2;
    return `[${this.s.toISO()} \u2013 ${this.e.toISO()})`;
  }
  /**
  * Returns a string representation of this Interval appropriate for the REPL.
  * @return {string}
  */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
  * Returns a localized string representing this Interval. Accepts the same options as the
  * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
  * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
  * is browser-specific, but in general it will return an appropriate representation of the
  * Interval in the assigned locale. Defaults to the system's locale if no locale has been
  * specified.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
  * Intl.DateTimeFormat constructor options.
  * @param {Object} opts - Options to override the configuration of the start DateTime.
  * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
  * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
  * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
  * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
  * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
  * @return {string}
  */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID2;
  }
  /**
  * Returns an ISO 8601-compliant string representation of this Interval.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @param {Object} opts - The same options as {@link DateTime#toISO}
  * @return {string}
  */
  toISO(opts) {
    if (!this.isValid) return INVALID2;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }
  /**
  * Returns an ISO 8601-compliant string representation of date of this Interval.
  * The time components are ignored.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @return {string}
  */
  toISODate() {
    if (!this.isValid) return INVALID2;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }
  /**
  * Returns an ISO 8601-compliant string representation of time of this Interval.
  * The date components are ignored.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @param {Object} opts - The same options as {@link DateTime#toISO}
  * @return {string}
  */
  toISOTime(opts) {
    if (!this.isValid) return INVALID2;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }
  /**
  * Returns a string representation of this Interval formatted according to the specified format
  * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
  * formatting tool.
  * @param {string} dateFormat - The format string. This string formats the start and end time.
  * See {@link DateTime#toFormat} for details.
  * @param {Object} opts - Options.
  * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
  * representations.
  * @return {string}
  */
  toFormat(dateFormat, { separator = " \u2013 " } = {}) {
    if (!this.isValid) return INVALID2;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }
  /**
  * Return a Duration representing the time spanned by this interval.
  * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
  * @param {Object} opts - options that affect the creation of the Duration
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
  * @return {Duration}
  */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }
  /**
  * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
  * @param {function} mapFn
  * @return {Interval}
  * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
  * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
  */
  mapEndpoints(mapFn) {
    return _Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
};
__name(_Interval, "Interval");
var Interval = _Interval;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/info.js
var _Info = class _Info {
  /**
  * Return whether the specified zone contains a DST.
  * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
  * @return {boolean}
  */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({
      month: 12
    });
    return !zone.isUniversal && proto.offset !== proto.set({
      month: 6
    }).offset;
  }
  /**
  * Return whether the specified zone is a valid IANA specifier.
  * @param {string} zone - Zone to check
  * @return {boolean}
  */
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }
  /**
  * Converts the input into a {@link Zone} instance.
  *
  * * If `input` is already a Zone instance, it is returned unchanged.
  * * If `input` is a string containing a valid time zone name, a Zone instance
  *   with that name is returned.
  * * If `input` is a string that doesn't refer to a known time zone, a Zone
  *   instance with {@link Zone#isValid} == false is returned.
  * * If `input is a number, a Zone instance with the specified fixed offset
  *   in minutes is returned.
  * * If `input` is `null` or `undefined`, the default zone is returned.
  * @param {string|Zone|number} [input] - the value to be converted
  * @return {Zone}
  */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  /**
  * Get the weekday on which the week starts according to the given locale.
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
  */
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }
  /**
  * Get the minimum number of days necessary in a week before it is considered part of the next year according
  * to the given locale.
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @returns {number}
  */
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }
  /**
  * Get the weekdays, which are considered the weekend according to the given locale
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
  */
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }
  /**
  * Return an array of standalone month names.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @param {string} [opts.outputCalendar='gregory'] - the calendar
  * @example Info.months()[0] //=> 'January'
  * @example Info.months('short')[0] //=> 'Jan'
  * @example Info.months('numeric')[0] //=> '1'
  * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
  * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
  * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
  * @return {Array}
  */
  static months(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }
  /**
  * Return an array of format month names.
  * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
  * changes the string.
  * See {@link Info#months}
  * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @param {string} [opts.outputCalendar='gregory'] - the calendar
  * @return {Array}
  */
  static monthsFormat(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }
  /**
  * Return an array of standalone week names.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @example Info.weekdays()[0] //=> 'Monday'
  * @example Info.weekdays('short')[0] //=> 'Mon'
  * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
  * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
  * @return {Array}
  */
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }
  /**
  * Return an array of format week names.
  * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
  * changes the string.
  * See {@link Info#weekdays}
  * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
  * @param {Object} opts - options
  * @param {string} [opts.locale=null] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @return {Array}
  */
  static weekdaysFormat(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }
  /**
  * Return an array of meridiems.
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @example Info.meridiems() //=> [ 'AM', 'PM' ]
  * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
  * @return {Array}
  */
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }
  /**
  * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
  * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @example Info.eras() //=> [ 'BC', 'AD' ]
  * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
  * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
  * @return {Array}
  */
  static eras(length = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length);
  }
  /**
  * Return the set of available features in this environment.
  * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
  * Keys:
  * * `relative`: whether this environment supports relative time formatting
  * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
  * @example Info.features() //=> { relative: false, localeWeek: true }
  * @return {Object}
  */
  static features() {
    return {
      relative: hasRelative(),
      localeWeek: hasLocaleWeekInfo()
    };
  }
};
__name(_Info, "Info");
var Info = _Info;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/diff.js
function dayDiff(earlier, later) {
  const utcDayStart = /* @__PURE__ */ __name((dt) => dt.toUTC(0, {
    keepLocalTime: true
  }).startOf("day").valueOf(), "utcDayStart"), ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}
__name(dayDiff, "dayDiff");
function highOrderDiffs(cursor, later, units) {
  const differs = [
    [
      "years",
      (a, b) => b.year - a.year
    ],
    [
      "quarters",
      (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4
    ],
    [
      "months",
      (a, b) => b.month - a.month + (b.year - a.year) * 12
    ],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - days % 7) / 7;
      }
    ],
    [
      "days",
      dayDiff
    ]
  ];
  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        results[unit]--;
        cursor = earlier.plus(results);
        if (cursor > later) {
          highWater = cursor;
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }
  return [
    cursor,
    results,
    highWater,
    lowestOrder
  ];
}
__name(highOrderDiffs, "highOrderDiffs");
function diff_default(earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
  const remainingMillis = later - cursor;
  const lowerOrderUnits = units.filter((u) => [
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
  ].indexOf(u) >= 0);
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({
        [lowestOrder]: 1
      });
    }
    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }
  const duration = Duration.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}
__name(diff_default, "default");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/tokenParser.js
var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post = (i) => i) {
  return {
    regex,
    deser: /* @__PURE__ */ __name(([s2]) => post(parseDigits(s2)), "deser")
  };
}
__name(intUnit, "intUnit");
var NBSP = String.fromCharCode(160);
var spaceOrNBSP = `[ ${NBSP}]`;
var spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s2) {
  return s2.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
__name(fixListRegex, "fixListRegex");
function stripInsensitivities(s2) {
  return s2.replace(/\./g, "").replace(spaceOrNBSPRegExp, " ").toLowerCase();
}
__name(stripInsensitivities, "stripInsensitivities");
function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: /* @__PURE__ */ __name(([s2]) => strings.findIndex((i) => stripInsensitivities(s2) === stripInsensitivities(i)) + startIndex, "deser")
    };
  }
}
__name(oneOf, "oneOf");
function offset(regex, groups) {
  return {
    regex,
    deser: /* @__PURE__ */ __name(([, h, m]) => signedOffset(h, m), "deser"),
    groups
  };
}
__name(offset, "offset");
function simple(regex) {
  return {
    regex,
    deser: /* @__PURE__ */ __name(([s2]) => s2, "deser")
  };
}
__name(simple, "simple");
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
__name(escapeToken, "escapeToken");
function unitForToken(token, loc) {
  const one = digitRegex(loc), two = digitRegex(loc, "{2}"), three = digitRegex(loc, "{3}"), four = digitRegex(loc, "{4}"), six = digitRegex(loc, "{6}"), oneOrTwo = digitRegex(loc, "{1,2}"), oneToThree = digitRegex(loc, "{1,3}"), oneToSix = digitRegex(loc, "{1,6}"), oneToNine = digitRegex(loc, "{1,9}"), twoToFour = digitRegex(loc, "{2,4}"), fourToSix = digitRegex(loc, "{4,6}"), literal3 = /* @__PURE__ */ __name((t) => ({
    regex: RegExp(escapeToken(t.val)),
    deser: /* @__PURE__ */ __name(([s2]) => s2, "deser"),
    literal: true
  }), "literal"), unitate = /* @__PURE__ */ __name((t) => {
    if (token.literal) {
      return literal3(t);
    }
    switch (t.val) {
      // era
      case "G":
        return oneOf(loc.eras("short"), 0);
      case "GG":
        return oneOf(loc.eras("long"), 0);
      // years
      case "y":
        return intUnit(oneToSix);
      case "yy":
        return intUnit(twoToFour, untruncateYear);
      case "yyyy":
        return intUnit(four);
      case "yyyyy":
        return intUnit(fourToSix);
      case "yyyyyy":
        return intUnit(six);
      // months
      case "M":
        return intUnit(oneOrTwo);
      case "MM":
        return intUnit(two);
      case "MMM":
        return oneOf(loc.months("short", true), 1);
      case "MMMM":
        return oneOf(loc.months("long", true), 1);
      case "L":
        return intUnit(oneOrTwo);
      case "LL":
        return intUnit(two);
      case "LLL":
        return oneOf(loc.months("short", false), 1);
      case "LLLL":
        return oneOf(loc.months("long", false), 1);
      // dates
      case "d":
        return intUnit(oneOrTwo);
      case "dd":
        return intUnit(two);
      // ordinals
      case "o":
        return intUnit(oneToThree);
      case "ooo":
        return intUnit(three);
      // time
      case "HH":
        return intUnit(two);
      case "H":
        return intUnit(oneOrTwo);
      case "hh":
        return intUnit(two);
      case "h":
        return intUnit(oneOrTwo);
      case "mm":
        return intUnit(two);
      case "m":
        return intUnit(oneOrTwo);
      case "q":
        return intUnit(oneOrTwo);
      case "qq":
        return intUnit(two);
      case "s":
        return intUnit(oneOrTwo);
      case "ss":
        return intUnit(two);
      case "S":
        return intUnit(oneToThree);
      case "SSS":
        return intUnit(three);
      case "u":
        return simple(oneToNine);
      case "uu":
        return simple(oneOrTwo);
      case "uuu":
        return intUnit(one);
      // meridiem
      case "a":
        return oneOf(loc.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return intUnit(four);
      case "kk":
        return intUnit(twoToFour, untruncateYear);
      // weekNumber (W)
      case "W":
        return intUnit(oneOrTwo);
      case "WW":
        return intUnit(two);
      // weekdays
      case "E":
      case "c":
        return intUnit(one);
      case "EEE":
        return oneOf(loc.weekdays("short", false), 1);
      case "EEEE":
        return oneOf(loc.weekdays("long", false), 1);
      case "ccc":
        return oneOf(loc.weekdays("short", true), 1);
      case "cccc":
        return oneOf(loc.weekdays("long", true), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
      case "ZZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return simple(/[^\S\n\r]/);
      default:
        return literal3(t);
    }
  }, "unitate");
  const unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token;
  return unit;
}
__name(unitForToken, "unitForToken");
var partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
  const { type, value } = part;
  if (type === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value
    };
  }
  const style = formatOpts[type];
  let actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }
  if (val) {
    return {
      literal: false,
      val
    };
  }
  return void 0;
}
__name(tokenForPart, "tokenForPart");
function buildRegex(units) {
  const re = units.map((u) => u.regex).reduce((f, r) => `${f}(${r.source})`, "");
  return [
    `^${re}$`,
    units
  ];
}
__name(buildRegex, "buildRegex");
function match(input, regex, handlers) {
  const matches = input.match(regex);
  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        const h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [
      matches,
      all
    ];
  } else {
    return [
      matches,
      {}
    ];
  }
}
__name(match, "match");
function dateTimeFromMatches(matches) {
  const toField = /* @__PURE__ */ __name((token) => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  }, "toField");
  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }
  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }
  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }
  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }
  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }
  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }
  const vals = Object.keys(matches).reduce((r, k) => {
    const f = toField(k);
    if (f) {
      r[f] = matches[k];
    }
    return r;
  }, {});
  return [
    vals,
    zone,
    specificOffset
  ];
}
__name(dateTimeFromMatches, "dateTimeFromMatches");
var dummyDateTimeCache = null;
function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }
  return dummyDateTimeCache;
}
__name(getDummyDateTime, "getDummyDateTime");
function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }
  const formatOpts = Formatter.macroTokenToFormatOpts(token.val);
  const tokens = formatOptsToTokens(formatOpts, locale);
  if (tokens == null || tokens.includes(void 0)) {
    return token;
  }
  return tokens;
}
__name(maybeExpandMacroToken, "maybeExpandMacroToken");
function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t) => maybeExpandMacroToken(t, locale)));
}
__name(expandMacroTokens, "expandMacroTokens");
var _TokenParser = class _TokenParser {
  constructor(locale, format) {
    this.locale = locale;
    this.format = format;
    this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
    this.units = this.tokens.map((t) => unitForToken(t, locale));
    this.disqualifyingUnit = this.units.find((t) => t.invalidReason);
    if (!this.disqualifyingUnit) {
      const [regexString, handlers] = buildRegex(this.units);
      this.regex = RegExp(regexString, "i");
      this.handlers = handlers;
    }
  }
  explainFromTokens(input) {
    if (!this.isValid) {
      return {
        input,
        tokens: this.tokens,
        invalidReason: this.invalidReason
      };
    } else {
      const [rawMatches, matches] = match(input, this.regex, this.handlers), [result, zone, specificOffset] = matches ? dateTimeFromMatches(matches) : [
        null,
        null,
        void 0
      ];
      if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
        throw new ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
      }
      return {
        input,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches,
        matches,
        result,
        zone,
        specificOffset
      };
    }
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
};
__name(_TokenParser, "TokenParser");
var TokenParser = _TokenParser;
function explainFromTokens(locale, input, format) {
  const parser = new TokenParser(locale, format);
  return parser.explainFromTokens(input);
}
__name(explainFromTokens, "explainFromTokens");
function parseFromTokens(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [
    result,
    zone,
    specificOffset,
    invalidReason
  ];
}
__name(parseFromTokens, "parseFromTokens");
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  const formatter = Formatter.create(locale, formatOpts);
  const df = formatter.dtFormatter(getDummyDateTime());
  const parts = df.formatToParts();
  const resolvedOpts = df.resolvedOptions();
  return parts.map((p) => tokenForPart(p, formatOpts, resolvedOpts));
}
__name(formatOptsToTokens, "formatOptsToTokens");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/datetime.js
var INVALID3 = "Invalid DateTime";
var MAX_DATE = 864e13;
function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}
__name(unsupportedZone, "unsupportedZone");
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}
__name(possiblyCachedWeekData, "possiblyCachedWeekData");
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
  }
  return dt.localWeekData;
}
__name(possiblyCachedLocalWeekData, "possiblyCachedLocalWeekData");
function clone2(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime(__spreadProps(__spreadValues(__spreadValues({}, current), alts), {
    old: current
  }));
}
__name(clone2, "clone");
function fixOffset(localTS, o, tz) {
  let utcGuess = localTS - o * 60 * 1e3;
  const o2 = tz.offset(utcGuess);
  if (o === o2) {
    return [
      utcGuess,
      o
    ];
  }
  utcGuess -= (o2 - o) * 60 * 1e3;
  const o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [
      utcGuess,
      o2
    ];
  }
  return [
    localTS - Math.min(o2, o3) * 60 * 1e3,
    Math.max(o2, o3)
  ];
}
__name(fixOffset, "fixOffset");
function tsToObj(ts, offset2) {
  ts += offset2 * 60 * 1e3;
  const d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
}
__name(tsToObj, "tsToObj");
function objToTS(obj, offset2, zone) {
  return fixOffset(objToLocalTS(obj), offset2, zone);
}
__name(objToTS, "objToTS");
function adjustTime(inst, dur) {
  const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = __spreadProps(__spreadValues({}, inst.c), {
    year,
    month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }), millisToAdd = Duration.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"), localTS = objToLocalTS(c);
  let [ts, o] = fixOffset(localTS, oPre, inst.zone);
  if (millisToAdd !== 0) {
    ts += millisToAdd;
    o = inst.zone.offset(ts);
  }
  return {
    ts,
    o
  };
}
__name(adjustTime, "adjustTime");
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
    const interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, __spreadProps(__spreadValues({}, opts), {
      zone: interpretationZone,
      specificOffset
    }));
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`));
  }
}
__name(parseDataToDateTime, "parseDataToDateTime");
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
}
__name(toTechFormat, "toTechFormat");
function toISODate(o, extended) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c = "";
  if (longFormat && o.c.year >= 0) c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);
  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    c += "-";
    c += padStart(o.c.day);
  } else {
    c += padStart(o.c.month);
    c += padStart(o.c.day);
  }
  return c;
}
__name(toISODate, "toISODate");
function toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
  let c = padStart(o.c.hour);
  if (extended) {
    c += ":";
    c += padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
      c += ":";
    }
  } else {
    c += padStart(o.c.minute);
  }
  if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
    c += padStart(o.c.second);
    if (o.c.millisecond !== 0 || !suppressMilliseconds) {
      c += ".";
      c += padStart(o.c.millisecond, 3);
    }
  }
  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }
  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}
__name(toISOTime, "toISOTime");
var defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var orderedUnits2 = [
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
var orderedWeekUnits = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
];
var orderedOrdinalUnits = [
  "year",
  "ordinal",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
}
__name(normalizeUnit, "normalizeUnit");
function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}
__name(normalizeUnitWithLocalWeeks, "normalizeUnitWithLocalWeeks");
function guessOffsetForZone(zone) {
  if (!zoneOffsetGuessCache[zone]) {
    if (zoneOffsetTs === void 0) {
      zoneOffsetTs = Settings.now();
    }
    zoneOffsetGuessCache[zone] = zone.offset(zoneOffsetTs);
  }
  return zoneOffsetGuessCache[zone];
}
__name(guessOffsetForZone, "guessOffsetForZone");
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone);
  if (!zone.isValid) {
    return DateTime.invalid(unsupportedZone(zone));
  }
  const loc = Locale.fromObject(opts);
  let ts, o;
  if (!isUndefined(obj.year)) {
    for (const u of orderedUnits2) {
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }
    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const offsetProvis = guessOffsetForZone(zone);
    [ts, o] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = Settings.now();
  }
  return new DateTime({
    ts,
    zone,
    loc,
    o
  });
}
__name(quickDT, "quickDT");
function diffRelative(start, end, opts) {
  const round = isUndefined(opts.round) ? true : opts.round, format = /* @__PURE__ */ __name((c, unit) => {
    c = roundTo(c, round || opts.calendary ? 0 : 2, true);
    const formatter = end.loc.clone(opts).relFormatter(opts);
    return formatter.format(c, unit);
  }, "format"), differ = /* @__PURE__ */ __name((unit) => {
    if (opts.calendary) {
      if (!end.hasSame(start, unit)) {
        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
      } else return 0;
    } else {
      return end.diff(start, unit).get(unit);
    }
  }, "differ");
  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }
  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
__name(diffRelative, "diffRelative");
function lastOpts(argList) {
  let opts = {}, args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [
    opts,
    args
  ];
}
__name(lastOpts, "lastOpts");
var zoneOffsetTs;
var zoneOffsetGuessCache = {};
var _DateTime = class _DateTime {
  /**
  * @access private
  */
  constructor(config) {
    const zone = config.zone || Settings.defaultZone;
    let invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
    let c = null, o = null;
    if (!invalid) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
      if (unchanged) {
        [c, o] = [
          config.old.c,
          config.old.o
        ];
      } else {
        const ot = isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }
    this._zone = zone;
    this.loc = config.loc || Locale.create();
    this.invalid = invalid;
    this.weekData = null;
    this.localWeekData = null;
    this.c = c;
    this.o = o;
    this.isLuxonDateTime = true;
  }
  // CONSTRUCT
  /**
  * Create a DateTime for the current instant, in the system's time zone.
  *
  * Use Settings to override these default values if needed.
  * @example DateTime.now().toISO() //~> now in the ISO format
  * @return {DateTime}
  */
  static now() {
    return new _DateTime({});
  }
  /**
  * Create a local DateTime
  * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
  * @param {number} [month=1] - The month, 1-indexed
  * @param {number} [day=1] - The day of the month, 1-indexed
  * @param {number} [hour=0] - The hour of the day, in 24-hour time
  * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
  * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
  * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
  * @example DateTime.local()                                  //~> now
  * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
  * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
  * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
  * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
  * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
  * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
  * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
  * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
  * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
  * @return {DateTime}
  */
  static local() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond
    }, opts);
  }
  /**
  * Create a DateTime in UTC
  * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
  * @param {number} [month=1] - The month, 1-indexed
  * @param {number} [day=1] - The day of the month
  * @param {number} [hour=0] - The hour of the day, in 24-hour time
  * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
  * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
  * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
  * @param {Object} options - configuration options for the DateTime
  * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
  * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
  * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
  * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
  * @example DateTime.utc()                                              //~> now
  * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
  * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
  * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
  * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
  * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
  * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
  * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
  * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
  * @return {DateTime}
  */
  static utc() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond
    }, opts);
  }
  /**
  * Create a DateTime from a JavaScript Date object. Uses the default zone.
  * @param {Date} date - a JavaScript Date object
  * @param {Object} options - configuration options for the DateTime
  * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
  * @return {DateTime}
  */
  static fromJSDate(date2, options = {}) {
    const ts = isDate(date2) ? date2.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return _DateTime.invalid("invalid input");
    }
    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return _DateTime.invalid(unsupportedZone(zoneToUse));
    }
    return new _DateTime({
      ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }
  /**
  * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
  * @param {number} milliseconds - a number of milliseconds since 1970 UTC
  * @param {Object} options - configuration options for the DateTime
  * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
  * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
  * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
  * @return {DateTime}
  */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(`fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`);
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      return _DateTime.invalid("Timestamp out of range");
    } else {
      return new _DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
  * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
  * @param {number} seconds - a number of seconds since 1970 UTC
  * @param {Object} options - configuration options for the DateTime
  * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
  * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
  * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
  * @return {DateTime}
  */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new _DateTime({
        ts: seconds * 1e3,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
  * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
  * @param {Object} obj - the object to create the DateTime from
  * @param {number} obj.year - a year, such as 1987
  * @param {number} obj.month - a month, 1-12
  * @param {number} obj.day - a day of the month, 1-31, depending on the month
  * @param {number} obj.ordinal - day of the year, 1-365 or 366
  * @param {number} obj.weekYear - an ISO week year
  * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
  * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
  * @param {number} obj.localWeekYear - a week year, according to the locale
  * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
  * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
  * @param {number} obj.hour - hour of the day, 0-23
  * @param {number} obj.minute - minute of the hour, 0-59
  * @param {number} obj.second - second of the minute, 0-59
  * @param {number} obj.millisecond - millisecond of the second, 0-999
  * @param {Object} opts - options for creating this DateTime
  * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
  * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
  * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
  * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
  * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
  * @return {DateTime}
  */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return _DateTime.invalid(unsupportedZone(zoneToUse));
    }
    const loc = Locale.fromObject(opts);
    const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc);
    const tsNow = Settings.now(), offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
    let units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits2;
      defaultValues = defaultUnitValues;
    }
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }
    const higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid) {
      return _DateTime.invalid(invalid);
    }
    const gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse), inst = new _DateTime({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc
    });
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return _DateTime.invalid("mismatched weekday", `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`);
    }
    if (!inst.isValid) {
      return _DateTime.invalid(inst.invalid);
    }
    return inst;
  }
  /**
  * Create a DateTime from an ISO 8601 string
  * @param {string} text - the ISO string
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
  * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
  * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
  * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
  * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromISO('2016-05-25T09:08:34.123')
  * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
  * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
  * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
  * @example DateTime.fromISO('2016-W05-4')
  * @return {DateTime}
  */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }
  /**
  * Create a DateTime from an RFC 2822 string
  * @param {string} text - the RFC 2822 string
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
  * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
  * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
  * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
  * @return {DateTime}
  */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }
  /**
  * Create a DateTime from an HTTP header date
  * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
  * @param {string} text - the HTTP header date
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
  * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
  * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
  * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
  * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
  * @return {DateTime}
  */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }
  /**
  * Create a DateTime from an input string and format string.
  * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
  * @param {string} text - the string to parse
  * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
  * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
  * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @return {DateTime}
  */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    }), [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return _DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }
  /**
  * @deprecated use fromFormat instead
  */
  static fromString(text, fmt, opts = {}) {
    return _DateTime.fromFormat(text, fmt, opts);
  }
  /**
  * Create a DateTime from a SQL date, time, or datetime
  * Defaults to en-US if no locale has been specified, regardless of the system's locale
  * @param {string} text - the string to parse
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
  * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
  * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @example DateTime.fromSQL('2017-05-15')
  * @example DateTime.fromSQL('2017-05-15 09:12:34')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
  * @example DateTime.fromSQL('09:12:34.342')
  * @return {DateTime}
  */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }
  /**
  * Create an invalid DateTime.
  * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
  * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
  * @return {DateTime}
  */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new _DateTime({
        invalid
      });
    }
  }
  /**
  * Check if an object is an instance of DateTime. Works across context boundaries
  * @param {object} o
  * @return {boolean}
  */
  static isDateTime(o) {
    return o && o.isLuxonDateTime || false;
  }
  /**
  * Produce the format string for a set of options
  * @param formatOpts
  * @param localeOpts
  * @returns {string}
  */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t) => t ? t.val : null).join("");
  }
  /**
  * Produce the the fully expanded format token for the locale
  * Does NOT quote characters, so quoted tokens will not round trip correctly
  * @param fmt
  * @param localeOpts
  * @returns {string}
  */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map((t) => t.val).join("");
  }
  static resetCache() {
    zoneOffsetTs = void 0;
    zoneOffsetGuessCache = {};
  }
  // INFO
  /**
  * Get the value of unit.
  * @param {string} unit - a unit such as 'minute' or 'day'
  * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
  * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
  * @return {number}
  */
  get(unit) {
    return this[unit];
  }
  /**
  * Returns whether the DateTime is valid. Invalid DateTimes occur when:
  * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
  * * The DateTime was created by an operation on another invalid date
  * @type {boolean}
  */
  get isValid() {
    return this.invalid === null;
  }
  /**
  * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
  * @type {string}
  */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
  * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
  * @type {string}
  */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
  * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
  *
  * @type {string}
  */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
  * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
  *
  * @type {string}
  */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
  * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
  *
  * @type {string}
  */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
  * Get the time zone associated with this DateTime.
  * @type {Zone}
  */
  get zone() {
    return this._zone;
  }
  /**
  * Get the name of the time zone.
  * @type {string}
  */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
  * Get the year
  * @example DateTime.local(2017, 5, 25).year //=> 2017
  * @type {number}
  */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
  * Get the quarter
  * @example DateTime.local(2017, 5, 25).quarter //=> 2
  * @type {number}
  */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
  * Get the month (1-12).
  * @example DateTime.local(2017, 5, 25).month //=> 5
  * @type {number}
  */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
  * Get the day of the month (1-30ish).
  * @example DateTime.local(2017, 5, 25).day //=> 25
  * @type {number}
  */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
  * Get the hour of the day (0-23).
  * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
  * @type {number}
  */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
  * Get the minute of the hour (0-59).
  * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
  * @type {number}
  */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
  * Get the second of the minute (0-59).
  * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
  * @type {number}
  */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
  * Get the millisecond of the second (0-999).
  * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
  * @type {number}
  */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
  * Get the week year
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
  * @type {number}
  */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }
  /**
  * Get the week number of the week year (1-52ish).
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
  * @type {number}
  */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }
  /**
  * Get the day of the week.
  * 1 is Monday and 7 is Sunday
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2014, 11, 31).weekday //=> 4
  * @type {number}
  */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }
  /**
  * Returns true if this date is on a weekend according to the locale, false otherwise
  * @returns {boolean}
  */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
  * Get the day of the week according to the locale.
  * 1 is the first day of the week and 7 is the last day of the week.
  * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
  * @returns {number}
  */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }
  /**
  * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
  * because the week can start on different days of the week (see localWeekday) and because a different number of days
  * is required for a week to count as the first week of a year.
  * @returns {number}
  */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }
  /**
  * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
  * differently, see localWeekNumber.
  * @returns {number}
  */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }
  /**
  * Get the ordinal (meaning the day of the year)
  * @example DateTime.local(2017, 5, 25).ordinal //=> 145
  * @type {number|DateTime}
  */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }
  /**
  * Get the human readable short month name, such as 'Oct'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
  * @type {string}
  */
  get monthShort() {
    return this.isValid ? Info.months("short", {
      locObj: this.loc
    })[this.month - 1] : null;
  }
  /**
  * Get the human readable long month name, such as 'October'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).monthLong //=> October
  * @type {string}
  */
  get monthLong() {
    return this.isValid ? Info.months("long", {
      locObj: this.loc
    })[this.month - 1] : null;
  }
  /**
  * Get the human readable short weekday, such as 'Mon'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
  * @type {string}
  */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", {
      locObj: this.loc
    })[this.weekday - 1] : null;
  }
  /**
  * Get the human readable long weekday, such as 'Monday'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
  * @type {string}
  */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", {
      locObj: this.loc
    })[this.weekday - 1] : null;
  }
  /**
  * Get the UTC offset of this DateTime in minutes
  * @example DateTime.now().offset //=> -240
  * @example DateTime.utc().offset //=> 0
  * @type {number}
  */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
  * Get the short human name for the zone's current offset, for example "EST" or "EDT".
  * Defaults to the system's locale if no locale has been specified
  * @type {string}
  */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
  * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
  * Defaults to the system's locale if no locale has been specified
  * @type {string}
  */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
  * Get whether this zone's offset ever changes, as in a DST.
  * @type {boolean}
  */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
  * Get whether the DateTime is in a DST.
  * @type {boolean}
  */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return this.offset > this.set({
        month: 1,
        day: 1
      }).offset || this.offset > this.set({
        month: 5
      }).offset;
    }
  }
  /**
  * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
  * in this DateTime's zone. During DST changes local time can be ambiguous, for example
  * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
  * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
  * @returns {DateTime[]}
  */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [
        this
      ];
    }
    const dayMs = 864e5;
    const minuteMs = 6e4;
    const localTS = objToLocalTS(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);
    const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [
        this
      ];
    }
    const ts1 = localTS - o1 * minuteMs;
    const ts2 = localTS - o2 * minuteMs;
    const c1 = tsToObj(ts1, o1);
    const c2 = tsToObj(ts2, o2);
    if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) {
      return [
        clone2(this, {
          ts: ts1
        }),
        clone2(this, {
          ts: ts2
        })
      ];
    }
    return [
      this
    ];
  }
  /**
  * Returns true if this DateTime is in a leap year, false otherwise
  * @example DateTime.local(2016).isInLeapYear //=> true
  * @example DateTime.local(2013).isInLeapYear //=> false
  * @type {boolean}
  */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }
  /**
  * Returns the number of days in this DateTime's month
  * @example DateTime.local(2016, 2).daysInMonth //=> 29
  * @example DateTime.local(2016, 3).daysInMonth //=> 31
  * @type {number}
  */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }
  /**
  * Returns the number of days in this DateTime's year
  * @example DateTime.local(2016).daysInYear //=> 366
  * @example DateTime.local(2013).daysInYear //=> 365
  * @type {number}
  */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }
  /**
  * Returns the number of weeks in this DateTime's year
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2004).weeksInWeekYear //=> 53
  * @example DateTime.local(2013).weeksInWeekYear //=> 52
  * @type {number}
  */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }
  /**
  * Returns the number of weeks in this DateTime's local week year
  * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
  * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
  * @type {number}
  */
  get weeksInLocalWeekYear() {
    return this.isValid ? weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
  }
  /**
  * Returns the resolved Intl options for this DateTime.
  * This is useful in understanding the behavior of formatting methods
  * @param {Object} opts - the same options as toLocaleString
  * @return {Object}
  */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this);
    return {
      locale,
      numberingSystem,
      outputCalendar: calendar
    };
  }
  // TRANSFORM
  /**
  * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
  *
  * Equivalent to {@link DateTime#setZone}('utc')
  * @param {number} [offset=0] - optionally, an offset from UTC in minutes
  * @param {Object} [opts={}] - options to pass to `setZone()`
  * @return {DateTime}
  */
  toUTC(offset2 = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset2), opts);
  }
  /**
  * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
  *
  * Equivalent to `setZone('local')`
  * @return {DateTime}
  */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  /**
  * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
  *
  * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
  * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
  * @param {Object} opts - options
  * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
  * @return {DateTime}
  */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return _DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone2(this, {
        ts: newTS,
        zone
      });
    }
  }
  /**
  * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
  * @param {Object} properties - the properties to set
  * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
  * @return {DateTime}
  */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({
      locale,
      numberingSystem,
      outputCalendar
    });
    return clone2(this, {
      loc
    });
  }
  /**
  * "Set" the locale. Returns a newly-constructed DateTime.
  * Just a convenient alias for reconfigure({ locale })
  * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
  * @return {DateTime}
  */
  setLocale(locale) {
    return this.reconfigure({
      locale
    });
  }
  /**
  * "Set" the values of specified units. Returns a newly-constructed DateTime.
  * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
  *
  * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
  * They cannot be mixed with ISO-week units like `weekday`.
  * @param {Object} values - a mapping of units to numbers
  * @example dt.set({ year: 2017 })
  * @example dt.set({ hour: 8, minute: 30 })
  * @example dt.set({ weekday: 5 })
  * @example dt.set({ year: 2005, ordinal: 234 })
  * @return {DateTime}
  */
  set(values) {
    if (!this.isValid) return this;
    const normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc);
    const settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian(__spreadValues(__spreadValues({}, gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek)), normalized), minDaysInFirstWeek, startOfWeek);
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian(__spreadValues(__spreadValues({}, gregorianToOrdinal(this.c)), normalized));
    } else {
      mixed = __spreadValues(__spreadValues({}, this.toObject()), normalized);
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }
    const [ts, o] = objToTS(mixed, this.o, this.zone);
    return clone2(this, {
      ts,
      o
    });
  }
  /**
  * Add a period of time to this DateTime and return the resulting DateTime
  *
  * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
  * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  * @example DateTime.now().plus(123) //~> in 123 milliseconds
  * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
  * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
  * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
  * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
  * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
  * @return {DateTime}
  */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return clone2(this, adjustTime(this, dur));
  }
  /**
  * Subtract a period of time to this DateTime and return the resulting DateTime
  * See {@link DateTime#plus}
  * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  @return {DateTime}
  */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return clone2(this, adjustTime(this, dur));
  }
  /**
  * "Set" this DateTime to the beginning of a unit of time.
  * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
  * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
  * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
  * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
  * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
  * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
  * @return {DateTime}
  */
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid) return this;
    const o = {}, normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
      case "milliseconds":
        break;
    }
    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const { weekday } = this;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }
    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }
    return this.set(o);
  }
  /**
  * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
  * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
  * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
  * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
  * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
  * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
  * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
  * @return {DateTime}
  */
  endOf(unit, opts) {
    return this.isValid ? this.plus({
      [unit]: 1
    }).startOf(unit, opts).minus(1) : this;
  }
  // OUTPUT
  /**
  * Returns a string representation of this DateTime formatted according to the specified format string.
  * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
  * Defaults to en-US if no locale has been specified, regardless of the system's locale.
  * @param {string} fmt - the format string
  * @param {Object} opts - opts to override the configuration options on this DateTime
  * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
  * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
  * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
  * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
  * @return {string}
  */
  toFormat(fmt, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID3;
  }
  /**
  * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
  * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
  * of the DateTime in the assigned locale.
  * Defaults to the system's locale if no locale has been specified
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
  * @param {Object} opts - opts to override the configuration options on this DateTime
  * @example DateTime.now().toLocaleString(); //=> 4/20/2017
  * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
  * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
  * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
  * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
  * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
  * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
  * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
  * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
  * @return {string}
  */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID3;
  }
  /**
  * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
  * Defaults to the system's locale if no locale has been specified
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
  * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
  * @example DateTime.now().toLocaleParts(); //=> [
  *                                   //=>   { type: 'day', value: '25' },
  *                                   //=>   { type: 'literal', value: '/' },
  *                                   //=>   { type: 'month', value: '05' },
  *                                   //=>   { type: 'literal', value: '/' },
  *                                   //=>   { type: 'year', value: '1982' }
  *                                   //=> ]
  */
  toLocaleParts(opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime
  * @param {Object} opts - options
  * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
  * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
  * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
  * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
  * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
  * @return {string}
  */
  toISO({ format = "extended", suppressSeconds = false, suppressMilliseconds = false, includeOffset = true, extendedZone = false } = {}) {
    if (!this.isValid) {
      return null;
    }
    const ext = format === "extended";
    let c = toISODate(this, ext);
    c += "T";
    c += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    return c;
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime's date component
  * @param {Object} opts - options
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
  * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
  * @return {string}
  */
  toISODate({ format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, format === "extended");
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime's week date
  * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
  * @return {string}
  */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime's time component
  * @param {Object} opts - options
  * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
  * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
  * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
  * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
  * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
  * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
  * @return {string}
  */
  toISOTime({ suppressMilliseconds = false, suppressSeconds = false, includeOffset = true, includePrefix = false, extendedZone = false, format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }
    let c = includePrefix ? "T" : "";
    return c + toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
  }
  /**
  * Returns an RFC 2822-compatible string representation of this DateTime
  * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
  * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
  * @return {string}
  */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
  * Specifically, the string conforms to RFC 1123.
  * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
  * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
  * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
  * @return {string}
  */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in SQL Date
  * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
  * @return {string}
  */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in SQL Time
  * @param {Object} opts - options
  * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
  * @example DateTime.utc().toSQL() //=> '05:15:16.345'
  * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
  * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
  * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
  * @return {string}
  */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat(this, fmt, true);
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in SQL DateTime
  * @param {Object} opts - options
  * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
  * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
  * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
  * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
  * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
  * @return {string}
  */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }
    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }
  /**
  * Returns a string representation of this DateTime appropriate for debugging
  * @return {string}
  */
  toString() {
    return this.isValid ? this.toISO() : INVALID3;
  }
  /**
  * Returns a string representation of this DateTime appropriate for the REPL.
  * @return {string}
  */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
  * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
  * @return {number}
  */
  valueOf() {
    return this.toMillis();
  }
  /**
  * Returns the epoch milliseconds of this DateTime.
  * @return {number}
  */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
  * Returns the epoch seconds of this DateTime.
  * @return {number}
  */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
  * Returns the epoch seconds (as a whole number) of this DateTime.
  * @return {number}
  */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
  * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
  * @return {string}
  */
  toJSON() {
    return this.toISO();
  }
  /**
  * Returns a BSON serializable equivalent to this DateTime.
  * @return {Date}
  */
  toBSON() {
    return this.toJSDate();
  }
  /**
  * Returns a JavaScript object with this DateTime's year, month, day, and so on.
  * @param opts - options for generating the object
  * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
  * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
  * @return {Object}
  */
  toObject(opts = {}) {
    if (!this.isValid) return {};
    const base = __spreadValues({}, this.c);
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }
  /**
  * Returns a JavaScript Date equivalent to this DateTime.
  * @return {Date}
  */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
  * Return the difference between two DateTimes as a Duration.
  * @param {DateTime} otherDateTime - the DateTime to compare this one to
  * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
  * @param {Object} opts - options that affect the creation of the Duration
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @example
  * var i1 = DateTime.fromISO('1982-05-25T09:45'),
  *     i2 = DateTime.fromISO('1983-10-14T10:30');
  * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
  * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
  * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
  * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
  * @return {Duration}
  */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }
    const durOpts = __spreadValues({
      locale: this.locale,
      numberingSystem: this.numberingSystem
    }, opts);
    const units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = diff_default(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }
  /**
  * Return the difference between this DateTime and right now.
  * See {@link DateTime#diff}
  * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
  * @param {Object} opts - options that affect the creation of the Duration
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @return {Duration}
  */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(_DateTime.now(), unit, opts);
  }
  /**
  * Return an Interval spanning between this DateTime and another DateTime
  * @param {DateTime} otherDateTime - the other end point of the Interval
  * @return {Interval}
  */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  /**
  * Return whether this DateTime is in the same unit of time as another DateTime.
  * Higher-order units must also be identical for this function to return `true`.
  * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
  * @param {DateTime} otherDateTime - the other DateTime
  * @param {string} unit - the unit of time to check sameness on
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
  * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
  * @return {boolean}
  */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;
    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, {
      keepLocalTime: true
    });
    return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
  }
  /**
  * Equality check
  * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
  * To compare just the millisecond values, use `+dt1 === +dt2`.
  * @param {DateTime} other - the other DateTime
  * @return {boolean}
  */
  equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  /**
  * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
  * platform supports Intl.RelativeTimeFormat. Rounds down by default.
  * @param {Object} options - options that affect the output
  * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
  * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
  * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
  * @param {boolean} [options.round=true] - whether to round the numbers in the output.
  * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
  * @param {string} options.locale - override the locale of this DateTime
  * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
  * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
  * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
  * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
  * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
  * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
  * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
  */
  toRelative(options = {}) {
    if (!this.isValid) return null;
    const base = options.base || _DateTime.fromObject({}, {
      zone: this.zone
    }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    let units = [
      "years",
      "months",
      "days",
      "hours",
      "minutes",
      "seconds"
    ];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = void 0;
    }
    return diffRelative(base, this.plus(padding), __spreadProps(__spreadValues({}, options), {
      numeric: "always",
      units,
      unit
    }));
  }
  /**
  * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
  * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
  * @param {Object} options - options that affect the output
  * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
  * @param {string} options.locale - override the locale of this DateTime
  * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
  * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
  * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
  * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
  * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
  * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
  */
  toRelativeCalendar(options = {}) {
    if (!this.isValid) return null;
    return diffRelative(options.base || _DateTime.fromObject({}, {
      zone: this.zone
    }), this, __spreadProps(__spreadValues({}, options), {
      numeric: "auto",
      units: [
        "years",
        "months",
        "days"
      ],
      calendary: true
    }));
  }
  /**
  * Return the min of several date times
  * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
  * @return {DateTime} the min DateTime, or undefined if called with no argument
  */
  static min(...dateTimes) {
    if (!dateTimes.every(_DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.min);
  }
  /**
  * Return the max of several date times
  * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
  * @return {DateTime} the max DateTime, or undefined if called with no argument
  */
  static max(...dateTimes) {
    if (!dateTimes.every(_DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.max);
  }
  // MISC
  /**
  * Explain how a string would be parsed by fromFormat()
  * @param {string} text - the string to parse
  * @param {string} fmt - the format the string is expected to be in (see description)
  * @param {Object} options - options taken by fromFormat()
  * @return {Object}
  */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return explainFromTokens(localeToUse, text, fmt);
  }
  /**
  * @deprecated use fromFormatExplain instead
  */
  static fromStringExplain(text, fmt, options = {}) {
    return _DateTime.fromFormatExplain(text, fmt, options);
  }
  /**
  * Build a parser for `fmt` using the given locale. This parser can be passed
  * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
  * can be used to optimize cases where many dates need to be parsed in a
  * specific format.
  *
  * @param {String} fmt - the format the string is expected to be in (see
  * description)
  * @param {Object} options - options used to set locale and numberingSystem
  * for parser
  * @returns {TokenParser} - opaque object to be used
  */
  static buildFormatParser(fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return new TokenParser(localeToUse, fmt);
  }
  /**
  * Create a DateTime from an input string and format parser.
  *
  * The format parser must have been created with the same locale as this call.
  *
  * @param {String} text - the string to parse
  * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
  * @param {Object} opts - options taken by fromFormat()
  * @returns {DateTime}
  */
  static fromFormatParser(text, formatParser, opts = {}) {
    if (isUndefined(text) || isUndefined(formatParser)) {
      throw new InvalidArgumentError("fromFormatParser requires an input string and a format parser");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    if (!localeToUse.equals(formatParser.locale)) {
      throw new InvalidArgumentError(`fromFormatParser called with a locale of ${localeToUse}, but the format parser was created for ${formatParser.locale}`);
    }
    const { result, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);
    if (invalidReason) {
      return _DateTime.invalid(invalidReason);
    } else {
      return parseDataToDateTime(result, zone, opts, `format ${formatParser.format}`, text, specificOffset);
    }
  }
  // FORMAT PRESETS
  /**
  * {@link DateTime#toLocaleString} format like 10/14/1983
  * @type {Object}
  */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
  * @type {Object}
  */
  static get DATE_MED() {
    return DATE_MED;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
  * @type {Object}
  */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'October 14, 1983'
  * @type {Object}
  */
  static get DATE_FULL() {
    return DATE_FULL;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
  * @type {Object}
  */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }
  /**
  * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
};
__name(_DateTime, "DateTime");
var DateTime = _DateTime;
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(`Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`);
  }
}
__name(friendlyDateTime, "friendlyDateTime");

// src/common/date.schema.ts
import { coerce, z as z11 } from "zod";
var CustomLuxonDateSchema = z11.custom((value) => value && DateTime.fromJSDate(value).toJSDate());
var CommonCustomDateSchema = coerce.string().date().or(coerce.string()).or(CustomLuxonDateSchema);
var CustomDateTimeSchema = coerce.string().datetime().or(coerce.string()).or(CustomLuxonDateSchema);

// src/common/id.ts
import { coerce as coerce2 } from "zod";
var UnsignedIDSchema = coerce2.number().int().nonnegative();

// src/common/pagination.schema.ts
import { number, object as object2, string } from "zod";
var MetaSchema = object2({
  totalPages: number().int().positive(),
  page: number().int().positive(),
  perPage: number().int().positive(),
  total: number().int().positive()
});
var ErrorSchema = object2({
  code: string(),
  message: string()
});

// src/common/permissions.ts
var Permissions = {
  APP_ACTIVE: "sub.active",
  // ── Community / shared ──────────────────────────────────────────────
  CHAT_VIEW: "chat.view",
  CHAT_SEND: "chat.send",
  CHAT_EDIT: "chat.edit",
  CHAT_DELETE: "chat.delete",
  CONTENT_VIEW: "content.view",
  CONTENT_CREATE: "content.create",
  CONTENT_EDIT: "content.edit",
  CONTENT_DELETE: "content.delete",
  FEED_VIEW: "feed.view",
  POST_CREATE: "post.create",
  COMMENT_CREATE: "comment.create",
  SPACE_VIEW: "space.view",
  SPACE_MANAGE: "space.manage",
  // ── FIT ─────────────────────────────────────────────────────────────
  FIT_CONTENT_VIEW: "fit.content.view",
  FIT_CONTENT_MANAGE: "fit.content.manage",
  FIT_SERIES_VIEW: "fit.series.view",
  FIT_SERIES_MANAGE: "fit.series.manage",
  FIT_CHALLENGE_VIEW: "fit.challenge.view",
  FIT_CHALLENGE_MANAGE: "fit.challenge.manage",
  FIT_COMMENT_VIEW: "fit.comment.view",
  FIT_COMMENT_WRITE: "fit.comment.write",
  FIT_COMMENT_EXPORT: "fit.comment.export",
  FIT_COMMENT_MODERATE: "fit.comment.moderate",
  FIT_CLASS_OF_THE_DAY_VIEW: "fit.class-of-the-day.view",
  FIT_CLASS_OF_THE_DAY_MANAGE: "fit.class-of-the-day.manage",
  FIT_SLIDESHOW_MANAGE: "fit.slideshow.manage",
  FIT_EVENT_MANAGE: "fit.event.manage",
  FIT_TRACKING_VIEW: "fit.tracking.view",
  FIT_SIMULATION_ADMIN: "fit.simulation.admin",
  // ── RYC ─────────────────────────────────────────────────────────────
  RYC_ACTIVE: "sub.active",
  RYC_CONTENT_VIEW: "ryc.content.view",
  RYC_CONTENT_MANAGE: "ryc.content.manage",
  RYC_JOURNEY_ACCESS: "ryc.journey.access",
  RYC_COACH_ACCESS: "ryc.coach.access",
  RYC_INSTRUCTION_MANAGE: "ryc.instruction.manage",
  RYC_USER_MANAGEMENT_MANAGE: "ryc.user-management.manage",
  RYC_STATS_VIEW: "ryc.stats.view",
  RYC_TRACKING_VIEW: "ryc.tracking.view",
  RYC_JOURNAL_WRITE: "ryc.journal.write",
  RYC_SIMULATION_ADMIN: "ryc.simulation.admin",
  // ── PD ──────────────────────────────────────────────────────────────
  PD_PUBLIC_LISTING: "pd.public-listing",
  PD_ACTIVE: "pro_directory.active"
};
var getAddonProgramViewPermission = /* @__PURE__ */ __name((slug) => `programs.${slug}`, "getAddonProgramViewPermission");

// src/common/request.schema.ts
import { coerce as coerce3, object as object3 } from "zod";

// src/coerce-boolean.ts
import { boolean, string as string2, union } from "zod";
var CoerceBoolean = union([
  boolean(),
  string2()
]).transform((value) => {
  if (value === "false") {
    return false;
  }
  if (value === "true") {
    return true;
  }
  return Boolean(value);
}).default(false);

// src/common/request.schema.ts
var RequestSchema = object3({
  perPage: coerce3.number().optional(),
  page: coerce3.number().optional(),
  isHidden: CoerceBoolean.optional()
});

// src/common/slug.ts
import { z as z12 } from "zod";
var SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
var SLUG_PATTERN_MESSAGE = "Lowercase letters, numbers, and hyphens only \u2014 no spaces or special characters";
var SlugSchema = z12.string().regex(SLUG_PATTERN, SLUG_PATTERN_MESSAGE);

// src/common/timezone.schema.ts
import { string as string3 } from "zod";
var timezoneSchema = string3().nullable().optional().transform((tz) => {
  if (!tz) {
    return "America/New_York";
  }
  try {
    Intl.DateTimeFormat(void 0, {
      timeZone: tz
    });
    return tz;
  } catch (e) {
    return "America/New_York";
  }
});

// src/comment/entity.ts
import { z as z13 } from "zod";
var MentionUserSchema = z13.object({
  id: z13.string(),
  displayName: z13.string(),
  username: z13.string().nullable().optional(),
  avatar: z13.string().nullable().optional()
});
var MentionUserCacheSchema = MentionUserSchema.extend({
  userId: z13.string(),
  isPrivate: z13.boolean(),
  apps: z13.array(AppNameEnumObj)
});
var CommentRejectReasonValues = [
  "SPAM",
  "HARASSMENT",
  "HATE_OR_OFFENSIVE",
  "INAPPROPRIATE",
  "OFF_TOPIC",
  "MISINFORMATION",
  "SELF_PROMOTION",
  "OTHER"
];
var CommentRejectReasonEnum = z13.enum(CommentRejectReasonValues);
var ECommentRejectReason = CommentRejectReasonEnum.enum;
var COMMENT_REJECT_REASON_LABELS = {
  SPAM: "Spam",
  HARASSMENT: "Harassment / Bullying",
  HATE_OR_OFFENSIVE: "Hate / Offensive language",
  INAPPROPRIATE: "Inappropriate / Explicit",
  OFF_TOPIC: "Off-topic",
  MISINFORMATION: "Misinformation",
  SELF_PROMOTION: "Self-promotion / Advertising",
  OTHER: "Other"
};
var CommentActivityActionValues = [
  "CREATED",
  "EDITED",
  "REVIEWED",
  "REJECTED",
  "UNREJECTED",
  "DELETED",
  "REPLIED"
];
var CommentActivityActionEnum = z13.enum(CommentActivityActionValues);
var ECommentActivityAction = CommentActivityActionEnum.enum;
var COMMENT_ACTIVITY_ACTION_LABELS = {
  CREATED: "Created",
  EDITED: "Edited",
  REVIEWED: "Reviewed",
  REJECTED: "Rejected",
  UNREJECTED: "Unrejected",
  DELETED: "Deleted",
  REPLIED: "Replied"
};
var CommentActivitySchema = z13.object({
  id: z13.string(),
  commentId: z13.number(),
  contentId: z13.string().nullable().optional(),
  action: CommentActivityActionEnum,
  actorUserId: z13.string(),
  actorName: z13.string().nullable().optional(),
  actorAvatar: z13.string().nullable().optional(),
  rejectReason: CommentRejectReasonEnum.nullable().optional(),
  note: z13.string().nullable().optional(),
  snapshot: z13.record(z13.unknown()).nullable().optional(),
  createdAt: z13.string()
});
var BaseCommentSchema = z13.object({
  id: z13.number(),
  contentId: z13.string(),
  userId: z13.coerce.string(),
  content: z13.string(),
  parentId: z13.number().nullable(),
  likesCount: z13.number(),
  isDeleted: z13.boolean(),
  isEdited: z13.boolean().optional(),
  reviewedAt: z13.string().nullable().optional(),
  isReject: z13.boolean(),
  rejectReason: CommentRejectReasonEnum.nullable().optional(),
  onBehalfOfUserId: z13.string().nullable().optional(),
  createdAt: z13.string(),
  updatedAt: z13.string(),
  userName: z13.string().optional(),
  userAvatar: z13.string().nullable().optional(),
  onBehalfOfUserName: z13.string().nullable().optional(),
  onBehalfOfUserAvatar: z13.string().nullable().optional(),
  isLikedByCurrentUser: z13.boolean().optional(),
  canEdit: z13.boolean().optional(),
  canDelete: z13.boolean().optional()
});
var AdminCommentRowSchema = BaseCommentSchema.extend({
  videoTitle: z13.string().nullable().optional(),
  videoId: z13.string().nullable().optional(),
  instructorName: z13.string().nullable().optional(),
  instructorId: z13.string().nullable().optional(),
  reviewedById: z13.string().nullable().optional(),
  reviewedByName: z13.string().nullable().optional()
});
var CommentWithRepliesSchema = z13.lazy(() => BaseCommentSchema.extend({
  replies: z13.array(CommentWithRepliesSchema).optional()
}));
var CommentSchema = CommentWithRepliesSchema;
var visibleContentLength = /* @__PURE__ */ __name((val) => val.replace(/<[^>]*>/g, "").trim().length, "visibleContentLength");
var CreateCommentDtoSchema = z13.object({
  contentId: z13.string().min(1, "content ID is required"),
  content: z13.string().refine((val) => visibleContentLength(val) > 0, "Comment content is required").refine((val) => visibleContentLength(val) <= 1e3, "Comment content is too long"),
  parentId: z13.number().optional()
});
var UpdateCommentDtoSchema = z13.object({
  content: z13.string().refine((val) => visibleContentLength(val) > 0, "Comment content is required").refine((val) => visibleContentLength(val) <= 1e3, "Comment content is too long")
});
var GetCommentsDtoSchema = z13.object({
  contentId: z13.string().min(1, "content ID is required"),
  page: z13.coerce.number().min(1).default(1).optional(),
  limit: z13.coerce.number().min(1).max(100).default(10).optional(),
  enabled: z13.boolean().default(true).optional()
});
var CommentsResponseSchema = z13.object({
  comments: z13.array(CommentWithRepliesSchema),
  total: z13.number(),
  hasMore: z13.boolean()
});
var LikeResponseSchema = z13.object({
  liked: z13.boolean(),
  likesCount: z13.number()
});
var GetContentsByCommentsDateRangeSchema = z13.object({
  app: AppNameEnumObj,
  page: z13.coerce.number().min(1).default(1),
  limit: z13.coerce.number().min(1).max(100).default(15),
  fromDate: z13.string().optional(),
  toDate: z13.string().optional()
});
var csvStringToArray = z13.union([
  z13.string(),
  z13.array(z13.string())
]).transform((val) => {
  if (Array.isArray(val)) {
    return val.filter(Boolean);
  }
  if (!val) {
    return [];
  }
  return val.split(",").map((v) => v.trim()).filter(Boolean);
}).optional();
var GetAdminCommentsDtoSchema = z13.object({
  instructorIds: csvStringToArray,
  isReject: z13.coerce.boolean().optional(),
  notReviewed: z13.coerce.boolean().optional(),
  fromDate: z13.string().optional(),
  toDate: z13.string().optional(),
  page: z13.coerce.number().min(1).default(1).optional(),
  limit: z13.coerce.number().min(1).max(200).default(20).optional()
});
var ExportAdminCommentsDtoSchema = z13.object({
  instructorIds: csvStringToArray,
  isReject: z13.coerce.boolean().optional(),
  notReviewed: z13.coerce.boolean().optional(),
  fromDate: z13.string().optional(),
  toDate: z13.string().optional()
});
var CommentAnalyticsFiltersSchema = z13.object({
  instructorIds: csvStringToArray,
  fromDate: z13.string().optional(),
  toDate: z13.string().optional()
});
var CommentAnalyticsGranularityEnum = z13.enum([
  "daily",
  "weekly",
  "monthly"
]);
var CommentAnalyticsTimelineFiltersSchema = CommentAnalyticsFiltersSchema.extend({
  granularity: CommentAnalyticsGranularityEnum.default("daily").optional()
});
var CommentAnalyticsOverviewSchema = z13.object({
  total: z13.number(),
  reviewed: z13.number(),
  rejected: z13.number(),
  pending: z13.number(),
  reviewRate: z13.number(),
  rejectionRate: z13.number(),
  avgReviewHours: z13.number().nullable()
});
var CommentAnalyticsInstructorRowSchema = z13.object({
  instructorId: z13.string().nullable(),
  instructorName: z13.string().nullable(),
  total: z13.number(),
  reviewed: z13.number(),
  rejected: z13.number(),
  pending: z13.number(),
  reviewRate: z13.number(),
  rejectionRate: z13.number(),
  avgReviewHours: z13.number().nullable()
});
var CommentAnalyticsByInstructorSchema = z13.array(CommentAnalyticsInstructorRowSchema);
var CommentAnalyticsTimelinePointSchema = z13.object({
  date: z13.string(),
  total: z13.number(),
  reviewed: z13.number(),
  rejected: z13.number()
});
var CommentAnalyticsTimelineSchema = z13.array(CommentAnalyticsTimelinePointSchema);
var CommentAnalyticsRejectionReasonSchema = z13.object({
  reason: CommentRejectReasonEnum.nullable(),
  count: z13.number()
});
var CommentAnalyticsRejectionReasonsSchema = z13.array(CommentAnalyticsRejectionReasonSchema);
var CommentAnalyticsReviewerSchema = z13.object({
  reviewerId: z13.string(),
  reviewerName: z13.string().nullable(),
  reviewed: z13.number(),
  rejected: z13.number(),
  total: z13.number()
});
var CommentAnalyticsReviewersSchema = z13.array(CommentAnalyticsReviewerSchema);
var AdminReplyDtoSchema = z13.object({
  contentId: z13.string().min(1, "content ID is required"),
  instructorId: z13.string().min(1, "instructor ID is required"),
  content: z13.string().refine((val) => visibleContentLength(val) > 0, "Reply content is required").refine((val) => visibleContentLength(val) <= 1e3, "Reply content is too long"),
  parentId: z13.number().optional()
});
var ToggleRejectDtoSchema = z13.object({
  isReject: z13.boolean(),
  rejectReason: CommentRejectReasonEnum.optional(),
  rejectNote: z13.string().max(500).optional()
});
var validateCreateComment = /* @__PURE__ */ __name((data) => {
  return CreateCommentDtoSchema.parse(data);
}, "validateCreateComment");
var validateUpdateComment = /* @__PURE__ */ __name((data) => {
  return UpdateCommentDtoSchema.parse(data);
}, "validateUpdateComment");
var validateGetComments = /* @__PURE__ */ __name((data) => {
  return GetCommentsDtoSchema.parse(data);
}, "validateGetComments");
var validateGetContentsByCommentsDateRange = /* @__PURE__ */ __name((data) => {
  return GetContentsByCommentsDateRangeSchema.parse(data);
}, "validateGetContentsByCommentsDateRange");
var validateComment = /* @__PURE__ */ __name((data) => {
  return CommentWithRepliesSchema.parse(data);
}, "validateComment");
var validateCommentsResponse = /* @__PURE__ */ __name((data) => {
  return CommentsResponseSchema.parse(data);
}, "validateCommentsResponse");
var validateLikeResponse = /* @__PURE__ */ __name((data) => {
  return LikeResponseSchema.parse(data);
}, "validateLikeResponse");

// src/community-hub/chat.ts
import { z as z14 } from "zod";
var ConversationType = /* @__PURE__ */ function(ConversationType2) {
  ConversationType2["GROUP"] = "group";
  ConversationType2["DIRECT"] = "direct";
  return ConversationType2;
}({});
var ConversationTypeSchema = z14.nativeEnum(ConversationType);
var MessageType = /* @__PURE__ */ function(MessageType2) {
  MessageType2["TEXT"] = "text";
  MessageType2["SYSTEM"] = "system";
  return MessageType2;
}({});
var MessageTypeSchema = z14.nativeEnum(MessageType);
var CreateConversationSchema = z14.object({
  conversationType: ConversationTypeSchema,
  title: z14.string().max(255, "Title must be 255 characters or less").optional(),
  memberUserIds: z14.array(z14.string().uuid("Invalid user ID")).min(1, "At least one member is required")
});
var SendMessageSchema = z14.object({
  body: z14.string().min(1, "Message body is required").max(1e4, "Message is too long")
});
var UpdateMessageSchema = z14.object({
  body: z14.string().min(1, "Message body is required").max(1e4, "Message is too long")
});
var MarkAsReadSchema = z14.object({
  messageId: z14.string().uuid("Invalid message ID")
});
var ConversationBaseSchema = z14.object({
  id: z14.string().uuid(),
  spaceId: z14.string().uuid(),
  conversationType: ConversationTypeSchema,
  title: z14.string().max(255).nullable(),
  lastMessageAt: z14.coerce.date().nullable(),
  createdAt: z14.coerce.date()
});
var MessageBaseSchema = z14.object({
  id: z14.string().uuid(),
  conversationId: z14.string().uuid(),
  senderId: z14.string().uuid(),
  body: z14.string(),
  messageType: MessageTypeSchema,
  editedAt: z14.coerce.date().nullable(),
  deletedAt: z14.coerce.date().nullable(),
  createdAt: z14.coerce.date()
});

// src/community-hub/content.ts
import { z as z15 } from "zod";
var LessonStatus = /* @__PURE__ */ function(LessonStatus2) {
  LessonStatus2["DRAFT"] = "draft";
  LessonStatus2["PUBLISHED"] = "published";
  LessonStatus2["ARCHIVED"] = "archived";
  return LessonStatus2;
}({});
var LessonStatusSchema = z15.nativeEnum(LessonStatus);
var EContentStatus = /* @__PURE__ */ function(EContentStatus2) {
  EContentStatus2["DRAFT"] = "draft";
  EContentStatus2["PUBLISHED"] = "published";
  EContentStatus2["ARCHIVED"] = "archived";
  return EContentStatus2;
}({});
var ContentStatusSchema = z15.nativeEnum(EContentStatus);
var LessonColorScheme = /* @__PURE__ */ function(LessonColorScheme2) {
  LessonColorScheme2["CORAL"] = "coral";
  LessonColorScheme2["GREEN"] = "green";
  LessonColorScheme2["PEACH"] = "peach";
  LessonColorScheme2["BLUE"] = "blue";
  LessonColorScheme2["DUSTY_BLUE"] = "dusty_blue";
  LessonColorScheme2["PEACH_CREAM"] = "peach_cream";
  LessonColorScheme2["CORAL_RED"] = "coral_red";
  LessonColorScheme2["MINT_CREAM"] = "mint_cream";
  LessonColorScheme2["ROSE_TAUPE"] = "rose_taupe";
  LessonColorScheme2["ICE_BLUE"] = "ice_blue";
  LessonColorScheme2["LIGHT_SAGE_GREEN"] = "light_sage_green";
  return LessonColorScheme2;
}({});
var LessonIconScheme = /* @__PURE__ */ function(LessonIconScheme2) {
  LessonIconScheme2["BOOK"] = "book";
  LessonIconScheme2["VIDEO"] = "video";
  LessonIconScheme2["FILES"] = "files";
  LessonIconScheme2["DOCUMENT"] = "document";
  return LessonIconScheme2;
}({});
var LessonColorSchemeSchema = z15.nativeEnum(LessonColorScheme);
var LessonIconSchemeSchema = z15.nativeEnum(LessonIconScheme);
var LessonTemplateType = /* @__PURE__ */ function(LessonTemplateType2) {
  LessonTemplateType2["DEFAULT"] = "default";
  LessonTemplateType2["INLINE"] = "inline";
  LessonTemplateType2["INLINE_DOCUMENT"] = "inline_document";
  return LessonTemplateType2;
}({});
var LessonTemplateTypeSchema = z15.nativeEnum(LessonTemplateType);
var ContentBlockType = /* @__PURE__ */ function(ContentBlockType2) {
  ContentBlockType2["TEXT"] = "text";
  ContentBlockType2["VIMEO"] = "vimeo";
  ContentBlockType2["PDF"] = "pdf";
  ContentBlockType2["QUIZ"] = "quiz";
  ContentBlockType2["FORM"] = "form";
  ContentBlockType2["EMBED"] = "embed";
  ContentBlockType2["REDIRECT"] = "redirect";
  ContentBlockType2["GCS_UPLOAD"] = "gcs_upload";
  ContentBlockType2["EVENT"] = "event";
  return ContentBlockType2;
}({});
var ContentBlockTypeSchema = z15.nativeEnum(ContentBlockType);
var ContentBlockResourceType = /* @__PURE__ */ function(ContentBlockResourceType2) {
  ContentBlockResourceType2["VIDEO"] = "video";
  ContentBlockResourceType2["PDF"] = "pdf";
  ContentBlockResourceType2["TEXT"] = "text";
  ContentBlockResourceType2["CANVA_TEMPLATE"] = "canva_template";
  ContentBlockResourceType2["GOOGLE_DOC"] = "google_doc";
  ContentBlockResourceType2["WORKSHEET"] = "worksheet";
  ContentBlockResourceType2["QUIZ"] = "quiz";
  ContentBlockResourceType2["FORM"] = "form";
  ContentBlockResourceType2["REDIRECT"] = "redirect";
  ContentBlockResourceType2["EMBED"] = "embed";
  return ContentBlockResourceType2;
}({});
var ContentBlockResourceTypeSchema = z15.nativeEnum(ContentBlockResourceType);
var ContentBlockContentCategory = /* @__PURE__ */ function(ContentBlockContentCategory2) {
  ContentBlockContentCategory2["STRENGTH"] = "STRENGTH";
  ContentBlockContentCategory2["CARDIO"] = "CARDIO";
  ContentBlockContentCategory2["FLOW"] = "FLOW";
  ContentBlockContentCategory2["RESTORE"] = "RESTORE";
  return ContentBlockContentCategory2;
}({});
var ContentBlockContentCategorySchema = z15.nativeEnum(ContentBlockContentCategory);
var LessonProgressStatus = /* @__PURE__ */ function(LessonProgressStatus2) {
  LessonProgressStatus2["NOT_STARTED"] = "not_started";
  LessonProgressStatus2["IN_PROGRESS"] = "in_progress";
  LessonProgressStatus2["COMPLETED"] = "completed";
  return LessonProgressStatus2;
}({});
var LessonProgressStatusSchema = z15.nativeEnum(LessonProgressStatus);
var LessonRefSchema = z15.object({
  id: z15.string().uuid(),
  title: z15.string(),
  position: z15.number().int().optional(),
  status: LessonStatusSchema,
  colorScheme: LessonColorSchemeSchema.optional().nullable()
});
var SECTION_TITLE_MAX = 100;
var sectionTitleSchema = z15.string().max(SECTION_TITLE_MAX, `Must be ${SECTION_TITLE_MAX} characters or less`).optional().nullable();
var CreateLessonSchema = z15.object({
  title: z15.string().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  shortDescription: z15.string().max(500, "Short description must be 500 characters or less").optional(),
  longDescription: z15.string().max(1e4, "Long description is too long").optional(),
  position: z15.number().int().min(0).optional(),
  colorScheme: LessonColorSchemeSchema.optional(),
  iconScheme: LessonIconSchemeSchema.optional(),
  templateType: LessonTemplateTypeSchema.optional(),
  parentId: z15.string().uuid("Invalid parent lesson ID").optional(),
  categoryId: z15.string().uuid("Invalid category ID").optional().nullable(),
  videoSectionTitle: sectionTitleSchema,
  documentSectionTitle: sectionTitleSchema,
  quizSectionTitle: sectionTitleSchema,
  communityDiscussionTitle: z15.string().max(1e4, "Community discussion title is too long").optional().nullable(),
  additionalResources: z15.string().max(1e4, "Additional resources is too long").optional().nullable(),
  showProgressBar: z15.boolean().optional(),
  // Permission-based access allow-list. Empty = open; non-empty = user must hold
  // at least one of these permission ids (on top of the module's own restriction).
  requiredPermissionIds: z15.array(z15.number().int()).optional()
});
var UpdateLessonSchema = z15.object({
  title: z15.string().min(1, "Title is required").max(255, "Title must be 255 characters or less").optional(),
  shortDescription: z15.string().max(500, "Short description must be 500 characters or less").optional(),
  longDescription: z15.string().max(1e4, "Long description is too long").optional(),
  position: z15.number().int().min(0).optional(),
  status: LessonStatusSchema.optional(),
  colorScheme: LessonColorSchemeSchema.optional(),
  iconScheme: LessonIconSchemeSchema.optional(),
  templateType: LessonTemplateTypeSchema.optional(),
  categoryId: z15.string().uuid("Invalid category ID").optional().nullable(),
  videoSectionTitle: sectionTitleSchema,
  documentSectionTitle: sectionTitleSchema,
  quizSectionTitle: sectionTitleSchema,
  communityDiscussionTitle: z15.string().max(1e4, "Community discussion title is too long").optional().nullable(),
  additionalResources: z15.string().max(1e4, "Additional resources is too long").optional().nullable(),
  showProgressBar: z15.boolean().optional(),
  requiredPermissionIds: z15.array(z15.number().int()).optional()
});
var optionalUrl = z15.string().optional();
var optionalUuid = z15.string().uuid().optional().or(z15.literal("")).transform((val) => val === "" ? void 0 : val);
var CreateContentBlockSchema = z15.object({
  blockType: ContentBlockTypeSchema,
  position: z15.number().int().min(0).optional(),
  // Publish status — defaults to published server-side when omitted.
  status: ContentStatusSchema.optional(),
  title: z15.string().max(255, "Title must be 255 characters or less").optional(),
  body: z15.string().max(5e4, "Body is too long").optional(),
  textBannerUrl: optionalUrl,
  // Vimeo fields
  vimeoId: z15.string().max(50, "Vimeo ID is too long").optional(),
  vimeoDurationSeconds: z15.number().int().min(0).optional(),
  vimeoThumbnailUrl: optionalUrl,
  instructorId: z15.string().max(50, "Instructor ID is too long").nullable().optional().or(z15.literal("")).transform((val) => val === "" ? null : val),
  isPublicViewMarkAndWatched: z15.boolean().optional(),
  contentCategory: ContentBlockContentCategorySchema.nullable().optional(),
  // PDF fields
  pdfUrl: optionalUrl,
  pdfBannerUrl: optionalUrl,
  pdfFilename: z15.string().max(255, "Filename is too long").optional(),
  pdfFileSize: z15.number().int().min(0).optional(),
  pdfPageCount: z15.number().int().min(0).optional(),
  // Quiz
  quizId: optionalUuid,
  // Form
  formId: optionalUuid,
  // Event
  eventId: optionalUuid,
  // Redirect
  redirectUrl: optionalUrl,
  // GCS Upload — config per block for external NestJS GCS uploader
  gcsBaseUrl: optionalUrl,
  gcsApiSecret: z15.string().max(255).optional().nullable(),
  gcsCallbackUrl: optionalUrl,
  gcsDriveId: z15.string().max(255).optional().nullable(),
  gcsAutoTransferToDrive: z15.boolean().optional(),
  gcsSheetUrl: optionalUrl,
  gcsSubfolder: z15.string().max(255).optional().nullable(),
  gcsOrganizeByUser: z15.boolean().optional(),
  gcsSuccessMessage: z15.string().max(500).optional().nullable(),
  resourceType: ContentBlockResourceTypeSchema.nullable().optional(),
  metadata: z15.record(z15.unknown()).optional(),
  requiredPermissionIds: z15.array(z15.number().int()).optional()
});
var UpdateContentBlockSchema = z15.object({
  blockType: ContentBlockTypeSchema.optional(),
  position: z15.number().int().min(0).optional(),
  status: ContentStatusSchema.optional(),
  title: z15.string().max(255, "Title must be 255 characters or less").optional(),
  body: z15.string().max(5e4, "Body is too long").optional(),
  textBannerUrl: optionalUrl,
  // Vimeo fields
  vimeoId: z15.string().max(50, "Vimeo ID is too long").optional(),
  vimeoDurationSeconds: z15.number().int().min(0).optional(),
  vimeoThumbnailUrl: optionalUrl,
  instructorId: z15.string().max(50, "Instructor ID is too long").nullable().optional().or(z15.literal("")).transform((val) => val === "" ? null : val),
  isPublicViewMarkAndWatched: z15.boolean().optional(),
  contentCategory: ContentBlockContentCategorySchema.nullable().optional(),
  // PDF fields
  pdfUrl: optionalUrl,
  pdfBannerUrl: optionalUrl,
  pdfFilename: z15.string().max(255, "Filename is too long").optional(),
  pdfFileSize: z15.number().int().min(0).optional(),
  pdfPageCount: z15.number().int().min(0).optional(),
  // Quiz
  quizId: optionalUuid,
  // Form
  formId: optionalUuid,
  // Event
  eventId: optionalUuid,
  // Redirect
  redirectUrl: optionalUrl,
  // GCS Upload
  gcsBaseUrl: optionalUrl,
  gcsApiSecret: z15.string().max(255).optional().nullable(),
  gcsCallbackUrl: optionalUrl,
  gcsDriveId: z15.string().max(255).optional().nullable(),
  gcsAutoTransferToDrive: z15.boolean().optional(),
  gcsSheetUrl: optionalUrl,
  gcsSubfolder: z15.string().max(255).optional().nullable(),
  gcsOrganizeByUser: z15.boolean().optional(),
  gcsSuccessMessage: z15.string().max(500).optional().nullable(),
  resourceType: ContentBlockResourceTypeSchema.nullable().optional(),
  metadata: z15.record(z15.unknown()).optional(),
  requiredPermissionIds: z15.array(z15.number().int()).optional()
});
var UpdateProgressSchema = z15.object({
  lastBlockId: z15.string().uuid("Invalid block ID").optional(),
  status: LessonProgressStatusSchema.optional(),
  logAction: z15.string().optional(),
  percentWatched: z15.number().min(0).max(100).optional()
});
var LessonBaseSchema = z15.object({
  id: z15.string().uuid(),
  spaceId: z15.string().uuid(),
  parentId: z15.string().uuid().optional().nullable(),
  categoryId: z15.string().uuid().optional().nullable(),
  title: z15.string().max(255),
  shortDescription: z15.string().nullable(),
  longDescription: z15.string().nullable(),
  position: z15.number().int(),
  status: LessonStatusSchema,
  colorScheme: LessonColorSchemeSchema,
  iconScheme: LessonIconSchemeSchema,
  templateType: LessonTemplateTypeSchema,
  videoSectionTitle: z15.string().nullable().optional(),
  documentSectionTitle: z15.string().nullable().optional(),
  quizSectionTitle: z15.string().nullable().optional(),
  communityDiscussionTitle: z15.string().nullable().optional(),
  additionalResources: z15.string().nullable().optional(),
  showProgressBar: z15.boolean(),
  requiredPermissionIds: z15.array(z15.number().int()).default([]),
  createdBy: z15.string().uuid(),
  createdAt: z15.coerce.date(),
  updatedAt: z15.coerce.date(),
  // Computed stats for lesson content
  videoCount: z15.number().int().optional(),
  pdfCount: z15.number().int().optional(),
  hasDownloadableAssets: z15.boolean().optional(),
  // Hierarchy relations (populated when loaded with relations)
  parent: LessonRefSchema.optional().nullable(),
  children: z15.array(LessonRefSchema).optional(),
  subLessonCount: z15.number().int().optional(),
  // Category relation (for sub-lessons)
  category: z15.lazy(() => LessonCategoryBaseSchema).optional().nullable(),
  // Categories relation (for parent lessons - their defined categories)
  categories: z15.lazy(() => z15.array(LessonCategoryBaseSchema)).optional()
});
var ModuleProgressSchema = z15.object({
  totalLessons: z15.number().int(),
  completedLessons: z15.number().int(),
  progressPercent: z15.number().int().min(0).max(100)
});
var ContentBlockBaseSchema = z15.object({
  id: z15.string().uuid(),
  lessonId: z15.string().uuid(),
  blockType: ContentBlockTypeSchema,
  position: z15.number().int(),
  // Publish status — members see published only; reviewers can preview drafts.
  status: ContentStatusSchema,
  title: z15.string().max(255).nullable(),
  body: z15.string().nullable(),
  bodyHtml: z15.string().nullable(),
  textBannerUrl: z15.string().max(500).nullable(),
  // Vimeo fields
  vimeoId: z15.string().max(50).nullable(),
  vimeoDurationSeconds: z15.number().int().nullable(),
  vimeoThumbnailUrl: z15.string().max(500).nullable(),
  instructorId: z15.string().max(50).nullable(),
  isPublicViewMarkAndWatched: z15.boolean().nullable(),
  contentCategory: ContentBlockContentCategorySchema.nullable(),
  // PDF fields
  pdfUrl: z15.string().max(500).nullable(),
  pdfBannerUrl: z15.string().max(500).nullable(),
  pdfFilename: z15.string().max(255).nullable(),
  pdfFileSize: z15.number().int().nullable(),
  pdfPageCount: z15.number().int().nullable(),
  // Quiz
  quizId: z15.string().uuid().nullable(),
  // Form
  formId: z15.string().uuid().nullable(),
  // Event
  eventId: z15.string().uuid().nullable(),
  // Status of the linked form (server-enriched for FORM blocks). Members
  // hide non-published forms; admins surface them to keep editing them.
  formStatus: z15.enum([
    "draft",
    "published",
    "archived"
  ]).optional().nullable(),
  // Redirect
  redirectUrl: z15.string().max(500).nullable(),
  // GCS Upload — admin-configured per-block fields. NOTE: `gcsApiSecret` is
  // returned by the API today (no row-level filtering), so we declare it here
  // for type parity. Strip it server-side before sending to members if/when
  // the field becomes sensitive.
  gcsBaseUrl: z15.string().max(500).nullable().optional(),
  gcsApiSecret: z15.string().max(255).nullable().optional(),
  gcsCallbackUrl: z15.string().max(500).nullable().optional(),
  gcsDriveId: z15.string().max(255).nullable().optional(),
  gcsAutoTransferToDrive: z15.boolean().nullable().optional(),
  gcsSheetUrl: z15.string().max(500).nullable().optional(),
  gcsSubfolder: z15.string().max(255).nullable().optional(),
  gcsOrganizeByUser: z15.boolean().nullable().optional(),
  gcsSuccessMessage: z15.string().max(500).nullable().optional(),
  resourceType: ContentBlockResourceTypeSchema.nullable(),
  metadata: z15.record(z15.unknown()),
  requiredPermissionIds: z15.array(z15.number().int()).default([]),
  createdAt: z15.coerce.date(),
  updatedAt: z15.coerce.date()
});
var LessonProgressBaseSchema = z15.object({
  id: z15.string().uuid(),
  lessonId: z15.string().uuid(),
  userId: z15.string().uuid(),
  status: LessonProgressStatusSchema,
  startedAt: z15.coerce.date().nullable(),
  completedAt: z15.coerce.date().nullable(),
  lastBlockId: z15.string().uuid().nullable(),
  createdAt: z15.coerce.date(),
  updatedAt: z15.coerce.date(),
  // Computed fields for progress percentage
  progressPercent: z15.number().int().min(0).max(100).optional(),
  totalBlocks: z15.number().int().optional(),
  completedBlocks: z15.number().int().optional()
});
var VideoWatchCountsSchema = z15.record(z15.string().uuid(), z15.number().int());
var LessonCategoryBaseSchema = z15.object({
  id: z15.string().uuid(),
  parentLessonId: z15.string().uuid(),
  name: z15.string().min(1).max(100),
  position: z15.number().int(),
  createdAt: z15.coerce.date(),
  updatedAt: z15.coerce.date()
});
var CreateLessonCategorySchema = z15.object({
  name: z15.string().min(1, "Name is required").max(100, "Name must be 100 characters or less"),
  position: z15.number().int().min(0).optional()
});
var UpdateLessonCategorySchema = z15.object({
  name: z15.string().min(1).max(100).optional(),
  position: z15.number().int().min(0).optional()
});
var GcsAllowedMediaType = /* @__PURE__ */ function(GcsAllowedMediaType2) {
  GcsAllowedMediaType2["IMAGE"] = "image";
  GcsAllowedMediaType2["VIDEO"] = "video";
  GcsAllowedMediaType2["AUDIO"] = "audio";
  GcsAllowedMediaType2["PDF"] = "pdf";
  GcsAllowedMediaType2["DOCUMENT"] = "document";
  return GcsAllowedMediaType2;
}({});
var GcsAllowedMediaTypeSchema = z15.nativeEnum(GcsAllowedMediaType);
var GCS_MEDIA_TYPE_PRESETS = {
  image: {
    label: "Images",
    extensions: [
      "jpg",
      "jpeg",
      "png",
      "gif",
      "webp",
      "svg",
      "avif"
    ],
    mimeTypes: [
      "image/*"
    ]
  },
  video: {
    label: "Videos",
    extensions: [
      "mp4",
      "mov",
      "webm",
      "avi",
      "m4v",
      "ogg"
    ],
    mimeTypes: [
      "video/*"
    ]
  },
  audio: {
    label: "Audio",
    extensions: [
      "mp3",
      "wav",
      "m4a",
      "aac",
      "ogg"
    ],
    mimeTypes: [
      "audio/*"
    ]
  },
  pdf: {
    label: "PDFs",
    extensions: [
      "pdf"
    ],
    mimeTypes: [
      "application/pdf"
    ]
  },
  document: {
    label: "Documents",
    extensions: [
      "doc",
      "docx",
      "xls",
      "xlsx",
      "ppt",
      "pptx",
      "txt",
      "csv"
    ],
    mimeTypes: [
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "text/plain",
      "text/csv"
    ]
  }
};
var GCS_ALLOWED_MEDIA_TYPE_KEYS = new Set(Object.values(GcsAllowedMediaType));
var parseAllowedMediaTypes = /* @__PURE__ */ __name((metadata) => {
  if (!metadata || typeof metadata !== "object") {
    return [];
  }
  const raw = metadata["allowedMediaTypes"];
  if (!Array.isArray(raw)) {
    return [];
  }
  return raw.filter((v) => typeof v === "string" && GCS_ALLOWED_MEDIA_TYPE_KEYS.has(v));
}, "parseAllowedMediaTypes");
var parseGcsFilenamePrefix = /* @__PURE__ */ __name((metadata) => {
  if (!metadata || typeof metadata !== "object") {
    return "";
  }
  const raw = metadata["filenamePrefix"];
  return typeof raw === "string" ? raw.trim() : "";
}, "parseGcsFilenamePrefix");
var isGcsFileAllowed = /* @__PURE__ */ __name((allowed, mimeType, extension) => {
  if (allowed.length === 0) {
    return true;
  }
  const ext = extension.replace(/^\./, "").toLowerCase();
  const mime = (mimeType || "").toLowerCase();
  return allowed.some((key) => {
    const preset = GCS_MEDIA_TYPE_PRESETS[key];
    if (preset.extensions.includes(ext)) {
      return true;
    }
    return preset.mimeTypes.some((m) => m.endsWith("/*") ? mime.startsWith(m.slice(0, -1)) : mime === m);
  });
}, "isGcsFileAllowed");
var GcsUploadStatus = /* @__PURE__ */ function(GcsUploadStatus2) {
  GcsUploadStatus2["PROCESSING"] = "processing";
  GcsUploadStatus2["UPLOADED_IN_BUCKET"] = "uploaded_in_bucket";
  GcsUploadStatus2["UPLOADED_IN_DRIVE"] = "uploaded_in_drive";
  GcsUploadStatus2["FAILED"] = "failed";
  return GcsUploadStatus2;
}({});
var GcsUploadStatusSchema = z15.nativeEnum(GcsUploadStatus);
var GcsUploadRowSchema = z15.object({
  id: z15.string().uuid(),
  blockId: z15.string().uuid(),
  lessonId: z15.string().uuid(),
  userId: z15.string(),
  fileKey: z15.string(),
  fileName: z15.string(),
  fileSize: z15.string().nullable(),
  status: GcsUploadStatusSchema,
  driveLink: z15.string().nullable(),
  createdAt: z15.coerce.date(),
  updatedAt: z15.coerce.date()
});
var StartGcsUploadSchema = z15.object({
  fileExtension: z15.string().min(1).max(20),
  contentType: z15.string().min(1).max(100),
  fileSize: z15.number().int().min(1)
});
var StartGcsUploadResultSchema = z15.object({
  uploadId: z15.string().uuid(),
  uploadUrl: z15.string(),
  fileKey: z15.string(),
  fileName: z15.string()
});
var GcsUploadReportRowSchema = z15.object({
  userId: z15.string(),
  email: z15.string(),
  file_name: z15.string(),
  user_firstname: z15.string(),
  user_lastname: z15.string(),
  display_name: z15.string(),
  event_id: z15.string(),
  google_drive_link: z15.string(),
  location: z15.string(),
  occupation: z15.string(),
  file_size: z15.string(),
  uploaded_at: z15.string()
});

// src/community-hub/engagement.ts
import { z as z16 } from "zod";
var EngagementEntityTypeValues = [
  "post",
  "comment",
  "space",
  "lesson",
  "content_block",
  "form"
];
var EngagementEntityTypeEnumObj = z16.enum(EngagementEntityTypeValues);
var EEngagementEntityType = EngagementEntityTypeEnumObj.enum;
var EngagementGroupTreatmentValues = [
  "exclude",
  "highlight"
];
var EngagementGroupTreatmentEnumObj = z16.enum(EngagementGroupTreatmentValues);
var SpaceReportingGroupTreatmentSchema = z16.object({
  userGroupId: z16.number().int(),
  treatment: EngagementGroupTreatmentEnumObj,
  /** Hex color for the `highlight` treatment (e.g. `#f8ae00`); ignored for `exclude`. */
  color: z16.string().optional().nullable()
});
var SpaceReportingConfigSchema = z16.object({
  groupTreatments: z16.array(SpaceReportingGroupTreatmentSchema).default([])
});
var EngagementReportingGroupSchema = z16.object({
  userGroupId: z16.number().int(),
  name: z16.string(),
  treatment: EngagementGroupTreatmentEnumObj,
  color: z16.string().nullable(),
  memberCount: z16.number().int().nonnegative()
});
var EngagementRowTagSchema = z16.object({
  userGroupId: z16.number().int(),
  name: z16.string(),
  color: z16.string().nullable(),
  treatment: EngagementGroupTreatmentEnumObj
});
var EngagementLogItemSchema = z16.object({
  id: z16.string(),
  userId: z16.string(),
  /** Resolved display name for the user; falls back to the raw id when unknown. */
  userName: z16.string(),
  userAvatar: z16.string().nullable(),
  action: z16.string(),
  entityType: z16.string(),
  entityId: z16.string(),
  spaceId: z16.string().nullable(),
  /** Resolved sub-space name the event happened in (best-effort). */
  spaceName: z16.string().nullable(),
  /**
  * Resolved lesson (subsection) the event belongs to — the lesson itself for a
  * lesson event, or the parent lesson for a content-block event. Null for events
  * that aren't inside a lesson (posts, comments, sub-space views).
  */
  lessonName: z16.string().nullable(),
  /** Primary content label (entity title; for a comment, the post context). */
  title: z16.string().nullable(),
  /** Secondary line, shown beneath the title (for a comment, the comment text). */
  subtitle: z16.string().nullable(),
  /** Relative members-fe deep link (canonical nested path), or null if not linkable. */
  linkPath: z16.string().nullable(),
  createdAt: z16.string(),
  /** Reporting marker for the acting user (highlight group, or an excluded group shown via the QA toggle). Null otherwise. */
  reportingTag: EngagementRowTagSchema.nullable()
});
var EngagementLogsResponseSchema = z16.object({
  items: z16.array(EngagementLogItemSchema),
  meta: MetaSchema
});
var EngagementLogsQuerySchema = z16.object({
  page: z16.coerce.number().int().positive().default(1),
  perPage: z16.coerce.number().int().positive().max(200).default(50),
  userId: z16.string().optional(),
  // action / entityType are free strings: the `ch_activity_log` table carries
  // values outside the static enums (e.g. ZOOM_JOIN, legacy `content-block`).
  // The UI builds its filter options from the live summary breakdown instead.
  action: z16.string().optional(),
  entityType: z16.string().optional(),
  /** Narrow to a single sub-space (module/feed/content). */
  subSpaceId: z16.string().uuid().optional(),
  /** Narrow to a single lesson — matches the lesson event + activity on its blocks. */
  lessonId: z16.string().uuid().optional(),
  /** ISO date-time; inclusive lower bound. */
  from: z16.string().optional(),
  /** ISO date-time; exclusive upper bound. */
  to: z16.string().optional(),
  /** QA bypass: when true, `exclude`-treatment groups are NOT filtered out (see the space's reporting config). */
  includeExcluded: z16.coerce.boolean().optional()
});
var EngagementSummaryQuerySchema = z16.object({
  from: z16.string().optional(),
  to: z16.string().optional(),
  /** QA bypass: when true, `exclude`-treatment groups are NOT filtered out (see the space's reporting config). */
  includeExcluded: z16.coerce.boolean().optional()
});
var EngagementCountSchema = z16.object({
  key: z16.string(),
  count: z16.number().int().nonnegative()
});
var EngagementSubSpaceSchema = z16.object({
  id: z16.string(),
  name: z16.string(),
  spaceType: z16.string()
});
var EngagementLessonSchema = z16.object({
  id: z16.string(),
  name: z16.string(),
  /** The sub-space (module) the lesson belongs to, so the filter can cascade. */
  spaceId: z16.string().nullable()
});
var EngagementUserSchema = z16.object({
  id: z16.string(),
  name: z16.string(),
  email: z16.string().nullable(),
  avatar: z16.string().nullable()
});
var EngagementUsersQuerySchema = z16.object({
  search: z16.string().optional(),
  limit: z16.coerce.number().int().positive().max(100).default(50)
});
var EngagementSummaryResponseSchema = z16.object({
  totalEvents: z16.number().int().nonnegative(),
  activeUsers: z16.number().int().nonnegative(),
  breakdownByAction: z16.array(EngagementCountSchema),
  breakdownByEntityType: z16.array(EngagementCountSchema),
  subSpaces: z16.array(EngagementSubSpaceSchema),
  lessons: z16.array(EngagementLessonSchema),
  /** The space's configured reporting treatments (resolved names + counts) — powers the legend / config UI. */
  reportingGroups: z16.array(EngagementReportingGroupSchema)
});
var EngagementMembersSortValues = [
  "name",
  "events",
  "lastActive"
];
var EngagementMembersSortEnumObj = z16.enum(EngagementMembersSortValues);
var EngagementMembersQuerySchema = z16.object({
  page: z16.coerce.number().int().positive().default(1),
  perPage: z16.coerce.number().int().positive().max(200).default(50),
  from: z16.string().optional(),
  to: z16.string().optional(),
  /** When true, return only members with no activity in the time frame. */
  inactiveOnly: z16.coerce.boolean().optional(),
  /** When true, return only members with activity in the time frame. */
  activeOnly: z16.coerce.boolean().optional(),
  /** Case-insensitive search over member name and email. */
  search: z16.string().optional(),
  /** Column to sort by; omitted keeps the default "least active first" order. */
  sortBy: EngagementMembersSortEnumObj.optional(),
  sortOrder: z16.enum([
    "asc",
    "desc"
  ]).optional(),
  /** QA bypass: when true, `exclude`-treatment groups are NOT filtered out (see the space's reporting config). */
  includeExcluded: z16.coerce.boolean().optional()
});
var EngagementMemberSchema = z16.object({
  /** Supabase auth UUID (matches ch_activity_log.user_id). */
  id: z16.string(),
  name: z16.string(),
  email: z16.string().nullable(),
  avatar: z16.string().nullable(),
  /** The member's role in the space's app (user_access.role). Null when unset. */
  role: z16.string().nullable(),
  eventCount: z16.number().int().nonnegative(),
  lastActiveAt: z16.string().nullable(),
  /** Reporting marker for this member (highlight group, or an excluded group shown via the QA toggle). Null otherwise. */
  reportingTag: EngagementRowTagSchema.nullable()
});
var EngagementMembersResponseSchema = z16.object({
  items: z16.array(EngagementMemberSchema),
  meta: MetaSchema,
  totalMembers: z16.number().int().nonnegative(),
  activeMembers: z16.number().int().nonnegative(),
  inactiveMembers: z16.number().int().nonnegative()
});
var EngagementTimelineGranularityValues = [
  "day",
  "week",
  "month"
];
var EngagementTimelineGranularityEnumObj = z16.enum(EngagementTimelineGranularityValues);
var EngagementTimelineMetricValues = [
  "users",
  "events"
];
var EngagementTimelineMetricEnumObj = z16.enum(EngagementTimelineMetricValues);
var EngagementTimelineQuerySchema = z16.object({
  from: z16.string().optional(),
  to: z16.string().optional(),
  granularity: EngagementTimelineGranularityEnumObj.default("day"),
  metric: EngagementTimelineMetricEnumObj.default("users"),
  /** Optional event / entity-type narrowing (same values as the activity feed). */
  action: z16.string().optional(),
  entityType: z16.string().optional(),
  /** QA bypass: when true, `exclude`-treatment groups are NOT filtered out (see the space's reporting config). */
  includeExcluded: z16.coerce.boolean().optional()
});
var EngagementTimelineSeriesSchema = z16.object({
  id: z16.string(),
  name: z16.string(),
  data: z16.array(z16.number())
});
var EngagementTimelineResponseSchema = z16.object({
  granularity: EngagementTimelineGranularityEnumObj,
  metric: EngagementTimelineMetricEnumObj,
  /** ISO bucket start dates, ascending — the chart's x-axis. */
  buckets: z16.array(z16.string()),
  series: z16.array(EngagementTimelineSeriesSchema)
});
var EngagementTopContentQuerySchema = z16.object({
  from: z16.string().optional(),
  to: z16.string().optional(),
  action: z16.string().optional(),
  entityType: z16.string().optional(),
  sortBy: z16.enum([
    "events",
    "users"
  ]).default("events"),
  limit: z16.coerce.number().int().positive().max(50).default(10),
  /** QA bypass: when true, `exclude`-treatment groups are NOT filtered out (see the space's reporting config). */
  includeExcluded: z16.coerce.boolean().optional()
});
var EngagementTopContentItemSchema = z16.object({
  entityId: z16.string(),
  entityType: z16.string(),
  title: z16.string().nullable(),
  spaceName: z16.string().nullable(),
  lessonName: z16.string().nullable(),
  /** Total events (plays / opens) on this content. */
  events: z16.number().int().nonnegative(),
  /** Distinct users who engaged with this content. */
  users: z16.number().int().nonnegative()
});
var EngagementTopContentResponseSchema = z16.object({
  items: z16.array(EngagementTopContentItemSchema)
});

// src/community-hub/event.ts
import { z as z17 } from "zod";
var EventType = /* @__PURE__ */ function(EventType2) {
  EventType2["ZOOM"] = "zoom";
  return EventType2;
}({});
var EventTypeSchema = z17.nativeEnum(EventType);
var EventStatus = /* @__PURE__ */ function(EventStatus2) {
  EventStatus2["SCHEDULED"] = "scheduled";
  EventStatus2["LIVE"] = "live";
  EventStatus2["ENDED"] = "ended";
  EventStatus2["CANCELLED"] = "cancelled";
  return EventStatus2;
}({});
var EventStatusSchema = z17.nativeEnum(EventStatus);
var EventBaseSchema = z17.object({
  id: z17.string().uuid(),
  spaceId: z17.string().uuid().nullable(),
  eventType: EventTypeSchema,
  title: z17.string(),
  description: z17.string().nullable(),
  startTime: z17.string().datetime(),
  durationMinutes: z17.number().int(),
  status: EventStatusSchema,
  createdBy: z17.string(),
  zoomMeetingId: z17.string().nullable(),
  zoomMeetingUuid: z17.string().nullable(),
  hostEmail: z17.string().nullable(),
  password: z17.string().nullable(),
  joinUrl: z17.string().nullable(),
  settings: z17.record(z17.unknown()),
  createdAt: z17.string().datetime(),
  updatedAt: z17.string().datetime()
});
var CreateZoomEventSchema = z17.object({
  contentBlockId: z17.string().uuid().optional(),
  spaceId: z17.string().uuid().optional(),
  title: z17.string().min(1).max(200),
  hostEmail: z17.string().email(),
  startTime: z17.string().datetime(),
  durationMinutes: z17.number().int().min(15).max(480),
  enableWaitingRoom: z17.boolean().default(true),
  enableRecording: z17.boolean().default(false)
});
var UpdateZoomEventSchema = CreateZoomEventSchema.omit({
  contentBlockId: true
}).partial();
var ZoomSignatureResponseSchema = z17.object({
  signature: z17.string(),
  sdkKey: z17.string(),
  meetingNumber: z17.string(),
  password: z17.string().nullable(),
  title: z17.string(),
  startTime: z17.string().datetime(),
  status: EventStatusSchema,
  customerKey: z17.string()
});
var EventAttendanceBaseSchema = z17.object({
  id: z17.string().uuid(),
  eventId: z17.string().uuid(),
  userId: z17.string(),
  joinedAt: z17.string().datetime(),
  leftAt: z17.string().datetime().nullable(),
  durationSeconds: z17.number().int().nullable(),
  source: z17.enum([
    "sdk",
    "webhook"
  ]),
  createdAt: z17.string().datetime(),
  updatedAt: z17.string().datetime()
});
var RecordEventLeaveSchema = z17.object({
  durationSeconds: z17.number().int().min(0).optional()
});

// src/community-hub/feed.ts
import { z as z19 } from "zod";

// src/community-hub/tags.ts
import { z as z18 } from "zod";
var CommunityTagType = /* @__PURE__ */ function(CommunityTagType2) {
  CommunityTagType2["QUESTION"] = "question";
  CommunityTagType2["SUBSPACE"] = "subspace";
  CommunityTagType2["LESSON"] = "lesson";
  return CommunityTagType2;
}({});
var CommunityTagTypeSchema = z18.nativeEnum(CommunityTagType);
var AvailableTagSchema = z18.object({
  type: CommunityTagTypeSchema,
  value: z18.string().uuid(),
  label: z18.string(),
  category: z18.string().nullable().optional()
});
var PostTagInputSchema = z18.object({
  type: CommunityTagTypeSchema,
  value: z18.string().uuid()
});
var TagRefSchema = z18.object({
  id: z18.string().uuid(),
  type: CommunityTagTypeSchema,
  label: z18.string(),
  refId: z18.string().uuid().nullable()
});
var CommunityTagAdminRowSchema = z18.object({
  id: z18.string().uuid(),
  type: CommunityTagTypeSchema,
  label: z18.string(),
  slug: z18.string().nullable(),
  refId: z18.string().uuid().nullable(),
  category: z18.string().nullable(),
  position: z18.number().int(),
  isActive: z18.boolean(),
  // Owning spaces for grouping/scoping. A `question` tag can belong to several
  // spaces at once; an empty array = global (offered in every space).
  // `subspace` / `lesson` tags resolve to their single source container.
  // `parentSpaceNames` are the live-resolved display names, aligned by index.
  parentSpaceIds: z18.array(z18.string().uuid()),
  parentSpaceNames: z18.array(z18.string()),
  createdAt: z18.string(),
  updatedAt: z18.string()
});
var CreateCommunityTagSchema = z18.object({
  label: z18.string().trim().min(1, "Label is required").max(150),
  category: z18.string().trim().max(60).nullable().optional(),
  position: z18.number().int().min(0).optional(),
  // Spaces this tag belongs to. Empty / omitted = a global tag offered in every
  // space. The bulk-add dialog applies the same target spaces to the whole batch.
  parentSpaceIds: z18.array(z18.string().uuid()).optional()
});
var BulkCreateCommunityTagsSchema = z18.object({
  tags: z18.array(CreateCommunityTagSchema).min(1, "Add at least one tag").max(50)
});
var UpdateCommunityTagSchema = z18.object({
  label: z18.string().trim().min(1).max(150).optional(),
  category: z18.string().trim().max(60).nullable().optional(),
  position: z18.number().int().min(0).optional(),
  isActive: z18.boolean().optional(),
  // Replace the spaces a question tag belongs to. Empty array = make it global.
  parentSpaceIds: z18.array(z18.string().uuid()).optional()
}).refine((data) => Object.keys(data).length > 0, {
  message: "Nothing to update"
});
var BulkUpdateCommunityTagsSchema = z18.object({
  ids: z18.array(z18.string().uuid()).min(1, "Select at least one tag").max(200),
  patch: z18.object({
    category: z18.string().trim().max(60).nullable().optional(),
    isActive: z18.boolean().optional(),
    parentSpaceIds: z18.array(z18.string().uuid()).optional()
  }).refine((data) => Object.keys(data).length > 0, {
    message: "Nothing to update"
  })
});
var ListCommunityTagsQuerySchema = z18.object({
  search: z18.string().trim().optional(),
  type: CommunityTagTypeSchema.optional(),
  status: z18.enum([
    "active",
    "inactive"
  ]).optional(),
  // Filter by owning space. A space uuid narrows to that space's tags; the
  // literal 'global' narrows to space-less (global) tags.
  spaceId: z18.union([
    z18.string().uuid(),
    z18.literal("global")
  ]).optional()
});

// src/community-hub/feed.ts
var POST_TYPE = {
  ANNOUNCEMENT: "announcement",
  QUESTION: "question",
  INTRODUCTION: "introduction",
  MILESTONE: "milestone",
  DISCUSSION: "discussion"
};
var PostTypeSchema = z19.nativeEnum(POST_TYPE);
var POST_TYPE_DEFINITIONS = [
  {
    value: POST_TYPE.ANNOUNCEMENT,
    label: "Announcement",
    icon: "\u{1F4E3}",
    adminOnly: true,
    description: "Zoom links, upcoming calls, schedule updates"
  },
  {
    value: POST_TYPE.QUESTION,
    label: "Question",
    icon: "\u2753",
    adminOnly: false,
    description: "Asking for help with teaching, business, or tech"
  },
  {
    value: POST_TYPE.INTRODUCTION,
    label: "Introduction",
    icon: "\u{1F44B}",
    adminOnly: false,
    description: "New member intro \u2014 who you are, background, location"
  },
  {
    value: POST_TYPE.MILESTONE,
    label: "Milestone",
    icon: "\u{1F389}",
    adminOnly: false,
    description: "Sharing a success, certification progress, or client breakthrough"
  },
  {
    value: POST_TYPE.DISCUSSION,
    label: "Discussion",
    icon: "\u{1F4AC}",
    adminOnly: true,
    description: "Open-ended conversation starter, general topic"
  }
];
var ADMIN_ONLY_POST_TYPES = POST_TYPE_DEFINITIONS.filter((d) => d.adminOnly).map((d) => d.value);
var PostTypeDefinitionSchema = z19.object({
  value: PostTypeSchema,
  label: z19.string(),
  icon: z19.string(),
  adminOnly: z19.boolean(),
  description: z19.string()
});
var POST_SORT = {
  RECENT_ACTIVITY: "recent_activity",
  NEWEST: "newest",
  MOST_DISCUSSED: "most_discussed"
};
var PostSortSchema = z19.nativeEnum(POST_SORT);
var POST_SORT_DEFINITIONS = [
  {
    value: POST_SORT.RECENT_ACTIVITY,
    label: "Most recent activity"
  },
  {
    value: POST_SORT.NEWEST,
    label: "Newest first"
  }
];
var PostStatus = /* @__PURE__ */ function(PostStatus2) {
  PostStatus2["PUBLISHED"] = "published";
  PostStatus2["DRAFT"] = "draft";
  PostStatus2["SCHEDULED"] = "scheduled";
  PostStatus2["PROCESSING_MEDIA"] = "processing_media";
  PostStatus2["ARCHIVED"] = "archived";
  PostStatus2["REMOVED"] = "removed";
  return PostStatus2;
}({});
var PostStatusSchema = z19.nativeEnum(PostStatus);
var CommentStatus = /* @__PURE__ */ function(CommentStatus2) {
  CommentStatus2["PUBLISHED"] = "published";
  CommentStatus2["REMOVED"] = "removed";
  return CommentStatus2;
}({});
var CommentStatusSchema = z19.nativeEnum(CommentStatus);
var ReactionTargetType = /* @__PURE__ */ function(ReactionTargetType2) {
  ReactionTargetType2["POST"] = "post";
  ReactionTargetType2["COMMENT"] = "comment";
  return ReactionTargetType2;
}({});
var ReactionTargetTypeSchema = z19.nativeEnum(ReactionTargetType);
var REACTION_EMOJIS = {
  like: "\u{1F44D}",
  love: "\u2764\uFE0F",
  haha: "\u{1F602}",
  wow: "\u{1F62E}",
  sad: "\u{1F622}",
  angry: "\u{1F620}"
};
var ATTACHMENT_TYPES = [
  "image",
  "video",
  "file"
];
var AttachmentSchema = z19.object({
  url: z19.string().url(),
  type: z19.enum(ATTACHMENT_TYPES),
  width: z19.number().optional(),
  height: z19.number().optional(),
  name: z19.string().optional(),
  mimeType: z19.string().optional(),
  size: z19.number().optional(),
  /**
  * Backing `media_files` row, set for uploads that may be compressed
  * asynchronously (video / PDF). When present, readers resolve the served
  * URL from that row (`compressed` if ready, else `original`) instead of
  * trusting `url` — attachments are denormalized into post/comment JSONB,
  * so rewriting `url` in place after a transcode is not viable.
  */
  mediaId: z19.string().uuid().optional(),
  /**
  * Video poster frame, filled in at read time from the backing media row once
  * the transcoder has extracted one. Never persisted in the post JSONB.
  */
  posterUrl: z19.string().optional(),
  /**
  * Compression state of the backing media, resolved at read time (never
  * stored). Only ever set on a held post shown to its own author, so the UI
  * can badge each attachment as still processing or failed. `undefined` once
  * the media is active (the normal case).
  */
  processingStatus: z19.enum([
    "processing",
    "failed"
  ]).optional()
});
var CommentAttachmentSchema = AttachmentSchema;
var PostAttachmentSchema = AttachmentSchema;
var isPdfAttachment = /* @__PURE__ */ __name((attachment) => {
  var _a5, _b, _c;
  return ((_a5 = attachment.mimeType) == null ? void 0 : _a5.toLowerCase()) === "application/pdf" || ((_c = (_b = attachment.name) == null ? void 0 : _b.toLowerCase().endsWith(".pdf")) != null ? _c : false);
}, "isPdfAttachment");
var findRejectedAttachment = /* @__PURE__ */ __name((attachments, allowVideo) => {
  var _a5, _b;
  for (const attachment of attachments != null ? attachments : []) {
    const mime = (_b = (_a5 = attachment.mimeType) == null ? void 0 : _a5.toLowerCase()) != null ? _b : "";
    const isVideo = attachment.type === "video" || mime.startsWith("video/");
    if (isVideo) {
      if (!allowVideo) {
        return {
          attachment,
          reason: "video_not_allowed"
        };
      }
      continue;
    }
    const isImage = attachment.type === "image" || mime.startsWith("image/");
    if (isImage || isPdfAttachment(attachment)) {
      continue;
    }
    return {
      attachment,
      reason: "unsupported_type"
    };
  }
  return null;
}, "findRejectedAttachment");
var POLL_MIN_OPTIONS = 2;
var POLL_MAX_OPTIONS = 10;
var CreatePollOptionSchema = z19.object({
  text: z19.string().min(1, "Option cannot be empty").max(200, "Option must be 200 characters or less")
});
var CreatePollSchema = z19.object({
  options: z19.array(CreatePollOptionSchema).min(POLL_MIN_OPTIONS, `Add at least ${POLL_MIN_OPTIONS} options`).max(POLL_MAX_OPTIONS, `A poll can have at most ${POLL_MAX_OPTIONS} options`),
  allowMultiple: z19.boolean().optional().default(false),
  closesAt: z19.coerce.date().optional()
});
var PollOptionSchema = z19.object({
  id: z19.string().uuid(),
  text: z19.string(),
  position: z19.number().int(),
  voteCount: z19.number().int()
});
var PollSchema = z19.object({
  id: z19.string().uuid(),
  postId: z19.string().uuid(),
  allowMultiple: z19.boolean(),
  closesAt: z19.coerce.date().nullable(),
  totalVotes: z19.number().int(),
  options: z19.array(PollOptionSchema),
  // Option IDs the current user has voted for (empty if not voted / anonymous).
  userVotedOptionIds: z19.array(z19.string().uuid()),
  createdAt: z19.coerce.date()
});
var VotePollSchema = z19.object({
  optionIds: z19.array(z19.string().uuid()).min(1, "Select at least one option")
});
var CreatePostSchema = z19.object({
  title: z19.string().max(300, "Title must be 300 characters or less").optional(),
  body: z19.string().max(5e4, "Post body is too long"),
  postType: PostTypeSchema,
  attachments: z19.array(PostAttachmentSchema).max(10).optional(),
  tags: z19.array(PostTagInputSchema).max(20).optional(),
  // When set to a future instant, the post is created as SCHEDULED and only
  // appears in the feed once due. Admin-only (enforced server-side).
  scheduledAt: z19.coerce.date().optional(),
  // Pin the post to the top of the feed on creation. Admin-only (enforced
  // server-side); ignored for non-admins.
  isPinned: z19.boolean().optional(),
  // Optional attached poll.
  poll: CreatePollSchema.optional()
}).refine((data) => data.body.trim().length > 0 || data.attachments && data.attachments.length > 0 || !!data.poll, {
  message: "Post must have text, an attachment, or a poll",
  path: [
    "body"
  ]
});
var UpdatePostSchema = z19.object({
  title: z19.string().max(300, "Title must be 300 characters or less").optional(),
  body: z19.string().min(1, "Post body is required").max(5e4, "Post body is too long").optional(),
  postType: PostTypeSchema.optional(),
  status: PostStatusSchema.optional(),
  isPinned: z19.boolean().optional(),
  // When provided, replaces the post's tags. An empty array clears all tags.
  tags: z19.array(PostTagInputSchema).max(20).optional(),
  // Reschedule (future instant) or clear scheduling (null → publish now).
  scheduledAt: z19.coerce.date().nullable().optional(),
  // Replace the post's attachments wholesale. Omit to leave unchanged; pass an
  // empty array to clear all attachments.
  attachments: z19.array(PostAttachmentSchema).max(10).optional(),
  // Reschedule the attached poll's close time. Omit to leave unchanged; pass a
  // date to (re)set the close time, or null to make the poll open-ended.
  // Ignored when the post has no poll.
  pollClosesAt: z19.coerce.date().nullable().optional(),
  // Create, replace, or remove the attached poll. Omit to leave the poll
  // unchanged; pass a poll to create it (or replace an existing one — changing
  // the option set resets existing votes); pass null to remove the poll.
  // Takes precedence over `pollClosesAt` when both are provided.
  poll: CreatePollSchema.nullable().optional()
});
var CreateCommentSchema = z19.object({
  body: z19.string().max(1e4, "Comment body is too long"),
  parentId: z19.string().uuid("Invalid parent comment ID").optional(),
  attachments: z19.array(CommentAttachmentSchema).max(4).optional()
}).refine((data) => data.body.trim().length > 0 || data.attachments && data.attachments.length > 0, {
  message: "Comment must have text or at least one image",
  path: [
    "body"
  ]
});
var UpdateCommentSchema = z19.object({
  body: z19.string().min(1, "Comment body is required").max(1e4, "Comment body is too long").optional(),
  status: CommentStatusSchema.optional()
});
var ToggleReactionSchema = z19.object({
  targetType: ReactionTargetTypeSchema,
  targetId: z19.string().uuid("Invalid target ID"),
  emoji: z19.string().min(1).max(50, "Emoji must be 50 characters or less")
});
var PostTypesCsvSchema = z19.union([
  z19.string(),
  z19.array(z19.string())
]).transform((val) => {
  const values = Array.isArray(val) ? val : val.split(",");
  const validTypes = Object.values(POST_TYPE);
  return values.map((v) => v.trim()).filter((v) => validTypes.includes(v));
});
var TagsCsvSchema = z19.union([
  z19.string(),
  z19.array(z19.string())
]).transform((val) => {
  const values = Array.isArray(val) ? val : val.split(",");
  return values.map((v) => v.trim()).filter((v) => z19.string().uuid().safeParse(v).success);
});
var BooleanParamSchema = z19.union([
  z19.boolean(),
  z19.string()
]).transform((v) => v === true || v === "true");
var GetSpacePostsQuerySchema = z19.object({
  limit: z19.coerce.number().int().min(1).max(50).default(20),
  offset: z19.coerce.number().int().min(0).default(0),
  search: z19.string().trim().max(200).optional(),
  postTypes: PostTypesCsvSchema.optional(),
  dateFrom: z19.string().date().optional(),
  dateTo: z19.string().date().optional(),
  /** Mention user id (from GET /mention/users) — resolved to authorId server-side */
  authorId: z19.string().optional(),
  /** Available-tag values (question tag id or subspace/lesson source id) — posts matching ANY resolve */
  tags: TagsCsvSchema.optional(),
  /** Only posts the current user has saved (bookmarked) */
  saved: BooleanParamSchema.optional(),
  /** Only the current user's own posts */
  mine: BooleanParamSchema.optional(),
  sort: PostSortSchema.default(POST_SORT.RECENT_ACTIVITY)
});
var AdminListPostsQuerySchema = z19.object({
  limit: z19.coerce.number().int().min(1).max(100).default(20),
  offset: z19.coerce.number().int().min(0).default(0),
  search: z19.string().trim().max(200).optional(),
  postTypes: PostTypesCsvSchema.optional(),
  dateFrom: z19.string().date().optional(),
  dateTo: z19.string().date().optional(),
  /** Mention user id (from GET /mention/users) — resolved to authorId server-side */
  authorId: z19.string().optional(),
  /** Available-tag values (question tag id or subspace/lesson source id) — posts matching ANY resolve */
  tags: TagsCsvSchema.optional(),
  sort: PostSortSchema.default(POST_SORT.NEWEST)
});
var BULK_POST_TAGS_MODE = {
  ADD: "add",
  REMOVE: "remove",
  REPLACE: "replace"
};
var BulkPostTagsModeSchema = z19.nativeEnum(BULK_POST_TAGS_MODE);
var BulkUpdatePostsSchema = z19.object({
  ids: z19.array(z19.string().uuid()).min(1, "Select at least one post").max(200),
  postType: PostTypeSchema.optional(),
  tagsMode: BulkPostTagsModeSchema.optional(),
  tags: z19.array(PostTagInputSchema).max(20).optional()
}).refine((data) => data.postType !== void 0 || data.tagsMode !== void 0, {
  message: "Choose a post type or a tag change to apply",
  path: [
    "postType"
  ]
}).refine((data) => {
  var _a5, _b;
  return data.tagsMode === void 0 || data.tagsMode === BULK_POST_TAGS_MODE.REPLACE || ((_b = (_a5 = data.tags) == null ? void 0 : _a5.length) != null ? _b : 0) > 0;
}, {
  message: "Select at least one tag to add or remove",
  path: [
    "tags"
  ]
});
var BulkUpdatePostsResultSchema = z19.object({
  updated: z19.number().int()
});
var PostBaseSchema = z19.object({
  id: z19.string().uuid(),
  spaceId: z19.string().uuid(),
  authorId: z19.string().uuid(),
  title: z19.string().max(300).nullable(),
  body: z19.string(),
  bodyHtml: z19.string().nullable(),
  postType: PostTypeSchema.nullable(),
  status: PostStatusSchema,
  isPinned: z19.boolean(),
  likeCount: z19.number().int(),
  commentCount: z19.number().int(),
  attachments: z19.array(PostAttachmentSchema).nullable(),
  tags: z19.array(z19.string().uuid()),
  lastActivityAt: z19.coerce.date(),
  scheduledAt: z19.coerce.date().nullable(),
  poll: PollSchema.nullable().optional(),
  createdAt: z19.coerce.date(),
  updatedAt: z19.coerce.date()
});
var CommentBaseSchema = z19.object({
  id: z19.string().uuid(),
  postId: z19.string().uuid(),
  authorId: z19.string().uuid(),
  parentId: z19.string().uuid().nullable(),
  body: z19.string(),
  bodyHtml: z19.string().nullable(),
  status: CommentStatusSchema,
  likeCount: z19.number().int(),
  attachments: z19.array(CommentAttachmentSchema).nullable(),
  createdAt: z19.coerce.date(),
  updatedAt: z19.coerce.date()
});
var ReactionBaseSchema = z19.object({
  id: z19.string().uuid(),
  userId: z19.string().uuid(),
  targetType: ReactionTargetTypeSchema,
  targetId: z19.string().uuid(),
  emoji: z19.string().max(50),
  createdAt: z19.coerce.date()
});
var AuthorInfoSchema = z19.object({
  id: z19.string(),
  name: z19.string(),
  avatar: z19.string().nullable()
});
var PollOptionVotersSchema = z19.object({
  optionId: z19.string().uuid(),
  voters: z19.array(AuthorInfoSchema)
});
var PollVotersSchema = z19.object({
  pollId: z19.string().uuid(),
  options: z19.array(PollOptionVotersSchema)
});
var PostWithAuthorSchema = PostBaseSchema.extend({
  author: AuthorInfoSchema,
  userReaction: z19.string().nullable().optional(),
  isSaved: z19.boolean().optional(),
  tags: z19.array(TagRefSchema)
});
var CommentWithAuthorBaseSchema = CommentBaseSchema.extend({
  author: AuthorInfoSchema,
  replyCount: z19.number().int().optional(),
  userReaction: z19.string().nullable().optional()
});
var CommentWithAuthorSchema = CommentWithAuthorBaseSchema.extend({
  replies: z19.array(CommentWithAuthorBaseSchema).optional()
});

// src/community-hub/form.ts
import { z as z22 } from "zod";

// src/community-hub/form-profile-mapping.ts
import { z as z21 } from "zod";

// src/community-hub/quiz.ts
import { z as z20 } from "zod";
var QuizStatus = /* @__PURE__ */ function(QuizStatus2) {
  QuizStatus2["DRAFT"] = "draft";
  QuizStatus2["PUBLISHED"] = "published";
  QuizStatus2["ARCHIVED"] = "archived";
  return QuizStatus2;
}({});
var QuizStatusSchema = z20.nativeEnum(QuizStatus);
var QuestionType = /* @__PURE__ */ function(QuestionType2) {
  QuestionType2["MULTIPLE_CHOICE"] = "multiple_choice";
  QuestionType2["MULTIPLE_SELECT"] = "multiple_select";
  QuestionType2["TRUE_FALSE"] = "true_false";
  QuestionType2["SHORT_ANSWER"] = "short_answer";
  QuestionType2["ORDERING"] = "ordering";
  QuestionType2["FILE_UPLOAD"] = "file_upload";
  QuestionType2["ACCEPT"] = "accept";
  QuestionType2["ACCEPT_WITH_SIGNATURE"] = "accept_with_signature";
  QuestionType2["DROPDOWN"] = "dropdown";
  return QuestionType2;
}({});
var QuestionTypeSchema = z20.nativeEnum(QuestionType);
var AttemptStatus = /* @__PURE__ */ function(AttemptStatus2) {
  AttemptStatus2["IN_PROGRESS"] = "in_progress";
  AttemptStatus2["SUBMITTED"] = "submitted";
  AttemptStatus2["GRADED"] = "graded";
  AttemptStatus2["ABANDONED"] = "abandoned";
  return AttemptStatus2;
}({});
var AttemptStatusSchema = z20.nativeEnum(AttemptStatus);
var CreateQuizSchema = z20.object({
  title: z20.string().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  description: z20.string().max(5e3, "Description is too long").optional(),
  passingScorePercent: z20.number().int().min(0).max(100).optional(),
  maxAttempts: z20.number().int().min(1).optional(),
  timeLimitSeconds: z20.number().int().min(1).max(86400, "Time limit cannot exceed 24 hours").optional(),
  shuffleQuestions: z20.boolean().optional(),
  showCorrectAnswers: z20.boolean().optional()
});
var UpdateQuizSchema = z20.object({
  title: z20.string().min(1, "Title is required").max(255, "Title must be 255 characters or less").optional(),
  description: z20.string().max(5e3, "Description is too long").optional(),
  passingScorePercent: z20.number().int().min(0).max(100).optional(),
  maxAttempts: z20.number().int().min(1).optional(),
  timeLimitSeconds: z20.number().int().min(1).max(86400, "Time limit cannot exceed 24 hours").optional(),
  shuffleQuestions: z20.boolean().optional(),
  showCorrectAnswers: z20.boolean().optional(),
  status: QuizStatusSchema.optional()
});
var CreateQuestionSchema = z20.object({
  questionType: QuestionTypeSchema,
  questionText: z20.string().min(1, "Question text is required").max(5e3),
  explanation: z20.string().max(5e3).optional(),
  points: z20.number().int().min(1).optional(),
  position: z20.number().int().min(0).optional(),
  metadata: z20.record(z20.unknown()).optional()
});
var UpdateQuestionSchema = z20.object({
  questionText: z20.string().min(1, "Question text is required").max(5e3).optional(),
  explanation: z20.string().max(5e3).optional(),
  points: z20.number().int().min(1).optional(),
  position: z20.number().int().min(0).optional(),
  metadata: z20.record(z20.unknown()).optional()
});
var CreateOptionSchema = z20.object({
  optionText: z20.string().min(1, "Option text is required").max(1e3),
  isCorrect: z20.boolean().optional(),
  position: z20.number().int().min(0).optional()
});
var UpdateOptionSchema = z20.object({
  optionText: z20.string().min(1, "Option text is required").max(1e3).optional(),
  isCorrect: z20.boolean().optional(),
  position: z20.number().int().min(0).optional()
});
var SubmitAnswerSchema = z20.object({
  questionId: z20.string().uuid("Invalid question ID"),
  selectedOptionIds: z20.array(z20.string().uuid()).optional(),
  orderingSequence: z20.array(z20.string().uuid()).optional(),
  textAnswer: z20.string().max(1e4).optional()
});
var SubmitQuizAttemptSchema = z20.object({
  answers: z20.array(SubmitAnswerSchema).min(1, "At least one answer is required")
});
var QuizBaseSchema = z20.object({
  id: z20.string().uuid(),
  spaceId: z20.string().uuid(),
  title: z20.string().max(255),
  description: z20.string().nullable(),
  passingScorePercent: z20.number().int(),
  maxAttempts: z20.number().int().nullable(),
  timeLimitSeconds: z20.number().int().nullable(),
  shuffleQuestions: z20.boolean(),
  showCorrectAnswers: z20.boolean(),
  status: QuizStatusSchema,
  createdBy: z20.string().uuid(),
  createdAt: z20.coerce.date(),
  updatedAt: z20.coerce.date()
});

// src/community-hub/form-profile-mapping.ts
var EProfileFieldKind = /* @__PURE__ */ function(EProfileFieldKind2) {
  EProfileFieldKind2["TEXT"] = "text";
  EProfileFieldKind2["URL"] = "url";
  EProfileFieldKind2["BOOLEAN"] = "boolean";
  return EProfileFieldKind2;
}({});
var MAPPABLE_PROFILE_FIELDS = [
  {
    key: "firstName",
    label: "First name",
    kind: "text"
  },
  {
    key: "lastName",
    label: "Last name",
    kind: "text"
  },
  {
    key: "displayName",
    label: "Display name",
    kind: "text"
  },
  {
    key: "occupation",
    label: "Profession",
    kind: "text"
  },
  {
    key: "bio",
    label: "Bio",
    kind: "text"
  },
  {
    key: "primaryLanguage",
    label: "Primary language",
    kind: "text"
  },
  {
    key: "phoneNumber",
    label: "Phone number",
    kind: "text"
  },
  {
    key: "zoomEmail",
    label: "Zoom email",
    kind: "text"
  },
  {
    key: "timezone",
    label: "Timezone",
    kind: "text"
  },
  {
    key: "isPrivate",
    label: "Private profile",
    kind: "boolean"
  },
  {
    key: "address.street",
    label: "Address \u2014 Street",
    kind: "text"
  },
  {
    key: "address.city",
    label: "Address \u2014 City",
    kind: "text"
  },
  {
    key: "address.state",
    label: "Address \u2014 State",
    kind: "text"
  },
  {
    key: "address.zip",
    label: "Address \u2014 Zip",
    kind: "text"
  },
  {
    key: "address.country",
    label: "Address \u2014 Country",
    kind: "text"
  },
  {
    key: "socials.facebook",
    label: "Social \u2014 Facebook",
    kind: "url"
  },
  {
    key: "socials.instagram",
    label: "Social \u2014 Instagram",
    kind: "url"
  },
  {
    key: "socials.youtube",
    label: "Social \u2014 YouTube",
    kind: "url"
  },
  {
    key: "socials.twitter",
    label: "Social \u2014 Twitter",
    kind: "url"
  },
  {
    key: "socials.linkedin",
    label: "Social \u2014 LinkedIn",
    kind: "url"
  },
  {
    key: "socials.tiktok",
    label: "Social \u2014 TikTok",
    kind: "url"
  }
];
var PROFILE_FIELD_KEYS = MAPPABLE_PROFILE_FIELDS.map((field) => field.key);
var ProfileFieldKeySchema = z21.enum(PROFILE_FIELD_KEYS);
var getProfileFieldByKey = /* @__PURE__ */ __name((key) => MAPPABLE_PROFILE_FIELDS.find((field) => field.key === key), "getProfileFieldByKey");
var getQuestionAnswerShape = /* @__PURE__ */ __name((questionType) => {
  switch (questionType) {
    case QuestionType.SHORT_ANSWER:
    case QuestionType.MULTIPLE_CHOICE:
    case QuestionType.DROPDOWN: {
      return {
        cardinality: "single",
        valueType: "string"
      };
    }
    case QuestionType.TRUE_FALSE: {
      return {
        cardinality: "single",
        valueType: "boolean"
      };
    }
    case QuestionType.MULTIPLE_SELECT:
    case QuestionType.ORDERING: {
      return {
        cardinality: "multiple",
        valueType: "string"
      };
    }
    case QuestionType.ACCEPT:
    case QuestionType.ACCEPT_WITH_SIGNATURE: {
      return {
        cardinality: "single",
        valueType: "none"
      };
    }
    case QuestionType.FILE_UPLOAD:
    default: {
      return {
        cardinality: "multiple",
        valueType: "file"
      };
    }
  }
}, "getQuestionAnswerShape");
var isQuestionTypeMappableToFieldKind = /* @__PURE__ */ __name((questionType, kind) => {
  const shape = getQuestionAnswerShape(questionType);
  if (shape.cardinality !== "single" || shape.valueType === "file" || shape.valueType === "none") {
    return false;
  }
  if (shape.valueType === "boolean") {
    return kind === "boolean";
  }
  return kind === "text" || kind === "url";
}, "isQuestionTypeMappableToFieldKind");
var isQuestionTypeMappableToProfileFieldKey = /* @__PURE__ */ __name((questionType, profileFieldKey) => {
  const field = getProfileFieldByKey(profileFieldKey);
  return !!field && isQuestionTypeMappableToFieldKind(questionType, field.kind);
}, "isQuestionTypeMappableToProfileFieldKey");
var getMappableProfileFieldsForQuestionType = /* @__PURE__ */ __name((questionType) => MAPPABLE_PROFILE_FIELDS.filter((field) => isQuestionTypeMappableToFieldKind(questionType, field.kind)), "getMappableProfileFieldsForQuestionType");

// src/community-hub/form.ts
var FormStatus = /* @__PURE__ */ function(FormStatus2) {
  FormStatus2["DRAFT"] = "draft";
  FormStatus2["PUBLISHED"] = "published";
  FormStatus2["ARCHIVED"] = "archived";
  return FormStatus2;
}({});
var FormStatusSchema = z22.nativeEnum(FormStatus);
var SubmissionStatus = /* @__PURE__ */ function(SubmissionStatus2) {
  SubmissionStatus2["IN_PROGRESS"] = "in_progress";
  SubmissionStatus2["SUBMITTED"] = "submitted";
  return SubmissionStatus2;
}({});
var SubmissionStatusSchema = z22.nativeEnum(SubmissionStatus);
var EFormType = /* @__PURE__ */ function(EFormType2) {
  EFormType2["GENERAL"] = "general";
  EFormType2["REGISTRATION"] = "registration";
  EFormType2["FEEDBACK"] = "feedback";
  return EFormType2;
}({});
var FormTypeSchema = z22.nativeEnum(EFormType);
var CreateFormSchema = z22.object({
  title: z22.string().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  description: z22.string().optional(),
  bannerUrl: z22.string().max(500, "Banner URL is too long").optional().nullable(),
  shuffleQuestions: z22.boolean().optional(),
  allowMultipleSubmissions: z22.boolean().optional(),
  formType: FormTypeSchema.optional().default("general")
});
var UpdateFormSchema = z22.object({
  title: z22.string().min(1, "Title is required").max(255, "Title must be 255 characters or less").optional(),
  description: z22.string().optional(),
  bannerUrl: z22.string().max(500, "Banner URL is too long").optional().nullable(),
  shuffleQuestions: z22.boolean().optional(),
  allowMultipleSubmissions: z22.boolean().optional(),
  status: FormStatusSchema.optional(),
  formType: FormTypeSchema.optional()
});
var CreateFormQuestionGroupSchema = z22.object({
  title: z22.string().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  description: z22.string().optional()
});
var UpdateFormQuestionGroupSchema = z22.object({
  title: z22.string().min(1, "Title is required").max(255, "Title must be 255 characters or less").optional(),
  description: z22.string().optional()
});
var CreateFormQuestionSchema = z22.object({
  questionType: QuestionTypeSchema,
  questionText: z22.string().min(1, "Question text is required").max(5e3),
  questionBody: z22.string().optional(),
  explanation: z22.string().max(5e3).optional(),
  position: z22.number().int().min(0).optional(),
  metadata: z22.record(z22.unknown()).optional(),
  isRequired: z22.boolean().optional().default(false),
  groupId: z22.string().uuid().nullable().optional(),
  profileFieldKey: ProfileFieldKeySchema.nullable().optional()
});
var UpdateFormQuestionSchema = z22.object({
  questionText: z22.string().min(1, "Question text is required").max(5e3).optional(),
  questionBody: z22.string().optional(),
  explanation: z22.string().max(5e3).optional(),
  position: z22.number().int().min(0).optional(),
  metadata: z22.record(z22.unknown()).optional(),
  isRequired: z22.boolean().optional(),
  groupId: z22.string().uuid().nullable().optional(),
  profileFieldKey: ProfileFieldKeySchema.nullable().optional()
});
var EQuestionInputType = /* @__PURE__ */ function(EQuestionInputType2) {
  EQuestionInputType2["TEXT"] = "text";
  EQuestionInputType2["EMAIL"] = "email";
  EQuestionInputType2["URL"] = "url";
  EQuestionInputType2["NUMBER"] = "number";
  EQuestionInputType2["PHONE"] = "phone";
  return EQuestionInputType2;
}({});
var QuestionInputTypeSchema = z22.nativeEnum(EQuestionInputType);
var getQuestionInputType = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const raw = metadata["inputType"];
    if (typeof raw === "string" && Object.values(EQuestionInputType).includes(raw)) {
      return raw;
    }
  }
  return "text";
}, "getQuestionInputType");
var isShortAnswerValueValid = /* @__PURE__ */ __name((inputType, value) => {
  const trimmed = value.trim();
  if (trimmed.length === 0) {
    return true;
  }
  switch (inputType) {
    case "email": {
      return z22.string().email().safeParse(trimmed).success;
    }
    case "url": {
      return z22.string().url().safeParse(trimmed).success;
    }
    case "number": {
      return !Number.isNaN(Number(trimmed));
    }
    case "phone": {
      return /^[+]?[\d\s()-]{6,20}$/.test(trimmed);
    }
    case "text":
    default: {
      return true;
    }
  }
}, "isShortAnswerValueValid");
var getAcceptButtonLabel = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const raw = metadata["buttonLabel"];
    if (typeof raw === "string" && raw.trim().length > 0) {
      return raw;
    }
  }
  return "Accept";
}, "getAcceptButtonLabel");
var getAcceptCheckboxLabel = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const raw = metadata["checkboxLabel"];
    if (typeof raw === "string" && raw.trim().length > 0) {
      return raw;
    }
  }
  return "I acknowledge the above";
}, "getAcceptCheckboxLabel");
var getDropdownOptions = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const raw = metadata["options"];
    if (Array.isArray(raw)) {
      return raw.filter((o) => typeof o === "string" && o.trim().length > 0);
    }
  }
  return [];
}, "getDropdownOptions");
var CreateFormOptionSchema = z22.object({
  optionText: z22.string().min(1, "Option text is required").max(1e3),
  position: z22.number().int().min(0).optional()
});
var UpdateFormOptionSchema = z22.object({
  optionText: z22.string().min(1, "Option text is required").max(1e3).optional(),
  position: z22.number().int().min(0).optional()
});
var SubmitFormAnswerSchema = z22.object({
  questionId: z22.string().uuid("Invalid question ID"),
  selectedOptionIds: z22.array(z22.string().uuid()).optional(),
  orderingSequence: z22.array(z22.string().uuid()).optional(),
  textAnswer: z22.string().max(1e4).optional(),
  fileUrls: z22.array(z22.string().max(1e3)).max(10).optional()
});
var SubmitFormSchema = z22.object({
  answers: z22.array(SubmitFormAnswerSchema).min(1, "At least one answer is required")
});
var SaveFormProgressSchema = z22.object({
  answers: z22.array(SubmitFormAnswerSchema)
});
var FormBaseSchema = z22.object({
  id: z22.string().uuid(),
  spaceId: z22.string().uuid(),
  title: z22.string().max(255),
  description: z22.string().nullable(),
  bannerUrl: z22.string().max(500).nullable(),
  shuffleQuestions: z22.boolean(),
  allowMultipleSubmissions: z22.boolean(),
  status: FormStatusSchema,
  formType: FormTypeSchema,
  createdBy: z22.string().uuid(),
  createdAt: z22.coerce.date(),
  updatedAt: z22.coerce.date()
});
var FormQuestionGroupSchema = z22.object({
  id: z22.string().uuid(),
  formId: z22.string().uuid(),
  title: z22.string().max(255),
  description: z22.string().nullable(),
  createdAt: z22.coerce.date(),
  updatedAt: z22.coerce.date()
});
var FormAnalyticsUserSchema = z22.object({
  userId: z22.string(),
  name: z22.string().nullable(),
  displayName: z22.string().nullable(),
  email: z22.string().nullable(),
  avatar: z22.string().nullable(),
  // Extended profile fields — populated from the Supabase profile table.
  // Optional + nullable so the schema stays backward-compatible.
  firstName: z22.string().nullable().optional(),
  lastName: z22.string().nullable().optional(),
  occupation: z22.string().nullable().optional(),
  city: z22.string().nullable().optional(),
  state: z22.string().nullable().optional(),
  country: z22.string().nullable().optional(),
  timezone: z22.string().nullable().optional(),
  facebook: z22.string().nullable().optional(),
  instagram: z22.string().nullable().optional(),
  youtube: z22.string().nullable().optional(),
  twitter: z22.string().nullable().optional(),
  linkedin: z22.string().nullable().optional(),
  tiktok: z22.string().nullable().optional(),
  hasSubmitted: z22.boolean(),
  submissionCount: z22.number().int(),
  inProgressCount: z22.number().int(),
  lastSubmittedAt: z22.coerce.date().nullable(),
  latestSubmissionId: z22.string().uuid().nullable()
});
var FormAnalyticsSubmissionByDateSchema = z22.object({
  date: z22.string(),
  count: z22.number().int()
});
var FormAnalyticsSchema = z22.object({
  totalMembers: z22.number().int(),
  submittedCount: z22.number().int(),
  notSubmittedCount: z22.number().int(),
  totalSubmissions: z22.number().int(),
  inProgressSubmissions: z22.number().int(),
  users: z22.object({
    data: z22.array(FormAnalyticsUserSchema),
    pagination: z22.object({
      totalItems: z22.number().int(),
      totalPages: z22.number().int(),
      currentPage: z22.number().int(),
      perPage: z22.number().int()
    })
  }),
  submissionsByDate: z22.array(FormAnalyticsSubmissionByDateSchema)
});

// src/community-hub/moderation.ts
import { z as z23 } from "zod";
var CreateReportSchema = z23.object({
  targetType: z23.enum([
    "post",
    "comment",
    "message",
    "user"
  ]),
  targetId: z23.string().uuid(),
  reason: z23.string().min(1).max(100).optional(),
  description: z23.string().max(1e3).optional()
});
var UpdateReportStatusSchema = z23.object({
  status: z23.enum([
    "pending",
    "reviewing",
    "resolved",
    "dismissed"
  ]),
  reason: z23.string().max(500).optional()
});

// src/community-hub/notification.ts
import { z as z24 } from "zod";
var NotificationType = /* @__PURE__ */ function(NotificationType2) {
  NotificationType2["POST_REPLY"] = "post.reply";
  NotificationType2["POST_REACTION"] = "post.reaction";
  NotificationType2["COMMENT_REPLY"] = "comment.reply";
  NotificationType2["COMMENT_REACTION"] = "comment.reaction";
  NotificationType2["MENTION"] = "mention";
  NotificationType2["QUIZ_GRADED"] = "quiz.graded";
  NotificationType2["LESSON_ASSIGNED"] = "lesson.assigned";
  NotificationType2["SPACE_INVITE"] = "space.invite";
  NotificationType2["ACHIEVEMENT_EARNED"] = "achievement.earned";
  return NotificationType2;
}({});
var NotificationTypeSchema = z24.nativeEnum(NotificationType);
var UpdateNotificationPreferencesSchema = z24.object({
  notificationType: NotificationTypeSchema,
  enabledInApp: z24.boolean().optional(),
  enabledEmail: z24.boolean().optional(),
  enabledPush: z24.boolean().optional()
});
var MarkNotificationsAsReadSchema = z24.object({
  notificationIds: z24.array(z24.string().uuid("Invalid notification ID")).min(1, "At least one notification ID required")
});

// src/community-hub/permission.ts
import { z as z25 } from "zod";
var CreatePermissionSchema = z25.object({
  name: z25.string().min(1, "Name is required").max(50, "Name must be 50 characters or less"),
  description: z25.string().max(200, "Description must be 200 characters or less").optional()
});
var UpdatePermissionSchema = z25.object({
  name: z25.string().min(1, "Name is required").max(50, "Name must be 50 characters or less").optional(),
  description: z25.string().max(200, "Description must be 200 characters or less").optional()
});
var PermissionBaseSchema = z25.object({
  id: z25.number().int(),
  name: z25.string().min(1).max(50),
  description: z25.string().max(200).nullable()
});
var PermissionWithUsageSchema = PermissionBaseSchema.extend({
  usedByRoles: z25.number().int().min(0)
});

// src/community-hub/promo-banner.ts
import { z as z26 } from "zod";
var PromoBannerEntityType = /* @__PURE__ */ function(PromoBannerEntityType2) {
  PromoBannerEntityType2["SPACE"] = "space";
  PromoBannerEntityType2["SUB_SPACE"] = "sub_space";
  PromoBannerEntityType2["LESSON"] = "lesson";
  return PromoBannerEntityType2;
}({});
var PromoBannerEntityTypeSchema = z26.nativeEnum(PromoBannerEntityType);
var PromoBannerPosition = /* @__PURE__ */ function(PromoBannerPosition2) {
  PromoBannerPosition2["HEADER"] = "header";
  PromoBannerPosition2["MIDDLE"] = "middle";
  PromoBannerPosition2["FOOTER"] = "footer";
  return PromoBannerPosition2;
}({});
var PromoBannerPositionSchema = z26.nativeEnum(PromoBannerPosition);
var PromoBannerIconScheme = /* @__PURE__ */ function(PromoBannerIconScheme2) {
  PromoBannerIconScheme2["ROCKET"] = "rocket";
  PromoBannerIconScheme2["STAR"] = "star";
  PromoBannerIconScheme2["AWARD"] = "award";
  PromoBannerIconScheme2["ALERT"] = "alert";
  PromoBannerIconScheme2["BIT"] = "bit";
  PromoBannerIconScheme2["CALENDAR"] = "calendar";
  PromoBannerIconScheme2["CHRISTMAS"] = "christmas";
  PromoBannerIconScheme2["EMOJI"] = "emoji";
  PromoBannerIconScheme2["INFO"] = "info";
  PromoBannerIconScheme2["LIVE"] = "live";
  PromoBannerIconScheme2["MAIL"] = "mail";
  PromoBannerIconScheme2["MESSAGE"] = "message";
  PromoBannerIconScheme2["NEWS"] = "news";
  PromoBannerIconScheme2["TIMER"] = "timer";
  PromoBannerIconScheme2["UNLOCK"] = "unlock";
  return PromoBannerIconScheme2;
}({});
var PromoBannerIconSchemeSchema = z26.nativeEnum(PromoBannerIconScheme);
var PromoBannerType = /* @__PURE__ */ function(PromoBannerType2) {
  PromoBannerType2["DEFAULT"] = "default";
  PromoBannerType2["BANNER_WITH_LAUREN_IMAGE"] = "banner_with_lauren_image";
  return PromoBannerType2;
}({});
var PromoBannerTypeSchema = z26.nativeEnum(PromoBannerType);
var PromoBannerTypeLabels = {
  ["default"]: "Default",
  ["banner_with_lauren_image"]: "Banner With Lauren Image"
};
var visibleTextLength = /* @__PURE__ */ __name((html) => html.replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, "").replace(/<[^>]*>/g, " ").replace(/&(?:nbsp|amp|lt|gt|quot|#39);/g, " ").replace(/\s+/g, " ").trim().length, "visibleTextLength");
var richTextField = /* @__PURE__ */ __name((label, maxVisible) => z26.string().max(1e4, `${label} content is too long`).superRefine((value, ctx) => {
  const length = visibleTextLength(value);
  if (length === 0) {
    ctx.addIssue({
      code: z26.ZodIssueCode.custom,
      message: `${label} is required`
    });
    return;
  }
  if (maxVisible !== void 0 && length > maxVisible) {
    ctx.addIssue({
      code: z26.ZodIssueCode.custom,
      message: `${label} must be ${maxVisible} characters or less`
    });
  }
}), "richTextField");
var optionalRichTextField = /* @__PURE__ */ __name((label, maxVisible) => z26.string().max(1e4, `${label} content is too long`).superRefine((value, ctx) => {
  if (maxVisible === void 0) {
    return;
  }
  const length = visibleTextLength(value);
  if (length > maxVisible) {
    ctx.addIssue({
      code: z26.ZodIssueCode.custom,
      message: `${label} must be ${maxVisible} characters or less`
    });
  }
}), "optionalRichTextField");
var titleField = richTextField("Title", 200);
var descriptionField = richTextField("Description");
var mobileTitleField = optionalRichTextField("Mobile title", 200);
var mobileDescriptionField = optionalRichTextField("Mobile description");
var isDescriptionActiveField = z26.boolean();
var isMobileDescriptionActiveField = z26.boolean();
var buttonLabelField = z26.string().min(1, "Button label is required").max(100, "Button label must be 100 characters or less");
var buttonUrlField = z26.string().url("Button URL must be a valid URL");
var backgroundColorField = z26.string().max(200);
var iconSchemeField = PromoBannerIconSchemeSchema;
var typeField = PromoBannerTypeSchema;
var CreatePromoBannerSchema = z26.object({
  type: typeField.optional().default("default"),
  title: titleField,
  description: descriptionField,
  mobileTitle: mobileTitleField.nullish(),
  mobileDescription: mobileDescriptionField.nullish(),
  isDescriptionActive: isDescriptionActiveField.optional().default(true),
  isMobileDescriptionActive: isMobileDescriptionActiveField.optional().default(true),
  buttonLabel: buttonLabelField,
  buttonUrl: buttonUrlField,
  backgroundColor: backgroundColorField.optional(),
  iconScheme: iconSchemeField.optional(),
  isActive: z26.boolean().optional().default(true)
});
var UpdatePromoBannerSchema = z26.object({
  type: typeField.optional(),
  title: titleField.optional(),
  description: descriptionField.optional(),
  mobileTitle: mobileTitleField.nullish(),
  mobileDescription: mobileDescriptionField.nullish(),
  isDescriptionActive: isDescriptionActiveField.optional(),
  isMobileDescriptionActive: isMobileDescriptionActiveField.optional(),
  buttonLabel: buttonLabelField.optional(),
  buttonUrl: buttonUrlField.optional(),
  backgroundColor: backgroundColorField.optional(),
  iconScheme: iconSchemeField.optional(),
  isActive: z26.boolean().optional()
});
var TogglePromoBannerSchema = z26.object({
  isActive: z26.boolean()
});
var PromoBannerPlacementSchema = z26.object({
  spaceId: z26.string().uuid().nullable(),
  lessonId: z26.string().uuid().nullable(),
  displayPosition: PromoBannerPositionSchema
});
var PromoBannerBaseSchema = z26.object({
  id: z26.string().uuid(),
  type: PromoBannerTypeSchema,
  title: z26.string(),
  description: z26.string(),
  mobileTitle: z26.string().nullable(),
  mobileDescription: z26.string().nullable(),
  isDescriptionActive: z26.boolean(),
  isMobileDescriptionActive: z26.boolean(),
  buttonLabel: z26.string(),
  buttonUrl: z26.string(),
  backgroundColor: z26.string().nullable(),
  iconScheme: iconSchemeField,
  isActive: z26.boolean(),
  placements: z26.array(PromoBannerPlacementSchema),
  createdAt: z26.coerce.date(),
  updatedAt: z26.coerce.date()
});
var PromoBannerForEntitySchema = PromoBannerBaseSchema.extend({
  displayPosition: PromoBannerPositionSchema
});
var AssignPromoBannerSchema = z26.object({
  bannerId: z26.string().uuid(),
  entityType: PromoBannerEntityTypeSchema,
  entityId: z26.string().uuid(),
  position: PromoBannerPositionSchema
});
var PromoBannerEntityQuerySchema = z26.object({
  entityType: PromoBannerEntityTypeSchema,
  entityId: z26.string().uuid()
});
var PromoBannerEntityTypeLabels = {
  ["space"]: "Space",
  ["sub_space"]: "Sub Space",
  ["lesson"]: "Lesson"
};
var PromoBannerPlacementInfoSchema = z26.object({
  entityId: z26.string().uuid(),
  entityType: PromoBannerEntityTypeSchema.nullable(),
  entityName: z26.string().nullable(),
  /** Root (top-level) space the placement lives under; null when unresolvable (deleted). */
  parentSpaceId: z26.string().uuid().nullable(),
  parentSpaceName: z26.string().nullable(),
  displayPosition: PromoBannerPositionSchema,
  assignedAt: z26.coerce.date()
});
var PromoBannerAnalyticsSchema = z26.object({
  bannerId: z26.string().uuid(),
  totalPlacements: z26.number(),
  placements: z26.array(PromoBannerPlacementInfoSchema)
});

// src/community-hub/role.ts
import { z as z27 } from "zod";
var CreateRoleSchema = z27.object({
  name: z27.string().min(1, "Name is required").max(50, "Name must be 50 characters or less"),
  description: z27.string().max(200, "Description must be 200 characters or less").optional()
});
var UpdateRoleSchema = z27.object({
  name: z27.string().min(1, "Name is required").max(50, "Name must be 50 characters or less").optional(),
  description: z27.string().max(200, "Description must be 200 characters or less").optional()
});
var AddPermissionToRoleSchema = z27.object({
  permissionId: z27.number().int().positive("Invalid permission ID")
});
var RoleBaseSchema = z27.object({
  id: z27.number().int(),
  name: z27.string().min(1).max(50),
  description: z27.string().max(200).nullable(),
  is_system: z27.boolean()
});
var RoleWithPermissionsSchema = RoleBaseSchema.extend({
  permissions: z27.array(z27.object({
    id: z27.number().int(),
    name: z27.string(),
    description: z27.string().nullable()
  }))
});

// src/community-hub/space.ts
import { z as z28 } from "zod";
var SpaceType = /* @__PURE__ */ function(SpaceType2) {
  SpaceType2["CONTAINER"] = "container";
  SpaceType2["FEED"] = "feed";
  SpaceType2["CONTENT"] = "content";
  SpaceType2["CHAT"] = "chat";
  SpaceType2["SINGLE_LESSON"] = "single_lesson";
  return SpaceType2;
}({});
var SpaceTypeSchema = z28.nativeEnum(SpaceType);
var SpaceStatus = /* @__PURE__ */ function(SpaceStatus2) {
  SpaceStatus2["DRAFT"] = "draft";
  SpaceStatus2["ACTIVE"] = "active";
  SpaceStatus2["ARCHIVED"] = "archived";
  return SpaceStatus2;
}({});
var SpaceStatusSchema = z28.nativeEnum(SpaceStatus);
var SpaceRefSchema = z28.object({
  id: z28.string().uuid(),
  name: z28.string(),
  spaceType: SpaceTypeSchema,
  icon: z28.string().optional().nullable(),
  bannerImage: z28.string().max(500).optional().nullable(),
  mobileBannerImage: z28.string().max(500).optional().nullable(),
  thumbnailImage: z28.string().max(500).optional().nullable(),
  parentId: z28.string().uuid().optional().nullable(),
  app: z28.string().optional().nullable()
});
var SpaceBaseSchema = z28.object({
  id: z28.string().uuid(),
  name: z28.string().min(1).max(150),
  description: z28.string().optional().nullable(),
  spaceType: SpaceTypeSchema,
  status: SpaceStatusSchema,
  parentId: z28.string().uuid().optional().nullable(),
  app: z28.string().optional().nullable(),
  icon: z28.string().optional().nullable(),
  bannerImage: z28.string().max(500).optional().nullable(),
  mobileBannerImage: z28.string().max(500).optional().nullable(),
  thumbnailImage: z28.string().max(500).optional().nullable(),
  position: z28.number().int().optional().nullable(),
  // Progress-based locking: prerequisite module that must be 100% complete to unlock this one
  prerequisiteSpaceId: z28.string().uuid().optional().nullable(),
  settings: z28.record(z28.unknown()).optional().nullable(),
  // Permission-based access allow-list. Empty = open to everyone with app access;
  // non-empty = the user must hold at least one of these permission ids (children
  // additionally inherit their ancestors' restrictions).
  requiredPermissionIds: z28.array(z28.number().int()).optional(),
  showProgressBar: z28.boolean(),
  showSubtitle: z28.boolean(),
  showIndexBadge: z28.boolean(),
  // Show the per-user "Watched Nx" chip on lesson video players in this space
  showWatchCount: z28.boolean(),
  showLessonLabel: z28.boolean(),
  showSectionLabel: z28.boolean(),
  createdAt: z28.coerce.date(),
  updatedAt: z28.coerce.date(),
  deletedAt: z28.coerce.date().optional().nullable(),
  // Computed stats for content-type sub-spaces (modules)
  lessonCount: z28.number().int().optional(),
  hasDownloadableAssets: z28.boolean().optional(),
  // Computed per-user lock state (populated on member sub-space listing)
  isLocked: z28.boolean().optional(),
  prerequisiteName: z28.string().optional().nullable(),
  // Relations (populated when loaded with relations)
  parent: SpaceRefSchema.optional().nullable(),
  children: z28.array(SpaceRefSchema).optional()
});
var CreateSpaceSchema = z28.object({
  name: z28.string().min(1, "Name is required").max(150, "Name must be 150 characters or less"),
  description: z28.string().optional(),
  app: z28.string().min(1, "App is required"),
  // Top-level space type: 'container' (default) holds sub-spaces; 'single_lesson' holds exactly one lesson
  spaceType: z28.enum([
    "container",
    "single_lesson"
  ]).optional(),
  icon: z28.string().optional(),
  bannerImage: z28.string().max(500).optional(),
  thumbnailImage: z28.string().max(500).optional(),
  position: z28.number().int().min(0).optional(),
  settings: z28.record(z28.unknown()).optional(),
  requiredPermissionIds: z28.array(z28.number().int()).optional(),
  showIndexBadge: z28.boolean().optional(),
  showWatchCount: z28.boolean().optional()
});
var CreateSubSpaceSchema = z28.object({
  name: z28.string().min(1, "Name is required").max(150, "Name must be 150 characters or less"),
  description: z28.string().optional(),
  spaceType: z28.enum([
    "feed",
    "content",
    "chat"
  ], {
    errorMap: /* @__PURE__ */ __name(() => ({
      message: "Space type must be feed, content, or chat"
    }), "errorMap")
  }),
  icon: z28.string().optional(),
  bannerImage: z28.string().max(500).optional(),
  mobileBannerImage: z28.string().max(500).optional(),
  thumbnailImage: z28.string().max(500).optional(),
  position: z28.number().int().min(0).optional(),
  prerequisiteSpaceId: z28.string().uuid().nullable().optional(),
  settings: z28.record(z28.unknown()).optional(),
  requiredPermissionIds: z28.array(z28.number().int()).optional(),
  showProgressBar: z28.boolean().optional(),
  showSubtitle: z28.boolean().optional(),
  showLessonLabel: z28.boolean().optional(),
  showSectionLabel: z28.boolean().optional()
});
var UpdateSpaceSchema = z28.object({
  name: z28.string().min(1, "Name is required").max(150, "Name must be 150 characters or less").optional(),
  description: z28.string().optional(),
  app: z28.string().min(1).optional(),
  status: SpaceStatusSchema.optional(),
  icon: z28.string().optional(),
  bannerImage: z28.string().max(500).optional(),
  mobileBannerImage: z28.string().max(500).optional(),
  thumbnailImage: z28.string().max(500).optional(),
  position: z28.number().int().min(0).optional(),
  prerequisiteSpaceId: z28.string().uuid().nullable().optional(),
  settings: z28.record(z28.unknown()).optional(),
  requiredPermissionIds: z28.array(z28.number().int()).optional(),
  showProgressBar: z28.boolean().optional(),
  showSubtitle: z28.boolean().optional(),
  showIndexBadge: z28.boolean().optional(),
  showWatchCount: z28.boolean().optional(),
  showLessonLabel: z28.boolean().optional(),
  showSectionLabel: z28.boolean().optional()
});
var FeedSpaceItemSchema = z28.object({
  id: z28.string().uuid(),
  name: z28.string(),
  icon: z28.string().nullable(),
  bannerImage: z28.string().nullable().optional(),
  thumbnailImage: z28.string().nullable().optional(),
  hasAccess: z28.boolean()
});

// src/community-hub/terms.ts
import { z as z29 } from "zod";
var TermsBaseSchema = z29.object({
  id: z29.string().uuid(),
  name: z29.string().min(1).max(150),
  version: z29.string().min(1).max(100),
  heading: z29.string().max(150).nullable().optional(),
  body: z29.string().min(1),
  termsUrl: z29.string().url().nullable().optional(),
  createdAt: z29.coerce.date(),
  updatedAt: z29.coerce.date()
});
var optionalUrlField = z29.string().max(500).optional().nullable().transform((value) => value && value.length > 0 ? value : void 0).pipe(z29.string().url("Invalid URL").optional());
var CreateTermsSchema = z29.object({
  name: z29.string().min(1, "Name is required").max(150),
  version: z29.string().min(1, "Version is required").max(100),
  heading: z29.string().max(150).optional(),
  body: z29.string().min(1, "Body is required"),
  termsUrl: optionalUrlField
});
var UpdateTermsSchema = z29.object({
  name: z29.string().min(1).max(150).optional(),
  version: z29.string().min(1).max(100).optional(),
  heading: z29.string().max(150).nullable().optional(),
  body: z29.string().min(1).optional(),
  termsUrl: optionalUrlField
});
var TermsAcceptanceResponseSchema = z29.object({
  requiresAcceptance: z29.boolean(),
  accepted: z29.boolean(),
  acceptedVersion: z29.string().nullable(),
  acceptedAt: z29.coerce.date().nullable(),
  terms: TermsBaseSchema.nullable()
});
var AcceptSpaceTermsSchema = z29.object({
  version: z29.string().min(1)
});

// src/community-hub/user.ts
import { z as z30 } from "zod";
var UserResponseSchema = z30.object({
  id: z30.string().uuid(),
  email: z30.string().email(),
  firstName: z30.string(),
  lastName: z30.string(),
  displayName: z30.string().optional().nullable(),
  avatar: z30.string().optional().nullable(),
  createdAt: z30.coerce.date()
});
var UpdateUserSchema = z30.object({
  email: z30.string().email("Invalid email address").optional(),
  password: z30.string().min(8, "Password must be at least 8 characters").optional(),
  firstName: z30.string().min(1, "First name is required").max(100).optional(),
  lastName: z30.string().min(1, "Last name is required").max(100).optional(),
  displayName: z30.string().max(200).optional(),
  avatar: z30.string().url("Invalid avatar URL").optional().or(z30.literal("")),
  app: z30.string().min(1, "App is required").optional(),
  roleId: z30.number().int().positive("Role is required").optional()
});

// src/community-hub/user-group.ts
import { z as z31 } from "zod";
var UserGroupStatus = /* @__PURE__ */ function(UserGroupStatus2) {
  UserGroupStatus2["ACTIVE"] = "active";
  UserGroupStatus2["INACTIVE"] = "inactive";
  return UserGroupStatus2;
}({});
var UserGroupStatusSchema = z31.nativeEnum(UserGroupStatus);
var CreateUserGroupSchema = z31.object({
  name: z31.string().min(1, "Name is required").max(100, "Name must be 100 characters or less")
});
var UpdateUserGroupSchema = z31.object({
  name: z31.string().min(1, "Name is required").max(100, "Name must be 100 characters or less").optional()
});
var AddUserGroupMemberSchema = z31.object({
  userId: z31.string().uuid("Invalid user ID")
});
var UserGroupBaseSchema = z31.object({
  id: z31.number().int(),
  name: z31.string().min(1).max(100),
  status: z31.string().max(20).optional(),
  createdBy: z31.string().uuid().optional().nullable(),
  createdAt: z31.coerce.date(),
  updatedAt: z31.coerce.date().optional()
});
var UserGroupMemberBaseSchema = z31.object({
  id: z31.number().int(),
  userGroupId: z31.number().int(),
  userId: z31.string().uuid(),
  createdAt: z31.coerce.date()
});
var GrantUserGroupAccessSchema = z31.object({
  productId: z31.number().int(),
  variationId: z31.number().int().optional(),
  reason: z31.string().min(1)
});
var GrantUserGroupAccessByAppSchema = z31.object({
  app: z31.string().min(1),
  roleId: z31.number().int().optional(),
  reason: z31.string().min(1)
});
var GrantUserGroupAccessResultSchema = z31.object({
  totalMembers: z31.number().int().nonnegative(),
  usersUpdated: z31.number().int().nonnegative(),
  usersSkipped: z31.number().int().nonnegative(),
  message: z31.string()
});
var UserGroupGrantJobStatusSchema = z31.enum([
  "pending",
  "running",
  "completed",
  "failed"
]);
var UserGroupGrantResultStatusSchema = z31.enum([
  "granted",
  "updated",
  "already",
  "failed"
]);
var UserGroupGrantResultItemSchema = z31.object({
  userId: z31.string(),
  email: z31.string().nullable().optional(),
  name: z31.string().nullable().optional(),
  status: UserGroupGrantResultStatusSchema,
  detail: z31.string()
});
var UserGroupGrantJobSchema = z31.object({
  id: z31.string().uuid(),
  userGroupId: z31.number().int(),
  grantType: z31.enum([
    "product",
    "app"
  ]),
  target: z31.record(z31.string(), z31.unknown()),
  reason: z31.string().nullable(),
  status: UserGroupGrantJobStatusSchema,
  totalMembers: z31.number().int().nonnegative(),
  processedCount: z31.number().int().nonnegative(),
  grantedCount: z31.number().int().nonnegative(),
  updatedCount: z31.number().int().nonnegative(),
  alreadyCount: z31.number().int().nonnegative(),
  failedCount: z31.number().int().nonnegative(),
  error: z31.string().nullable(),
  createdBy: z31.string().nullable(),
  createdByName: z31.string().nullable().optional(),
  createdAt: z31.coerce.date(),
  updatedAt: z31.coerce.date().nullable().optional()
});
var UserGroupGrantPreviewAppSchema = z31.object({
  app: z31.string(),
  roleId: z31.number().int().nullable(),
  roleName: z31.string().nullable(),
  alreadyHave: z31.number().int().nonnegative(),
  willUpdate: z31.number().int().nonnegative(),
  willGrant: z31.number().int().nonnegative()
});
var UserGroupGrantPreviewSchema = z31.object({
  totalMembers: z31.number().int().nonnegative(),
  apps: z31.array(UserGroupGrantPreviewAppSchema)
});
var EUserGroupImportSource = /* @__PURE__ */ function(EUserGroupImportSource2) {
  EUserGroupImportSource2["ACTIVE_CAMPAIGN_TAG"] = "active_campaign_tag";
  EUserGroupImportSource2["APP_ACCESS"] = "app_access";
  EUserGroupImportSource2["CSV"] = "csv";
  EUserGroupImportSource2["EMAIL_LIST"] = "email_list";
  EUserGroupImportSource2["USER_GROUP"] = "user_group";
  return EUserGroupImportSource2;
}({});
var UserGroupImportSourceSchema = z31.nativeEnum(EUserGroupImportSource);
var UserGroupImportModeSchema = z31.enum([
  "append",
  "replace",
  "remove"
]);
var ActiveCampaignTagConfigSchema = z31.object({
  tagId: z31.string().min(1, "Tag is required"),
  tagName: z31.string().min(1)
});
var ActiveCampaignTagSchema = z31.object({
  id: z31.string(),
  name: z31.string()
});
var AppAccessConfigSchema = z31.object({
  app: z31.string().min(1, "App is required"),
  roleId: z31.number().int().optional(),
  roleName: z31.string().optional()
});
var EmailListConfigSchema = z31.object({
  emails: z31.array(z31.string()).min(1, "At least one email is required").max(5e4)
});
var UserGroupSourceConfigSchema = z31.object({
  sourceUserGroupId: z31.number().int(),
  sourceUserGroupName: z31.string().optional()
});
var UserGroupImportRequestSchema = z31.object({
  source: UserGroupImportSourceSchema,
  sourceConfig: z31.record(z31.string(), z31.unknown()),
  mode: UserGroupImportModeSchema
});
var UserGroupImportPreviewSchema = z31.object({
  sourceTotal: z31.number().int().nonnegative(),
  currentMemberCount: z31.number().int().nonnegative(),
  mode: UserGroupImportModeSchema
});
var UserGroupImportJobStatusSchema = z31.enum([
  "pending",
  "running",
  "completed",
  "failed"
]);
var UserGroupImportJobSchema = z31.object({
  id: z31.string().uuid(),
  userGroupId: z31.number().int(),
  source: UserGroupImportSourceSchema,
  sourceConfig: z31.record(z31.string(), z31.unknown()),
  mode: UserGroupImportModeSchema,
  status: UserGroupImportJobStatusSchema,
  sourceTotal: z31.number().int().nonnegative(),
  addedCount: z31.number().int().nonnegative(),
  skippedCount: z31.number().int().nonnegative(),
  removedCount: z31.number().int().nonnegative(),
  notFoundCount: z31.number().int().nonnegative(),
  error: z31.string().nullable(),
  createdBy: z31.string().nullable(),
  createdByName: z31.string().nullable().optional(),
  createdAt: z31.coerce.date(),
  updatedAt: z31.coerce.date().nullable().optional()
});

// src/community-hub/widgets.ts
import { z as z32 } from "zod";
var TrendingTagSchema = z32.object({
  value: z32.string(),
  label: z32.string(),
  count: z32.number().int()
});
var TrendingTagsResponseSchema = z32.object({
  tags: z32.array(TrendingTagSchema)
});
var CommunityStatsSchema = z32.object({
  totalMembers: z32.number().int(),
  postsThisMonth: z32.number().int()
});
var TopContributorSchema = z32.object({
  id: z32.string(),
  name: z32.string(),
  avatar: z32.string().nullable(),
  replyCount: z32.number().int()
});
var TopContributorsResponseSchema = z32.object({
  contributors: z32.array(TopContributorSchema)
});

// src/content/base.ts
import { array, coerce as coerce7, lazy, object as object9, string as string9, union as union2, z as z43 } from "zod";

// src/instructor/base.ts
import { coerce as coerce4, object as object4, string as string4 } from "zod";

// src/instructor/instructor-type.enum.ts
import { z as z33 } from "zod";
var InstructorTypeEnumValues = [
  "REGULAR",
  "GUEST"
];
var InstructorTypeEnumObj = z33.enum(InstructorTypeEnumValues);
var InstructorTypeEnum = InstructorTypeEnumObj.enum;

// src/instructor/media-type.enum.ts
import { z as z34 } from "zod";
var MediaTypeEnumValues = [
  "instagram",
  "facebook",
  "linkedin",
  "twitter",
  "website",
  "youtube",
  "tiktok"
];
var MediaTypeEnumObj = z34.enum(MediaTypeEnumValues);
var MediaTypeEnum = MediaTypeEnumObj.enum;

// src/instructor/base.ts
var SocialMedia = object4({
  mediaType: MediaTypeEnumObj,
  url: string4().url()
});
var ProfilePicture = object4({
  potrait: string4(),
  landscape: string4(),
  square: string4()
});
var InstructorProfilePictureSchema = object4({
  potrait: string4().url().nullable(),
  landscape: string4().url().nullable(),
  square: string4().url().nullable()
}).optional();
var Instructor = object4({
  id: coerce4.string(),
  firstName: string4(),
  lastName: string4(),
  email: string4().email().optional().nullable(),
  isActive: coerce4.boolean(),
  rycProfile: string4().nullable(),
  slug: string4().optional(),
  createdAt: coerce4.string(),
  updatedAt: coerce4.string(),
  profilePicture: InstructorProfilePictureSchema,
  socialMedia: SocialMedia.array().optional().nullable(),
  strongPoints: string4().array().optional().nullable(),
  role: string4().optional(),
  location: string4().optional(),
  bio: string4().optional(),
  type: InstructorTypeEnumObj.optional(),
  affiliateUrl: string4().optional().nullable(),
  userId: string4().optional().nullable()
});
var InstructorRequestSchema = object4({
  type: InstructorTypeEnumObj.optional()
});
var InstructorsByIdsRequestSchema = object4({
  ids: coerce4.string().array().min(1)
});

// src/ryc/content/meta.ts
import { boolean as boolean2, coerce as coerce5, object as object6, string as string6, z as z39 } from "zod";

// src/content/category.enum.ts
import { z as z35 } from "zod";
var CategoryEnumValues = [
  "STRENGTH",
  "CARDIO",
  "FLOW",
  "RESTORE"
];
var CategoryEnumObj = z35.enum(CategoryEnumValues);
var CategoryEnum = CategoryEnumObj.enum;
var AddonCategoryEnumValues = [
  "INTRODUCTION",
  "EXERCISES",
  "WORKOUT",
  "FOUNDATION",
  "EDUCATIONAL"
];
var AddonCategoryEnumObj = z35.enum(AddonCategoryEnumValues);
var AddonCategoryEnum = AddonCategoryEnumObj.enum;
var AddonCategoryLabels = {
  INTRODUCTION: "Introduction",
  EXERCISES: "Exercises",
  WORKOUT: "Workout",
  FOUNDATION: "Foundation",
  EDUCATIONAL: "Educational"
};

// src/ryc/step/tier.ts
import { z as z36 } from "zod";
var TierValues = [
  "TIER_1",
  "TIER_2",
  "TIER_3"
];
var TiersEnumObject = z36.enum(TierValues);
var ETiersEnum = TiersEnumObject.enum;

// src/ryc/content/category.ts
import { date, number as number2, object as object5, string as string5 } from "zod";
var RYCContentCategorySchema = object5({
  id: number2(),
  name: string5(),
  createdAt: string5().or(date()),
  updatedAt: string5().or(date())
});
var RYCContentCategoryResponseSchema = RYCContentCategorySchema.array();

// src/ryc/content/series.enum.ts
import { z as z37 } from "zod";
var RYCContentMetaSeriesEnumValues = [
  "Core",
  "Flow",
  "Standing",
  "Express",
  "Chair",
  "Fusion",
  "Scaled"
];
var RYCContentMetaSeriesEnumObject = z37.enum(RYCContentMetaSeriesEnumValues);
var ERYCContentMetaSeries = RYCContentMetaSeriesEnumObject.enum;

// src/ryc/content/type.enum.ts
import { z as z38 } from "zod";
var RYCContentMeTypeEnumValues = [
  "WORKOUT",
  "Educational",
  "Addon"
];
var RYCContentMetaTypeEnumObject = z38.enum(RYCContentMeTypeEnumValues);
var ERYCContentMetaType = RYCContentMetaTypeEnumObject.enum;

// src/ryc/content/meta.ts
var RYCContentMetaInfromationSchema = object6({
  tiers: TiersEnumObject.array().optional().default([]),
  series: RYCContentMetaSeriesEnumObject.nullable().optional(),
  stage: coerce5.number().nullable().optional(),
  type: RYCContentMetaTypeEnumObject.optional(),
  isRegular: coerce5.boolean().optional().default(false),
  isSupportive: coerce5.boolean().optional().default(false),
  category: CategoryEnumObj,
  categories: RYCContentCategorySchema.array().optional().default([]),
  pdfLink: string6().optional().nullable(),
  hasPdfAttachment: boolean2().optional()
});
var RYCContentMetaInformationBaseSchema = RYCContentMetaInfromationSchema.extend({
  id: coerce5.string().optional(),
  contentId: coerce5.string().optional(),
  createdAt: coerce5.string().or(z39.date()).optional(),
  updatedAt: coerce5.string().or(z39.date()).optional()
});

// src/content/content-type.enum.ts
import { z as z40 } from "zod";
var ContentTypeEnumValues = [
  "DOCUMENT",
  "VIDEO",
  "PDF",
  "IMAGE",
  "EVENT"
];
var ContentTypeEnumObj = z40.enum(ContentTypeEnumValues);
var ContentTypeEnum = ContentTypeEnumObj.enum;

// src/content/equipment.ts
import { number as number3, object as object7, string as string7 } from "zod";
var EquipmentIconSchema = string7().max(2e4, "Icon SVG is too large (max 20000 characters)").refine((value) => value.trim() === "" || /<svg[\s>]/i.test(value), "Icon must be valid SVG markup starting with <svg>");
var Equipment = object7({
  id: number3(),
  name: string7(),
  slug: string7(),
  icon: string7().nullable().optional()
});
var CreateEquipmentRequest = object7({
  name: string7().min(1, "name is required"),
  slug: string7().regex(SLUG_PATTERN, "Slug must contain only lowercase letters (a\u2013z), numbers, and hyphens, and cannot start or end with a hyphen (e.g. barbell-curl)"),
  icon: EquipmentIconSchema.nullable().optional()
});
var UpdateEquipmentRequest = CreateEquipmentRequest.partial();

// src/content/rating.ts
import { coerce as coerce6, object as object8, string as string8, z as z41 } from "zod";
var IndicateorsEnumValues = [
  "difficulty",
  "intensity",
  "nerdiness",
  "awesomeness"
];
var IndicatorsEnumObj = z41.enum(IndicateorsEnumValues);
var IndicatorEnum = IndicatorsEnumObj.enum;
var RatingIndicator = object8({
  [IndicatorEnum.difficulty]: coerce6.number(),
  [IndicatorEnum.intensity]: coerce6.number(),
  [IndicatorEnum.nerdiness]: coerce6.number(),
  [IndicatorEnum.awesomeness]: coerce6.number()
});
var ContentRating = object8({
  contentId: string8(),
  rating: RatingIndicator
});
var ContentRatingResponse = object8({
  contentId: string8(),
  userRating: RatingIndicator,
  averageRating: RatingIndicator
});
var RateContentSchema = object8({
  userId: string8(),
  contentId: string8(),
  ratings: RatingIndicator
});
var GetContentRatingsSchema = RateContentSchema.omit({
  ratings: true
});

// src/content/status.enum.ts
import { z as z42 } from "zod";
var StatusEnumValues = [
  "DRAFT",
  "PUBLISHED",
  "TRASH"
];
var StatusEnumObj = z42.enum(StatusEnumValues);
var StatusEnum = StatusEnumObj.enum;

// src/content/base.ts
var VimeoVideo = object9({
  vimeoVideoId: string9().min(1, "Vimeo Video Id is required"),
  bannerUrl2x: string9(),
  duration: coerce7.number().min(1, "duration is required"),
  description: string9().nullable()
});
var VimeoVideoInput = VimeoVideo.extend({
  duration: coerce7.number().min(0).optional()
});
var TrashContentVimeoVideo = object9({
  bannerUrl2x: string9(),
  duration: coerce7.number(),
  description: string9()
});
var CommonContentFields = object9({
  id: string9(),
  name: string9().min(3, "name is required"),
  category: lazy(() => CategoryEnumObj.or(AddonCategoryEnumObj)),
  instructor: lazy(() => Instructor),
  createdAt: coerce7.string(),
  updatedAt: coerce7.string(),
  watchedDate: coerce7.string().optional(),
  meta: lazy(() => RYCContentMetaInformationBaseSchema.partial().optional())
});
var BareContent = CommonContentFields.extend({
  type: lazy(() => ContentTypeEnumObj),
  status: StatusEnumObj,
  video: lazy(() => VimeoVideo),
  isAllowComment: coerce7.boolean().default(false),
  equipments: lazy(() => Equipment.array()),
  publishedDate: z43.union([
    z43.string(),
    z43.date(),
    CustomLuxonDateSchema
  ]),
  averageRating: lazy(() => RatingIndicator),
  isNew: coerce7.boolean().default(false).optional(),
  favorite: coerce7.boolean().default(false).optional(),
  instructorId: string9(),
  // this is needed for for react rendering. id is not unique in watch history response.
  uniqueId: string9().optional(),
  createdAt: coerce7.date(),
  updatedAt: coerce7.date(),
  meta: lazy(() => RYCContentMetaInformationBaseSchema.partial().optional())
});
var Content = BareContent.extend({
  parentPlaylistsIds: string9().array().default([]).optional(),
  userHasLeftRating: coerce7.boolean().default(false).optional(),
  instructor: Instructor
});
var TrashContentSchema = CommonContentFields.extend({
  status: z43.literal(StatusEnum.TRASH),
  video: lazy(() => TrashContentVimeoVideo)
});
var AllStatusContentSchema = Content.omit({
  status: true
}).extend({
  status: lazy(() => StatusEnumObj)
});
var ContentWithRatingFlagSchema = AllStatusContentSchema.extend({
  createdAt: coerce7.date(),
  updatedAt: coerce7.date(),
  publishedDate: z43.union([
    z43.string(),
    z43.date()
  ]).optional().nullable(),
  instructor: Instructor.extend({
    id: z43.union([
      coerce7.string(),
      coerce7.number()
    ]),
    createdAt: coerce7.date(),
    updatedAt: coerce7.date()
  }),
  userHasLeftRating: coerce7.boolean()
});
var ContentFindAllResponseSchema = object9({
  items: ContentWithRatingFlagSchema.array(),
  meta: object9({
    page: coerce7.number(),
    perPage: coerce7.number(),
    total: coerce7.number(),
    totalPages: coerce7.number()
  })
});
var ContentAndTrashContentUnion = z43.union([
  Content,
  TrashContentSchema
]);
var ContentWithWatchedDate = Content.extend({
  watchedDate: string9().or(CustomLuxonDateSchema).optional()
});
var ContentByDate = object9({
  id: string9(),
  activeOn: string9(),
  createdAt: coerce7.date(),
  updatedAt: coerce7.date(),
  content: Content
});
var ContentByDateResponseSchema = object9({
  items: union2([
    array(ContentByDate),
    z43.null()
  ]),
  meta: object9({
    startDate: string9(),
    endDate: string9()
  })
});
var DateRangeQuerySchema = object9({
  startDate: string9().nullable(),
  endDate: string9().nullable(),
  page: coerce7.number().optional()
});
var UserContentRatingResponse = array(RatingIndicator);
var WatchedStatusEnumValues = [
  "WATCHED",
  "UNWATCHED",
  "ALL"
];
var WatchedStatusEnumObj = z43.enum(WatchedStatusEnumValues);
var WatchedFilterEnum = WatchedStatusEnumObj.enum;

// src/content/content.request.ts
import { array as array2, coerce as coerce8, object as object10, string as string10 } from "zod";

// src/fit/content/recently-added.enum.ts
import { z as z44 } from "zod";
var ContentFilterTypeValues = [
  "recentlyAdded"
];
var ContentFilterTypeObj = z44.enum(ContentFilterTypeValues);
var ContentFilterTypeEnum = ContentFilterTypeObj.enum;

// src/content/content.request.ts
var ContentRequestSchema = object10({
  type: ContentFilterTypeObj.optional(),
  instructorId: string10().optional(),
  categoryId: string10().optional(),
  duration: string10().optional(),
  equipments: string10().optional(),
  difficulty: string10().optional(),
  intensity: string10().optional(),
  nerdiness: string10().optional(),
  awesomeness: string10().optional(),
  perPage: coerce8.number().optional(),
  page: coerce8.number().optional()
});
var ContentRequestBESchema = object10({
  app: AppNameEnumObj.optional(),
  query: string10().optional(),
  shuffle: CoerceBoolean.optional().default(false),
  loadAll: CoerceBoolean.optional().default(false),
  type: ContentFilterTypeObj,
  instructorIds: array2(string10()).default([]),
  categoryId: CategoryEnumObj,
  equipments: array2(string10()).default([]),
  status: StatusEnumObj.array().optional(),
  dashboard: CoerceBoolean.optional().default(false),
  durationFrom: coerce8.number().default(1),
  durationTo: coerce8.number().default(1e3),
  difficultyFrom: coerce8.number().default(1),
  difficultyTo: coerce8.number().default(5),
  intensityFrom: coerce8.number().default(1),
  intensityTo: coerce8.number().default(5),
  nerdinessFrom: coerce8.number().default(1),
  nerdinessTo: coerce8.number().default(5),
  awesomenessFrom: coerce8.number().default(1),
  awesomenessTo: coerce8.number().default(5),
  watchedStatus: WatchedStatusEnumObj,
  perPage: coerce8.number().max(150),
  page: coerce8.number(),
  sortByNewlyAdded: CoerceBoolean.optional().default(false),
  period: string10(),
  date: string10(),
  orderBy: string10().optional(),
  userTimezone: string10().optional(),
  addon: CoerceBoolean.optional().default(false),
  programId: coerce8.number().optional()
}).partial();
var contentFilterDefaultValues = {
  categoryId: "",
  difficulty: "0-5",
  duration: "1-60",
  equipments: "",
  instructorId: "",
  intensity: "0-5",
  nerdiness: "0-5",
  awesomeness: "0-5",
  page: "1",
  perPage: "15",
  type: "",
  query: "",
  shuffle: "true"
};
var contentFilterEmptyDefaultValues = {
  categoryId: "",
  difficulty: "",
  duration: "",
  equipments: "",
  instructorId: "",
  intensity: "",
  nerdiness: "",
  awesomeness: "",
  page: "",
  perPage: "",
  type: "",
  query: "",
  programId: ""
};

// src/content/content.response.ts
import { coerce as coerce9, object as object11 } from "zod";
var ContentFindByIdsResponseSchema = object11({
  items: Content.array(),
  meta: object11({
    total: coerce9.number(),
    page: coerce9.number(),
    perPage: coerce9.number(),
    totalPages: coerce9.number()
  })
});

// src/content/you-may-like.request.ts
import { coerce as coerce10, object as object12, string as string11 } from "zod";
var YouMayLikeRequestFilterSchema = object12({
  contentId: string11(),
  commentId: coerce10.number().optional().transform((val) => val == null ? void 0 : val.toString()),
  date: string11().optional(),
  category: CategoryEnumObj.or(AddonCategoryEnumObj).optional(),
  instructorId: coerce10.string().optional(),
  playlistId: coerce10.string().optional(),
  seriesId: coerce10.string().optional()
});

// src/equipments/equipments.enum.ts
import { z as z45 } from "zod";
var EquipmentsValues = [
  "CHAIR",
  "BALL",
  "ROPE",
  "YOGA_MAT",
  "CUP"
];
var EQuipmentObj = z45.enum(EquipmentsValues);
var EQuipmentEnum = EQuipmentObj.enum;

// src/feature-flags/index.ts
import { array as array3, boolean as boolean3, object as object13, record, string as string12, z as z46 } from "zod";
var FeatureFlagMapSchema = record(string12(), array3(string12()));
var hasFeatureFlag = /* @__PURE__ */ __name((featureFlags, flagSlug, app) => {
  var _a5, _b;
  if (!featureFlags) {
    return false;
  }
  if (app) {
    return (_b = (_a5 = featureFlags[app]) == null ? void 0 : _a5.includes(flagSlug)) != null ? _b : false;
  }
  return Object.values(featureFlags).some((slugs) => slugs.includes(flagSlug));
}, "hasFeatureFlag");
var EFeatureFlagSlug = {
  SHOW_WATCH_COUNT: "show-watch-count",
  SHOW_APPS_LANDING: "show-apps-landing",
  SHOW_ENDPOINT_SWITCHER: "show-endpoint-switcher",
  SHOW_FIT_RYC_APPS: "show-fit-ryc-apps"
};
var FeatureFlagAssignmentSchema = object13({
  id: string12().uuid(),
  featureFlagId: string12().uuid(),
  userUuid: string12(),
  app: AppNameEnumObj,
  createdAt: string12().optional(),
  // Display fields resolved on the backend (the assigned user's profile).
  userName: string12().nullable().optional(),
  userEmail: string12().nullable().optional(),
  userAvatar: string12().nullable().optional()
});
var FeatureFlagSchema = object13({
  id: string12().uuid(),
  slug: string12(),
  label: string12(),
  description: string12().nullable().optional(),
  enabled: boolean3(),
  createdAt: string12().optional(),
  updatedAt: string12().optional(),
  assignmentCount: z46.number().optional(),
  assignments: array3(FeatureFlagAssignmentSchema).optional()
});
var CreateFeatureFlagRequestSchema = object13({
  slug: string12().min(1, "Slug is required").max(150, "Slug is too long (max 150 characters)").regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "Slug must be lowercase kebab-case (e.g. new-checkout-flow)"),
  label: string12().min(1, "Label is required").max(150, "Label is too long (max 150 characters)"),
  description: string12().max(2e3, "Description is too long (max 2000 characters)").nullable().optional(),
  // New flags are live by default; the admin can create one disabled if needed.
  enabled: boolean3().default(true)
});
var UpdateFeatureFlagRequestSchema = CreateFeatureFlagRequestSchema.partial();
var AssignFeatureFlagRequestSchema = object13({
  userUuid: string12().min(1, "User is required"),
  app: AppNameEnumObj
});
var MyFeatureFlagSchema = object13({
  id: string12().uuid(),
  slug: string12(),
  label: string12(),
  description: string12().nullable().optional(),
  enabled: boolean3()
});
var FeatureFlagAudienceTypeEnumObject = z46.enum([
  "group",
  "space-members",
  "space-admins"
]);
var BulkAssignFeatureFlagRequestSchema = z46.discriminatedUnion("type", [
  object13({
    type: z46.literal(FeatureFlagAudienceTypeEnumObject.enum.group),
    groupId: z46.number().int().positive(),
    app: AppNameEnumObj
  }),
  object13({
    type: z46.literal(FeatureFlagAudienceTypeEnumObject.enum["space-members"]),
    spaceId: string12().uuid()
  }),
  object13({
    type: z46.literal(FeatureFlagAudienceTypeEnumObject.enum["space-admins"]),
    spaceId: string12().uuid()
  })
]);
var BulkAssignFeatureFlagResultSchema = object13({
  audienceType: FeatureFlagAudienceTypeEnumObject,
  app: AppNameEnumObj,
  resolved: z46.number(),
  granted: z46.number(),
  alreadyHadAccess: z46.number()
});

// src/events/base.ts
import { z as z49 } from "zod";

// src/events/event.ts
import { z as z47 } from "zod";
var EventStatusEnumValues = [
  "SCHEDULED",
  "STARTED",
  "ENDED"
];
var EventStatusEnumObj = z47.enum(EventStatusEnumValues);
var EventStatusEnum = EventStatusEnumObj.enum;

// src/events/type.enum.ts
import { z as z48 } from "zod";
var EventTypeValues = [
  "CLASS",
  "LECTURE",
  "WORKSHOP",
  "MEETUP",
  "CONFERENCE"
];
var EventTypeObj = z48.enum(EventTypeValues);
var EEventTypeEnum = EventTypeObj.enum;

// src/events/base.ts
var BaseEventSchema = z49.object({
  id: z49.string(),
  title: z49.string().min(1, "title is required"),
  description: z49.string().optional(),
  instructor: Instructor,
  status: EventStatusEnumObj,
  videoStreamUrl: z49.string().url().min(1, "video stream url is required"),
  type: EventTypeObj,
  contentId: z49.coerce.string(),
  calendarLink: z49.string().optional(),
  scheduleDateTime: CustomLuxonDateSchema,
  isDataMigrated: z49.boolean().optional().default(false)
});

// src/events/be-schema.ts
import { string as string13 } from "zod";
var CreateEventSchemaBE = BaseEventSchema.pick({
  title: true,
  description: true,
  videoStreamUrl: true,
  type: true,
  calendarLink: true,
  scheduleDateTime: true,
  contentId: true
}).extend({
  instructorId: string13()
});
var UpdateEventSchemaBE = BaseEventSchema.omit({
  id: true,
  instructor: true
}).extend({
  instructorId: string13()
}).partial();

// src/events/fe-schema.ts
import { string as string14, z as z50 } from "zod";
var CreateEventSchemaFE = BaseEventSchema.pick({
  title: true,
  description: true,
  videoStreamUrl: true,
  type: true,
  calendarLink: true,
  scheduleDateTime: true
}).extend({
  instructorId: z50.coerce.string(),
  contentId: string14().min(1, "content id is required")
});
var UpdateEventSchemaFE = CreateEventSchemaFE.partial();
var defaultEventSchemaValues = {
  title: "",
  description: "",
  videoStreamUrl: "",
  calendarLink: "",
  type: EEventTypeEnum.CLASS,
  scheduleDateTime: void 0,
  instructorId: ""
};

// src/events/message.ts
import { number as number4, object as object14, string as string15, z as z51 } from "zod";
var EventMessageUserInfoSchema = object14({
  id: string15(),
  avatarUrl: string15(),
  username: string15(),
  userRoles: z51.array(string15()).optional()
});
var EventMessageSchema = z51.object({
  id: number4(),
  user: EventMessageUserInfoSchema,
  message: string15(),
  event: object14({
    id: string15()
  }),
  createdAt: string15(),
  updatedAt: string15()
});
var EventMessagePayloadSchema = object14({
  message: string15(),
  userId: string15(),
  parentId: number4().optional(),
  eventId: string15(),
  avatarUrl: string15(),
  username: string15(),
  userRoles: z51.array(string15()).optional()
});
var SendEventMessageRequestSchema = object14({
  message: string15().min(1, "Message cannot be empty"),
  parentId: number4().optional()
});

// src/events/pub-sub-event.enum.ts
import { z as z52 } from "zod";
var PubSubEventsEnumValues = [
  "VIEWER_JOINED",
  "VIEWER_LEFT",
  "EVENT_ENDED",
  "EVENT_STARTED",
  "SEND_MESSAGE",
  "REACT_TO_MESSAGE",
  "BROADCAST_MESSAGE"
];
var PubSubEventsEnumObj = z52.enum(PubSubEventsEnumValues);
var PubSubEventsEnum = PubSubEventsEnumObj.enum;

// src/events/reaction.ts
import { number as number5, object as object15, string as string16 } from "zod";
var EventReactionSchema = object15({
  id: string16().uuid(),
  eventMessage: EventMessageSchema,
  userId: string16()
});
var ReactToEventMessageSchema = object15({
  messageId: number5().positive(),
  userId: string16(),
  eventId: string16()
});

// src/events/reply.ts
import { z as z53 } from "zod";
var RepliesSchema = z53.lazy(() => EventMessageSchema.array());
var EventMessageSchemaWithReplies = EventMessageSchema.extend({
  replies: RepliesSchema,
  reactions: EventReactionSchema.array()
});

// src/events/socket-event.enum.ts
import { z as z54 } from "zod";
var SocketEventTypeEnumValues = [
  "connect",
  "disconnect",
  "USER_JOINED",
  "USER_LEFT",
  "EVENT_STARTED",
  "EVENT_FINISHED",
  "EVENT_INFO",
  "SEND_MESSAGE",
  "REACT_TO_MESSAGE",
  "MESSAGE_ERROR"
];
var SocketEventTypeEnumObj = z54.enum(SocketEventTypeEnumValues);
var SocketEventTypeEnum = SocketEventTypeEnumObj.enum;

// src/leaderboard/base.ts
import { boolean as boolean4, coerce as coerce11, number as number6, object as object16, string as string17, z as z55 } from "zod";
var LeaderBoardSchema = object16({
  id: coerce11.string().min(1),
  index: number6(),
  userId: coerce11.string().min(1),
  avatar: string17().url(),
  name: string17(),
  location: string17(),
  daysActive: string17().nullable(),
  workouts: coerce11.string(),
  points: coerce11.number(),
  isSelf: boolean4(),
  ranked: boolean4(),
  funFact: string17(),
  totalCompletedClass: number6(),
  date: string17()
});
var LeaderBoardTypeEnumValues = [
  "thisWeek",
  "lastWeek",
  "thisMonth",
  "lastMonth"
];
var LeaderBoardTypeEnumObj = z55.enum(LeaderBoardTypeEnumValues);
var LeaderBoardTypeEnum = LeaderBoardTypeEnumObj.enum;
var LeaderBoardRequestSchema = object16({
  type: LeaderBoardTypeEnumObj,
  page: coerce11.number().nullable().optional(),
  perPage: coerce11.number().nullable().optional()
});

// src/leaderboard/be-privacy-schema.ts
import { number as number7, object as object17, string as string18 } from "zod";
var UserPrivacySchemaBE = object17({
  id: number7().positive(),
  userId: string18(),
  isPrivate: CoerceBoolean,
  createdAt: string18(),
  updatedAt: string18()
});
var UserPrivacyRedisSchemaBE = UserPrivacySchemaBE.pick({
  userId: true,
  isPrivate: true
});
var UpdateUserPrivacyBESchema = UserPrivacySchemaBE.pick({
  userId: true,
  isPrivate: true
});

// src/login/base.ts
import { object as object18, string as string19 } from "zod";
var LoginSchema = object18({
  username: string19().min(3),
  password: string19().min(6)
});
var EmailLoginSchema = object18({
  password: string19().min(6),
  email: string19().email()
});

// src/login/exception.enum.ts
import { z as z56 } from "zod";
var JwtExceptionEnumValues = [
  "TokenExpired"
];
var JwtExceptionEnumObj = z56.enum(JwtExceptionEnumValues);

// src/login/password-reset.ts
import { z as z57 } from "zod";
var ForgotPasswordSchema = z57.object({
  email: z57.string().email()
});
var ResetPasswordSchema = z57.object({
  password: z57.string().min(8, "Password must be at least 8 characters"),
  confirmPassword: z57.string().min(8, "Password must be at least 8 characters")
}).refine((d) => d.password === d.confirmPassword, {
  message: "Passwords do not match",
  path: [
    "confirmPassword"
  ]
});
var SendPasswordResetSchema = z57.object({
  email: z57.string().email(),
  redirectUrl: z57.string().url(),
  expiresInHours: z57.number().int().min(1).max(8).optional()
});
var SetPasswordWithTokenSchema = z57.object({
  token: z57.string().uuid(),
  password: z57.string().min(8)
});
var AdminSetPasswordSchema = z57.object({
  email: z57.string().email(),
  password: z57.string().min(8)
});
var SetPasswordWithWpTokenSchema = z57.object({
  password: z57.string().min(8, "Password must be at least 8 characters"),
  userId: z57.string().min(1, "User ID is required")
});
var ResetPasswordSearchParamsSchema = z57.object({
  token: z57.string().uuid().optional()
});

// src/notification/be-condition-json-schema.ts
import { z as z59 } from "zod";

// src/notification/notification.enum.ts
import { z as z58 } from "zod";
var RealTimeNotificationEventTypeValues = [
  "CUSTOM_NOTIFICATION",
  "FIT_COMMENT_MENTION",
  "FIT_COMMENT_REACTION",
  "FIT_INSTRUCTOR_NOTIFICATION",
  "FIT_VIDEO_COMMENT",
  "FIT_WELCOME",
  "MAGIC_LINK_LOGIN",
  "OTP_LOGIN",
  "PASSWORD_CHANGE",
  "PASSWORD_RESET",
  // Secure email-change flow
  "EMAIL_CHANGE_VERIFY",
  "EMAIL_CHANGE_SECURITY_ALERT",
  "EMAIL_CHANGE_CONFIRMED",
  // Pro Directory notifications
  "PRO_DIRECTORY_APPROVED",
  "PRO_DIRECTORY_REJECTED",
  "PRO_DIRECTORY_SUBMISSION_CONFIRMED",
  "PRO_DIRECTORY_SUBMITTED",
  // Community Hub Feed notifications
  "CH_NEW_POST",
  "CH_POST_COMMENT",
  "CH_POST_REACTION",
  "CH_COMMENT_REPLY",
  "CH_COMMENT_REACTION",
  "CH_MENTION",
  // Support ticket notifications
  "SUPPORT_NEW_TICKET",
  "SUPPORT_TICKET_REPLY"
];
var CronNotificationEventTypeValues = [
  "INACTIVITY"
];
var NotificationRulesTypeValues = [
  ...CronNotificationEventTypeValues,
  ...RealTimeNotificationEventTypeValues
];
var NotificationRulesTypeEnumObject = z58.enum(NotificationRulesTypeValues);
var ENotificationRulesType = NotificationRulesTypeEnumObject.enum;
var NotificationRuleStatusValues = [
  "ACTIVE",
  "INACTIVE",
  "DRAFT"
];
var NotificationRuleStatusEnumObject = z58.enum(NotificationRuleStatusValues);
var ENotificationRuleStatus = NotificationRuleStatusEnumObject.enum;
var NotificationChannelValues = [
  "EMAIL",
  "In-App",
  "App-push"
];
var NotificationChannelEnumObject = z58.enum(NotificationChannelValues);
var ENotificationChannel = NotificationChannelEnumObject.enum;
var NotificationStatusValues = [
  "PENDING",
  "SENT",
  "FAILED",
  "SCHEDULED"
];
var NotificationStatusEnumObject = z58.enum(NotificationStatusValues);
var ENotificationStatus = NotificationStatusEnumObject.enum;
var NotificationTypeValues = [
  "CRON",
  "REALTIME"
];
var NotificationTypeEnumObject = z58.enum(NotificationTypeValues);
var ENotificationType = NotificationTypeEnumObject.enum;

// src/notification/be-condition-json-schema.ts
var BaseRuleConditionSchema = z59.object({
  type: NotificationRulesTypeEnumObject
});
var FitVideoCommentConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.FIT_VIDEO_COMMENT)
});
var FitCommentMentionConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.FIT_COMMENT_MENTION)
});
var FitInstructorCommentConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.FIT_INSTRUCTOR_NOTIFICATION)
});
var FitCommentLikeConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.FIT_COMMENT_REACTION)
});
var CustomNotificationConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.CUSTOM_NOTIFICATION)
});
var FitWelcomeConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.FIT_WELCOME)
});
var PasswordChangeConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.PASSWORD_CHANGE)
});
var PasswordResetConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.PASSWORD_RESET)
});
var MagicLinkLoginConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.MAGIC_LINK_LOGIN)
});
var OtpLoginConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.OTP_LOGIN)
});
var EmailChangeVerifyConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.EMAIL_CHANGE_VERIFY)
});
var EmailChangeSecurityAlertConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.EMAIL_CHANGE_SECURITY_ALERT)
});
var EmailChangeConfirmedConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.EMAIL_CHANGE_CONFIRMED)
});
var ChNewPostConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.CH_NEW_POST)
});
var ChPostCommentConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.CH_POST_COMMENT)
});
var ChPostReactionConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.CH_POST_REACTION)
});
var ChCommentReplyConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.CH_COMMENT_REPLY)
});
var ChCommentReactionConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.CH_COMMENT_REACTION)
});
var ChMentionConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.CH_MENTION)
});
var SupportNewTicketConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.SUPPORT_NEW_TICKET)
});
var SupportTicketReplyConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.SUPPORT_TICKET_REPLY)
});
var ProDirectoryApprovedConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.PRO_DIRECTORY_APPROVED)
});
var ProDirectoryRejectedConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.PRO_DIRECTORY_REJECTED)
});
var ProDirectorySubmittedConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.PRO_DIRECTORY_SUBMITTED)
});
var ProDirectorySubmissionConfirmedConditionSchema = BaseRuleConditionSchema.extend({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.PRO_DIRECTORY_SUBMISSION_CONFIRMED)
});
var RuleConditionJsonColumnValues = [
  "daysOfInactivity",
  "postPurchase",
  "totalCheckins"
];
var RuleConditionJsonColumnObject = z59.enum(RuleConditionJsonColumnValues);
var EnumRuleConditionJsonColumnObject = RuleConditionJsonColumnObject.enum;
var InactivityRuleConditionJsonSchemaBE = z59.object({
  type: z59.literal(NotificationRulesTypeEnumObject.enum.INACTIVITY),
  daysOfInactivity: z59.coerce.number().int().positive().describe("Number of days user has been inactive").optional(),
  postPurchase: z59.tuple([
    z59.number().positive(),
    z59.number().positive()
  ]).describe("Number of days since purchase").optional(),
  totalCheckins: z59.tuple([
    z59.number(),
    z59.number()
  ]).describe("Number of checkins").optional()
});
var RuleConditionJsonSchemaBE_ = z59.discriminatedUnion("type", [
  InactivityRuleConditionJsonSchemaBE,
  CustomNotificationConditionSchema,
  FitCommentMentionConditionSchema,
  FitCommentLikeConditionSchema,
  FitInstructorCommentConditionSchema,
  FitVideoCommentConditionSchema,
  FitWelcomeConditionSchema,
  MagicLinkLoginConditionSchema,
  OtpLoginConditionSchema,
  PasswordChangeConditionSchema,
  PasswordResetConditionSchema,
  EmailChangeVerifyConditionSchema,
  EmailChangeSecurityAlertConditionSchema,
  EmailChangeConfirmedConditionSchema,
  // Community Hub Feed notifications
  ChNewPostConditionSchema,
  ChPostCommentConditionSchema,
  ChPostReactionConditionSchema,
  ChCommentReplyConditionSchema,
  ChCommentReactionConditionSchema,
  ChMentionConditionSchema,
  // Support ticket notifications
  SupportNewTicketConditionSchema,
  SupportTicketReplyConditionSchema,
  // Pro Directory notifications
  ProDirectoryApprovedConditionSchema,
  ProDirectoryRejectedConditionSchema,
  ProDirectorySubmissionConfirmedConditionSchema,
  ProDirectorySubmittedConditionSchema
]);
var RuleConditionJsonSchemaBE = RuleConditionJsonSchemaBE_.refine((data) => {
  if (data.type === "INACTIVITY") {
    return data.daysOfInactivity !== void 0 || data.postPurchase !== void 0 || data.totalCheckins !== void 0;
  }
  return true;
}, {
  message: 'For INACTIVITY, at least one of "Days of Inactivity", "Post Purchase", or "Total Checkins" must be provided.'
});
function validateRuleConditions(conditionsJson) {
  const parsed = JSON.parse(conditionsJson);
  return RuleConditionJsonSchemaBE.parse(parsed);
}
__name(validateRuleConditions, "validateRuleConditions");

// src/notification/be-request.ts
import { coerce as coerce12, object as object19, string as string20 } from "zod";
var NotificationFindAllRequestQuerySchema = object19({
  page: coerce12.number().optional().default(1).describe("Page number (default: 1)"),
  perPage: coerce12.number().optional().default(10).describe("Items per page (default: 10)"),
  isActive: coerce12.boolean().optional().describe("Filter by active status"),
  channel: NotificationChannelEnumObject.optional().describe("Filter by notification channel"),
  type: NotificationTypeEnumObject.optional().describe("Filter by notification type"),
  app: AppNameEnumObj.optional().describe("Filter by app"),
  search: string20().optional().describe("Search by rule name")
});
var NotificationLogFindAllRequestQuerySchema = object19({
  page: coerce12.number().optional().default(1).describe("Page number (default: 1)"),
  perPage: coerce12.number().optional().default(10).describe("Items per page (default: 10)"),
  status: NotificationStatusEnumObject.optional().describe("Filter by notification status"),
  userId: string20().optional().describe("Filter by user ID"),
  channel: NotificationChannelEnumObject.optional().describe("Filter by notification channel")
});

// src/notification/be-response-schema.ts
import { boolean as boolean5, number as number8, string as string21, z as z60 } from "zod";
var TemplateResponseSchema = z60.object({
  id: number8(),
  name: string21(),
  subject: string21(),
  body: string21(),
  isEnabled: boolean5(),
  createdAt: string21(),
  updatedAt: string21(),
  redirectUrl: string21().nullable().optional(),
  iconUrl: string21().nullable().optional(),
  useBrandedTemplate: boolean5().optional(),
  renderedHtml: string21().nullable().optional()
});
var NotificationRuleResponseSchemaBE = z60.object({
  id: string21(),
  name: string21(),
  app: AppNameEnumObj,
  type: NotificationTypeEnumObject,
  conditionsJson: RuleConditionJsonSchemaBE,
  template: TemplateResponseSchema,
  channels: z60.array(NotificationChannelEnumObject).min(1),
  isActive: boolean5(),
  workflowId: string21(),
  createdBy: number8().nullable().optional(),
  updatedBy: number8().nullable().optional(),
  createdAt: string21(),
  updatedAt: string21()
});
var NotificationLogResponseSchemaBE = z60.object({
  id: string21(),
  userId: string21(),
  app: AppNameEnumObj,
  ruleId: string21(),
  templateId: string21(),
  status: NotificationStatusEnumObject,
  scheduledAt: string21().nullable().optional(),
  sentAt: string21().nullable().optional(),
  failedAt: string21().nullable().optional(),
  errorMessage: string21().nullable().optional(),
  retryCount: number8().default(0),
  maxRetries: number8().default(3),
  metadata: z60.record(z60.unknown()).nullable().optional(),
  rule: z60.object({
    id: number8(),
    name: string21(),
    type: NotificationTypeEnumObject,
    channel: NotificationChannelEnumObject,
    isActive: boolean5()
  }).nullable().optional(),
  createdAt: string21(),
  updatedAt: string21()
});

// src/notification/be-schema.ts
import { boolean as boolean6, object as object20, string as string22 } from "zod";
var CreateTemplateSchema = object20({
  name: string22().min(1, "Template name is required"),
  subject: string22().min(1, "Email subject is required"),
  body: string22().min(1, "Email body is required"),
  isEnabled: boolean6().optional().default(true),
  redirectUrl: string22().optional().nullable(),
  iconUrl: string22().optional().nullable(),
  // Email-channel only. When true, the rendered HTML body is wrapped in the
  // hardcoded branded email shell.
  useBrandedTemplate: boolean6().optional().default(false),
  // Email body (React Email JSX or raw HTML) compiled to HTML in the browser on
  // save, with `{var}` placeholders. This is what the backend sends.
  renderedHtml: string22().optional().nullable()
});

// src/notification/bulk-notification.ts
import { array as array4, boolean as boolean7, number as number9, object as object22, string as string23, z as z62 } from "zod";

// src/notification/novu-workflows.ts
import { object as object21, z as z61 } from "zod";
var NovuWorkflowValues = [
  "inactivity",
  "post-purchase",
  "welcome-notification"
];
var NovuWorkflowsEnumObject = z61.enum(NovuWorkflowValues);
var ENovuWorkflowsEnum = NovuWorkflowsEnumObject.enum;
var NovuEmailTemplateNameValues = [
  "send-inactivity-email",
  "send-post-purchase-email",
  "send-fit-welcome-email"
];
var NovuEmailTemplateNameEnumObject = z61.enum(NovuEmailTemplateNameValues);
var ENovuEmailTemplateNameEnum = NovuEmailTemplateNameEnumObject.enum;
var NovuTenantIdentifierValues = [
  "fit",
  "ryc",
  "members",
  "addon"
];
var NovuTenantIdentifierEnumObject = z61.enum(NovuTenantIdentifierValues);
var ENovuTenantIdentifierEnum = NovuTenantIdentifierEnumObject.enum;
var GenerateSubscriberIdWithTenantSchema = object21({
  tenantIdentifier: NovuTenantIdentifierEnumObject,
  userId: z61.coerce.string()
}).transform((data) => {
  const { tenantIdentifier, userId: userId2 } = data;
  return `${tenantIdentifier}:${userId2}`;
});

// src/notification/bulk-notification.ts
var CreateBulkNotificationSchema = object22({
  appName: AppNameEnumObj,
  tenantIdentifier: NovuTenantIdentifierEnumObject,
  selectAll: boolean7().optional(),
  userIds: array4(string23()).optional(),
  ruleIds: array4(z62.coerce.number().int().positive()).min(1, "Select at least one rule"),
  title: string23().min(1, "Title is required"),
  message: string23().min(1, "Message is required"),
  redirectUrl: string23().optional(),
  iconUrl: string23().url().optional()
});
var BulkNotificationBatchStatusSchema = object22({
  batchId: string23().uuid(),
  total: number9().int().nonnegative(),
  scheduled: number9().int().nonnegative(),
  pending: number9().int().nonnegative(),
  sent: number9().int().nonnegative(),
  failed: number9().int().nonnegative(),
  createdAt: string23().datetime().optional(),
  scheduledAt: string23().datetime().optional()
});
var CreateBulkNotificationResponseSchema = object22({
  batchId: string23().uuid(),
  logsCreated: number9().int().nonnegative(),
  inAppLogsCreated: number9().int().nonnegative().optional(),
  pushLogsCreated: number9().int().nonnegative().optional(),
  /** Users excluded from the App-push channel because they have no registered device token */
  pushSkippedNoDevice: number9().int().nonnegative().optional()
});
var MAX_BULK_RECIPIENT_IDENTIFIERS = 5e3;
var ResolveBulkRecipientsSchema = object22({
  identifiers: array4(string23().trim().min(1)).min(1, "Provide at least one identifier").max(MAX_BULK_RECIPIENT_IDENTIFIERS, `At most ${MAX_BULK_RECIPIENT_IDENTIFIERS} identifiers can be resolved at once`)
});
var ResolvedBulkRecipientSchema = object22({
  /** The identifier exactly as the admin typed it, so the UI can trace a match back to its input line. */
  identifier: string23(),
  userId: string23(),
  name: string23(),
  email: string23()
});
var ResolveBulkRecipientsResponseSchema = object22({
  resolved: array4(ResolvedBulkRecipientSchema),
  /** Identifiers that matched no profile, or were not a recognisable ID / email / UUID. */
  unresolved: array4(string23()),
  /** Identifiers dropped because an earlier identifier already resolved to the same user. */
  duplicates: array4(string23())
});

// src/notification/device-token/register-request.ts
import { object as object23, string as string24, z as z63 } from "zod";
var RegisterDeviceTokenRequestSchema = object23({
  expoPushToken: string24(),
  platform: z63.enum([
    "ios",
    "android"
  ]).optional()
});

// src/notification/notification-log.ts
import { boolean as boolean8, number as number10, object as object26, string as string27, z as z67 } from "zod";

// src/notification/realtime-notification/be-payload.ts
import { array as array5, coerce as coerce13, lazy as lazy2, object as object24, string as string25 } from "zod";
var RealtimeNotificationBePayloadSchemaBE = object24({
  appName: lazy2(() => AppNameEnumObj),
  tenantIdentifier: lazy2(() => NovuTenantIdentifierEnumObject),
  type: lazy2(() => NotificationRulesTypeEnumObject),
  content: object24({
    id: string25().optional(),
    name: string25().optional()
  }).optional(),
  liker: object24({
    id: string25(),
    name: string25()
  }).optional(),
  mentioner: object24({
    id: string25(),
    name: string25()
  }).optional(),
  comment: object24({
    id: coerce13.string().optional(),
    body: string25().optional(),
    replier: object24({
      id: string25(),
      name: string25()
    }).optional(),
    commenter: object24({
      id: string25(),
      name: string25()
    }).optional()
  }).optional(),
  user: object24({
    id: string25(),
    name: string25().optional(),
    email: string25().optional()
  }).optional(),
  userIdsToNotify: array5(string25()),
  title: string25().optional(),
  message: string25().optional(),
  redirectUrl: string25().optional(),
  iconUrl: string25().url().optional()
});
var WelcomeNotificationPayloadSchemaBE = object24({
  appName: lazy2(() => AppNameEnumObj),
  tenantIdentifier: lazy2(() => NovuTenantIdentifierEnumObject),
  type: lazy2(() => NotificationRulesTypeEnumObject),
  user: object24({
    id: string25(),
    name: string25().optional(),
    email: string25().optional()
  }),
  userIdsToNotify: array5(string25())
});

// src/notification/realtime-notification/device-token-payload.ts
import { array as array6, object as object25, string as string26, z as z64 } from "zod";
var DeviceTokenRegisterPayloadSchemaBE = object25({
  tenantIdentifier: NovuTenantIdentifierEnumObject,
  userId: string26(),
  expoPushToken: string26(),
  platform: z64.enum([
    "ios",
    "android"
  ]).optional(),
  activeExpoPushTokens: array6(string26())
});
var DeviceTokenUnregisterPayloadSchemaBE = object25({
  tenantIdentifier: NovuTenantIdentifierEnumObject,
  userId: string26(),
  expoPushToken: string26(),
  activeExpoPushTokens: array6(string26())
});

// src/notification/realtime-notification/messages.enum.ts
import { z as z65 } from "zod";
var RealtimeNotificationMessageTypeValues = [
  "COMMON",
  "WELCOME",
  "DEVICE_TOKEN_REGISTER",
  "DEVICE_TOKEN_UNREGISTER"
];
var RealtimeNotificationMessageTypeEnumObject = z65.enum(RealtimeNotificationMessageTypeValues);
var ERealtimeNotificationMessageType = RealtimeNotificationMessageTypeEnumObject.enum;

// src/notification/rule-engine-communication.ts
import { z as z66 } from "zod";
var RuleConditionTypeSchema = z66.enum([
  "INACTIVITY",
  "POST_PURCHASE",
  "NEVER_LOGIN",
  "SUBSCRIPTION_EXPIRY",
  "TRIAL_ENDING",
  "DAY_STEP_CHANGE"
]);
var NotificationRuleSchema = z66.object({
  id: z66.number().describe("Unique rule identifier"),
  name: z66.string().describe("Human-readable rule name"),
  type: NotificationTypeEnumObject.describe("Rule type for categorization"),
  conditionsJson: RuleConditionJsonSchemaBE.describe("Rule conditions in structured format"),
  templateId: z66.number().describe("Associated template ID (for notification app use)"),
  isActive: z66.boolean().describe("Whether rule is currently active"),
  createdAt: z66.string().datetime().describe("Rule creation timestamp"),
  updatedAt: z66.string().datetime().describe("Rule last update timestamp")
});
var RuleEvaluationRequestSchema = z66.object({
  jobDueDate: z66.string().describe("for which date the log should be created"),
  batchId: z66.string().uuid().describe("Unique batch identifier for tracking"),
  requestedAt: z66.string().datetime().describe("When the evaluation was requested"),
  requestSource: z66.string().default("NOTIFICATION_CRON").describe("Source of the request"),
  rules: z66.array(NotificationRuleSchema).min(1).describe("Active rules to evaluate against user data"),
  metadata: z66.record(z66.any()).optional().describe("Additional request metadata")
});
var UserDataSchema = z66.object({
  userId: z66.string().describe("User identifier"),
  username: z66.string().optional().describe("User display name"),
  email: z66.string().email().optional().describe("User email address"),
  registrationDate: z66.string().datetime().optional().describe("User registration date"),
  lastLoginDate: z66.string().datetime().optional().describe("Last login timestamp"),
  lastPurchaseDate: z66.string().datetime().optional().describe("Last purchase timestamp"),
  lastCheckinDate: z66.string().datetime().optional().describe("Last checkin timestamp"),
  purchaseDate: z66.string().datetime().optional().describe("Purchase timestamp"),
  tier: z66.number().optional().describe("User tier level"),
  subscriptionStatus: z66.string().optional().describe("Current subscription status"),
  additionalData: z66.record(z66.any()).optional().describe("Additional user-specific data")
});
var RuleMatchResultSchema = z66.object({
  userId: z66.string().describe("User ID that matched the rule"),
  ruleId: z66.number().describe("Rule ID that was matched"),
  templateId: z66.number().describe("Template ID for notification app to use"),
  matchedConditions: z66.record(z66.any()).describe("Details about which conditions were matched"),
  userData: UserDataSchema.describe("User data for notification app template rendering"),
  matchedAt: z66.string().datetime().describe("When the match was identified"),
  priority: z66.number().default(3).describe("Notification priority (1=highest, 5=lowest)")
});
var RuleEvaluationResponseSchema = z66.object({
  batchId: z66.string().uuid().describe("Same batch ID from request"),
  jobDueDate: z66.string().describe("for which date the job was created"),
  processedAt: z66.string().datetime().describe("When evaluation was completed"),
  totalRulesEvaluated: z66.number().describe("Number of rules processed"),
  totalUsersMatched: z66.number().describe("Total users matched across all rules"),
  matches: z66.array(RuleMatchResultSchema).describe("Array of user-rule matches with user data"),
  processingTimeMs: z66.number().describe("Processing time in milliseconds"),
  statistics: z66.object({
    ruleBreakdown: z66.record(z66.number()).describe("Matches per rule ID"),
    conditionTypeBreakdown: z66.record(z66.number()).describe("Matches per condition type")
  }).optional().describe("Evaluation statistics"),
  metadata: z66.record(z66.any()).optional().describe("Additional response metadata")
});

// src/notification/notification-log.ts
var BasicRuleSchema = object26({
  id: string27(),
  name: string27(),
  type: NotificationTypeEnumObject,
  channels: z67.array(NotificationChannelEnumObject),
  isActive: boolean8(),
  conditionsJson: RuleConditionJsonSchemaBE,
  workflowId: string27().nullable().optional(),
  template: object26({
    name: string27(),
    subject: string27(),
    body: string27()
  }).nullable().optional()
});
var NotificationLogSchema = object26({
  id: string27(),
  userId: string27(),
  ruleId: string27(),
  templateId: string27(),
  status: NotificationStatusEnumObject,
  scheduledAt: string27().datetime().nullable().optional(),
  sentAt: string27().datetime().nullable().optional(),
  failedAt: string27().datetime().nullable().optional(),
  errorMessage: string27().nullable().optional(),
  retryCount: number10().default(0),
  maxRetries: number10().default(3),
  metadata: z67.record(z67.unknown()).optional(),
  rule: BasicRuleSchema.nullable().optional(),
  createdAt: string27().datetime()
});
var GetNotificationLogsRequestSchema = RequestSchema.extend({
  status: NotificationStatusEnumObject.optional(),
  userId: string27().optional(),
  channel: NotificationChannelEnumObject.optional()
});
var GetNotificationLogsResponseSchema = object26({
  items: z67.array(NotificationLogSchema),
  meta: object26({
    totalPages: number10(),
    page: number10(),
    perPage: number10(),
    total: number10()
  })
});
var NotificationLogMetadataSchema = object26({
  ruleName: string27(),
  ruleType: NotificationTypeEnumObject,
  conditions: RuleConditionJsonSchemaBE,
  batchId: string27().uuid(),
  userData: object26({
    userId: string27()
  }),
  matchedAt: string27().datetime(),
  requestSource: string27(),
  matchedConditions: object26({
    type: RuleConditionTypeSchema,
    daysOfInactivity: number10().int().nonnegative(),
    lastCheckinDate: string27().optional()
  }).partial(),
  totalRulesProcessed: number10().int().nonnegative(),
  averageProcessingTimePerRule: number10().nonnegative(),
  // Bulk notification fields (title/message from RealtimeNotificationBePayloadSchemaBE)
  isBulkNotification: boolean8(),
  scheduledBy: string27(),
  channels: z67.array(NotificationChannelEnumObject)
}).merge(RealtimeNotificationBePayloadSchemaBE).partial().nullable();

// src/notification/rule/be-request-schema.ts
import { coerce as coerce14, z as z68 } from "zod";

// src/notification/rule/be-schema.ts
import { array as array7, boolean as boolean10, number as number12, object as object28, string as string29 } from "zod";

// src/notification/template/be-schema.ts
import { boolean as boolean9, number as number11, object as object27, string as string28 } from "zod";
var NotificationTemplateSchemaBE = object27({
  id: number11().int().positive(),
  name: string28().min(1),
  subject: string28().min(1),
  body: string28().min(1),
  isEnabled: boolean9().optional(),
  iconUrl: string28().nullable().optional(),
  redirectUrl: string28().nullable().optional(),
  useBrandedTemplate: boolean9().optional(),
  renderedHtml: string28().nullable().optional(),
  createdAt: string28(),
  updatedAt: string28()
});

// src/notification/template/novu-workflow.ts
var NovuWorkflowTemplateSchema = NotificationTemplateSchemaBE.pick({
  body: true,
  subject: true
});

// src/notification/template/variables.ts
var cronVariables = [
  "name",
  "humanizedDate",
  "relativeDate",
  "daysOfInactivity"
];
var userProfileVariables = [
  "name",
  "firstName",
  "lastName",
  "email"
];
var TemplateVariables = {
  [ENotificationRulesType.FIT_VIDEO_COMMENT]: [
    "contentId",
    "contentName",
    "commentOwner",
    "commentId",
    "commentBody",
    "replierId",
    "replierName",
    "commenterId",
    "commenterName"
  ],
  [ENotificationRulesType.FIT_INSTRUCTOR_NOTIFICATION]: [
    "contentId",
    "contentName",
    "commentOwner",
    "commentId",
    "commentBody",
    "commenterId",
    "commenterName"
  ],
  [ENotificationRulesType.FIT_COMMENT_MENTION]: [
    "contentId",
    "contentName",
    "commentId",
    "commentBody",
    "mentionerId",
    "mentionerName"
  ],
  [ENotificationRulesType.FIT_COMMENT_REACTION]: [
    "contentId",
    "contentName",
    "commentOwner",
    "commentId",
    "commentBody",
    "likerId",
    "likerName"
  ],
  [ENotificationRulesType.CUSTOM_NOTIFICATION]: userProfileVariables,
  [ENotificationRulesType.INACTIVITY]: cronVariables,
  [ENotificationRulesType.FIT_WELCOME]: userProfileVariables,
  [ENotificationRulesType.MAGIC_LINK_LOGIN]: [
    "magicLink",
    "expiresInMinutes",
    "email"
  ],
  [ENotificationRulesType.OTP_LOGIN]: [
    "otpCode",
    "expiresInMinutes",
    "email",
    "firstName",
    "name"
  ],
  [ENotificationRulesType.PASSWORD_CHANGE]: [
    "changedAt"
  ],
  // Community Hub Feed notifications
  [ENotificationRulesType.CH_NEW_POST]: [
    "postAuthorId",
    "postAuthorName",
    "spaceName"
  ],
  [ENotificationRulesType.CH_POST_COMMENT]: [
    "postId",
    "commenterId",
    "commenterName",
    "commentBody"
  ],
  [ENotificationRulesType.CH_POST_REACTION]: [
    "postId",
    "reactorId",
    "reactorName",
    "emoji"
  ],
  [ENotificationRulesType.CH_COMMENT_REPLY]: [
    "commentId",
    "replierId",
    "replierName",
    "replyBody"
  ],
  [ENotificationRulesType.CH_COMMENT_REACTION]: [
    "commentId",
    "reactorId",
    "reactorName",
    "emoji"
  ],
  [ENotificationRulesType.CH_MENTION]: [
    "mentionerId",
    "mentionerName",
    "targetType"
  ],
  // Pro Directory notifications
  [ENotificationRulesType.PRO_DIRECTORY_APPROVED]: userProfileVariables,
  [ENotificationRulesType.PRO_DIRECTORY_REJECTED]: [
    "rejectionReason",
    ...userProfileVariables
  ],
  [ENotificationRulesType.PRO_DIRECTORY_SUBMISSION_CONFIRMED]: userProfileVariables,
  [ENotificationRulesType.PRO_DIRECTORY_SUBMITTED]: [
    "name",
    "email",
    "dashboardUrl",
    "revisionId"
  ],
  [ENotificationRulesType.PASSWORD_RESET]: [
    "resetUrl",
    "expiresInMinutes",
    "username",
    "firstName",
    "lastName",
    "displayName",
    "name",
    "email"
  ],
  // Secure email-change flow
  [ENotificationRulesType.EMAIL_CHANGE_VERIFY]: [
    "verifyUrl",
    "expiresInHours",
    "newEmail",
    "oldEmail",
    "firstName",
    "displayName",
    "name"
  ],
  [ENotificationRulesType.EMAIL_CHANGE_SECURITY_ALERT]: [
    "cancelUrl",
    "newEmail",
    "oldEmail",
    "requestedAt",
    "firstName",
    "displayName",
    "name"
  ],
  [ENotificationRulesType.EMAIL_CHANGE_CONFIRMED]: [
    "newEmail",
    "oldEmail",
    "changedAt",
    "firstName",
    "displayName",
    "name"
  ],
  [ENotificationRulesType.SUPPORT_NEW_TICKET]: [
    "ticketId",
    "ticketTitle",
    "userEmail",
    "product",
    "dashboardUrl"
  ],
  [ENotificationRulesType.SUPPORT_TICKET_REPLY]: [
    "ticketId",
    "ticketTitle",
    "staffName",
    "replySnippet",
    "ticketUrl"
  ]
};

// src/notification/rule/be-schema.ts
var NotificationRuleSchemaBE = object28({
  id: number12().positive().int().min(1),
  name: string29().min(1),
  app: AppNameEnumObj,
  type: NotificationTypeEnumObject,
  conditionsJson: RuleConditionJsonSchemaBE,
  template: NotificationTemplateSchemaBE,
  workflowId: string29().min(1, "Workflow ID is required").describe("novu workflow identifier. (e.g post-purchase)"),
  channels: array7(NotificationChannelEnumObject).min(1, "Select at least one channel"),
  isActive: boolean10().optional(),
  createdBy: number12().nullable(),
  updatedBy: number12().nullable(),
  createdAt: string29(),
  updatedAt: string29()
});

// src/notification/rule/be-request-schema.ts
var APP_PUSH_INVALID_CHARS = /[<>\u0000-\u0008\u000B\u000C\u000E-\u001F]/;
var APP_PUSH_PLAIN_TEXT_MESSAGE = "App-push templates must be plain text \u2014 HTML tags and special characters are not allowed";
var validateRuleChannels = /* @__PURE__ */ __name((data, ctx) => {
  if (data.channels.includes(ENotificationChannel.EMAIL) && data.channels.length > 1) {
    ctx.addIssue({
      code: z68.ZodIssueCode.custom,
      path: [
        "channels"
      ],
      message: "EMAIL cannot be combined with other channels \u2014 create a separate rule for email"
    });
    return;
  }
  const isPushOnly = data.channels.includes(ENotificationChannel["App-push"]) && !data.channels.includes(ENotificationChannel["In-App"]);
  if (!isPushOnly) {
    return;
  }
  if (APP_PUSH_INVALID_CHARS.test(data.template.subject)) {
    ctx.addIssue({
      code: z68.ZodIssueCode.custom,
      path: [
        "template",
        "subject"
      ],
      message: APP_PUSH_PLAIN_TEXT_MESSAGE
    });
  }
  if (APP_PUSH_INVALID_CHARS.test(data.template.body)) {
    ctx.addIssue({
      code: z68.ZodIssueCode.custom,
      path: [
        "template",
        "body"
      ],
      message: APP_PUSH_PLAIN_TEXT_MESSAGE
    });
  }
}, "validateRuleChannels");
var CreateNotificationRuleObjectSchemaBE = NotificationRuleSchemaBE.pick({
  name: true,
  app: true,
  type: true,
  conditionsJson: true,
  workflowId: true,
  channels: true,
  isActive: true
}).extend({
  template: CreateTemplateSchema
});
var CreateNotificationRuleSchemaBE = CreateNotificationRuleObjectSchemaBE.superRefine(validateRuleChannels);
var UpdateNotificationRuleSchemaBE = CreateNotificationRuleObjectSchemaBE.extend({
  template: CreateTemplateSchema.extend({
    id: coerce14.number()
  })
}).superRefine(validateRuleChannels);

// src/notification/rule/export-schema.ts
import { array as array8, boolean as boolean11, literal, number as number13, object as object29, string as string30 } from "zod";
var RULE_EXPORT_VERSION = "1.1";
var NotificationRuleExportItemSchemaBE = CreateNotificationRuleObjectSchemaBE.omit({
  isActive: true
}).superRefine(validateRuleChannels);
var NotificationRuleExportSchemaBE = object29({
  version: literal(RULE_EXPORT_VERSION),
  exportedAt: string30(),
  rules: array8(NotificationRuleExportItemSchemaBE).min(1, "Export must contain at least one rule")
});
var ImportNotificationRulesSchemaBE = NotificationRuleExportSchemaBE.extend({
  overwrite: boolean11().optional().default(false).describe("Rewrite rules that already exist instead of skipping them")
});
var NotificationRuleExportQuerySchema = NotificationFindAllRequestQuerySchema.omit({
  page: true,
  perPage: true
});
var NotificationRuleImportResultSchemaBE = object29({
  created: array8(object29({
    id: number13(),
    name: string30()
  })),
  updated: array8(object29({
    id: number13(),
    name: string30()
  })),
  skipped: array8(object29({
    name: string30(),
    reason: string30()
  }))
});

// src/notification/user-management/get-users-request.ts
import { coerce as coerce15, object as object30, string as string31 } from "zod";
var GetNotificationUsersRequestBESchema = object30({
  tierInfo: coerce15.number().optional(),
  subscriptionsType: AppNameEnumObj.array(),
  limit: coerce15.number().max(100),
  page: coerce15.number(),
  query: string31().optional()
});

// src/playlist/base.ts
import { coerce as coerce25, number as number18, object as object44, string as string40, z as z90 } from "zod";

// src/fit/challenge/base.ts
import { z as z73 } from "zod";

// src/fit/challenge-content/base.ts
import { z as z71 } from "zod";

// src/fit/content/schema.ts
import { array as array9, boolean as boolean12, coerce as coerce16, lazy as lazy3, object as object31, string as string32, union as union3, z as z69 } from "zod";
var FITCommonContentFields = object31({
  id: string32(),
  name: string32().min(3, "name is required"),
  category: CategoryEnumObj,
  instructor: Instructor,
  watchedDate: coerce16.string().optional(),
  createdAt: coerce16.date(),
  updatedAt: coerce16.date()
});
var FITBareContent = FITCommonContentFields.extend({
  type: lazy3(() => ContentTypeEnumObj),
  status: StatusEnumObj,
  video: VimeoVideo,
  isAllowComment: coerce16.boolean().default(false),
  equipments: lazy3(() => Equipment.array()),
  publishedDate: z69.union([
    z69.string(),
    z69.date(),
    CustomLuxonDateSchema
  ]),
  averageRating: lazy3(() => RatingIndicator),
  isNew: coerce16.boolean().default(false).optional(),
  favorite: coerce16.boolean().default(false).optional(),
  instructorId: string32(),
  // this is needed for for react rendering. id is not unique in watch history response.
  uniqueId: string32().optional()
});
var FITContent = FITBareContent.extend({
  parentPlaylistsIds: string32().array().default([]).optional(),
  userHasLeftRating: coerce16.boolean().default(false).optional(),
  instructor: Instructor
});
var FITTrashContentSchema = FITCommonContentFields.extend({
  status: z69.literal(StatusEnum.TRASH),
  video: lazy3(() => TrashContentVimeoVideo)
});
var FITContentWithRatingFlagSchema = FITContent.extend({
  createdAt: coerce16.date(),
  updatedAt: coerce16.date(),
  publishedDate: z69.union([
    z69.string(),
    z69.date()
  ]).optional().nullable(),
  instructor: Instructor.extend({
    id: z69.union([
      coerce16.string(),
      coerce16.number()
    ]),
    createdAt: coerce16.date(),
    updatedAt: coerce16.date()
  }),
  userHasLeftRating: coerce16.boolean()
});
var FITContentFindAllResponseSchema = object31({
  items: FITContentWithRatingFlagSchema.array(),
  meta: object31({
    page: coerce16.number(),
    perPage: coerce16.number(),
    total: coerce16.number(),
    totalPages: coerce16.number()
  })
});
var FITContentAndTrashContentUnion = z69.union([
  FITContent,
  FITTrashContentSchema
]);
var FITContentWithWatchedDate = FITContent.extend({
  watchedDate: string32().or(CustomLuxonDateSchema)
});
var FITContentByDate = object31({
  id: string32(),
  activeOn: string32(),
  createdAt: coerce16.date(),
  updatedAt: coerce16.date(),
  content: FITContent
});
var FITContentResponseSchema = object31({
  items: FITContent.array().nullable(),
  // Computed from the requesting user's profile/subscription so the client can
  // lock cards straight from this response — no separate permissions request.
  hasAccess: boolean12().optional(),
  meta: object31({
    total: coerce16.number(),
    page: coerce16.number(),
    perPage: coerce16.number(),
    totalPages: coerce16.number()
  })
});
var FITContentByDateResponseSchema = object31({
  items: union3([
    array9(FITContentByDate),
    z69.null()
  ]),
  meta: object31({
    startDate: string32(),
    endDate: string32()
  })
});
var FITDateRangeQuerySchema = object31({
  startDate: string32().nullable(),
  endDate: string32().nullable(),
  page: coerce16.number().optional()
});
var FITUserContentRatingResponse = array9(RatingIndicator);
var FITWatchedStatusEnumValues = [
  "WATCHED",
  "UNWATCHED",
  "ALL"
];
var FITWatchedStatusEnumObj = z69.enum(FITWatchedStatusEnumValues);
var FITWatchedFilterEnum = FITWatchedStatusEnumObj.enum;

// src/fit/challenge-content/type.enum.ts
import { z as z70 } from "zod";
var FitChallengeContentTypeValues = [
  "event",
  "content"
];
var FitChallengeContentTypeEnumObject = z70.enum(FitChallengeContentTypeValues);
var EFitChallengeContentType = FitChallengeContentTypeEnumObject.enum;

// src/fit/challenge-content/base.ts
var BaseFitChallengeContentSchema = z71.object({
  id: z71.number().int().positive(),
  contentId: z71.string().max(36),
  type: FitChallengeContentTypeEnumObject,
  dayIndex: z71.number().int().min(1),
  createdAt: z71.date(),
  updatedAt: z71.date(),
  content: z71.lazy(() => FITContent.passthrough()).optional(),
  event: z71.lazy(() => BaseEventSchema.passthrough()).optional()
});

// src/fit/challenge/maintained-by.ts
import { z as z72 } from "zod";
var FitChallengeMaintainedBySchema = z72.record(z72.string().datetime(), z72.string());

// src/fit/challenge/base.ts
var BaseFitChallengeSchema = z73.object({
  id: z73.number().int().positive(),
  title: z73.string().max(255),
  description: z73.string().max(255).nullable().optional(),
  isActive: z73.boolean(),
  startDate: z73.string().datetime(),
  createdAt: z73.string(),
  updatedAt: z73.string(),
  maintainedBy: FitChallengeMaintainedBySchema,
  contents: z73.lazy(() => z73.array(BaseFitChallengeContentSchema.passthrough()).optional()),
  isChallengeRunning: z73.boolean().optional().transform((value) => value != null ? value : false),
  isChallengeFinished: z73.boolean().optional().transform((value) => value != null ? value : false),
  isChallengeStarted: z73.boolean().optional().transform((value) => value != null ? value : false),
  bufferDays: z73.number().int().optional(),
  isWithinOfficialChallengeDates: z73.boolean().optional().transform((value) => value != null ? value : false)
});

// src/fit/challenge/status.ts
import { boolean as boolean13, object as object32 } from "zod";
var ChallengeCompletionStatusSchema = object32({
  earnedDailyDedication: boolean13().describe("Given if daily dedication badge is already earned!"),
  earnedChallengeChampion: boolean13().describe("Given if challenge champion badge is already earned!"),
  canEarnDailyDedication: boolean13().describe("Given if all day badges are earned!"),
  canEarnChallengeChampion: boolean13().describe("Given if all video badges are earned!")
}).strict();

// src/fit/community-updates/activity.ts
import { z as z74 } from "zod";
var CommunityActivityTypeEnum = {
  COMMENT: "COMMENT",
  REACTION: "REACTION"
};
var CommunityUpdatesEventPattern = {
  ADD_ACTIVITY: "community-updates.add",
  REMOVE_ACTIVITY: "community-updates.remove"
};
var CommunityActivitySchema = z74.object({
  id: z74.string(),
  type: z74.enum([
    CommunityActivityTypeEnum.COMMENT,
    CommunityActivityTypeEnum.REACTION
  ]),
  contentId: z74.string(),
  contentName: z74.string(),
  contentCategory: CategoryEnumObj,
  instructorName: z74.string(),
  parentPlaylistsIds: z74.array(z74.string()).default([]),
  user: z74.object({
    id: z74.string(),
    name: z74.string(),
    avatarUrl: z74.string().nullable().optional()
  }),
  commentText: z74.string().nullable().optional(),
  hasRating: z74.boolean(),
  createdAt: z74.string()
});
var CommunityActivityResponseSchema = z74.object({
  activities: z74.array(CommunityActivitySchema)
});

// src/fit/community-updates/namespace.ts
var CommunityUpdatesNamespace = "community-updates";
var COMMUNITY_UPDATES_MAX_ITEMS = 5;

// src/fit/content/be-schema.ts
import { coerce as coerce18, lazy as lazy5, object as object34, string as string33, z as z76 } from "zod";

// src/fit/content/fe-schema.ts
import { coerce as coerce17, lazy as lazy4, object as object33, z as z75 } from "zod";
var CreateContentBasicSchemaFE = FITContent.omit({
  id: true,
  video: true,
  instructor: true,
  createdAt: true,
  updatedAt: true,
  isNew: true,
  status: true
}).extend({
  instructorId: coerce17.string(),
  equipments: coerce17.number().array().min(1, "Please select at least one equipment"),
  isAllowComment: coerce17.boolean().default(false),
  status: lazy4(() => StatusEnumObj),
  publishedDate: z75.string().or(CustomLuxonDateSchema).optional()
});
var CreateContentVideoSchemaFE = object33({
  video: VimeoVideoInput
});
var CreateContentSchemaFE = CreateContentBasicSchemaFE.omit({
  averageRating: true
}).merge(CreateContentVideoSchemaFE).refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var CreateContentSchemaFEWithoutValidation = CreateContentBasicSchemaFE.omit({
  averageRating: true
}).merge(CreateContentVideoSchemaFE);
var UpdateContentSchemaFE = CreateContentSchemaFEWithoutValidation.partial();
var FITDashboardUpdateContentSchemaFE = UpdateContentSchemaFE;
var FITDashboardCreateContentSchemaFEWithoutValidation = CreateContentSchemaFEWithoutValidation;
var FITDashboardCreateContentSchemaFE = CreateContentSchemaFE;
var defaultContentSchemaValues = {
  video: {
    bannerUrl2x: "",
    description: "",
    vimeoVideoId: ""
  },
  name: "",
  instructorId: "",
  equipments: [],
  isAllowComment: false,
  type: "VIDEO",
  favorite: false,
  category: "STRENGTH",
  status: "PUBLISHED",
  publishedDate: void 0
};

// src/fit/content/be-schema.ts
var CreateContentSchemaBEBase = CreateContentSchemaFEWithoutValidation.extend({
  category: lazy5(() => CategoryEnumObj),
  app: AppNameEnumObj,
  equipments: object34({
    id: coerce18.number().min(1, "id is required")
  }).array().min(1, "Please select at least one equipment"),
  video: VimeoVideoInput,
  publishedDate: z76.string().or(CustomLuxonDateSchema).optional().nullable(),
  id: string33().optional(),
  instructorId: string33().optional()
});
var CreateContentSchemaBE = CreateContentSchemaBEBase.refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var UpdateContentSchemaBE = CreateContentSchemaBEBase.partial();

// src/fit/content/complete-content-action.enum.ts
import { z as z77 } from "zod";
var CompleteContentActionValues = [
  "1min_before_finish",
  "2min_watch",
  "5min_watch"
];
var CompleteContentActionEnumObject = z77.enum(CompleteContentActionValues);
var ECompleteContentAction = CompleteContentActionEnumObject.enum;

// src/fit/content/complete-content.request.ts
import { object as object39, string as string37 } from "zod";

// src/tracking/user-log/action.enum.ts
import { z as z78 } from "zod";
var UserLogActionValues = [
  "CHECKIN",
  "WATCH_COMPLETE",
  "ATTENDING_LIVE",
  "PURCHASE",
  "PURCHASE_FAILED",
  "PURCHASE_CANCELLED",
  "PURCHASE_REFUND",
  "PURCHASE_PROCESSING",
  "PURCHASE_PENDING",
  "PURCHASE_ON_HOLD",
  "PURCHASE_PROCESSING",
  "VIDEO_PLAY",
  "PURCHASE_PENDING_CANCEL",
  "PURCHASE_EXPIRED",
  // Community hub — navigation
  "LESSON_VIEW",
  "MODULE_VIEW",
  "SPACE_VIEW",
  "COMMUNITY_VIEW",
  // Community hub — content block views
  "VIDEO_VIEW",
  "PDF_VIEW",
  "QUIZ_VIEW",
  "EMBED_VIEW",
  "FORM_VIEW",
  "GCS_UPLOAD_VIEW",
  "TEXT_VIEW",
  // Community hub — video lifecycle
  "VIDEO_COMPLETE",
  "VIDEO_PROGRESS_25",
  "VIDEO_PROGRESS_50",
  "VIDEO_PROGRESS_75",
  // Community hub — form submission states
  "FORM_SUBMISSION_IN_PROGRESS",
  "FORM_SUBMITTED",
  // Community hub — quiz completion states. Written to user_log from
  // GradingService (mirroring the form actions) and also recorded in
  // ch_quiz_attempts, which analytics reads for historical attempts.
  "QUIZ_SUBMITTED",
  "QUIZ_PASSED",
  // Community hub — GCS upload status transitions
  "GCS_UPLOAD_STARTED",
  "GCS_UPLOAD_IN_BUCKET",
  "GCS_UPLOAD_IN_DRIVE",
  "GCS_UPLOAD_FAILED",
  // Community hub — social feed
  "POST_VIEW",
  "POST_CREATE",
  "COMMENT_CREATE",
  "REACTION_ADD",
  // Events — join/leave tracking (standalone, not tied to spaces)
  "EVENT_JOIN",
  "EVENT_LEAVE",
  // Admin actions
  "ADMIN_GIVEN_ACCESS",
  // Admin granted product/app access to every member of a user group (one
  // summary record per operation, logged against the admin; each member also
  // gets its own ADMIN_GIVEN_ACCESS row carrying the group context in meta).
  "ADMIN_GROUP_GIVEN_ACCESS"
];
var UserLogActionEnumObj = z78.enum(UserLogActionValues);
var EUserLogActionEnum = UserLogActionEnumObj.enum;

// src/tracking/user-log/base.ts
import { coerce as coerce19, object as object35, string as string34, z as z79 } from "zod";
var UserLogBaseSchema = object35({
  id: coerce19.number().min(1, "id is required"),
  action: UserLogActionEnumObj,
  // Optional at the base level: purchase rows carry no app name (they have
  // productId instead). Non-purchase writes tighten this to required via
  // CreateUserLogSchemaBE.
  appName: string34().min(1).optional(),
  appTrackingId: string34().nullable().optional(),
  productId: string34().nullable().optional(),
  contentId: string34().min(1, "content id is required").nullable().optional(),
  contentTitle: string34().min(1, "content title is required").nullable().optional(),
  createdAt: string34().or(CustomLuxonDateSchema).or(z79.instanceof(Date)),
  ipAddress: string34().min(1, "ip address is required").nullable().optional(),
  userId: string34().min(1, "user id is required"),
  meta: z79.record(z79.any()).nullable().optional(),
  skipAddWatchPoint: z79.boolean().optional()
});
var UserLogBaseSchemaWithFullContent = UserLogBaseSchema.extend({
  content: Content
});

// src/tracking/user-log/be-schema.ts
import { coerce as coerce21, z as z83 } from "zod";

// src/emailer/be-schema.ts
import { coerce as coerce20, number as number14, object as object36, string as string35, z as z81 } from "zod";

// src/emailer/send-reason.enum.ts
import { z as z80 } from "zod";
var EmailSentReasonValues = [
  "COMPLETED_STEP_5",
  "COMPLETED_STEP_6_DAY_2",
  "COMPLETED_STEP_8",
  "COMPLETED_STEP_9_DAY_2",
  "COMPLETED_STEP_2",
  "COMPLETED_STEP_3_DAY_2",
  "IMMEDIATELY_AFTER_PURCHASE",
  "THREE_DAYS_AFTER_PURCHASE",
  "EIGHT_DAYS_AFTER_PURCHASE",
  "FIFTEEN_DAYS_AFTER_PURCHASE",
  "TWENTY_FIVE_DAYS_AFTER_PURCHASE",
  "NINE_DAYS_AFTER_PURCHASE_WITH_SEVEN_DAYS_LOGIN",
  "FIFTEEN_DAYS_AFTER_PURCHASE_WITH_THIRTEEN_DAYS_LOGIN",
  "DID_NOT_TRY_PROGRAM_AFTER_SEVEN_DAYS",
  "THIRTEEN_DAYS_AFTER_PURCHASE",
  "DID_NOT_TRY_PROGRAM_AFTER_FOURTEEN_DAYS",
  "DID_NOT_TRY_PROGRAM_AFTER_TWENTY_FOUR_DAYS",
  "NOT_LOGGED_IN_FOR_SEVEN_DAYS",
  "NOT_LOGGED_IN_FOR_FOURTEEN_DAYS",
  "THIRTY_DAYS_AFTER_PURCHASE_NO_LOGIN",
  "PURCHASE_OVER_EIGHT_DAYS_LOGIN_SIX_DAYS"
];
var EmailSendReasonObj = z80.enum(EmailSentReasonValues);
var EEmailSentReason = EmailSendReasonObj.enum;

// src/emailer/be-schema.ts
var SendEmailSchema = object36({
  email: string35().email(),
  emailType: EmailSendReasonObj,
  context: object36({
    name: string35(),
    userId: coerce20.string(),
    tier: number14()
  })
});
var EmailMetaSchema = object36({
  email: string35().email(),
  body: string35(),
  context: object36({
    name: string35(),
    userId: coerce20.string(),
    subject: string35()
  })
});
var SendStepAndDayCompletionSchema = object36({
  email: string35().email(),
  name: string35(),
  step: number14(),
  day: number14()
});
var EImmediateAfterPurchaseSchema = SendEmailSchema.omit({
  emailType: true
});
var SendTransactionalEmailSchema = object36({
  to: string35().email(),
  ruleName: string35(),
  context: z81.record(string35(), string35()),
  userId: string35().optional(),
  replyTo: string35().email().optional()
});

// src/emailer/email-status.enum.ts
import { z as z82 } from "zod";
var EmailSentStatusValues = [
  "COMPLETED",
  "SCHEDULED",
  "FAILED"
];
var EmailSentStatusObj = z82.enum(EmailSentStatusValues);
var EEmailSentStatus = EmailSentStatusObj.enum;

// src/emailer/send-email-response.ts
import { boolean as boolean14, number as number15, object as object37, string as string36 } from "zod";
var EmailReturnResponse = object37({
  to: string36().email(),
  subject: string36(),
  body: string36(),
  status: string36(),
  persistInDb: boolean14()
});
var EmailResponse = object37({
  accepted: string36().array(),
  rejected: string36().array(),
  ehlo: string36().array(),
  envelopeTime: number15(),
  messageTime: number15(),
  messageSize: number15(),
  response: string36(),
  envelope: object37({
    from: string36(),
    to: string36().array()
  }),
  messageId: string36()
});

// src/tracking/user-log/be-schema.ts
var PurchaseProductSchema = z83.object({
  product_id: z83.number().int(),
  variation_id: z83.number().int().nullable().optional(),
  subscription_id: z83.number().int().nullable().optional(),
  product_name: z83.string().optional(),
  tier: z83.number().optional(),
  price: z83.number().optional(),
  quantity: z83.number().int().optional()
});
var CreateUserLogSchemaBE = UserLogBaseSchema.omit({
  id: true,
  createdAt: true
}).extend({
  appName: z83.string().min(1, "app name is required")
});
var CreatePurchaseLogSchemaBE = UserLogBaseSchema.omit({
  id: true,
  createdAt: true,
  action: true,
  contentId: true,
  appName: true
}).extend({
  email: z83.string().email("Invalid email format")
});
var UserDayChangeSchemaBe = z83.object({
  email: z83.string().email(),
  eventType: EmailSendReasonObj,
  appName: AppNameEnumObj,
  tier: z83.number(),
  userId: z83.string().min(1, "user id is required"),
  name: z83.string().min(1, "name is required")
});
var AfterPurchaseRequestDtoBe = z83.object({
  appName: z83.string().optional(),
  productId: z83.string().optional(),
  userId: z83.string().min(1, "user id is required"),
  name: z83.string().min(1, "name is required"),
  action: UserLogActionEnumObj,
  // Purchase identifiers live inside `meta` — they're stored in the
  // `meta_information` jsonb column on user_log, not as first-class columns.
  // `.passthrough()` keeps other keys (email, tier, wpUserId, etc.) intact.
  meta: z83.object({
    orderId: z83.number().int().nullable().optional(),
    subscriptionId: z83.number().int().nullable().optional(),
    status: z83.string().max(30).nullable().optional(),
    tier: TiersEnumObject.optional(),
    email: z83.string().email().optional(),
    wpUserId: z83.string().optional(),
    product: PurchaseProductSchema.optional()
  }).passthrough().optional()
});
var UserLogFilterDtoBe = z83.object({
  page: coerce21.number(),
  perPage: coerce21.number().max(150),
  userId: z83.string().min(1, "user id is required"),
  appName: AppNameEnumObj,
  actions: UserLogActionEnumObj.array().optional()
});
var FindOneUserLogSchemaBe = z83.object({
  userId: z83.string().min(1)
});
var GetEventAttendeesSchemaBe = z83.string().min(1);
var FindUserLogSchemaBe = z83.object({
  userId: z83.string().optional(),
  appName: z83.string(),
  perPage: coerce21.number().optional(),
  page: coerce21.number().optional(),
  period: z83.string().optional(),
  date: z83.string().optional(),
  month: z83.string().optional(),
  // Inclusive ISO date (yyyy-MM-dd) range, resolved in the user's timezone.
  // Takes precedence over period/date/month when supplied.
  startDate: z83.string().optional(),
  endDate: z83.string().optional(),
  contentIds: z83.array(z83.string()).optional(),
  action: z83.array(UserLogActionEnumObj)
});
var UserCheckInSchemaBe = z83.object({
  appName: z83.string(),
  userId: z83.string(),
  page: z83.number(),
  perPage: z83.number()
});
var UserLastCheckInSchemaBe = z83.object({
  userId: z83.string(),
  appName: z83.string()
});

// src/tracking/user-log/purchase-request.ts
import { z as z84 } from "zod";
var PurchaseStatusValues = [
  "active",
  "expired",
  "cancelled",
  "completed",
  "failed",
  "refunded",
  "processing",
  "on-hold",
  "pending",
  "pending-cancel"
];
var PurchaseStatusEnum = z84.enum(PurchaseStatusValues);
var EPurchaseStatusEnum = PurchaseStatusEnum.enum;
var PurchaseRequestSchema = z84.object({
  appName: AppNameEnumObj.optional(),
  productId: z84.string().min(1, "product id is required"),
  userId: z84.string().min(1, "user id is required"),
  name: z84.string().min(1, "name is required"),
  email: z84.string().email("Invalid email format"),
  status: PurchaseStatusEnum,
  meta: z84.record(z84.any()).optional()
});

// src/tracking/watch-history/base.ts
import { coerce as coerce22, object as object38 } from "zod";
var WatchHistoryBaseSchema = object38({
  id: coerce22.number(),
  userId: coerce22.string().min(1, "user id is required"),
  contentId: coerce22.string().min(1, "content id is required"),
  createdAt: coerce22.string().or(CustomLuxonDateSchema)
});

// src/tracking/watch-history/be-schema.ts
import { z as z85 } from "zod";
var CreateWatchHistoryBeSchema = WatchHistoryBaseSchema.omit({
  id: true,
  createdAt: true
}).extend({
  email: z85.string().email("Invalid email format").optional()
});
var UpdateWatchHistoryBeSchema = CreateWatchHistoryBeSchema.partial();
var GetActivityDatesByMonthBeSchema = z85.object({
  appName: AppNameEnumObj,
  userId: z85.string(),
  timezone: z85.string(),
  month: z85.number(),
  year: z85.number()
});
var FindAllWatchHistoryBeSchema = z85.object({
  userId: z85.string().optional(),
  appName: z85.string(),
  perPage: z85.coerce.number().optional(),
  page: z85.coerce.number().optional(),
  period: z85.string().optional(),
  date: z85.string().optional(),
  month: z85.string().optional(),
  contentIds: z85.array(z85.string()).optional()
});
var FindAllByContentIdBeSchema = z85.object({
  contentId: z85.string().min(1),
  appName: z85.string().min(1),
  perPage: z85.coerce.number().optional(),
  page: z85.coerce.number().optional()
});
var FindOneWatchHistoryBeSchema = z85.object({
  id: z85.number().optional(),
  userId: z85.string().optional(),
  contentId: z85.string().optional(),
  appName: z85.string().min(1)
}).refine((data) => data.id !== void 0 || data.userId !== void 0 && data.contentId !== void 0, {
  message: "Either id or both userId and contentId must be provided"
});
var DeleteWatchHistoryBeSchema = z85.object({
  userId: z85.string(),
  appName: z85.string()
});

// src/fit/content/complete-content.request.ts
var CompleteContentRequestSchema = object39({
  contentId: string37(),
  action: UserLogActionEnumObj,
  app: AppNameEnumObj
});

// src/fit/onboarding/base.ts
import { coerce as coerce24, object as object41, string as string38 } from "zod";

// src/fit/onboarding/step.ts
import { coerce as coerce23, object as object40, z as z87 } from "zod";

// src/fit/onboarding/step.enum.ts
import { z as z86 } from "zod";
var FitOnboardingStepValues = [
  "WELCOME",
  "MILESTONE_NAV"
];
var FitOnboardingStepEnumObject = z86.enum(FitOnboardingStepValues);
var EFitOnboardingStep = FitOnboardingStepEnumObject.enum;

// src/fit/onboarding/step.ts
var FitOnboardingStepSchema = object40({
  id: coerce23.number().int().positive(),
  name: FitOnboardingStepEnumObject,
  isCompleted: CoerceBoolean,
  updatedAt: coerce23.string().date()
});
var CreateFitOnboardingStepSchemaBE = FitOnboardingStepSchema.extend({
  isCompleted: z87.boolean()
});
var UpdateFitOnboardingStepSchemaBE = object40({
  step: FitOnboardingStepEnumObject,
  timezone: z87.string().optional()
});

// src/fit/onboarding/base.ts
var FitOnboardingProgressSchema = object41({
  onboarding: FitOnboardingStepSchema.array(),
  tour: FitOnboardingStepSchema.array()
});
var BaseFitOnboardingSchema = object41({
  id: coerce24.number(),
  progress: FitOnboardingProgressSchema,
  userId: string38(),
  createdAt: coerce24.string().date(),
  updatedAt: coerce24.string().date()
});

// src/fit/onboarding/be-schema.ts
var CreateFitOnboardingSchemaBE = CreateFitOnboardingStepSchemaBE.array();

// src/fit/user-online/namespace.ts
var UserOnlineNamespace = "i-am-online";

// src/fit/user-online/pub-sub.ts
import { lazy as lazy7, z as z88 } from "zod";

// src/fit/user-online/user.ts
import { boolean as boolean15, lazy as lazy6, number as number16, object as object42, string as string39 } from "zod";
var UserOnlineLastWatchedContentSchema = BareContent.pick({
  id: true,
  name: true
}).extend({
  instructor: Instructor.pick({
    id: true,
    firstName: true,
    lastName: true
  }).nullable().optional()
});
var OnlineUserSchema = object42({
  id: string39(),
  avatarUrl: string39(),
  name: string39(),
  username: string39(),
  isPrivate: boolean15(),
  isActive: boolean15(),
  app: string39(),
  lastWatchedContent: lazy6(() => UserOnlineLastWatchedContentSchema.nullable().optional()),
  timestamp: number16()
});

// src/fit/user-online/pub-sub.ts
var USER_ONLINE_REDIS_CHANNEL = "USER_ONLINE";
var UserOnlinePubSubValues = [
  "UPDATE_LAST_WATCHED_CONTENT"
];
var UserOnlinePubSubEnumObject = z88.enum(UserOnlinePubSubValues);
var EUserOnlinePubSub = UserOnlinePubSubEnumObject.enum;
var UpadateUserOnlineLastWatchedContentSchema = z88.object({
  type: z88.literal(EUserOnlinePubSub.UPDATE_LAST_WATCHED_CONTENT),
  userId: z88.string(),
  lastWatchedContent: lazy7(() => UserOnlineLastWatchedContentSchema)
});
var UserOnlinePubSubSchema = z88.discriminatedUnion("type", [
  UpadateUserOnlineLastWatchedContentSchema
]);
var UserOnlinePubSubSchemaStringifiedSchema = UserOnlinePubSubSchema.transform((data) => JSON.stringify(data));
var stringifyUserOnlinePubSubSchema = /* @__PURE__ */ __name((data) => {
  return UserOnlinePubSubSchemaStringifiedSchema.parse(data);
}, "stringifyUserOnlinePubSubSchema");

// src/fit/user-online/response.ts
import { number as number17, object as object43 } from "zod";
var OnlineUsersResponseSchema = object43({
  users: OnlineUserSchema.array(),
  meta: MetaSchema
});
var HeartbeatResponseSchema = object43({
  users: OnlineUserSchema.array(),
  totalUsers: number17(),
  disconnectTimeoutMs: number17()
});

// src/fit/user-online/topics.enum.ts
import { z as z89 } from "zod";
var UserOnlineTopicValues = [
  "JOIN",
  "USER_JOINED",
  "LEAVE",
  "GET_NEXT_PAGE_USERS",
  "GET_PREVIOUS_PAGE_USERS",
  "GET_INITIAL_PUBLIC_USERS",
  "GET_ALL_USERS",
  "REFRESH_USERS",
  "REFRESH_ONLINE_PUBLIC_USERS",
  "NEW_USER"
];
var UserOnlineTopicEnumObject = z89.enum(UserOnlineTopicValues);
var EUserOnlineTopicEnum = UserOnlineTopicEnumObject.enum;

// src/playlist/base.ts
var PlaylistStatusEnumValues = [
  "ACTIVE",
  "DELETED"
];
var PlaylistStatusEnumObj = z90.enum(PlaylistStatusEnumValues);
var PlaylistStatusEnum = PlaylistStatusEnumObj.enum;
var PlaylistItem = object44({
  id: number18(),
  order: number18().int().positive(),
  content: FITContent
});
var PlaylistItemReorder = object44({
  id: number18().optional(),
  order: number18().int().positive(),
  content: object44({
    id: string40()
  })
});
var Playlist = object44({
  id: coerce25.string(),
  name: string40(),
  isFavorite: coerce25.boolean(),
  status: PlaylistStatusEnumObj,
  items: PlaylistItem.array(),
  createdAt: coerce25.string(),
  updatedAt: coerce25.string()
});
var PlaylistFormSchema = Playlist.omit({
  status: true,
  items: true,
  createdAt: true,
  updatedAt: true
});
var CreatePlaylistSchema = Playlist.omit({
  id: true,
  createdAt: true,
  updatedAt: true
});
var UpdatePlaylistSchema = Playlist.partial().omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  items: true
});
var PlaylistResponseSchema = object44({
  items: Playlist
});
var PlaylistsResponseSchema = object44({
  items: Playlist.array(),
  meta: object44({
    total: z90.number().int().nonnegative(),
    page: z90.number().int().positive(),
    perPage: z90.number().int().positive(),
    totalPages: z90.number().int().nonnegative()
  })
});

// src/playlist/playlist-type.enum.ts
import { z as z91 } from "zod";
var PlaylistTypeValues = [
  "playlist",
  "series"
];
var PlaylistTypeObj = z91.enum(PlaylistTypeValues);
var PlaylistTypeEnum = PlaylistTypeObj.enum;

// src/playlist/requests.schema.ts
import { coerce as coerce26, number as number19, object as object45, string as string41 } from "zod";
var Name = string41().min(1).max(100).trim();
var userId = coerce26.string();
var playlistId = coerce26.number().int().positive();
var id = coerce26.number().int().positive();
var CreatePlaylistRequestSchema = object45({
  name: Name,
  contentId: coerce26.string().optional()
});
var CreatePlaylistBeRequestSchema = CreatePlaylistRequestSchema.extend({
  userId
});
var UpdatePlaylistRequestSchema = object45({
  playlistId,
  name: Name.optional()
});
var ReorderPlaylistRequestSchema = object45({
  items: object45({
    id: number19(),
    order: number19(),
    content: object45({
      id: string41()
    })
  }).array(),
  id
});
var UpdatePlaylistBeRequestSchema = UpdatePlaylistRequestSchema.extend({
  userId
});
var ReorderPlaylistRequestSchemaBE = ReorderPlaylistRequestSchema.extend({
  userId
});
var InsertContentInPlaylistRequestSchema = object45({
  playlistId: playlistId.min(1),
  contentId: string41()
});
var DeleteContentFromPlaylistRequestSchema = object45({
  playlistId: playlistId.min(1),
  itemId: id.min(1)
});
var MovePlaylistContentRequestSchema = object45({
  currentPlaylistId: playlistId.min(1),
  newPlaylistId: playlistId.min(1),
  itemId: id.min(1)
});
var MovePlaylistContentRequestSchemaBE = MovePlaylistContentRequestSchema.extend({
  userId: userId.min(1)
});
var DeleteContentFromPlaylistBeRequestSchema = DeleteContentFromPlaylistRequestSchema.extend({
  userId
});
var InsertContentInPlaylistBeRequestSchema = InsertContentInPlaylistRequestSchema.extend({
  userId
});
var GetFavoriteContentBeRequestSchema = RequestSchema.omit({
  isHidden: true
}).extend({
  userId: string41()
});
var GetPlaylistsRequestSchema = object45({
  page: coerce26.number().int().positive().optional(),
  perPage: coerce26.number().int().positive().max(100).optional()
});
var GetPlaylistsBeRequestSchema = GetPlaylistsRequestSchema.extend({
  userId
});
var GetSinglePlaylistRequestSchema = object45({
  playlistId
});
var GetSinglePlaylistBeRequestSchema = GetSinglePlaylistRequestSchema.extend({
  userId
});
var RemovePlaylistRequestSchema = object45({
  playlistId
});
var RemovePlaylistBeRequestSchema = RemovePlaylistRequestSchema.extend({
  userId
});

// src/playlist/series-type.enum.ts
import { z as z92 } from "zod";
var SeriesTypeValues = [
  "collections",
  "mini-programs"
];
var SeriesTypeObj = z92.enum(SeriesTypeValues);
var SeriesTypeEnum = SeriesTypeObj.enum;

// src/playlist/settings.schema.ts
import { object as object46, string as string42 } from "zod";
var PlaylistSettingsSchema = object46({
  resourceBtnLabel: string42(),
  resourceBtnSubLabel: string42().optional(),
  resourceBtnUrl: string42(),
  resourceBtnLabel2: string42().optional(),
  resourceBtnSubLabel2: string42().optional(),
  resourceBtnUrl2: string42().optional(),
  resourceBtnLabel3: string42().optional(),
  resourceBtnSubLabel3: string42().optional(),
  resourceBtnUrl3: string42().optional()
});

// src/roles/index.ts
import { z as z93 } from "zod";
var RoleValues = [
  "instructor",
  "administrator",
  "kit_organizer"
];
var RolesEnumObj = z93.enum(RoleValues);
var ERolesEnum = RolesEnumObj.enum;
var MANAGEMENT_ROLES = [
  ERolesEnum.administrator,
  ERolesEnum.kit_organizer
];

// src/series/base.ts
import { array as array10, coerce as coerce27, number as number20, object as object47, string as string43, z as z94 } from "zod";
var Series = object47({
  id: coerce27.string(),
  // Slug must look like "example-slug-name": lowercase letters, digits, single
  // dashes between segments, no leading/trailing dashes. Optional at the base
  // level so non-addon series (fit/ryc) keep working unchanged.
  slug: string43().regex(SLUG_PATTERN, "Slug must be lowercase letters, digits and single dashes (e.g. example-slug-name)").optional(),
  classCount: number20().default(0).optional(),
  isFavorite: coerce27.boolean(),
  name: string43(),
  description: string43().nullable().default(""),
  imageUrl: coerce27.string().optional(),
  imageUrl2x: coerce27.string().optional(),
  isHidden: coerce27.boolean().default(false).optional(),
  requireSequentialCompletion: coerce27.boolean().default(false).optional(),
  settings: PlaylistSettingsSchema.optional(),
  seriesType: z94.preprocess((val) => val === "" ? null : val, SeriesTypeObj.nullable().default(null)),
  // publishDate: string(),
  order: coerce27.number().optional().nullable(),
  startButtonText: string43().optional().nullable()
});
var SingleSeries = Series.extend({
  contents: array10(FITContent)
});
var SeriesResponseSchema = Series.extend({
  items: PlaylistItem.array()
});
var SeriesListResponseSchema = object47({
  items: SeriesResponseSchema.array(),
  meta: object47({
    total: z94.number().int().nonnegative(),
    page: z94.number().int().positive(),
    perPage: z94.number().int().positive(),
    totalPages: z94.number().int().nonnegative()
  })
});

// src/series/be-schema.ts
import { coerce as coerce28, z as z95 } from "zod";

// src/series/fe-schema.ts
import { array as array11, string as string44 } from "zod";
var CreateSeriesSchemaFE = Series.omit({
  id: true,
  isFavorite: true,
  classCount: true,
  imageUrl: true,
  imageUrl2x: true,
  settings: true
}).extend({
  imageUrl: string44().optional(),
  imageUrl2x: string44().optional(),
  items: array11(PlaylistItem),
  resourceBtnLabel: string44().optional(),
  resourceBtnSubLabel: string44().optional(),
  resourceBtnUrl: string44().optional(),
  resourceBtnLabel2: string44().optional(),
  resourceBtnSubLabel2: string44().optional(),
  resourceBtnUrl2: string44().optional(),
  resourceBtnLabel3: string44().optional(),
  resourceBtnSubLabel3: string44().optional(),
  resourceBtnUrl3: string44().optional()
});
var defaultSeriesSchemaValues = {
  name: "",
  slug: void 0,
  imageUrl: "",
  imageUrl2x: "",
  description: "",
  isHidden: false,
  requireSequentialCompletion: false,
  seriesType: null,
  items: [],
  resourceBtnLabel: "",
  resourceBtnSubLabel: "",
  resourceBtnUrl: "",
  resourceBtnLabel2: "",
  resourceBtnSubLabel2: "",
  resourceBtnUrl2: "",
  resourceBtnLabel3: "",
  resourceBtnSubLabel3: "",
  resourceBtnUrl3: "",
  startButtonText: null
};

// src/series/be-schema.ts
var CreateSeriesSchemaBE = CreateSeriesSchemaFE.extend({
  items: PlaylistItemReorder.array()
});
var CreateSeriesRequestSchemaBE = CreateSeriesSchemaBE.extend({
  userId: coerce28.string()
});
var SeriesItemsRequestSchemaFE = z95.object({
  id: coerce28.number().int().positive(),
  items: PlaylistItemReorder.array()
});
var UpdateSeriesRequestSchemaFE = CreateSeriesSchemaFE.merge(SeriesItemsRequestSchemaFE);

// src/fit/slideshow/badge.ts
import { coerce as coerce29, object as object48, string as string45, z as z96 } from "zod";
var SlideBadgeImagePositionValues = [
  "top-left",
  "top-right",
  "top-center",
  "bottom-left",
  "bottom-right",
  "bottom-center",
  "center"
];
var SlideBadgeImagePositionEnumObj = z96.enum(SlideBadgeImagePositionValues);
var ESlideBadgeImagePositionEnum = SlideBadgeImagePositionEnumObj.enum;
var SlideBadgeDeviceSizesSchema = object48({
  mobile: coerce29.number().min(20, "Size must be at least 20").max(300, "Size must be at most 300"),
  tablet: coerce29.number().min(20, "Size must be at least 20").max(300, "Size must be at most 300"),
  desktop: coerce29.number().min(20, "Size must be at least 20").max(300, "Size must be at most 300")
});
var SlideBadgeDevicePositionsSchema = object48({
  mobile: SlideBadgeImagePositionEnumObj.optional().nullable(),
  tablet: SlideBadgeImagePositionEnumObj.optional().nullable(),
  desktop: SlideBadgeImagePositionEnumObj.optional().nullable()
});
var SlideBadgeSchema = object48({
  image: string45().optional().nullable(),
  positions: SlideBadgeDevicePositionsSchema.optional().nullable(),
  sizes: SlideBadgeDeviceSizesSchema.optional()
});

// src/fit/slideshow/base.ts
import { coerce as coerce30, never as never2, object as object50, string as string47 } from "zod";

// src/fit/slideshow/enums/app.ts
import { z as z97 } from "zod";
var SlideshowAppValues = [
  "fit"
];
var SlideshowAppEnumObj = z97.enum(SlideshowAppValues);
var ESlideshowAppEnum = SlideshowAppEnumObj.enum;

// src/fit/slideshow/enums/type.ts
import { z as z98 } from "zod";
var SlideshowTypeValues = [
  "content",
  "event",
  "series",
  "regular",
  "video"
];
var SlideshowTypeEnumObj = z98.enum(SlideshowTypeValues);
var ESlideshowTypeEnum = SlideshowTypeEnumObj.enum;

// src/fit/slideshow/union.ts
import { lazy as lazy8, literal as literal2, never, object as object49, string as string46, z as z99 } from "zod";
var NeverSchema = never().optional().nullable();
var ImageSchema = string46().min(1, "image url is required");
var ButtonLabelSchema = string46().min(3, "button label is required");
var ButtonUrlSchema = string46().url().min(1, "button url is required");
var BaseDiscriminatedUnion = z99.discriminatedUnion("type", [
  object49({
    type: literal2(ESlideshowTypeEnum.event),
    content: NeverSchema,
    buttonLabel: NeverSchema,
    buttonUrl: NeverSchema,
    series: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    event: lazy8(() => BaseEventSchema)
  }),
  object49({
    type: literal2(ESlideshowTypeEnum.content),
    event: NeverSchema,
    buttonLabel: NeverSchema,
    buttonUrl: NeverSchema,
    series: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    content: lazy8(() => FITContent)
  }),
  object49({
    type: literal2(ESlideshowTypeEnum.series),
    buttonLabel: NeverSchema,
    buttonUrl: NeverSchema,
    event: NeverSchema,
    content: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    series: lazy8(() => Playlist)
  }),
  object49({
    type: literal2(ESlideshowTypeEnum.regular),
    series: NeverSchema,
    event: NeverSchema,
    content: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    buttonLabel: ButtonLabelSchema,
    buttonUrl: ButtonUrlSchema
  }),
  object49({
    type: literal2(ESlideshowTypeEnum.video),
    series: NeverSchema,
    event: NeverSchema,
    content: NeverSchema,
    vimeoVideoId: string46().min(1, "vimeo video id is required"),
    image: string46().optional().nullable(),
    buttonLabel: string46().optional().nullable(),
    buttonUrl: string46().url().optional().nullable()
  })
]);
var FEDiscriminatedUnion = z99.discriminatedUnion("type", [
  object49({
    type: literal2(ESlideshowTypeEnum.event),
    content: NeverSchema,
    buttonLabel: NeverSchema,
    buttonUrl: NeverSchema,
    series: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    event: object49({
      id: string46().min(1, "event id is required")
    })
  }),
  object49({
    type: literal2(ESlideshowTypeEnum.content),
    event: NeverSchema,
    buttonLabel: NeverSchema,
    buttonUrl: NeverSchema,
    series: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    content: object49({
      id: string46().min(1, "content id is required")
    })
  }),
  object49({
    type: literal2(ESlideshowTypeEnum.series),
    event: NeverSchema,
    content: NeverSchema,
    buttonUrl: NeverSchema,
    buttonLabel: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    series: lazy8(() => PlaylistFormSchema)
  }),
  object49({
    type: literal2(ESlideshowTypeEnum.regular),
    series: NeverSchema,
    event: NeverSchema,
    content: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    buttonLabel: ButtonLabelSchema,
    buttonUrl: ButtonUrlSchema
  }),
  object49({
    type: literal2(ESlideshowTypeEnum.video),
    series: NeverSchema,
    event: NeverSchema,
    content: NeverSchema,
    image: string46().optional().nullable(),
    buttonLabel: string46().optional().nullable(),
    buttonUrl: ButtonUrlSchema.optional().nullable(),
    vimeoVideoId: string46().min(1, "vimeo video id is required")
  })
]);

// src/fit/slideshow/base.ts
var EventContentSchema = object50({
  event: never2().optional(),
  content: never2().optional()
});
var FromToDateSchema = object50({
  fromDate: coerce30.string().date().or(CustomLuxonDateSchema).or(string47()),
  toDate: coerce30.string().date().or(CustomLuxonDateSchema).or(string47())
});
var FromToDateNeverSchema = FromToDateSchema.extend({
  fromDate: never2().nullable().optional(),
  toDate: never2().nullable().optional()
});
var FromToDateORSchema = FromToDateSchema.or(FromToDateNeverSchema);
var BaseSlideshowSchemaWithoutUnion = object50({
  id: string47().min(1, "id is required"),
  title: coerce30.string().min(3, "Title is required"),
  image: string47().optional().nullable(),
  vimeoVideoId: string47().optional().nullable(),
  isActive: coerce30.boolean().default(true),
  subtitle: string47().optional().nullable(),
  description: string47().optional().nullable(),
  type: SlideshowTypeEnumObj.default("event"),
  badge: SlideBadgeSchema.optional().nullable().default(null),
  createdAt: coerce30.date(),
  updatedAt: coerce30.date()
});
var BaseSlideshowSchema = BaseSlideshowSchemaWithoutUnion.and(BaseDiscriminatedUnion).and(FromToDateORSchema);

// src/fit/slideshow/fe-schema.ts
var CreateSlideshowSchemaFE = BaseSlideshowSchemaWithoutUnion.omit({
  id: true,
  isActive: true,
  image: true,
  updatedAt: true,
  createdAt: true
}).and(FEDiscriminatedUnion).and(FromToDateORSchema).refine((data) => {
  const hasFromDate = !!data.fromDate;
  const hasToDate = !!data.toDate;
  if (!hasFromDate && !hasToDate) {
    return true;
  }
  if (hasFromDate && hasToDate) {
    const fromDate = DateTime.fromISO(data == null ? void 0 : data.fromDate.toString());
    const toDate = DateTime.fromISO(data == null ? void 0 : data.toDate.toString());
    return toDate > fromDate;
  }
  return true;
}, {
  message: "To date must be greater than From date",
  path: [
    "toDate"
  ]
});
var UpdateSlideshowSchemaFE = BaseSlideshowSchemaWithoutUnion.omit({
  id: true
}).partial().and(FEDiscriminatedUnion).and(FromToDateORSchema);
var defaultSlideshowSchemaValues = {
  title: "",
  type: ESlideshowTypeEnum.content,
  image: "",
  subtitle: "",
  description: "",
  buttonUrl: null,
  buttonLabel: null,
  badge: {
    image: null,
    positions: {
      mobile: ESlideBadgeImagePositionEnum["top-right"],
      tablet: ESlideBadgeImagePositionEnum["top-right"],
      desktop: ESlideBadgeImagePositionEnum["top-right"]
    },
    sizes: {
      mobile: 50,
      tablet: 70,
      desktop: 100
    }
  }
};

// src/fit/slideshow/filters.ts
import { z as z100 } from "zod";
var SlideshowFiltersSchema = BaseSlideshowSchemaWithoutUnion.pick({
  isActive: true
}).merge(RequestSchema.omit({
  isHidden: true
}).extend({
  isDashboard: z100.coerce.boolean().optional()
})).partial();

// src/user/change-password.ts
import { z as z101 } from "zod";
var ChangePasswordSchema = z101.object({
  currentPassword: z101.string().min(1, "Current password is required"),
  newPassword: z101.string().min(8, "Password must be at least 8 characters"),
  confirmPassword: z101.string().min(1, "Please confirm your new password")
}).refine((data) => data.newPassword !== data.currentPassword, {
  message: "New password must be different from your current password",
  path: [
    "newPassword"
  ]
}).refine((data) => data.newPassword === data.confirmPassword, {
  message: "Passwords don't match",
  path: [
    "confirmPassword"
  ]
});
var ChangePasswordApiSchema = z101.object({
  currentPassword: z101.string().min(1),
  newPassword: z101.string().min(8)
});

// src/user/check-in.ts
import { number as number21, object as object51, string as string48, z as z102 } from "zod";
var CheckInSchema = object51({
  id: number21().min(1, "id is required"),
  userId: string48().min(1, "user id is required"),
  appName: AppNameEnumObj,
  action: UserLogActionEnumObj,
  contentId: string48().nullable().default(null),
  ipAddress: string48().min(1, "ip address is required").nullable().optional(),
  createdAt: string48().or(z102.instanceof(Date)).or(CustomLuxonDateSchema)
});

// src/user/email-change.ts
import { z as z103 } from "zod";
var RequestEmailChangeSchema = z103.object({
  newEmail: z103.string().email("Must be a valid email"),
  currentPassword: z103.string().min(1, "Current password is required"),
  /** FE base URL the new-email activation link points at, e.g. https://app/auth/verify-email-change */
  verifyRedirectUrl: z103.string().url(),
  /** FE base URL the old-email cancel link points at, e.g. https://app/auth/cancel-email-change */
  cancelRedirectUrl: z103.string().url()
});
var ConfirmEmailChangeSchema = z103.object({
  token: z103.string().uuid()
});
var CancelEmailChangeSchema = z103.object({
  token: z103.string().uuid(),
  /**
  * FE base URL for the password-reset page. Cancelling a request also forces a
  * password reset on the old address as a "this wasn't me" safety net, and the
  * reset email needs a redirect target.
  */
  resetRedirectUrl: z103.string().url()
});
var EmailChangeSearchParamsSchema = z103.object({
  token: z103.string().uuid().optional()
});

// src/user/update-pro-directory.ts
import { z as z105 } from "zod";

// src/supabase/pro-directory.ts
import { z as z104 } from "zod";
var TeachingFormatSchema = z104.string().transform((v) => v.toLowerCase()).pipe(z104.enum([
  "in_person",
  "online",
  "both"
]));
var ProDirectorySocialsSchema = z104.object({
  facebook: z104.string().nullable().optional(),
  instagram: z104.string().nullable().optional(),
  youtube: z104.string().nullable().optional(),
  twitter: z104.string().nullable().optional(),
  linkedin: z104.string().nullable().optional(),
  tiktok: z104.string().nullable().optional()
}).nullable().optional();
var ProDirectoryRowSchema = z104.object({
  id: z104.coerce.number(),
  slug: z104.string().nullable().optional(),
  is_active: z104.boolean().default(false),
  bio: z104.string().nullable().optional(),
  profession: z104.array(z104.string()).nullable().optional(),
  other_profession: z104.string().nullable().optional(),
  company_name: z104.string().nullable().optional(),
  company_email: z104.string().nullable().optional(),
  professional_website: z104.string().nullable().optional(),
  offerings: z104.array(z104.string()).nullable().optional(),
  teaching_format: TeachingFormatSchema.nullable().optional(),
  expertise: z104.array(z104.string()).nullable().optional(),
  languages_taught: z104.array(z104.string()).nullable().optional(),
  casual_image: z104.string().nullable().optional(),
  landscape_image: z104.string().nullable().optional(),
  full_name: z104.string().nullable().optional(),
  title: z104.string().nullable().optional(),
  phone: z104.string().nullable().optional(),
  business_street: z104.string().nullable().optional(),
  business_country_id: z104.number().nullable().optional(),
  business_state_id: z104.number().nullable().optional(),
  business_city_id: z104.number().nullable().optional(),
  certificates: z104.string().nullable().optional(),
  socials: ProDirectorySocialsSchema,
  created_at: z104.string(),
  updated_at: z104.string()
});
var ProDirectorySchema = ProDirectoryRowSchema.transform((values) => {
  var _a5, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v;
  return {
    id: values.id,
    slug: (_a5 = values.slug) != null ? _a5 : null,
    isActive: values.is_active,
    bio: (_b = values.bio) != null ? _b : null,
    profession: (_c = values.profession) != null ? _c : [],
    otherProfession: (_d = values.other_profession) != null ? _d : null,
    companyName: (_e = values.company_name) != null ? _e : null,
    companyEmail: (_f = values.company_email) != null ? _f : null,
    professionalWebsite: (_g = values.professional_website) != null ? _g : null,
    offerings: (_h = values.offerings) != null ? _h : [],
    teachingFormat: (_i = values.teaching_format) != null ? _i : null,
    expertise: (_j = values.expertise) != null ? _j : [],
    languagesTaught: (_k = values.languages_taught) != null ? _k : [],
    casualImage: (_l = values.casual_image) != null ? _l : null,
    landscapeImage: (_m = values.landscape_image) != null ? _m : null,
    fullName: (_n = values.full_name) != null ? _n : null,
    title: (_o = values.title) != null ? _o : null,
    phone: (_p = values.phone) != null ? _p : null,
    businessStreet: (_q = values.business_street) != null ? _q : null,
    businessCountryId: (_r = values.business_country_id) != null ? _r : null,
    businessStateId: (_s = values.business_state_id) != null ? _s : null,
    businessCityId: (_t = values.business_city_id) != null ? _t : null,
    certificates: (_u = values.certificates) != null ? _u : null,
    socials: (_v = values.socials) != null ? _v : null,
    createdAt: values.created_at,
    updatedAt: values.updated_at
  };
});
var ProDirectoryRevisionStatusSchema = z104.enum([
  "pending",
  "approved",
  "rejected",
  "draft"
]);
var offeringsField = z104.union([
  z104.array(z104.string()),
  z104.string().transform((v) => v.split(",").map((s2) => s2.trim()).filter(Boolean))
]).nullable().optional();
var ProDirectoryDataSchema = z104.object({
  bio: z104.string().nullable().optional(),
  profession: z104.array(z104.string()).nullable().optional(),
  other_profession: z104.string().nullable().optional(),
  company_name: z104.string().nullable().optional(),
  company_email: z104.string().nullable().optional(),
  professional_website: z104.string().nullable().optional(),
  offerings: offeringsField,
  teaching_format: TeachingFormatSchema.nullable().optional(),
  expertise: z104.array(z104.string()).nullable().optional(),
  languages_taught: z104.array(z104.string()).nullable().optional(),
  casual_image: z104.string().nullable().optional(),
  landscape_image: z104.string().nullable().optional(),
  full_name: z104.string().nullable().optional(),
  title: z104.string().nullable().optional(),
  phone: z104.string().nullable().optional(),
  business_street: z104.string().nullable().optional(),
  business_country_id: z104.number().nullable().optional(),
  business_state_id: z104.number().nullable().optional(),
  business_city_id: z104.number().nullable().optional(),
  certificates: z104.string().nullable().optional(),
  socials: ProDirectorySocialsSchema,
  slug: z104.string().nullable().optional()
});
var ProDirectoryRevisionRowSchema = z104.object({
  id: z104.coerce.number(),
  pro_directory_id: z104.coerce.number().nullable(),
  user_id: z104.coerce.number(),
  status: ProDirectoryRevisionStatusSchema,
  data: ProDirectoryDataSchema,
  approved_on: z104.string().nullable(),
  rejected_on: z104.string().nullable(),
  reviewed_by: z104.string().nullable(),
  rejection_reason: z104.string().nullable().optional(),
  created_at: z104.string()
});
var ProDirectoryRevisionSchema = ProDirectoryRevisionRowSchema.transform((r) => {
  var _a5;
  return {
    id: r.id,
    proDirectoryId: r.pro_directory_id,
    userId: r.user_id,
    status: r.status,
    data: r.data,
    approvedOn: r.approved_on,
    rejectedOn: r.rejected_on,
    reviewedBy: r.reviewed_by,
    rejectionReason: (_a5 = r.rejection_reason) != null ? _a5 : null,
    createdAt: r.created_at
  };
});
var ProDirectoryRevisionWithProSchema = z104.object({
  id: z104.coerce.number(),
  proDirectoryId: z104.coerce.number().nullable(),
  userId: z104.coerce.number(),
  status: ProDirectoryRevisionStatusSchema,
  data: ProDirectoryDataSchema,
  approvedOn: z104.string().nullable(),
  rejectedOn: z104.string().nullable(),
  reviewedBy: z104.string().nullable(),
  rejectionReason: z104.string().nullable().optional(),
  createdAt: z104.string(),
  proName: z104.string().nullable(),
  proAvatar: z104.string().nullable(),
  proEmail: z104.string().nullable(),
  currentSlug: z104.string().nullable(),
  currentData: ProDirectoryDataSchema.nullable()
});
var ApproveProDirectoryRevisionSchema = z104.object({
  slug: z104.string().min(1).regex(SLUG_PATTERN, "Slug must contain only English letters (a\u2013z), numbers, and hyphens, and cannot start or end with a hyphen (e.g. jane-doe)")
});
var ListProDirectoryRevisionsQuerySchema = z104.object({
  status: ProDirectoryRevisionStatusSchema.optional(),
  page: z104.coerce.number().int().positive().default(1),
  limit: z104.coerce.number().int().positive().max(100).default(20)
});
var RejectProDirectoryRevisionSchema = z104.object({
  reason: z104.string().min(1, "Reason is required").max(500, "Reason must be 500 characters or fewer"),
  sendNotification: z104.boolean().default(true)
});

// src/user/update-pro-directory.ts
var optionalUrl2 = z105.string().url("Must be a valid URL").or(z105.literal("")).nullable().optional();
var optionalEmail = z105.string().email("Must be a valid email").or(z105.literal("")).nullable().optional();
var DOMAIN_PATTERN = /^(https?:\/\/)?(www\.)?[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+(:\d+)?(\/\S*)?$/i;
var optionalWebsite = z105.string().regex(DOMAIN_PATTERN, "Enter a valid website, e.g. example.com").or(z105.literal("")).nullable().optional();
var UpdateProDirectorySchema = z105.object({
  isDraft: z105.boolean().optional(),
  slug: z105.string().regex(SLUG_PATTERN, "Slug must contain only English letters (a\u2013z), numbers, and hyphens, and cannot start or end with a hyphen (e.g. jane-doe)").nullable().optional(),
  bio: z105.string().max(3e3, "Bio must be 3000 characters or fewer").nullable().optional(),
  profession: z105.array(z105.string()).max(10, "Select up to 10 professions").nullable().optional(),
  otherProfession: z105.string().nullable().optional(),
  companyName: z105.string().nullable().optional(),
  companyEmail: optionalEmail,
  professionalWebsite: optionalWebsite,
  offerings: z105.array(z105.string()).nullable().optional(),
  teachingFormat: TeachingFormatSchema.nullable().optional(),
  expertise: z105.array(z105.string()).max(10, "Select up to 10 conditions").nullable().optional(),
  languagesTaught: z105.array(z105.string()).nullable().optional(),
  casualImage: z105.string().nullable().optional(),
  landscapeImage: z105.string().nullable().optional(),
  fullName: z105.string().nullable().optional(),
  title: z105.string().nullable().optional(),
  phone: z105.string().nullable().optional(),
  businessStreet: z105.string().nullable().optional(),
  businessCountryId: z105.number().nullable().optional(),
  businessStateId: z105.number().nullable().optional(),
  businessCityId: z105.number().nullable().optional(),
  certificates: z105.string().nullable().optional(),
  socials: z105.object({
    facebook: optionalUrl2,
    instagram: optionalUrl2,
    youtube: optionalUrl2,
    twitter: optionalUrl2,
    linkedin: optionalUrl2,
    tiktok: optionalUrl2
  }).nullable().optional()
});

// src/user/update-profile.ts
import { z as z106 } from "zod";
var optionalUrl3 = z106.string().url("Must be a valid URL").or(z106.literal("")).nullable().optional();
var USERNAME_REGEX = /^[a-z0-9._]{3,30}$/;
var UsernameSchema = z106.string().trim().min(3, "Username must be at least 3 characters").max(30, "Username must be at most 30 characters").regex(USERNAME_REGEX, "Use lowercase letters, numbers, period and underscore only");
var UpdateProfileSchema = z106.object({
  firstName: z106.string().min(1, "First name is required"),
  lastName: z106.string().optional(),
  email: z106.string().email("Must be a valid email").optional().or(z106.literal("")),
  displayName: z106.string().optional(),
  username: UsernameSchema.optional(),
  occupation: z106.string().optional(),
  timezone: z106.string().min(1, "Timezone is required"),
  isPrivate: z106.boolean().default(false),
  bio: z106.string().nullable().optional(),
  primaryLanguage: z106.string().min(1, "Primary language is required"),
  phoneNumber: z106.string().nullable().optional(),
  zoomEmail: z106.string().email("Must be a valid email").optional().or(z106.literal("")),
  address: z106.object({
    street: z106.string().nullable().optional(),
    city: z106.string().nullable().optional(),
    state: z106.string().nullable().optional(),
    zip: z106.string().nullable().optional(),
    country: z106.string().nullable().optional(),
    countryId: z106.coerce.number().nullable().optional(),
    stateId: z106.coerce.number().nullable().optional(),
    cityId: z106.coerce.number().nullable().optional()
  }).nullable().optional(),
  socials: z106.object({
    facebook: optionalUrl3,
    instagram: optionalUrl3,
    youtube: optionalUrl3,
    twitter: optionalUrl3,
    linkedin: optionalUrl3,
    tiktok: optionalUrl3
  }).nullable().optional()
});
var ProfileFormSchema = UpdateProfileSchema.extend({
  avatar: z106.string().optional(),
  lastName: z106.string().min(1, "Last name is required"),
  email: z106.string().email("Must be a valid email").min(1, "Email is required"),
  displayName: z106.string().min(1, "Display name is required"),
  occupation: z106.string().min(1, "Profession is required"),
  phoneNumber: z106.string().nullable().optional(),
  address: z106.object({
    city: z106.string().nullable().optional(),
    state: z106.string().nullable().optional(),
    country: z106.string().nullable().optional(),
    street: z106.string().nullable().optional(),
    countryId: z106.coerce.number().nullable().optional(),
    stateId: z106.coerce.number().nullable().optional(),
    cityId: z106.coerce.number().nullable().optional()
  })
});

// src/wp-jwt/base.ts
import { array as array12, object as object52, string as string49, z as z107 } from "zod";
var UserJwtSchema = z107.object({
  wp_token: z107.string(),
  data: object52({
    user_apps: array12(z107.number()).optional(),
    user_email: string49(),
    user_id: z107.number(),
    user_uuid: z107.string().optional(),
    role: string49().array().default([
      "user"
    ])
  })
}).required();

// src/service-response/index.ts
import { coerce as coerce31, object as object53, z as z108 } from "zod";
var ServiceResponseErrorSchema = object53({
  message: z108.string(),
  code: z108.number()
});
var ServiceResponseDescriminatedUnionSchema = /* @__PURE__ */ __name((dataType) => {
  return z108.discriminatedUnion("status", [
    object53({
      status: z108.literal("ok"),
      items: dataType,
      meta: z108.object({
        total: coerce31.number(),
        page: coerce31.number(),
        perPage: coerce31.number(),
        totalPages: coerce31.number()
      })
    }),
    object53({
      status: z108.literal("error"),
      error: ServiceResponseErrorSchema
    })
  ]);
}, "ServiceResponseDescriminatedUnionSchema");

// src/settings/base.ts
import { coerce as coerce32, object as object54, union as union4 } from "zod";
var FeaturedSeriesSettingSchema = object54({
  title: coerce32.string().min(5, "Title is required"),
  subtitle: coerce32.string().min(5, "Subtitle is required"),
  body: coerce32.string().min(5, "Description is required"),
  button_label: coerce32.string().min(3, "Button label is required"),
  video_badge: coerce32.string().min(3, "Video badge is required"),
  isEnable: CoerceBoolean.default(false).optional(),
  seriesId: coerce32.number().optional()
});
var ChallengeBannerSettingSchema = object54({
  isEnable: CoerceBoolean.default(false)
});
var ChallengePageSettingSchema = ChallengeBannerSettingSchema;
var OnboardingSettingSchema = ChallengeBannerSettingSchema;
var UpcomingLiveBannerSettingSchema = ChallengeBannerSettingSchema;
var BaseSettingSchema = union4([
  FeaturedSeriesSettingSchema,
  ChallengeBannerSettingSchema,
  OnboardingSettingSchema,
  UpcomingLiveBannerSettingSchema
]);

// src/settings/be-schema.ts
import { object as object56, z as z111 } from "zod";

// src/settings/fe-schema.ts
import { z as z110 } from "zod";

// src/settings/global-settings-schema.ts
import { coerce as coerce33, object as object55, z as z109 } from "zod";
var ContactFormSettingSchema = object55({
  iframeUrl: coerce33.string().url("Must be a valid URL")
});
var GlobalSettingsValue = ContactFormSettingSchema;
var GlobalSettingsTypeEnumValues = [
  "CONTACT_FORM_IFRAME_URL"
];
var GlobalSettingsTypeEnumObj = z109.enum(GlobalSettingsTypeEnumValues);
var GlobalSettingsTypeEnum = GlobalSettingsTypeEnumObj.enum;
var GlobalSettingsSchema = object55({
  id: GlobalSettingsTypeEnumObj,
  values: GlobalSettingsValue
});

// src/settings/fe-schema.ts
var UpdateContentScheduleSettingsFE = FeaturedSeriesSettingSchema;
var CreateFeatureSeriesContentSchemaFE = FeaturedSeriesSettingSchema.omit({
  subtitle: true,
  body: true,
  button_label: true,
  video_badge: true
}).extend({
  seriesId: z110.coerce.number().min(1, "Please select series")
});
var CreateFitChallengeSchemaFE = CreateFeatureSeriesContentSchemaFE.omit({
  title: true,
  seriesId: true
}).extend({
  isEnable: CoerceBoolean.default(false)
});
var defaultFeatureSeriesContentValues = {
  title: "",
  isEnable: false,
  seriesId: 0
};
var defaultFitChallengeValues = {
  isEnable: false
};
var OnboardingSettingSchemaFE = z110.object({
  isEnable: CoerceBoolean.default(false)
});
var defaultOnboardingSettingValues = {
  isEnable: false
};
var UpcomingLiveBannerSettingSchemaFE = UpcomingLiveBannerSettingSchema;
var defaultUpcomingLiveBannerSettingValues = {
  isEnable: false
};
var ContactFormSettingSchemaFE = ContactFormSettingSchema;
var defaultContactFormSettingValues = {
  iframeUrl: ""
};

// src/settings/be-schema.ts
var UpdateContentScheduleSettingsSchemaBE = FeaturedSeriesSettingSchema.pick({
  title: true,
  subtitle: true,
  body: true,
  button_label: true,
  video_badge: true
}).extend({
  id: z111.coerce.string(),
  seriesId: z111.coerce.number().optional(),
  isHidden: CoerceBoolean.optional()
});
var CreateFeatureSeriesContentSchemaBE = CreateFeatureSeriesContentSchemaFE.extend({
  id: z111.coerce.string()
});
var CreateFitChallengeSchemaBE = CreateFitChallengeSchemaFE.extend({
  id: z111.coerce.string()
});
var OnboardingSettingSchemaBE = OnboardingSettingSchemaFE.extend({
  id: z111.coerce.string()
});
var UpcomingLiveBannerSettingSchemaBE = UpcomingLiveBannerSettingSchemaFE.extend({
  id: z111.coerce.string()
});
var ContactFormSettingSchemaBE = ContactFormSettingSchemaFE.extend({
  id: z111.coerce.string()
});
var SettingBEResponseSchema = object56({
  FEATURED_SERIES: FeaturedSeriesSettingSchema,
  FEATURED_SERIES_CONTENTS: FeaturedSeriesSettingSchema,
  FIT_CHALLENGE_BANNER: ChallengeBannerSettingSchema,
  FIT_CHALLENGE_PAGE: ChallengePageSettingSchema,
  ONBOARDING: OnboardingSettingSchema,
  UPCOMING_LIVE_BANNER: UpcomingLiveBannerSettingSchema,
  CONTACT_FORM_IFRAME_URL: ContactFormSettingSchema
});
var GlobalSettingBEResponseSchema = object56({
  CONTACT_FORM_IFRAME_URL: ContactFormSettingSchema
});

// src/settings/feature-series/be-schema.ts
import { z as z113 } from "zod";

// src/settings/feature-series/fe-schema.ts
import { z as z112 } from "zod";
var CreateFeatureSeriesSchemaFE = FeaturedSeriesSettingSchema.omit({
  title: true,
  subtitle: true,
  body: true,
  video_badge: true
}).extend({
  seriesId: z112.coerce.number().min(1, "Please select series")
});
var defaultSettingsValues = {
  button_label: "",
  isEnable: false,
  seriesId: 0
};

// src/settings/feature-series/be-schema.ts
var CreateFeatureSeriesSchemaBE = CreateFeatureSeriesSchemaFE.extend({
  id: z113.coerce.string()
});

// src/settings/settings-schema.ts
import { object as object57, z as z114 } from "zod";
var SettingsTypeEnumValues = [
  "FEATURED_SERIES",
  "FEATURED_SERIES_CONTENTS",
  "FIT_CHALLENGE_BANNER",
  "FIT_CHALLENGE_PAGE",
  "ONBOARDING",
  "UPCOMING_LIVE_BANNER",
  "CONTACT_FORM_IFRAME_URL"
];
var SettingsTypeEnumObj = z114.enum(SettingsTypeEnumValues);
var SettingsTypeEnum = SettingsTypeEnumObj.enum;
var SettingsSchema = object57({
  id: SettingsTypeEnumObj,
  values: BaseSettingSchema
});

// src/help-center/app-names.ts
import { z as z115 } from "zod";
var HelpCenterAppNameValues = [
  "FIT",
  "RYC",
  "BUMP"
];
var HelpCenterAppNameEnumObj = z115.enum(HelpCenterAppNameValues);
var EHelpCenterAppNameEnum = HelpCenterAppNameEnumObj.enum;

// src/help-center/article-base.ts
import { array as array13, coerce as coerce35, lazy as lazy9, number as number22, object as object59, string as string51, z as z116 } from "zod";

// src/help-center/taxonomy-base.ts
import { coerce as coerce34, object as object58, string as string50 } from "zod";
var BaseTaxonomySchema = object58({
  id: coerce34.number(),
  title: string50(),
  slug: string50(),
  createdAt: coerce34.string().date(),
  updatedAt: coerce34.string().date()
});
var BaseTopicTaxonomySchema = BaseTaxonomySchema.extend({
  categoryId: coerce34.number()
});

// src/help-center/article-base.ts
var HelpCenterArticle = object59({
  id: string51(),
  question: string51(),
  answer: string51(),
  category: lazy9(() => HelpCenterArticleCategory),
  createdAt: coerce35.string(),
  topics: lazy9(() => HelpCenterArticleTopic.array()),
  updatedAt: coerce35.string(),
  sourceTicketId: number22().nullable().optional()
});
var HelpCenterArticleDetails = object59({
  details: lazy9(() => HelpCenterArticle),
  category: lazy9(() => HelpCenterArticleCategory),
  topics: lazy9(() => HelpCenterArticleTopic.array())
});
var HelpCenterArticleCategory = object59({
  id: string51(),
  title: string51(),
  slug: string51(),
  topics: lazy9(() => HelpCenterArticleTopic.array()),
  createdAt: coerce35.string(),
  updatedAt: coerce35.string()
});
var HelpCenterArticleTopic = object59({
  id: string51(),
  title: string51(),
  slug: string51(),
  createdAt: coerce35.string(),
  updatedAt: coerce35.string()
});
var HelpCenterArticleTopicWithCategory = object59({
  id: string51(),
  title: string51(),
  slug: string51(),
  category: lazy9(() => HelpCenterArticleCategory),
  createdAt: coerce35.string(),
  updatedAt: coerce35.string()
});
var HelpCenterArticleSearchResponse = object59({
  didYouMean: string51().optional(),
  items: HelpCenterArticle.array(),
  topics: HelpCenterArticleTopic.array().optional()
});
var ArticleStatusValues = [
  "DRAFT",
  "PUBLISHED",
  "ARCHIVED"
];
var ArticleStatusEnumObj = z116.enum(ArticleStatusValues);
var EArticleStatus = ArticleStatusEnumObj.enum;
var BaseHelpCenterArticleSchema = object59({
  id: coerce35.number(),
  question: string51(),
  answer: string51(),
  topics: BaseTaxonomySchema.array(),
  category: BaseTaxonomySchema,
  appNames: HelpCenterAppNameEnumObj.array(),
  status: ArticleStatusEnumObj,
  sourceTicketId: number22().nullable().optional(),
  createdAt: coerce35.string().date(),
  updatedAt: coerce35.string().date()
});
var HelpCenterArticleCreationPayloadSchema = object59({
  id: coerce35.number(),
  question: string51(),
  answer: string51(),
  topicIds: array13(number22()),
  categorySlug: string51(),
  appNames: HelpCenterAppNameEnumObj.array(),
  status: ArticleStatusEnumObj,
  sourceTicketId: number22().optional(),
  createdAt: coerce35.string().date(),
  updatedAt: coerce35.string().date()
});

// src/help-center/article-be-schema.ts
var CreateHelpCenterArticleSchemaBE = BaseHelpCenterArticleSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
});
var CreateArticleSchemaBE = HelpCenterArticleCreationPayloadSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
});
var UpdateHelpCenterArticleSchemaBE = CreateArticleSchemaBE;
var defaultHelpCenterSchemaValues = {
  question: "",
  answer: "",
  topicIds: [],
  categorySlug: "",
  appNames: [],
  status: "DRAFT"
};

// src/help-center/article-edit-history.ts
import { z as z117 } from "zod";
var HelpCenterArticleEditHistoryDataSchema = z117.object({
  question: z117.string(),
  answer: z117.string(),
  topicIds: z117.array(z117.number()),
  categorySlug: z117.string(),
  appNames: HelpCenterAppNameEnumObj.array(),
  status: ArticleStatusEnumObj,
  category: BaseTaxonomySchema.optional(),
  topics: BaseTaxonomySchema.array().optional()
});
var HelpCenterArticleEditHistorySchema = z117.object({
  id: z117.number(),
  articleId: z117.number(),
  data: HelpCenterArticleEditHistoryDataSchema,
  createdBy: z117.string(),
  createdByName: z117.string(),
  createdOn: z117.coerce.string()
});
var HelpCenterArticleEditHistoryListSchema = z117.array(HelpCenterArticleEditHistorySchema);

// src/help-center/article-filter.ts
import { coerce as coerce36, object as object60 } from "zod";
var HelpCenterArticlesFiltersSchema = object60({
  categorySlug: coerce36.string().optional(),
  topicId: coerce36.number().optional(),
  topicSlug: coerce36.string().optional(),
  app: HelpCenterAppNameEnumObj.optional(),
  perPage: coerce36.number().optional(),
  page: coerce36.number().optional(),
  query: coerce36.string().optional(),
  enabled: coerce36.boolean().optional(),
  status: ArticleStatusEnumObj.optional()
}).partial();

// src/help-center/taxonomy-be-schema.ts
var CreateHelpCenterCategoryTaxonomySchemaBE = BaseTaxonomySchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  appNames: HelpCenterAppNameEnumObj.array().min(1)
});
var CreateHelpCenterTopicTaxonomySchemaBE = BaseTopicTaxonomySchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  appNames: HelpCenterAppNameEnumObj.array().min(1)
});
var UpdateHelpCenterTopicTaxonomySchemaBE = CreateHelpCenterTopicTaxonomySchemaBE;
var UpdateHelpCenterCategoryTaxonomySchemaBE = CreateHelpCenterCategoryTaxonomySchemaBE;

// src/ryc/addon-content/addon-content-type.enum.ts
import { z as z118 } from "zod";
var AddonContentTypeValues = [
  "BONUS",
  "ADDON"
];
var AddonContentTypeObject = z118.enum(AddonContentTypeValues);
var EAddonContentType = AddonContentTypeObject.enum;

// src/ryc/addon-content/base.ts
import { coerce as coerce39, object as object63, string as string52 } from "zod";

// src/ryc/user/base.ts
import { coerce as coerce37, object as object61 } from "zod";
var BaseUserSchema = object61({
  id: coerce37.string(),
  electiveContents: coerce37.number().array(),
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});

// src/ryc/user/select-elective-contents.ts
import { coerce as coerce38, object as object62 } from "zod";
var SelectElectiveContentsSchema = object62({
  contentIds: coerce38.number().array().max(3).min(1)
});

// src/ryc/user/user-manage-item-type.enum.ts
import { z as z119 } from "zod";
var UserManageItemTypeValues = [
  "USER_INFORMATION",
  "INSTRUCTION",
  "ACTIVITY",
  "CHECK_IN",
  "BONUS_VIDEOS",
  "JOURNEY",
  "SIMULATION",
  "CUSTOM_NOTIFICATION",
  "NOTIFICATION_HISTORY"
];
var UserManageItemTypeObj = z119.enum(UserManageItemTypeValues);
var UserManageItemTypeEnum = UserManageItemTypeObj.enum;

// src/ryc/addon-content/base.ts
var UserMetaSchema = BaseUserSchema.omit({
  electiveContents: true
});
var AddonContentBaseSchema = object63({
  id: coerce39.number(),
  contentId: string52(),
  type: AddonContentTypeObject,
  createdAt: coerce39.date(),
  userMeta: UserMetaSchema
});

// src/ryc/content/base.ts
import { array as array14, boolean as boolean16, coerce as coerce40, number as number23, object as object64, string as string53, union as union5, z as z121 } from "zod";

// src/ryc/content/path.enum.ts
import { z as z120 } from "zod";
var RYCContentPathValues = [
  "REGULAR_PATH",
  "SUPPORTIVE_PATH"
];
var RYCContentPathEnumObject = z120.enum(RYCContentPathValues);
var ERYCContentPath = RYCContentPathEnumObject.enum;

// src/ryc/content/base.ts
var RYCContent = Content.omit({
  category: true
}).extend({
  category: CategoryEnumObj
});
var BaseRYCContentWitMetaInformation = Content;
var RYCContentTypeValues = [
  "CONTENT",
  "JOURNAL"
];
var RYCContentTypeEnumObject = z121.enum(RYCContentTypeValues);
var ERYCContentType = RYCContentTypeEnumObject.enum;
var BaseRYCContentSchema = z121.object({
  id: coerce40.string(),
  contentId: string53(),
  order: coerce40.number().min(1),
  type: RYCContentTypeEnumObject,
  path: RYCContentPathEnumObject,
  createdAt: z121.string(),
  updatedAt: z121.string()
});
var CreateRYCContentSchemaFE = BaseRYCContentSchema.omit({
  id: true,
  path: true,
  type: true,
  contentId: true,
  createdAt: true,
  updatedAt: true
}).extend({
  id: number23().optional(),
  path: string53().optional(),
  content: RYCContent
});
var CreateRYCContentSchemaBE = BaseRYCContentSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
});
var UpdateRYCContentSchemaBE = BaseRYCContentSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  id: coerce40.number().optional()
});
var ContentResponseSchema = object64({
  items: Content.array().nullable(),
  meta: object64({
    total: coerce40.number(),
    page: coerce40.number(),
    perPage: coerce40.number(),
    totalPages: coerce40.number()
  })
});
var CalendarStateResponse = object64({
  id: number23(),
  stage: number23(),
  level: number23(),
  days: object64({
    day: number23(),
    items: array14(string53()),
    isRest: union5([
      boolean16(),
      z121.null()
    ]),
    checked: union5([
      boolean16(),
      z121.null()
    ])
  }).array()
});

// src/ryc/content/be-schema.ts
import { coerce as coerce41, lazy as lazy10, object as object65, string as string54, z as z122 } from "zod";
var CreateRYCContentBEBase = object65({
  name: string54().min(3, "name is required"),
  instructorId: coerce41.string(),
  status: lazy10(() => StatusEnumObj),
  equipments: object65({
    id: coerce41.number().min(1, "id is required")
  }).array().min(1, "Please select at least one equipment"),
  video: VimeoVideo,
  publishedDate: z122.string().or(CustomLuxonDateSchema).optional().nullable(),
  id: string54().optional(),
  meta: lazy10(() => RYCContentMetaInformationBaseSchema.omit({
    id: true,
    contentId: true,
    createdAt: true,
    updatedAt: true
  }).extend({
    type: RYCContentMetaTypeEnumObject.default("WORKOUT"),
    category: lazy10(() => CategoryEnumObj),
    categories: coerce41.number().array().optional().default([])
  }).partial({
    category: true,
    categories: true,
    series: true,
    stage: true,
    isRegular: true,
    isSupportive: true,
    tiers: true,
    pdfLink: true
  }).optional())
});
var CreateRYCContentWithMetaSchemaBE = CreateRYCContentBEBase.refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var UpdateRYCContentWithMetaSchemaBE = CreateRYCContentBEBase.partial();

// src/ryc/content/fe-schema.ts
import { coerce as coerce42, lazy as lazy11, object as object66, z as z123 } from "zod";
var RYCDashboardCreateContentSchemaFEBase = object66({
  name: z123.string().min(3, "name is required"),
  instructorId: coerce42.string(),
  equipments: coerce42.number().array().min(1, "Please select at least one equipment"),
  status: lazy11(() => StatusEnumObj),
  publishedDate: z123.string().or(CustomLuxonDateSchema).optional().nullable(),
  video: VimeoVideoInput,
  meta: object66({
    type: RYCContentMetaTypeEnumObject.default("WORKOUT"),
    category: CategoryEnumObj,
    categories: coerce42.number().array().optional().default([]),
    tiers: TiersEnumObject.array().optional().default([]),
    series: z123.preprocess((v) => v === "" ? void 0 : v, RYCContentMetaSeriesEnumObject.optional()),
    stage: z123.preprocess((v) => v === "" ? void 0 : v, coerce42.number().optional().nullable()),
    isRegular: coerce42.boolean().optional().default(false),
    isSupportive: coerce42.boolean().optional().default(false),
    pdfLink: z123.string().optional().nullable()
  }).optional()
});
var RYCDashboardCreateContentSchemaFEWithoutValidation = RYCDashboardCreateContentSchemaFEBase;
var RYCDashboardCreateContentSchemaFE = RYCDashboardCreateContentSchemaFEBase.refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var RYCDashboardUpdateContentSchemaFE = RYCDashboardCreateContentSchemaFEWithoutValidation.partial();
var defaultRYCContentSchemaValues = {
  video: {
    bannerUrl2x: "",
    description: "",
    vimeoVideoId: ""
  },
  name: "",
  instructorId: "",
  equipments: [],
  status: "PUBLISHED",
  publishedDate: void 0,
  meta: {
    type: "WORKOUT",
    category: "RESTORE",
    categories: [],
    tiers: [],
    isRegular: false,
    isSupportive: false
  }
};

// src/ryc/content/request.ts
import { array as array15, coerce as coerce43, object as object67, string as string55 } from "zod";
var CreateRYCContentRequestWithMetaSchema = CreateRYCContentWithMetaSchemaBE;
var UpdateRYCContentRequestWithMetaSchema = UpdateRYCContentWithMetaSchemaBE;
var RYCContentRequestBESchema = object67({
  app: AppNameEnumObj.optional(),
  query: string55().optional(),
  shuffle: CoerceBoolean.optional().default(false),
  loadAll: CoerceBoolean.optional().default(false),
  stage: coerce43.number().optional(),
  series: RYCContentMetaSeriesEnumObject.optional(),
  path: string55().optional(),
  type: RYCContentMetaTypeEnumObject,
  skipTypeFilter: coerce43.boolean().optional().default(false),
  categoryIds: array15(string55()).default([]),
  instructorIds: array15(coerce43.string()).default([]),
  status: StatusEnumObj.array().optional(),
  durationFrom: coerce43.number().default(1),
  durationTo: coerce43.number().default(1e3),
  perPage: coerce43.number().max(150),
  page: coerce43.number()
}).partial();
var rycContentFilterDefaultValues = {
  categoryIds: "",
  duration: "1-60",
  stage: "",
  series: "",
  page: "1",
  path: "",
  perPage: "15",
  type: "",
  query: ""
};
var rycContentFilterEmptyDefaultValues = {
  categoryIds: "",
  duration: "",
  stage: "",
  series: "",
  path: "",
  type: "",
  instructorIds: "",
  page: "",
  perPage: "",
  query: ""
};
var DownloadPdfRequestBESchema = object67({
  contentId: string55()
});

// src/ryc/instruction/base.ts
import { array as array16, coerce as coerce44, number as number24, object as object68, string as string56, z as z125 } from "zod";

// src/ryc/instruction/plan-type.enum.ts
import { z as z124 } from "zod";
var PlanTypeValues = [
  "TEXT",
  "PLAN"
];
var PlanTypeObj = z124.enum(PlanTypeValues);
var PlanTypeEnum = PlanTypeObj.enum;

// src/ryc/instruction/base.ts
var InstructionPlanItemResponseSchema = object68({
  id: coerce44.number().optional(),
  day: number24(),
  order: coerce44.number(),
  content: Content.optional(),
  isRestDay: z125.boolean().default(false).optional()
});
var InstructionPlanItemSchema = object68({
  id: coerce44.number().optional(),
  day: number24(),
  order: coerce44.number(),
  contentId: string56().optional(),
  isRestDay: z125.boolean().default(false).optional()
});
var instructionSchema = object68({
  id: coerce44.number(),
  userId: string56(),
  message: string56().optional(),
  type: PlanTypeObj,
  plan: array16(InstructionPlanItemResponseSchema).optional(),
  createdBy: Instructor,
  createdAt: coerce44.string(),
  updatedAt: coerce44.string()
});
var CreateInstructionSchema = instructionSchema.omit({
  id: true,
  plan: true,
  createdBy: true,
  createdAt: true,
  updatedAt: true
}).extend({
  plan: array16(InstructionPlanItemSchema).optional()
});
var UpdateInstructionSchema = CreateInstructionSchema.extend({
  id: coerce44.number()
});

// src/ryc/journal/base.ts
import { array as array17, coerce as coerce48, object as object72, string as string58, z as z129 } from "zod";

// src/ryc/step/content.ts
import { coerce as coerce45, object as object69, string as string57 } from "zod";
var BaseStepContentSchema = object69({
  id: UnsignedIDSchema,
  isMandatory: coerce45.boolean().optional().default(false),
  hasAlternatives: coerce45.boolean().optional().default(false),
  contentId: string57(),
  order: coerce45.number().min(1),
  path: RYCContentPathEnumObject,
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});
var UpdateStepContentSchemaBE = BaseStepContentSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  id: UnsignedIDSchema.optional(),
  rycContent: UpdateRYCContentSchemaBE
});
var UpdateStepContentSchemaFE = BaseStepContentSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  id: UnsignedIDSchema.optional()
}).merge(CreateRYCContentSchemaFE).extend({
  path: RYCContentPathEnumObject
});
var UpdateStepContentsSchemaBE = object69({
  stepContents: object69({
    // step content id (primary column value)
    id: coerce45.number().optional(),
    // ryc content id (primary column value)
    // rycContentId: coerce.number().optional(),
    // content id from content service
    contentId: coerce45.string(),
    order: coerce45.number().min(1),
    path: RYCContentPathEnumObject,
    type: RYCContentTypeEnumObject,
    isMandatory: coerce45.boolean().optional().default(false),
    hasAlternatives: coerce45.boolean().optional().default(false)
  }).array()
});

// src/ryc/step/day.ts
import { coerce as coerce46, object as object70 } from "zod";
var BaseStepDaySchema = object70({
  id: coerce46.number().int().nonnegative(),
  day: coerce46.number().int().nonnegative().nullable(),
  stepContents: BaseStepContentSchema.array(),
  electiveContents: BaseStepContentSchema.array(),
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});
var BaseStepContentSchemaWithContentInfo = BaseStepContentSchema.extend({
  content: RYCContent.extend({
    instructor: Instructor
  })
});
var BaseStepDayWithContentsSchema = BaseStepDaySchema.extend({
  stepContents: BaseStepContentSchemaWithContentInfo.array(),
  electiveContents: BaseStepContentSchemaWithContentInfo.array()
});
var UpdateStepDaySchemaBE = object70({
  stepContents: UpdateStepContentSchemaBE.array()
});

// src/ryc/step/step.ts
import { coerce as coerce47, object as object71, z as z128 } from "zod";

// src/ryc/step/stage.ts
import { z as z126 } from "zod";
var Stages = [
  "STAGE_1",
  "STAGE_2",
  "STAGE_3",
  "STAGE_4"
];
var StagesEnumObject = z126.enum(Stages);
var EStagesEnum = StagesEnumObject.enum;

// src/ryc/step/step-type.ts
import { z as z127 } from "zod";
var StepType = [
  "REGULAR",
  "BONUS"
];
var StepTypeEnumObject = z127.enum(StepType);
var EStepTypeEnum = StepTypeEnumObject.enum;

// src/ryc/step/step.ts
var Steps = [
  "STEP_1",
  "STEP_2",
  "STEP_3",
  "STEP_4"
];
var StepsEnumObject = z128.enum(Steps);
var EStepsEnum = StepsEnumObject.enum;
var BaseStepSchema = object71({
  id: coerce47.number(),
  adjustedStepId: coerce47.number(),
  tier: TiersEnumObject,
  stage: StagesEnumObject,
  days: BaseStepDaySchema.array().nullable(),
  stepType: StepTypeEnumObject.optional(),
  bonusVideos: z128.array(BaseStepContentSchema).nullable(),
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});
var BaseStepSchemaWithContents = BaseStepSchema.extend({
  contents: Content.array()
});
var BonusSchemaWithContent = BaseStepContentSchema.extend({
  content: RYCContent.extend({
    instructor: Instructor
  })
});
var BaseStepSchemaWithBonusVideos = BaseStepSchema.extend({
  bonusVideos: BonusSchemaWithContent.array()
});

// src/ryc/step/fe-schema.ts
var CreateStepSchemaFE = BaseStepSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  contents: CreateRYCContentSchemaFE.array()
});
var UpdateStepSchemaFE = BaseStepSchema.partial();
var UpdateStepSchemaBE = BaseStepSchema.omit({
  createdAt: true,
  updatedAt: true
}).extend({
  contents: CreateRYCContentSchemaBE.array()
});

// src/ryc/journal/base.ts
var BaseJournalSchema = object72({
  id: coerce48.string(),
  userId: coerce48.string(),
  content: coerce48.string(),
  path: RYCContentPathEnumObject.nullable(),
  dayNumber: coerce48.number(),
  link: coerce48.string().optional(),
  stepDay: BaseStepDaySchema,
  journey: object72({
    id: coerce48.number()
  }),
  skipJournal: coerce48.boolean().optional().nullable(),
  contents: array17(RYCContentMetaInformationBaseSchema).nullable(),
  createdAt: coerce48.string(),
  updatedAt: coerce48.string()
});
var CreateJournalSchemaBE = BaseJournalSchema.pick({
  content: true,
  path: true,
  link: true,
  skipJournal: true
}).partial();
var SkipJournalSchemaBE = object72({
  journeyId: coerce48.number().or(z129.literal(void 0))
});
var RYCJournalRequestBESchema = object72({
  stage: StagesEnumObject.optional(),
  series: array17(RYCContentMetaSeriesEnumObject).optional(),
  types: array17(RYCContentMetaTypeEnumObject).optional(),
  query: string58().optional(),
  byDate: string58().optional(),
  perPage: coerce48.number().max(150),
  page: coerce48.number()
}).partial();
var rycJournalFilterDefaultValues = {
  byDate: void 0,
  stage: "STAGE_1",
  series: [],
  page: 1,
  perPage: 15,
  types: [],
  query: ""
};
var FindVideoTagsRequestSchema = object72({
  contentIds: array17(string58())
});
var JournalEntryDatesRequestSchema = object72({
  month: coerce48.number().int().min(1).max(12),
  year: coerce48.number().int().min(2e3).max(2100)
});

// src/ryc/journey/base.ts
import { coerce as coerce51, object as object75, string as string59, z as z131 } from "zod";

// src/ryc/journey/elective-content.ts
import { coerce as coerce49, object as object73 } from "zod";
var ElectiveContentSchema = object73({
  id: coerce49.number(),
  userId: coerce49.string(),
  electiveContents: coerce49.number().array(),
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});

// src/ryc/journey/user-activity.ts
import { coerce as coerce50, object as object74 } from "zod";

// src/ryc/journey/user-activity-type.ts
import { z as z130 } from "zod";
var UserActivityTypeValues = [
  "CONTENT_WATCH",
  "JOURNAl_SAVED",
  "STAGE_COMPLETE",
  "STEP_COMPLETE",
  "BONUS_CLAIMED",
  "PATH_SWITCH_TO_REGULAR",
  "PATH_SWITCH_TO_SUPPORTIVE",
  "JOURNAL_SKIPPED",
  "NEW_DAY",
  "PROGRAM_COMPLETE",
  "RESET",
  "START_JOURNEY",
  "RESTART_JOURNEY",
  "SPECIAL_JOURNAL",
  "JOINED_ELECTIVE",
  "CHECKIN"
];
var UserActivityTypeEnumObject = z130.enum(UserActivityTypeValues);
var EUserActivityTypeEnum = UserActivityTypeEnumObject.enum;

// src/ryc/journey/user-activity.ts
var UserActivitySchema = object74({
  id: coerce50.number(),
  userId: coerce50.string(),
  type: UserActivityTypeEnumObject,
  exerciseId: coerce50.string().nullable(),
  exercisePath: RYCContentPathEnumObject,
  stepId: coerce50.number().nullable(),
  adjustedStepId: coerce50.number().nullable(),
  stepDay: coerce50.number().nullable(),
  dayNumber: coerce50.number().min(1).max(7).nullable(),
  content: Content.optional().nullable(),
  isMandatory: coerce50.boolean().nullable(),
  createdAt: coerce50.string()
});
var UserActivityItemSchema = UserActivitySchema.extend({
  content: Content.optional()
});
var JourneyUserActivitiesSchema = object74({
  items: UserActivityItemSchema.array()
});
var JourniesUserActivitiesSchema = JourneyUserActivitiesSchema.array();

// src/ryc/journey/base.ts
var JourneyAlreadyClaimedBonusValues = z131.union([
  z131.literal("t"),
  z131.literal("f"),
  z131.literal(null)
]);
var BaseJourneySchema = object75({
  id: coerce51.number(),
  userId: string59(),
  tier: TiersEnumObject,
  stage: StagesEnumObject,
  path: RYCContentPathEnumObject,
  journals: BaseJournalSchema.array(),
  userActivities: UserActivitySchema.array(),
  dayDiffInMS: coerce51.number().optional().default(0),
  currentElectiveDay: coerce51.number().default(0),
  currentElectiveContentId: coerce51.number().nullable().default(null),
  lastElectiveContentSelectedTime: CommonCustomDateSchema,
  electiveContent: ElectiveContentSchema,
  stepId: coerce51.number(),
  adjustedStepId: coerce51.number(),
  currentDay: coerce51.number(),
  isComplete: coerce51.boolean(),
  isCurrent: coerce51.boolean(),
  joinedElective: coerce51.boolean().optional().default(false),
  showBonusSelection: coerce51.boolean(),
  alreadyClaimedBonus: JourneyAlreadyClaimedBonusValues,
  nextStep: BaseStepSchema.optional().nullable(),
  selectElectiveContent: coerce51.boolean().optional().default(false),
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});

// src/ryc/journey/filters.ts
import { coerce as coerce52, object as object76 } from "zod";
var JourneyFiltersSchema = object76({
  perPage: coerce52.number().optional(),
  page: coerce52.number().optional()
});
var CurrentJourneyFiltersSchema = object76({
  withNextRestore: CoerceBoolean.optional().default(false)
});

// src/ryc/journey/select-bonus-content.request.ts
import { object as object77, string as string60 } from "zod";
var SelectBonusContentRequestSchema = object77({
  contentIds: string60().array().min(1, "Select at least 1 content").max(3, "Maximum 3 contents allowed")
});

// src/ryc/onboarding/base.ts
import { coerce as coerce55, object as object80, string as string62, z as z135 } from "zod";

// src/ryc/onboarding/step.ts
import { coerce as coerce54, object as object79, z as z134 } from "zod";

// src/ryc/onboarding/step.enum.ts
import { z as z132 } from "zod";
var OnboardingStepValues = [
  "WELCOME",
  "INTRO",
  "UPDATE_PROFILE_INFORMATION",
  "EXPECTATION"
];
var OnboardingStepEnumObject = z132.enum(OnboardingStepValues);
var EOnboardingStep = OnboardingStepEnumObject.enum;

// src/ryc/onboarding/video.ts
import { coerce as coerce53, object as object78, string as string61, z as z133 } from "zod";
var OnboardingVideoSchema = object78({
  id: coerce53.number(),
  title: string61(),
  isWatched: CoerceBoolean,
  thumbnail: string61(),
  type: string61().optional(),
  videoId: string61()
});
var CreateOnboardingVideoSchemaBE = OnboardingVideoSchema.extend({
  isWatched: z133.boolean()
});

// src/ryc/onboarding/step.ts
var OnboardingStepSchema = object79({
  name: OnboardingStepEnumObject,
  isCompleted: CoerceBoolean,
  videos: OnboardingVideoSchema.array(),
  updatedAt: coerce54.string().date()
});
var CreateOnboardingStepSchemaBE = OnboardingStepSchema.extend({
  isCompleted: z134.boolean(),
  videos: CreateOnboardingVideoSchemaBE.array()
});
var UpdateOnboardingStepVideoWatchedSchemaBE = OnboardingStepSchema.extend({
  videoId: coerce54.string().optional(),
  step: OnboardingStepEnumObject
});

// src/ryc/onboarding/base.ts
var BaseOnboardingSchema = object80({
  id: coerce55.number(),
  tier: TiersEnumObject,
  isComplete: z135.boolean(),
  currentProgressStep: OnboardingStepEnumObject,
  isCompleted: coerce55.boolean(),
  progress: OnboardingStepSchema.array(),
  userId: string62(),
  createdAt: coerce55.string().date(),
  updatedAt: coerce55.string().date()
});

// src/ryc/onboarding/be-schema.ts
var CreateOnboardingSchemaBE = CreateOnboardingStepSchemaBE.array();

// src/ryc/todays-workout/fe-schema.ts
import { coerce as coerce56, object as object81 } from "zod";
var TodaysWorkoutSchemaFE = object81({
  step: coerce56.number(),
  completedClass: coerce56.number(),
  classes: BaseRYCContentSchema.array()
});

// src/ryc/user-management/get-users-assigned-instructors-request.ts
import { array as array18, object as object82, string as string63 } from "zod";
var GetAssignedInstructorsWidthUserIdsBESchema = object82({
  userIds: array18(string63())
});

// src/ryc/user-management/get-users-request.ts
import { coerce as coerce58, object as object84, string as string65 } from "zod";

// src/user-activity/get-users-request.ts
import { coerce as coerce57, object as object83, string as string64, z as z136 } from "zod";
var UserSourceEnum = z136.enum([
  "wordpress",
  "supabase"
]);
var GetUsersRequestBESchema = object83({
  limit: coerce57.number().max(100),
  page: coerce57.number(),
  name: string64().optional().transform((v) => v || void 0),
  email: string64().optional().transform((v) => v || void 0),
  source: UserSourceEnum.default("wordpress")
});

// src/ryc/user-management/get-users-request.ts
var GetSubscribedUsersRequestBESchema = object84({
  tierInfo: coerce58.number().optional(),
  limit: coerce58.number().max(100),
  page: coerce58.number(),
  name: string65().optional(),
  email: string65().optional(),
  source: UserSourceEnum.default("wordpress")
});

// src/ryc/user-management/user-type.ts
import { array as array20, number as number26, object as object86, string as string67, z as z141 } from "zod";

// src/supabase/pro-directory-expertise.ts
import { z as z137 } from "zod";
var ExpertiseItemSchema = z137.object({
  id: z137.number(),
  name: z137.string(),
  parentId: z137.number().nullable()
});

// src/supabase/pro-directory-profession.ts
import { z as z138 } from "zod";
var ProfessionSchema = z138.object({
  id: z138.number(),
  name: z138.string(),
  parentId: z138.number().nullable()
});

// src/supabase/pro-public-profile.ts
import { z as z139 } from "zod";
var SocialsSchema = z139.object({
  facebook: z139.string().nullable().optional(),
  instagram: z139.string().nullable().optional(),
  youtube: z139.string().nullable().optional(),
  twitter: z139.string().nullable().optional(),
  linkedin: z139.string().nullable().optional(),
  tiktok: z139.string().nullable().optional()
}).nullable().optional();
var ProPublicProfileSchema = z139.object({
  proDirectoryId: z139.number(),
  isActive: z139.boolean().default(true),
  slug: z139.string().nullable().optional(),
  bio: z139.string().nullable().optional(),
  profession: z139.array(z139.object({
    id: z139.number(),
    name: z139.string()
  })).default([]),
  companyName: z139.string().nullable().optional(),
  companyEmail: z139.string().nullable().optional(),
  professionalWebsite: z139.string().nullable().optional(),
  offerings: z139.array(z139.string()).default([]),
  teachingFormat: TeachingFormatSchema.nullable().optional(),
  expertise: z139.array(z139.string()).default([]),
  languagesTaught: z139.array(z139.string()).default([]),
  casualImage: z139.string().nullable().optional(),
  landscapeImage: z139.string().nullable().optional(),
  fullName: z139.string().nullable().optional(),
  title: z139.string().nullable().optional(),
  phone: z139.string().nullable().optional(),
  businessStreet: z139.string().nullable().optional(),
  businessCountry: z139.object({
    id: z139.number(),
    name: z139.string()
  }).nullable().optional(),
  businessState: z139.object({
    id: z139.number(),
    name: z139.string()
  }).nullable().optional(),
  businessCity: z139.object({
    id: z139.number(),
    name: z139.string()
  }).nullable().optional(),
  certificates: z139.string().nullable().optional(),
  directorySocials: SocialsSchema,
  sortOrder: z139.number().nullable().optional()
});
var ProDirectoryPaginationSchema = z139.object({
  totalItems: z139.number().int().nonnegative(),
  totalPages: z139.number().int().nonnegative(),
  currentPage: z139.number().int().positive(),
  perPage: z139.number().int().positive()
});
var ProDirectoryListResponseSchema = z139.object({
  data: z139.array(ProPublicProfileSchema),
  pagination: ProDirectoryPaginationSchema
});
var EProSpecialtyValues = [
  "Low back pain",
  "SIJ pain",
  "Pelvic organ prolapse",
  "Pelvic floor",
  "Yoga",
  "Prenatal",
  "Hip pain",
  "Incontinence",
  "Diastasis recti",
  "SPD",
  "Postpartum",
  "Other"
];
var EProSpecialtyEnum = z139.enum(EProSpecialtyValues);
var TEACHER_DIRECTORY_DEFAULT_PAGE = 1;
var TEACHER_DIRECTORY_DEFAULT_PER_PAGE = 20;
var TEACHER_DIRECTORY_MAX_PER_PAGE = 100;
var ListProQuerySchema = z139.object({
  page: z139.coerce.number().int().positive().default(TEACHER_DIRECTORY_DEFAULT_PAGE),
  perPage: z139.coerce.number().int().positive().max(TEACHER_DIRECTORY_MAX_PER_PAGE).default(TEACHER_DIRECTORY_DEFAULT_PER_PAGE),
  countryId: z139.coerce.number().int().positive().optional(),
  stateId: z139.coerce.number().int().positive().optional(),
  cityId: z139.coerce.number().int().positive().optional(),
  specialty: EProSpecialtyEnum.optional(),
  includeInactive: z139.string().transform((v) => v === "true").optional().default("false").pipe(z139.boolean())
});
var ListProQueryWithSearchSchema = ListProQuerySchema.extend({
  q: z139.string().max(200).optional()
});
var SearchProQuerySchema = ListProQueryWithSearchSchema;

// src/supabase/profile.ts
import { array as array19, coerce as coerce59, number as number25, object as object85, string as string66, z as z140 } from "zod";
var normalizeSubscription = /* @__PURE__ */ __name((data) => {
  var _a5, _b, _c, _d;
  if (!data || typeof data !== "object") {
    return data;
  }
  const d = data;
  const meta = d["meta"];
  return {
    appId: (_a5 = d["appId"]) != null ? _a5 : d["app_id"],
    appName: (_b = d["appName"]) != null ? _b : d["app_name"],
    isActive: (_c = d["isActive"]) != null ? _c : d["is_active"],
    meta: meta ? __spreadProps(__spreadValues({}, meta), {
      isTrial: (_d = meta["isTrial"]) != null ? _d : meta["is_trial"],
      tier: meta["tier"]
    }) : void 0
  };
}, "normalizeSubscription");
var normalizeSubscriptionAddon = /* @__PURE__ */ __name((data) => {
  var _a5, _b;
  if (!data || typeof data !== "object") {
    return data;
  }
  const d = data;
  return {
    appName: (_a5 = d["appName"]) != null ? _a5 : d["app_name"],
    access: d["access"],
    isActive: (_b = d["isActive"]) != null ? _b : d["is_active"]
  };
}, "normalizeSubscriptionAddon");
var Subscription = z140.preprocess(normalizeSubscription, object85({
  appId: coerce59.number().min(1),
  appName: string66().min(1),
  isActive: StringToBooleanSchema,
  meta: z140.object({
    isTrial: StringToBooleanSchema.optional(),
    tier: z140.coerce.string().optional(),
    isPlanChangeAllowed: StringToBooleanSchema.optional(),
    isUpgradable: z140.string().optional(),
    upgradeLink: z140.string().optional()
  }).catchall(z140.unknown()).optional()
}));
var SubscriptionAddon = z140.preprocess(normalizeSubscriptionAddon, object85({
  appName: string66().min(1),
  access: array19(string66()),
  isActive: z140.boolean().default(false)
}));
var WPSubscriptionArraySchema = z140.array(Subscription);
var SubscriptionObjectSchema = z140.record(z140.string(), Subscription);
var transformSubscriptionArrayToObject = /* @__PURE__ */ __name((subscriptionArray) => {
  return subscriptionArray.reduce((acc, sub) => {
    const key = sanitizeAppName(sub.appName);
    acc[key] = sub;
    return acc;
  }, {});
}, "transformSubscriptionArrayToObject");
var ProfileMetaSchema = object85({
  isInstructor: z140.boolean().nullable().default(false).optional()
});
var UserAccessPermissionSchema = object85({
  id: number25(),
  name: string66()
});
var UserAccessItemSchema = object85({
  roleId: number25(),
  roleName: string66(),
  permissions: z140.array(UserAccessPermissionSchema).optional()
});
var UserAccessMapSchema = z140.record(z140.string(), UserAccessItemSchema);
var hasPermissionInAccessMap = /* @__PURE__ */ __name((access, permissionName) => Object.values(access != null ? access : {}).some((entry) => {
  var _a5;
  return (_a5 = entry.permissions) == null ? void 0 : _a5.some((permission) => permission.name === permissionName);
}), "hasPermissionInAccessMap");
var hasPermissionForApp = /* @__PURE__ */ __name((access, app, permissionName) => {
  var _a5, _b, _c;
  return !!app && ((_c = (_b = (_a5 = access == null ? void 0 : access[app]) == null ? void 0 : _a5.permissions) == null ? void 0 : _b.some((permission) => permission.name === permissionName)) != null ? _c : false);
}, "hasPermissionForApp");
var isContentManagerForApp = /* @__PURE__ */ __name((access, app) => hasPermissionForApp(access, app, Permissions.CONTENT_EDIT) || hasPermissionForApp(access, app, Permissions.SPACE_MANAGE), "isContentManagerForApp");
var getPermissionIdSetFromAccessMap = /* @__PURE__ */ __name((access) => {
  var _a5;
  const ids = /* @__PURE__ */ new Set();
  for (const entry of Object.values(access != null ? access : {})) {
    for (const permission of (_a5 = entry.permissions) != null ? _a5 : []) {
      ids.add(permission.id);
    }
  }
  return ids;
}, "getPermissionIdSetFromAccessMap");
var passesPermissionRestriction = /* @__PURE__ */ __name((requiredPermissionIds, userPermissionIds) => {
  const required = requiredPermissionIds != null ? requiredPermissionIds : [];
  return required.length === 0 || required.some((id2) => userPermissionIds.has(id2));
}, "passesPermissionRestriction");
var SupabaseRowProfileSchema = z140.object({
  id: z140.coerce.string(),
  // Legacy WP identifier — surfaced for cross-system integrations (e.g. Novu
  // subscriberId) that key off the original numeric WP user id.
  userid: z140.string().min(1).optional(),
  // Legacy WP subscription-type bucket — preserved for callers that still read
  // this denormalized list off the cached profile.
  subscriptionType: z140.array(z140.string()).optional(),
  first_name: z140.string().optional(),
  last_name: z140.string().optional(),
  name: z140.string(),
  display_name: z140.string().optional(),
  email: z140.string(),
  avatar: z140.string().nullable(),
  auth_user_id: z140.string(),
  created_at: z140.string(),
  updated_at: z140.string(),
  user_roles: z140.array(z140.string()).nullable().optional(),
  last_check_in: z140.string().or(z140.instanceof(Date)).or(CustomLuxonDateSchema).optional(),
  timezone: timezoneSchema,
  is_timezone_set: z140.boolean().default(false),
  occupation: z140.string().nullable().optional(),
  bio: z140.string().nullable().optional(),
  primary_language: z140.string().nullable().optional(),
  phone_number: z140.string().nullable().optional(),
  zoom_email: z140.string().nullable().optional(),
  is_teacher: z140.boolean().nullable().default(false).optional(),
  meta: object85({
    isInstructor: z140.boolean().nullable().default(false).optional()
  }).optional(),
  is_test_user: z140.boolean().nullable().default(false).optional(),
  is_private: z140.boolean().nullable().default(false).optional(),
  address: z140.object({
    street: z140.string().nullable().optional(),
    city: z140.string().nullable().optional(),
    state: z140.string().nullable().optional(),
    zip: z140.string().nullable().optional(),
    country: z140.string().nullable().optional(),
    countryId: z140.coerce.number().nullable().optional(),
    stateId: z140.coerce.number().nullable().optional(),
    cityId: z140.coerce.number().nullable().optional()
  }).nullable().optional(),
  socials: z140.object({
    facebook: z140.string().nullable().optional(),
    instagram: z140.string().nullable().optional(),
    youtube: z140.string().nullable().optional(),
    twitter: z140.string().nullable().optional(),
    linkedin: z140.string().nullable().optional(),
    tiktok: z140.string().nullable().optional()
  }).nullable().optional(),
  username: z140.string().nullable().optional(),
  user_uuid: z140.string(),
  mention_id: z140.string().uuid().nullable().optional(),
  access: UserAccessMapSchema.optional(),
  user_access: array19(object85({
    app: string66(),
    role: z140.object({
      id: z140.number(),
      name: z140.string(),
      role_permissions: z140.array(z140.object({
        permissions: z140.object({
          id: z140.number(),
          name: z140.string()
        }).nullable()
      })).optional()
    })
  })).optional()
});
var SupabaseProfileSchema = SupabaseRowProfileSchema.transform((values) => {
  var _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const _a5 = values, { id: id2, name, avatar, email, timezone, access, user_access } = _a5, rest = __objRest(_a5, ["id", "name", "avatar", "email", "timezone", "access", "user_access"]);
  const buildAccessEntry = /* @__PURE__ */ __name((r) => {
    var _a6, _b2;
    const permissions = (_b2 = (_a6 = r.role.role_permissions) == null ? void 0 : _a6.flatMap((rp) => rp.permissions ? [
      rp.permissions
    ] : [])) != null ? _b2 : [];
    return {
      roleId: r.role.id,
      roleName: r.role.name,
      permissions
    };
  }, "buildAccessEntry");
  const resolvedAccess = user_access && user_access.length > 0 ? Object.fromEntries(user_access.map((r) => [
    r.app,
    buildAccessEntry(r)
  ])) : access;
  return {
    id: id2,
    userId: id2,
    userid: rest.userid,
    subscriptionType: rest.subscriptionType,
    name,
    avatar,
    email,
    timezone,
    firstName: rest.first_name,
    lastName: rest.last_name,
    displayName: rest.display_name,
    authUserId: rest.auth_user_id,
    createdAt: rest.created_at,
    updatedAt: rest.updated_at,
    userRoles: (_b = rest.user_roles) != null ? _b : [],
    isManagement: ((_c = rest.user_roles) != null ? _c : []).some((r) => MANAGEMENT_ROLES.includes(r)),
    lastCheckIn: rest.last_check_in,
    isTimezoneSet: rest.is_timezone_set,
    occupation: (_d = rest.occupation) != null ? _d : null,
    bio: (_e = rest.bio) != null ? _e : null,
    primaryLanguage: (_f = rest.primary_language) != null ? _f : null,
    phoneNumber: (_g = rest.phone_number) != null ? _g : null,
    zoomEmail: (_h = rest.zoom_email) != null ? _h : null,
    isTeacher: (_i = rest.is_teacher) != null ? _i : false,
    meta: (_j = rest.meta) != null ? _j : {
      isInstructor: false
    },
    isTestUser: (_k = rest.is_test_user) != null ? _k : false,
    address: (_l = rest.address) != null ? _l : {
      street: null,
      city: null,
      state: null,
      zip: null,
      country: null,
      countryId: null,
      stateId: null,
      cityId: null
    },
    socials: (_m = rest.socials) != null ? _m : {
      facebook: null,
      instagram: null,
      youtube: null,
      twitter: null,
      linkedin: null,
      tiktok: null
    },
    isPrivate: (_n = rest.is_private) != null ? _n : false,
    username: (_o = rest.username) != null ? _o : "",
    userUUID: rest.user_uuid,
    mentionId: (_p = rest.mention_id) != null ? _p : null,
    access: resolvedAccess,
    // Populated post-parse by profile enrichment (see BaseSupabaseProfileService),
    // exactly like `access`. Not a column on the `profile` row.
    featureFlags: void 0
  };
});
var ProfileSchema = object85({
  id: coerce59.string().min(1),
  userId: coerce59.string().min(1),
  userid: string66().min(1).optional(),
  subscriptionType: array19(string66()).optional(),
  firstName: string66().optional(),
  lastName: string66().optional(),
  name: string66(),
  displayName: string66().optional(),
  avatar: string66().nullable(),
  email: string66(),
  timezone: timezoneSchema,
  authUserId: string66(),
  createdAt: string66(),
  updatedAt: string66(),
  userRoles: array19(string66()),
  isManagement: z140.boolean(),
  lastCheckIn: string66().or(z140.instanceof(Date)).or(CustomLuxonDateSchema).optional(),
  isTimezoneSet: z140.boolean(),
  occupation: string66().nullable(),
  bio: string66().nullable(),
  primaryLanguage: string66().nullable(),
  phoneNumber: string66().nullable(),
  zoomEmail: string66().nullable(),
  isTeacher: z140.boolean(),
  meta: ProfileMetaSchema,
  isTestUser: z140.boolean(),
  address: z140.object({
    street: string66().nullable().optional(),
    city: string66().nullable().optional(),
    state: string66().nullable().optional(),
    zip: string66().nullable().optional(),
    country: string66().nullable().optional(),
    countryId: z140.coerce.number().nullable().optional(),
    stateId: z140.coerce.number().nullable().optional(),
    cityId: z140.coerce.number().nullable().optional()
  }),
  socials: z140.object({
    facebook: string66().nullable().optional(),
    instagram: string66().nullable().optional()
  }),
  isPrivate: z140.boolean(),
  username: string66().nullable(),
  userUUID: string66().uuid(),
  mentionId: string66().uuid().nullable(),
  access: UserAccessMapSchema.optional(),
  featureFlags: FeatureFlagMapSchema.optional()
});
var SupabaseMentionableProfileRowSchema = z140.object({
  id: z140.coerce.string(),
  mention_id: z140.string().uuid().nullable().optional(),
  display_name: z140.string().nullable().optional(),
  name: z140.string().nullable().optional(),
  username: z140.string().nullable().optional(),
  avatar: z140.string().nullable().optional(),
  is_private: z140.boolean().nullable().optional(),
  // Active-app derivation comes from the `user_access` join, not a column.
  // `access` is not a real column — it is built from this join below.
  user_access: array19(object85({
    app: string66(),
    role: z140.object({
      id: z140.number(),
      name: z140.string(),
      role_permissions: z140.array(z140.object({
        permissions: z140.object({
          id: z140.number(),
          name: z140.string()
        }).nullable()
      })).optional()
    })
  })).optional()
});
var SupabaseMentionableProfileSchema = SupabaseMentionableProfileRowSchema.transform((row) => {
  var _a5, _b, _c, _d, _e, _f;
  const access = row.user_access && row.user_access.length > 0 ? Object.fromEntries(row.user_access.map((r) => {
    var _a6, _b2;
    return [
      r.app,
      {
        roleId: r.role.id,
        roleName: r.role.name,
        permissions: (_b2 = (_a6 = r.role.role_permissions) == null ? void 0 : _a6.flatMap((rp) => rp.permissions ? [
          rp.permissions
        ] : [])) != null ? _b2 : []
      }
    ];
  })) : void 0;
  return {
    id: row.id,
    mentionId: (_a5 = row.mention_id) != null ? _a5 : null,
    displayName: (_b = row.display_name) != null ? _b : null,
    name: (_c = row.name) != null ? _c : null,
    username: (_d = row.username) != null ? _d : null,
    avatar: (_e = row.avatar) != null ? _e : null,
    isPrivate: (_f = row.is_private) != null ? _f : false,
    access
  };
});

// src/ryc/user-management/user-type.ts
var SingleUserSchema = z141.object({
  userid: number26(),
  name: string67(),
  avatar: string67(),
  email: string67().email(),
  subscriptionType: AppNameEnumObj.array(),
  subscription: array20(Subscription),
  timezone: timezoneSchema.optional()
});
var SubscribedUserSchema = z141.object({
  userid: z141.string(),
  name: z141.string(),
  avatar: z141.string(),
  email: z141.string().email(),
  subscriptionType: z141.array(AppNameEnumObj),
  subscription: z141.array(Subscription)
});
var UserWatchedAContentSchema = SingleUserSchema.extend({
  createdAt: z141.date()
});
var SubscribedUserResponseSchema = z141.object({
  data: SubscribedUserSchema.array(),
  pagination: object86({
    totalItems: z141.number(),
    totalPages: z141.number(),
    currentPage: z141.number(),
    perPage: z141.number()
  })
});

// src/ryc/user-progress/base.ts
import { coerce as coerce60, object as object87 } from "zod";
var BaseUserProgressSchema = object87({
  totalCompletedClasses: coerce60.number(),
  totalTimeSpentInMin: coerce60.number()
});

// src/plan/base.ts
import { array as array21, coerce as coerce61, number as number27, object as object88, string as string68, z as z142 } from "zod";
var PlanItemContent = Content.omit({
  averageRating: true,
  publishedDate: true,
  type: true
}).extend({
  type: z142.union([
    RYCContentMetaTypeEnumObject,
    ContentTypeEnumObj
  ])
});
var Plan = object88({
  id: coerce61.string(),
  classCount: number27().default(0).optional(),
  name: string68()
});
var SinglePlan = Plan.extend({
  contents: array21(Content)
});
var PlanItem = object88({
  id: number27(),
  order: number27().int().positive(),
  day: coerce61.number().int().positive(),
  content: PlanItemContent.optional(),
  isRestDay: z142.boolean().optional()
});
var PlanItemReorder = object88({
  id: number27().optional(),
  order: number27().int().positive(),
  day: number27().int().positive(),
  contentId: string68().optional(),
  isRestDay: z142.boolean().optional()
});
var PlanResponseSchema = Plan.extend({
  items: PlanItem.array()
});
var PlansResponseSchema = object88({
  items: Plan.array(),
  meta: object88({
    total: z142.number().int().nonnegative(),
    page: z142.number().int().positive(),
    perPage: z142.number().int().positive(),
    totalPages: z142.number().int().nonnegative()
  })
});

// src/plan/be-schema.ts
import { coerce as coerce62, z as z143 } from "zod";

// src/plan/fe-schema.ts
import { array as array22 } from "zod";
var CreatePlanSchemaFE = Plan.omit({
  id: true,
  classCount: true
}).extend({
  items: array22(PlanItem)
});
var defaultPlanSchemaValues = {
  name: "",
  items: []
};

// src/plan/be-schema.ts
var CreatePlanSchemaBE = CreatePlanSchemaFE.extend({
  items: PlanItemReorder.array()
});
var CreatePlanRequestSchemaBE = CreatePlanSchemaBE.extend({
  userId: coerce62.string().min(1)
});
var PlanItemsRequestSchemaFE = z143.object({
  id: coerce62.number().int().positive(),
  items: PlanItemReorder.array()
});
var UpdatePlanRequestSchemaFE = CreatePlanSchemaFE.merge(PlanItemsRequestSchemaFE);

// src/user-activity/base.ts
import { object as object89, string as string69 } from "zod";
var UserSchema = object89({
  userid: string69(),
  name: string69(),
  email: string69()
});

// src/user-activity/manual-complete-content.request.ts
import { object as object90, string as string70 } from "zod";
var ManualCompleteContentRequestSchema = object90({
  userId: string70(),
  contentId: string70()
});

// src/user-activity/query.ts
import { coerce as coerce63, object as object91, z as z144 } from "zod";
var UserActivityQuerySchema = object91({
  page: coerce63.number().int().positive().default(1),
  perPage: coerce63.number().int().positive().default(15),
  excludeTypes: z144.preprocess((val) => typeof val === "string" ? val.split(",") : val, z144.array(UserActivityTypeEnumObject).optional())
});

// src/user-activity/time-period-filter.enum.ts
import { z as z145 } from "zod";
var TimePeriodEnumValues = [
  "WEEK",
  "MONTH",
  "YEAR"
];
var TimePeriodEnumObj = z145.enum(TimePeriodEnumValues);
var TimePeriodEnum = TimePeriodEnumObj.enum;

// src/user-activity/user-activity-type.enum.ts
import { z as z146 } from "zod";
var UserActivitiesTypeValues = [
  "USER_ACTIVITY",
  "USER_INFORMATION",
  "PURCHASE_HISTORY",
  "VIDEO_WATCHED",
  "CHECK_IN",
  "TROPHIES",
  "SIMULATION"
];
var UserActivitiesTypeObj = z146.enum(UserActivitiesTypeValues);
var UserActivitiesTypeEnum = UserActivitiesTypeObj.enum;

// src/user-progress/base.ts
import { coerce as coerce64, object as object92 } from "zod";
var UserTotalWatchedByCategory = object92({
  strength: coerce64.number(),
  flow: coerce64.number(),
  cardio: coerce64.number(),
  restore: coerce64.number()
});
var AddonUserTotalWatchedByCategory = object92({
  introduction: coerce64.number(),
  exercises: coerce64.number(),
  workout: coerce64.number(),
  foundation: coerce64.number()
});
var BaseFitUserProgressSchema = object92({
  totalCompletedClasses: coerce64.number(),
  totalWatchedMin: coerce64.number(),
  activeDays: coerce64.number(),
  watchedCategory: UserTotalWatchedByCategory
});
var BaseAddonUserProgressSchema = object92({
  totalCompletedClasses: coerce64.number(),
  totalWatchedMin: coerce64.number(),
  activeDays: coerce64.number(),
  watchedCategory: AddonUserTotalWatchedByCategory
});

// src/user-progress/get-watch-history-date.ts
import { coerce as coerce65, z as z147 } from "zod";
var UserWatchHistoryDates = z147.array(coerce65.string());

// src/class-of-the-day-theme/base.ts
import { array as array23, coerce as coerce66, number as number28, object as object93, string as string71 } from "zod";
var contentSchema = FITContent.omit({
  averageRating: true
});
var ClassOfTheDayTheme = object93({
  id: coerce66.string(),
  title: string71().min(1),
  description: string71().optional(),
  month: number28().int().min(1).max(12),
  year: number28().int().min(2e3).max(2100),
  buttonLabel: string71().nullable()
});
var SingleContentSchedule = ClassOfTheDayTheme.extend({
  contents: array23(FITContent)
});
var ContentScheduleItemWithContent = object93({
  id: number28(),
  day: coerce66.number().int().positive(),
  content: contentSchema
});
var ContentScheduleItem = object93({
  id: number28().optional(),
  day: coerce66.number().int().positive(),
  contentId: string71().optional()
});
var ContentScheduleResponseSchema = ClassOfTheDayTheme.extend({
  items: ContentScheduleItemWithContent.array()
});

// src/class-of-the-day-theme/be-schema.ts
import { coerce as coerce67, object as object94, string as string72 } from "zod";
var CODPayloadItem = object94({
  contentId: string72(),
  day: coerce67.number().int().positive()
});
var CreateCODThemeSchemaBE = ClassOfTheDayTheme.omit({
  id: true
}).merge(object94({
  items: CODPayloadItem.array()
}));
var UpdateCODThemeSchemaBE = ClassOfTheDayTheme.merge(object94({
  items: CODPayloadItem.array()
}));

// src/class-of-the-day-theme/fe-schema.ts
import { array as array24 } from "zod";
var ClassOfTheDayThemeSchemaFE = ClassOfTheDayTheme.omit({
  id: true
}).extend({
  items: array24(ContentScheduleItemWithContent)
});
var currentDate = /* @__PURE__ */ new Date();
var defaultClassOfTheDayThemeSchemaValues = {
  title: "",
  description: "",
  items: [],
  buttonLabel: null,
  month: currentDate.getMonth() + 1,
  year: currentDate.getFullYear()
};

// src/ws-url.ts
import { string as string73 } from "zod";
var WsUrl = string73().refine((url) => url.startsWith("//") || /^wss?:\/\//.test(url) || /^https?:\/\//.test(url), {
  message: "Must be a valid URL or protocol-relative URL (//host)"
});

// src/user-meta/get-user-ids-request.ts
import { array as array25, object as object95, string as string74 } from "zod";
var GetUserIdsBESchema = object95({
  userIds: array25(string74())
});

// src/version.ts
import { z as z148 } from "zod";
var VersionInfoSchema = z148.object({
  timestamp: z148.number(),
  buildDate: z148.string(),
  version: z148.string()
});

// src/user-management/update-timezone.schema.ts
import { object as object96, string as string75 } from "zod";
var UpdateTimezoneSchema = object96({
  timezone: string75().min(1, "Timezone is required").refine((tz) => {
    try {
      Intl.DateTimeFormat(void 0, {
        timeZone: tz
      });
      return true;
    } catch (e) {
      return false;
    }
  }, {
    message: "Invalid IANA timezone"
  })
});

// src/search/global-search.schema.ts
import { array as array26, number as number29, object as object97, string as string76 } from "zod";
var GlobalSearchRequestSchema = object97({
  q: string76().min(2)
});
var SearchContentItemSchema = object97({
  id: string76(),
  title: string76(),
  instructorName: string76().nullable().optional(),
  banner: string76().nullable().optional(),
  duration: number29()
});
var SearchContentSchema = object97({
  contents: array26(SearchContentItemSchema),
  total: number29()
});
var SearchTextItemSchema = object97({
  id: string76(),
  title: string76(),
  videoCount: number29()
});
var SearchCategoryItemSchema = object97({
  name: string76()
});
var SearchInstructorItemSchema = object97({
  id: string76(),
  name: string76(),
  avatar: string76().nullable().optional()
});
var GlobalSearchResultSchema = object97({
  content: SearchContentSchema,
  playlists: array26(SearchTextItemSchema),
  series: array26(SearchTextItemSchema),
  categories: array26(SearchCategoryItemSchema),
  instructors: array26(SearchInstructorItemSchema)
});

// src/billing/index.ts
import { z as z149 } from "zod";
var GetOrdersSchema = z149.object({
  page: z149.coerce.number().int().positive().default(1),
  perPage: z149.coerce.number().int().positive().default(10)
});
var OrderProductSchema = z149.object({
  productId: z149.number(),
  productName: z149.string(),
  price: z149.number(),
  quantity: z149.number()
});
var OrderSchema = z149.object({
  orderNo: z149.number(),
  date: z149.string(),
  status: z149.string(),
  paymentUrl: z149.string().url().nullable().optional(),
  products: z149.array(OrderProductSchema),
  subtotal: z149.number(),
  discount: z149.number(),
  total: z149.number(),
  currency: z149.string()
});
var OrdersResponseSchema = z149.object({
  totalPages: z149.number(),
  page: z149.number(),
  perPage: z149.number(),
  total: z149.number(),
  items: z149.array(OrderSchema)
});
var BillingSubscriptionSchema = z149.object({
  subscriptionNo: z149.number(),
  status: z149.string(),
  nextPaymentOn: z149.string(),
  products: z149.array(OrderProductSchema),
  subtotal: z149.number(),
  discount: z149.number(),
  total: z149.number(),
  currency: z149.string(),
  orderIds: z149.array(z149.number())
});
var SubscriptionsResponseSchema = z149.object({
  totalPages: z149.number(),
  page: z149.number(),
  perPage: z149.number(),
  total: z149.number(),
  items: z149.array(BillingSubscriptionSchema)
});
var PaymentPlanSchema = z149.object({
  paymentPlanId: z149.number(),
  status: z149.string(),
  nextPaymentOn: z149.string(),
  products: z149.array(OrderProductSchema),
  subtotal: z149.number(),
  discount: z149.number(),
  total: z149.number(),
  currency: z149.string(),
  orderIds: z149.array(z149.number())
});
var PaymentPlansResponseSchema = z149.object({
  totalPages: z149.number(),
  page: z149.number(),
  perPage: z149.number(),
  total: z149.number(),
  items: z149.array(PaymentPlanSchema)
});

// src/upload/index.ts
import { z as z151 } from "zod";

// src/media/base.ts
import { coerce as coerce68, z as z150 } from "zod";
var EMediaFileStatus = /* @__PURE__ */ function(EMediaFileStatus2) {
  EMediaFileStatus2["ACTIVE"] = "active";
  EMediaFileStatus2["SOFT_DELETED"] = "soft_deleted";
  EMediaFileStatus2["PROCESSING"] = "processing";
  EMediaFileStatus2["FAILED"] = "failed";
  return EMediaFileStatus2;
}({});
var EImageVariant = /* @__PURE__ */ function(EImageVariant2) {
  EImageVariant2["w90"] = "w90";
  EImageVariant2["w230x280"] = "w230x280";
  EImageVariant2["w400"] = "w400";
  EImageVariant2["w715x500"] = "w715x500";
  EImageVariant2["w800"] = "w800";
  EImageVariant2["w1070"] = "w1070";
  EImageVariant2["w1200"] = "w1200";
  EImageVariant2["w1375"] = "w1375";
  EImageVariant2["w1920x768"] = "w1920x768";
  EImageVariant2["w1986x558"] = "w1986x558";
  EImageVariant2["w2400"] = "w2400";
  EImageVariant2["original"] = "original";
  EImageVariant2["compressed"] = "compressed";
  EImageVariant2["poster"] = "poster";
  return EImageVariant2;
}({});
var MediaCdnUrlsSchema = z150.record(z150.nativeEnum(EImageVariant), z150.string());
var MediaFileBaseSchema = z150.object({
  id: z150.string().uuid(),
  userId: z150.string().max(36),
  originalName: z150.string().max(255),
  cdnUrls: MediaCdnUrlsSchema,
  mimeType: z150.string().max(100),
  sizeBytes: coerce68.number().int(),
  altText: z150.string().max(500).nullable().optional(),
  status: z150.nativeEnum(EMediaFileStatus).default("active"),
  isSystem: z150.boolean().default(false),
  createdAt: z150.date().or(z150.string()),
  updatedAt: z150.date().or(z150.string()),
  deletedAt: z150.date().or(z150.string()).nullable().optional()
});
var CreateMediaFileSchema = z150.object({
  originalName: z150.string().min(1).max(255),
  cdnUrls: MediaCdnUrlsSchema,
  mimeType: z150.string().min(1).max(100),
  sizeBytes: z150.number().int().positive(),
  altText: z150.string().max(500).nullable().optional(),
  isSystem: z150.boolean().optional().default(false),
  // Callers that upload a compressible asset (video / PDF) create the row as
  // PROCESSING so the transcoder has something to flip to ACTIVE when done.
  status: z150.nativeEnum(EMediaFileStatus).optional()
});
var UpdateMediaFileSchema = z150.object({
  altText: z150.string().max(500).nullable().optional(),
  status: z150.nativeEnum(EMediaFileStatus).optional()
});
var MediaFileFiltersSchema = z150.object({
  mimeType: z150.string().optional(),
  status: z150.nativeEnum(EMediaFileStatus).optional(),
  isSystem: CoerceBoolean.optional(),
  page: coerce68.number().int().min(1).optional().default(1),
  limit: coerce68.number().int().min(1).max(100).optional().default(24)
});
var MediaFilePageSchema = z150.object({
  data: z150.array(MediaFileBaseSchema),
  total: z150.number().int(),
  page: z150.number().int(),
  limit: z150.number().int()
});
var MediaMonthlyStatSchema = z150.object({
  month: z150.string(),
  count: z150.number().int(),
  totalBytes: z150.number()
});
var MediaUserStatsSchema = z150.object({
  totalCount: z150.number().int(),
  totalBytes: z150.number(),
  monthly: z150.array(MediaMonthlyStatSchema)
});
var MediaUploadLimitSchema = z150.object({
  maxMonthlyBytes: z150.number().int().positive(),
  isCustom: z150.boolean()
});
var UpdateMediaUploadLimitSchema = z150.object({
  maxMonthlyBytes: z150.number().int().positive()
});

// src/upload/index.ts
var PresignedUploadResultSchema = z151.object({
  uploadUrl: z151.string(),
  publicUrl: z151.string().nullable()
});
var UploadedFileSchema = z151.object({
  key: z151.string(),
  publicUrl: z151.string().nullable(),
  /** All available size variant URLs. Undefined for files uploaded before multi-size support. */
  cdnUrls: z151.record(z151.nativeEnum(EImageVariant), z151.string()).optional(),
  filename: z151.string(),
  size: z151.number(),
  lastModified: z151.date().or(z151.string()),
  mimeType: z151.string(),
  /** Supabase auth_user_id of the uploader */
  uploadedBy: z151.string().optional()
});

// src/media/storage-analytics.ts
import { coerce as coerce69, z as z152 } from "zod";
var EStorageSortField = /* @__PURE__ */ function(EStorageSortField2) {
  EStorageSortField2["total"] = "total";
  EStorageSortField2["image"] = "image";
  EStorageSortField2["file"] = "file";
  EStorageSortField2["video"] = "video";
  EStorageSortField2["lastUpload"] = "lastUpload";
  return EStorageSortField2;
}({});
var EStorageSortOrder = /* @__PURE__ */ function(EStorageSortOrder2) {
  EStorageSortOrder2["asc"] = "asc";
  EStorageSortOrder2["desc"] = "desc";
  return EStorageSortOrder2;
}({});
var StorageAnalyticsFiltersSchema = z152.object({
  /** Partial match on user id (numeric profile id), name, email or display name. */
  search: z152.string().trim().max(200).optional(),
  /** ISO date — include uploads created on/after this instant. */
  startDate: z152.string().datetime({
    offset: true
  }).or(z152.string().date()).optional(),
  /** ISO date — include uploads created on/before this instant. */
  endDate: z152.string().datetime({
    offset: true
  }).or(z152.string().date()).optional(),
  sortBy: z152.nativeEnum(EStorageSortField).optional().default("total"),
  sortOrder: z152.nativeEnum(EStorageSortOrder).optional().default("desc"),
  page: coerce69.number().int().min(1).optional().default(1),
  limit: coerce69.number().int().min(1).max(100).optional().default(20)
});
var StorageAnalyticsUserRowSchema = z152.object({
  userId: z152.string(),
  name: z152.string(),
  email: z152.string(),
  displayName: z152.string().optional(),
  avatar: z152.string().optional(),
  imageBytes: z152.number(),
  fileBytes: z152.number(),
  videoBytes: z152.number(),
  totalBytes: z152.number(),
  imageCount: z152.number().int(),
  fileCount: z152.number().int(),
  videoCount: z152.number().int(),
  totalCount: z152.number().int(),
  lastUploadAt: z152.string().nullable(),
  /** Monthly upload cap in bytes — the per-user value from user_meta, or the server default. */
  maxMonthlyBytes: z152.number().int(),
  /** True when the user has a per-user limit stored in user_meta (vs the server default). */
  isCustomLimit: z152.boolean()
});
var StorageAnalyticsSummarySchema = z152.object({
  totalBytes: z152.number(),
  imageBytes: z152.number(),
  fileBytes: z152.number(),
  videoBytes: z152.number(),
  imageCount: z152.number().int(),
  fileCount: z152.number().int(),
  videoCount: z152.number().int(),
  totalCount: z152.number().int(),
  userCount: z152.number().int()
});
var StorageAnalyticsResponseSchema = z152.object({
  summary: StorageAnalyticsSummarySchema,
  data: z152.array(StorageAnalyticsUserRowSchema),
  pagination: z152.object({
    totalItems: z152.number().int(),
    totalPages: z152.number().int(),
    currentPage: z152.number().int(),
    perPage: z152.number().int()
  })
});

// src/media/transcode.ts
import { z as z153 } from "zod";
var EMediaProcessingKind = /* @__PURE__ */ function(EMediaProcessingKind2) {
  EMediaProcessingKind2["video"] = "video";
  return EMediaProcessingKind2;
}({});
var resolveProcessingKind = /* @__PURE__ */ __name((mimeType) => {
  if (mimeType.startsWith("video/")) {
    return "video";
  }
  return null;
}, "resolveProcessingKind");
var TranscodeJobSchema = z153.object({
  mediaId: z153.string().uuid(),
  /** R2 object key of the uploaded original, e.g. `uploads/2026-07-21/<name>.mp4`. */
  key: z153.string().min(1),
  mimeType: z153.string().min(1),
  kind: z153.nativeEnum(EMediaProcessingKind)
});
var TranscodeOutputSchema = z153.object({
  variant: z153.nativeEnum(EImageVariant),
  key: z153.string(),
  url: z153.string(),
  sizeBytes: z153.number().int().nonnegative()
});
var TranscodeResultSchema = z153.object({
  mediaId: z153.string().uuid(),
  outputs: z153.array(TranscodeOutputSchema),
  /** Size of the source object, so callers can log the compression ratio. */
  originalSizeBytes: z153.number().int().nonnegative(),
  durationMs: z153.number().int().nonnegative(),
  /**
  * True when compression ran but the result was no smaller than the source,
  * so the original was kept and no `compressed` output was produced.
  */
  skipped: z153.boolean().default(false),
  /**
  * True when the source object was deleted from R2 because a verified
  * compressed derivative replaced it. Callers must then drop `original` from
  * `cdnUrls`, or the record would point at an object that no longer exists.
  */
  originalDeleted: z153.boolean().default(false)
});
var TranscodeResultEventSchema = z153.discriminatedUnion("status", [
  z153.object({
    status: z153.literal("ok"),
    result: TranscodeResultSchema
  }),
  z153.object({
    status: z153.literal("unprocessable"),
    mediaId: z153.string().uuid(),
    error: z153.string()
  })
]);

// src/support/comment.ts
import { z as z154 } from "zod";
var CreateTicketCommentSchema = z154.object({
  content: z154.string().min(1),
  attachmentPaths: z154.array(z154.string()).optional()
});
var TicketCommentSchema = z154.object({
  id: z154.string().uuid(),
  ticketId: z154.number(),
  authorEmail: z154.string(),
  content: z154.string(),
  isAdmin: z154.boolean(),
  isSystem: z154.boolean(),
  seenAt: z154.string().nullable(),
  createdAt: z154.string(),
  attachments: z154.array(z154.object({
    id: z154.string().uuid(),
    path: z154.string(),
    originalName: z154.string(),
    mimeType: z154.string(),
    sizeBytes: z154.number()
  })).optional()
});

// src/support/issue-category.ts
import { z as z155 } from "zod";
var CreateIssueCategorySchema = z155.object({
  name: z155.string().min(1),
  parentId: z155.string().uuid().nullable().optional(),
  allowPublic: z155.boolean().default(false),
  order: z155.number().int().default(0),
  icon: z155.string().nullable().optional(),
  description: z155.string().nullable().optional()
});
var UpdateIssueCategorySchema = CreateIssueCategorySchema.partial();
var IssueCategorySchema = z155.lazy(() => z155.object({
  id: z155.string().uuid(),
  name: z155.string(),
  parentId: z155.string().uuid().nullable(),
  allowPublic: z155.boolean(),
  order: z155.number(),
  icon: z155.string().nullable(),
  description: z155.string().nullable(),
  createdAt: z155.string(),
  updatedAt: z155.string(),
  children: IssueCategorySchema.array().optional()
}));

// src/support/rbac.ts
import { z as z156 } from "zod";
var SupportPermissionKeyValues = [
  "help.ticket.view_all",
  "help.ticket.reply",
  "help.ticket.update_status",
  "help.ticket.delete",
  "help.chat.view",
  "help.chat.join",
  "help.chat.close",
  "help.chat.takeover",
  "help.issue_category.manage",
  "help.role.manage",
  "help.staff.manage",
  "help.settings.ai"
];
var SupportPermissionKeyEnum = z156.enum(SupportPermissionKeyValues);
var AssignRoleSchema = z156.object({
  userUuid: z156.string().uuid(),
  roleId: z156.number().int().positive()
});
var SupportRoleSchema = z156.object({
  id: z156.number(),
  name: z156.string(),
  description: z156.string().nullable(),
  isSystem: z156.boolean(),
  createdAt: z156.string()
});
var SupportStaffMemberSchema = z156.object({
  userUuid: z156.string(),
  wpUserId: z156.string().nullable().optional(),
  email: z156.string().nullable(),
  name: z156.string().nullable(),
  roleId: z156.number(),
  roleName: z156.string()
});

// src/support/support-settings.ts
import { z as z157 } from "zod";
var SlackNotificationEventValues = [
  "ticket_created",
  "customer_replied",
  "staff_replied",
  "ai_draft_generated",
  "ai_draft_approved",
  "ai_draft_dismissed",
  "status_changed",
  "assigned"
];
var SlackNotificationEventEnum = z157.enum(SlackNotificationEventValues);
var DEFAULT_AI_SYSTEM_PROMPT = `You are {agentName}, a helpful support agent. Use the knowledge base articles below to answer the customer's question. Be concise and friendly. If the answer is not in the knowledge base, acknowledge the question and let the customer know the team will follow up.

CRITICAL RULES \u2014 never break these:
- NEVER invent or estimate timeframes (e.g. "24-48 hours", "within a day", "soon"). If you do not know when something will happen, do not guess \u2014 simply say the team will follow up.
- NEVER make promises or guarantees about outcomes, fixes, or timelines.
- NEVER fabricate information not present in the knowledge base or conversation history.

IMPORTANT: Format your entire response as valid HTML. Use <p> for paragraphs, <strong> for bold, <a href="..."> for links, <ol>/<ul>/<li> for lists. Do NOT use Markdown syntax (no **, no #, no backticks, no [text](url) syntax). Output only the inner HTML content \u2014 no <html>, <head>, or <body> tags.`;
var DEFAULT_ARTICLE_SYSTEM_PROMPT = `You are an expert technical writer. Your job is to turn a resolved support ticket conversation into a polished, reusable knowledge base article that helps future customers solve the same problem themselves.

Guidelines:
- Write for a general audience \u2014 assume the reader has the same problem but has never seen this ticket.
- The "question" should be the most natural way a customer would search for this problem (plain text, no HTML, no punctuation at the end except "?").
- The "answer" should be a self-contained solution: explain the cause briefly, then provide clear step-by-step instructions or information. Omit personal details, ticket numbers, and back-and-forth pleasantries.
- Use <p> for paragraphs, <ol>/<li> for numbered steps, <ul>/<li> for unordered lists, <strong> for key terms. No markdown.
- Be concise but complete \u2014 aim for 100\u2013300 words in the answer.

Return a JSON object with exactly two keys:
- "question": article title as a natural search query (plain text)
- "answer": article body as valid inner HTML

Output only the raw JSON object \u2014 no markdown code fences, no extra text before or after.`;
var SupportSettingsSchema = z157.object({
  aiAgentName: z157.string().default("Support Bot"),
  aiEnabled: z157.boolean().default(false),
  aiAvatarUrl: z157.string().nullable().default(null),
  aiSystemPrompt: z157.string().default(DEFAULT_AI_SYSTEM_PROMPT),
  articleSystemPrompt: z157.string().default(DEFAULT_ARTICLE_SYSTEM_PROMPT),
  slackEnabledEvents: z157.array(SlackNotificationEventEnum).default([
    ...SlackNotificationEventValues
  ])
});
var UpdateSupportSettingsSchema = SupportSettingsSchema.partial();

// src/support/ticket.ts
import { z as z158 } from "zod";
var TicketStatusValues = [
  "open",
  "customer_reply",
  "replied",
  "closed"
];
var TicketStatusEnum = z158.enum(TicketStatusValues);
var CreateTicketSchema = z158.object({
  title: z158.string().min(1),
  description: z158.string().min(1),
  product: z158.string().optional(),
  issueCategoryId: z158.string().uuid().optional(),
  userEmail: z158.string().email().optional(),
  attachmentPaths: z158.array(z158.string()).optional()
});
var UpdateTicketStatusSchema = z158.object({
  status: TicketStatusEnum
});
var TicketFiltersSchema = z158.object({
  status: TicketStatusEnum.optional(),
  search: z158.string().optional(),
  userId: z158.string().optional(),
  dateFrom: z158.string().optional(),
  dateTo: z158.string().optional(),
  issueCategoryId: z158.string().uuid().optional(),
  page: z158.coerce.number().int().min(1).default(1),
  perPage: z158.coerce.number().int().min(1).max(100).default(20)
});
var AssignTicketSchema = z158.object({
  assignedTo: z158.string().nullable()
});
var TicketSchema = z158.object({
  id: z158.number(),
  userEmail: z158.string().nullable(),
  userId: z158.string().nullable(),
  title: z158.string(),
  description: z158.string(),
  status: TicketStatusEnum,
  product: z158.string().nullable(),
  issueCategoryId: z158.string().uuid().nullable(),
  assignedTo: z158.string().nullable(),
  assignedToName: z158.string().nullable().optional(),
  accessToken: z158.string().nullable().optional(),
  sourceArticleId: z158.number().nullable().optional(),
  createdAt: z158.string(),
  updatedAt: z158.string()
});

// src/support/ticket-event.ts
import { z as z159 } from "zod";
var TicketEventTypeValues = [
  "created",
  "status_changed",
  "assigned",
  "unassigned",
  "staff_replied",
  "customer_replied"
];
var TicketEventTypeEnum = z159.enum(TicketEventTypeValues);
var TicketEventSchema = z159.object({
  id: z159.number(),
  ticketId: z159.number(),
  actorEmail: z159.string().nullable(),
  actorId: z159.string().nullable().optional(),
  eventType: TicketEventTypeEnum,
  metadata: z159.record(z159.unknown()).nullable(),
  createdAt: z159.string()
});

// src/addon/content/be-schema.ts
import { coerce as coerce70, object as object98, string as string77, z as z160 } from "zod";
var AddonCreateContentSchemaBEBase = object98({
  app: AppNameEnumObj,
  id: string77().optional(),
  name: string77().min(3, "name is required"),
  category: AddonCategoryEnumObj,
  type: ContentTypeEnumObj,
  status: StatusEnumObj,
  // Equipments are optional for the addon app — provided as optional sets, not mandatory.
  equipments: object98({
    id: coerce70.number().min(1, "id is required")
  }).array().optional().default([]),
  instructorId: coerce70.string().min(1, "Please select instructor"),
  video: VimeoVideoInput,
  isAllowComment: coerce70.boolean().default(false),
  publishedDate: z160.string().or(CustomLuxonDateSchema).optional().nullable(),
  favorite: CoerceBoolean.optional().default(false)
});
var AddonCreateContentSchemaBE = AddonCreateContentSchemaBEBase.refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var AddonUpdateContentSchemaBE = AddonCreateContentSchemaBEBase.partial();

// src/addon/content/fe-schema.ts
import { coerce as coerce71, lazy as lazy12, object as object99, z as z161 } from "zod";
var AddonContent = Content.extend({
  category: AddonCategoryEnumObj
});
var AddonAllStatusContentSchema = AllStatusContentSchema.extend({
  category: AddonCategoryEnumObj
});
var AddonTrashContentSchema = TrashContentSchema.extend({
  category: AddonCategoryEnumObj
});
var AddonContentAndTrashContentUnion = z161.union([
  AddonContent,
  AddonTrashContentSchema
]);
var AddonContentWithRatingFlagSchema = ContentWithRatingFlagSchema.extend({
  category: AddonCategoryEnumObj
});
var AddonContentFindAllResponseSchema = object99({
  items: AddonContentWithRatingFlagSchema.array(),
  meta: object99({
    page: coerce71.number(),
    perPage: coerce71.number(),
    total: coerce71.number(),
    totalPages: coerce71.number()
  })
});
var AddonDashboardCreateContentSchemaFEWithoutValidation = CreateContentSchemaFEWithoutValidation.extend({
  category: lazy12(() => CategoryEnumObj.or(AddonCategoryEnumObj)),
  // Equipments are optional for the addon app — provided as optional sets, not mandatory.
  equipments: coerce71.number().array().optional().default([])
});
var AddonDashboardCreateContentSchemaFE = AddonDashboardCreateContentSchemaFEWithoutValidation.refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var AddonDashboardUpdateContentSchemaFE = AddonDashboardCreateContentSchemaFEWithoutValidation.partial();
var defaultAddonContentSchemaValues = {
  video: {
    bannerUrl2x: "",
    description: "",
    vimeoVideoId: ""
  },
  name: "",
  instructorId: "",
  equipments: [],
  isAllowComment: false,
  type: "VIDEO",
  favorite: false,
  category: AddonCategoryEnum.EXERCISES,
  status: "PUBLISHED",
  publishedDate: void 0
};

// src/addon/program/base.ts
import { z as z163 } from "zod";

// src/addon/program/section-schema.ts
import { z as z162 } from "zod";
var ProgramSectionInput = z162.object({
  // Stable key used to link items to sections within a single create/update
  // payload. For sections loaded from the DB this is the stringified id; for
  // sections newly added in the dashboard it is a client-generated key. The
  // backend resolves it to the real section id when persisting items.
  key: z162.string(),
  // Present when the section already exists in the DB; absent for new ones.
  id: z162.coerce.number().int().positive().optional().nullable(),
  // The content category this section represents (drives the section heading).
  category: AddonCategoryEnumObj,
  description: z162.string().nullable().optional().default(""),
  order: z162.coerce.number().int().nonnegative()
});
var ProgramSectionResponse = z162.object({
  id: z162.coerce.number(),
  category: AddonCategoryEnumObj,
  description: z162.string().nullable().optional().default(""),
  order: z162.coerce.number()
});

// src/addon/program/base.ts
var Program = Series;
var SingleProgram = SingleSeries;
var ProgramResponseItem = PlaylistItem.extend({
  section: ProgramSectionResponse.nullable().optional()
});
var ProgramResponseSchema = SeriesResponseSchema.extend({
  salesPageUrl: z163.string().nullable().optional(),
  published: z163.coerce.boolean().default(true),
  sections: ProgramSectionResponse.array().optional().default([]),
  items: ProgramResponseItem.array()
});
var ProgramListResponseSchema = z163.object({
  items: ProgramResponseSchema.array(),
  meta: z163.object({
    total: z163.number().int().nonnegative(),
    page: z163.number().int().positive(),
    perPage: z163.number().int().positive(),
    totalPages: z163.number().int().nonnegative()
  })
});
var MiniProgramCatalogItemSchema = z163.object({
  id: z163.coerce.number(),
  slug: z163.string(),
  name: z163.string(),
  imageUrl: z163.string().nullable().optional(),
  imageUrl2x: z163.string().nullable().optional(),
  salesPageUrl: z163.string().nullable().optional()
});

// src/addon/program/be-schema.ts
import { z as z165 } from "zod";

// src/addon/program/fe-schema.ts
import { array as array27, number as number30, object as object100, z as z164 } from "zod";
var ProgramReorderItem = object100({
  id: number30(),
  order: number30().int().positive(),
  content: AddonContent,
  // Links this item to one of the program's sections (by section key). Optional
  // so a program with no sections defined yet keeps working.
  sectionKey: z164.string().nullable().optional()
});
var CreateProgramSchemaFE = CreateSeriesSchemaFE.extend({
  items: array27(ProgramReorderItem),
  // Ordered, per-program list of sections with editable helper text.
  sections: array27(ProgramSectionInput).default([]),
  // Where non-owners are sent to purchase from the Members Panel card. Without
  // it, only owners see the card.
  salesPageUrl: z164.string().url("Enter a valid URL").or(z164.literal("")).nullable().optional(),
  // Single visibility toggle — published programs show in the programs app and
  // as Members Panel cards; unpublished stay hidden from members without explicit access.
  published: CoerceBoolean.default(true)
});
var CreateProgramFormSchemaFE = CreateProgramSchemaFE.superRefine((data, ctx) => {
  const seenCategories = /* @__PURE__ */ new Map();
  data.sections.forEach((section, index) => {
    if (seenCategories.has(section.category)) {
      ctx.addIssue({
        code: z164.ZodIssueCode.custom,
        path: [
          "sections",
          index,
          "category"
        ],
        message: "Each category can be used by only one section"
      });
    } else {
      seenCategories.set(section.category, index);
    }
  });
  if (data.sections.length > 0) {
    const sectionKeys = new Set(data.sections.map((section) => section.key));
    data.items.forEach((item, index) => {
      if (!item.sectionKey || !sectionKeys.has(item.sectionKey)) {
        ctx.addIssue({
          code: z164.ZodIssueCode.custom,
          path: [
            "items",
            index,
            "sectionKey"
          ],
          message: "Assign this video to a section"
        });
      }
    });
  }
});
var defaultProgramSchemaValues = {
  name: "",
  slug: void 0,
  imageUrl: "",
  imageUrl2x: "",
  description: "",
  isHidden: false,
  requireSequentialCompletion: false,
  seriesType: null,
  items: [],
  sections: [],
  resourceBtnLabel: "",
  resourceBtnSubLabel: "",
  resourceBtnUrl: "",
  resourceBtnLabel2: "",
  resourceBtnSubLabel2: "",
  resourceBtnUrl2: "",
  resourceBtnLabel3: "",
  resourceBtnSubLabel3: "",
  resourceBtnUrl3: "",
  startButtonText: null,
  salesPageUrl: "",
  published: true
};

// src/addon/program/be-schema.ts
var MembersPanelFieldsBE = {
  salesPageUrl: z165.string().url().or(z165.literal("")).nullable().optional(),
  published: CoerceBoolean.default(true)
};
var AddonProgramItemReorder = PlaylistItemReorder.extend({
  sectionKey: z165.string().nullable().optional()
});
var ProgramSectionFieldsBE = {
  items: AddonProgramItemReorder.array(),
  sections: ProgramSectionInput.array().optional().default([])
};
var CreateProgramSchemaBE = CreateSeriesSchemaBE.extend(__spreadValues(__spreadValues({}, MembersPanelFieldsBE), ProgramSectionFieldsBE));
var CreateProgramRequestSchemaBE = CreateProgramSchemaBE.extend({
  userId: z165.coerce.string()
});
var UpdateAddonProgramRequestSchemaFE = CreateProgramSchemaFE.merge(SeriesItemsRequestSchemaFE).omit({
  seriesType: true,
  slug: true
}).extend(ProgramSectionFieldsBE);
var ToggleProgramPublishSchema = z165.object({
  id: z165.coerce.number(),
  published: CoerceBoolean
});

// src/geography/index.ts
import { z as z166 } from "zod";
var CountrySchema = z166.object({
  id: z166.number(),
  name: z166.string(),
  flag: z166.string().nullable().optional(),
  phonecode: z166.string().nullable().optional(),
  is_active: z166.boolean().optional().default(true)
});
var StateSchema = z166.object({
  id: z166.number(),
  name: z166.string()
});
var CitySchema = z166.object({
  id: z166.number(),
  name: z166.string()
});
var GeographyCacheEntrySchema = z166.object({
  key: z166.string(),
  type: z166.enum([
    "countries",
    "states",
    "cities"
  ]),
  referenceId: z166.number().nullable(),
  itemCount: z166.number(),
  sizeBytes: z166.number()
});
var GeographyCacheStatusSchema = z166.object({
  totalKeys: z166.number(),
  totalSizeBytes: z166.number(),
  entries: z166.array(GeographyCacheEntrySchema)
});
var GeographyCacheEntryDetailSchema = z166.object({
  key: z166.string(),
  data: z166.array(z166.object({
    id: z166.number(),
    name: z166.string()
  }).passthrough()).nullable()
});

// src/product/access-config.ts
import { z as z167 } from "zod";
var AccessConfigRoleSchema = z167.object({
  trial: z167.string().nullable().optional(),
  subscriber: z167.string().min(1, "Subscriber role is required"),
  unsubscriber: z167.string().min(1, "Unsubscriber role is required")
});
var AccessConfigEntrySchema = z167.object({
  app: z167.string(),
  role: AccessConfigRoleSchema.optional(),
  variation: z167.number().optional(),
  variation_title: z167.string().nullable().optional(),
  access_group: z167.string().nullable().optional(),
  // Higher number = higher-ranked product. Gates whether a purchase may
  // overwrite an existing user_access row (only a higher priority upgrades).
  // Nullable/optional: null or missing → treated as the column default (1) by
  // the consumer (webhook), so entries at the base priority can leave it blank.
  product_priority: z167.coerce.number().int().min(1, "Priority must be at least 1").nullable().optional()
});

// src/product/grant-access.ts
import { z as z168 } from "zod";
var GrantUserAccessSchema = z168.object({
  userId: z168.string().uuid(),
  productId: z168.number().int(),
  variationId: z168.number().int().optional(),
  reason: z168.string().min(1)
});
var GrantUserAccessByAppSchema = z168.object({
  userId: z168.string().uuid(),
  app: z168.string().min(1),
  roleId: z168.number().int().optional(),
  reason: z168.string().min(1)
});
var BulkGrantUserAccessSchema = z168.object({
  userIds: z168.array(z168.string().uuid()).min(1, "Select at least one user").max(100),
  productId: z168.number().int(),
  variationId: z168.number().int().optional(),
  reason: z168.string().min(1)
});
var BulkGrantUserAccessByAppSchema = z168.object({
  userIds: z168.array(z168.string().uuid()).min(1, "Select at least one user").max(100),
  app: z168.string().min(1),
  roleId: z168.number().int().optional(),
  reason: z168.string().min(1)
});

// src/product/product.ts
import { z as z169 } from "zod";
var ProductSchema = z169.object({
  product_id: z169.number().int(),
  product_title: z169.string().nullable(),
  access_config: z169.array(AccessConfigEntrySchema).nullable(),
  created_at: z169.string(),
  is_enabled: z169.boolean().default(true)
});
var CreateProductSchema = z169.object({
  product_id: z169.number().int().positive("Product ID must be a positive integer"),
  product_title: z169.string().min(1, "Product title is required"),
  access_config: z169.array(AccessConfigEntrySchema).optional().default([])
});
var ProductFiltersSchema = z169.object({
  search: z169.string().optional()
});

// src/product/wp-product.ts
import { z as z170 } from "zod";
var WpProductSchema = z170.object({
  id: z170.number(),
  name: z170.string(),
  type: z170.string(),
  status: z170.string(),
  sku: z170.string().nullable().optional(),
  price: z170.string().nullable().optional(),
  regular_price: z170.string().nullable().optional(),
  is_variation: z170.boolean(),
  parent_id: z170.number().nullable().optional(),
  variation_ids: z170.array(z170.number()).optional(),
  attributes: z170.record(z170.string()).optional(),
  date_created: z170.string().optional(),
  featured_image: z170.string().nullable().optional()
});
var WpProductSearchResponseSchema = z170.object({
  success: z170.boolean(),
  data: z170.array(WpProductSchema)
});
var WpProductDetailResponseSchema = z170.object({
  success: z170.boolean(),
  data: WpProductSchema
});

// src/analytics/be-catalog-schema.ts
import { boolean as boolean17, object as object101, string as string78 } from "zod";

// src/analytics/source.enum.ts
import { z as z171 } from "zod";
var AnalyticsSourceValues = [
  "FIT",
  "RYC",
  "PROGRAMS",
  "SPACES"
];
var AnalyticsSourceEnumObj = z171.enum(AnalyticsSourceValues);
var EAnalyticsSourceEnum = AnalyticsSourceEnumObj.enum;
var AnalyticsSourceLabels = {
  FIT: "FIT",
  RYC: "RYC",
  PROGRAMS: "Programs",
  SPACES: "Spaces"
};
var SourceAllowedActions = {
  // FIT/RYC/PROGRAMS emit WATCH_COMPLETE + VIDEO_PLAY (both carry the content UUID);
  // FIT additionally emits ATTENDING_LIVE. They do NOT emit VIDEO_PROGRESS_* /
  // VIDEO_COMPLETE — those come only from SPACES (community-hub).
  FIT: [
    EUserLogActionEnum.WATCH_COMPLETE,
    EUserLogActionEnum.VIDEO_PLAY,
    EUserLogActionEnum.ATTENDING_LIVE
  ],
  RYC: [
    EUserLogActionEnum.WATCH_COMPLETE,
    EUserLogActionEnum.VIDEO_PLAY
  ],
  PROGRAMS: [
    EUserLogActionEnum.WATCH_COMPLETE,
    EUserLogActionEnum.VIDEO_PLAY
  ],
  SPACES: [
    // lesson / space navigation
    EUserLogActionEnum.LESSON_VIEW,
    EUserLogActionEnum.MODULE_VIEW,
    EUserLogActionEnum.COMMUNITY_VIEW,
    EUserLogActionEnum.CHECKIN,
    // content-block engagement (mirrors user-progress ACTION_ENTITY_TYPE, the
    // canonical action → entity map). Vimeo blocks emit VIDEO_PLAY (+ milestones).
    EUserLogActionEnum.VIDEO_PLAY,
    EUserLogActionEnum.VIDEO_VIEW,
    EUserLogActionEnum.VIDEO_COMPLETE,
    EUserLogActionEnum.VIDEO_PROGRESS_25,
    EUserLogActionEnum.VIDEO_PROGRESS_50,
    EUserLogActionEnum.VIDEO_PROGRESS_75,
    EUserLogActionEnum.PDF_VIEW,
    EUserLogActionEnum.QUIZ_VIEW,
    EUserLogActionEnum.EMBED_VIEW,
    EUserLogActionEnum.TEXT_VIEW,
    EUserLogActionEnum.GCS_UPLOAD_VIEW,
    // GCS upload lifecycle — emitted to user_log against the block id by
    // gcs-upload.service (STARTED → started, IN_BUCKET → member confirmed the
    // file landed, IN_DRIVE → post-processed to Drive). FAILED is defined but
    // never emitted, so it is intentionally not selectable.
    EUserLogActionEnum.GCS_UPLOAD_STARTED,
    EUserLogActionEnum.GCS_UPLOAD_IN_BUCKET,
    EUserLogActionEnum.GCS_UPLOAD_IN_DRIVE,
    EUserLogActionEnum.FORM_VIEW,
    // forms — the submit events also sit on the form content block; the compute
    // service bridges the block id to the form id (ch_form_submissions).
    EUserLogActionEnum.FORM_SUBMITTED,
    EUserLogActionEnum.FORM_SUBMISSION_IN_PROGRESS,
    // quizzes — on the quiz content block; compute bridges the block id to the
    // quiz id (ch_quiz_attempts).
    EUserLogActionEnum.QUIZ_SUBMITTED,
    EUserLogActionEnum.QUIZ_PASSED,
    // event blocks (e.g. a Zoom meeting) — attendance on the block id
    EUserLogActionEnum.EVENT_JOIN,
    EUserLogActionEnum.EVENT_LEAVE,
    // forum / feed
    EUserLogActionEnum.POST_VIEW,
    EUserLogActionEnum.POST_CREATE,
    EUserLogActionEnum.COMMENT_CREATE,
    EUserLogActionEnum.REACTION_ADD
  ]
};
var isActionAllowedForSource = /* @__PURE__ */ __name((source, action) => SourceAllowedActions[source].includes(action), "isActionAllowedForSource");
var AnalyticsSpacesTargetKindValues = [
  "forum",
  "content_block",
  "lesson",
  "space",
  "form",
  "quiz"
];
var AnalyticsSpacesTargetKindEnumObj = z171.enum(AnalyticsSpacesTargetKindValues);
var EAnalyticsSpacesTargetKindEnum = AnalyticsSpacesTargetKindEnumObj.enum;
var SpacesEventTargetKind = {
  // forum / feed
  POST_CREATE: "forum",
  POST_VIEW: "forum",
  COMMENT_CREATE: "forum",
  REACTION_ADD: "forum",
  COMMUNITY_VIEW: "forum",
  // lesson
  LESSON_VIEW: "lesson",
  // content blocks
  VIDEO_PLAY: "content_block",
  VIDEO_VIEW: "content_block",
  VIDEO_COMPLETE: "content_block",
  VIDEO_PROGRESS_25: "content_block",
  VIDEO_PROGRESS_50: "content_block",
  VIDEO_PROGRESS_75: "content_block",
  PDF_VIEW: "content_block",
  QUIZ_VIEW: "content_block",
  EMBED_VIEW: "content_block",
  TEXT_VIEW: "content_block",
  GCS_UPLOAD_VIEW: "content_block",
  GCS_UPLOAD_STARTED: "content_block",
  GCS_UPLOAD_IN_BUCKET: "content_block",
  GCS_UPLOAD_IN_DRIVE: "content_block",
  FORM_VIEW: "content_block",
  // Form/quiz submit + event attendance are selected on the content block (the
  // condition carries the block id); the compute service bridges the block id to
  // the form/quiz id for the submission/attempt tables.
  FORM_SUBMITTED: "content_block",
  FORM_SUBMISSION_IN_PROGRESS: "content_block",
  QUIZ_SUBMITTED: "content_block",
  QUIZ_PASSED: "content_block",
  EVENT_JOIN: "content_block",
  EVENT_LEAVE: "content_block",
  // sub-space navigation
  MODULE_VIEW: "space",
  CHECKIN: "space"
};
var spacesTargetKindForEvent = /* @__PURE__ */ __name((event) => {
  var _a5;
  return (_a5 = SpacesEventTargetKind[event]) != null ? _a5 : "content_block";
}, "spacesTargetKindForEvent");
var allowedTargetKindsForEvent = /* @__PURE__ */ __name((event) => {
  const primary = spacesTargetKindForEvent(event);
  if (event === "FORM_SUBMITTED" || event === "FORM_SUBMISSION_IN_PROGRESS") {
    return [
      primary,
      "form"
    ];
  }
  if (event === "QUIZ_SUBMITTED" || event === "QUIZ_PASSED") {
    return [
      primary,
      "quiz"
    ];
  }
  return [
    primary
  ];
}, "allowedTargetKindsForEvent");
var SpacesTargetKindEvents = AnalyticsSpacesTargetKindValues.reduce((acc, kind) => {
  acc[kind] = SourceAllowedActions.SPACES.filter((event) => spacesTargetKindForEvent(event) === kind);
  return acc;
}, {});
var eventsForTargetKinds = /* @__PURE__ */ __name((kinds) => {
  const seen = /* @__PURE__ */ new Set();
  kinds.forEach((kind) => {
    var _a5;
    return (_a5 = SpacesTargetKindEvents[kind]) == null ? void 0 : _a5.forEach((event) => seen.add(event));
  });
  return [
    ...seen
  ];
}, "eventsForTargetKinds");
var ContentBlockTypeEvents = {
  text: [
    EUserLogActionEnum.TEXT_VIEW
  ],
  vimeo: [
    EUserLogActionEnum.VIDEO_PLAY,
    EUserLogActionEnum.VIDEO_VIEW,
    EUserLogActionEnum.VIDEO_COMPLETE,
    EUserLogActionEnum.VIDEO_PROGRESS_25,
    EUserLogActionEnum.VIDEO_PROGRESS_50,
    EUserLogActionEnum.VIDEO_PROGRESS_75
  ],
  pdf: [
    EUserLogActionEnum.PDF_VIEW
  ],
  quiz: [
    EUserLogActionEnum.QUIZ_VIEW,
    EUserLogActionEnum.QUIZ_SUBMITTED,
    EUserLogActionEnum.QUIZ_PASSED
  ],
  form: [
    EUserLogActionEnum.FORM_VIEW,
    EUserLogActionEnum.FORM_SUBMITTED,
    EUserLogActionEnum.FORM_SUBMISSION_IN_PROGRESS
  ],
  embed: [
    EUserLogActionEnum.EMBED_VIEW
  ],
  gcs_upload: [
    EUserLogActionEnum.GCS_UPLOAD_VIEW,
    EUserLogActionEnum.GCS_UPLOAD_STARTED,
    EUserLogActionEnum.GCS_UPLOAD_IN_BUCKET,
    EUserLogActionEnum.GCS_UPLOAD_IN_DRIVE
  ],
  event: [
    EUserLogActionEnum.EVENT_JOIN,
    EUserLogActionEnum.EVENT_LEAVE
  ]
};
var eventsForBlockType = /* @__PURE__ */ __name((blockType) => blockType && ContentBlockTypeEvents[blockType] ? [
  ...ContentBlockTypeEvents[blockType]
] : [
  ...SpacesTargetKindEvents.content_block
], "eventsForBlockType");

// src/analytics/be-catalog-schema.ts
var AnalyticsCatalogItemSchemaBE = object101({
  /** Raw id, written straight into the condition's contentRef. */
  id: string78(),
  label: string78(),
  /** Human-readable type, e.g. 'Forum' | 'Module' | 'Lesson' | 'Video' | 'Form'. */
  typeLabel: string78(),
  /**
  * Target kinds this item can serve. A `feed` sub-space carries both 'forum'
  * and 'space'. Empty for FIT / RYC / PROGRAMS, which have no target kinds.
  */
  kinds: AnalyticsSpacesTargetKindEnumObj.array(),
  /**
  * Ancestor names, materialized server-side. Essential under search: matching
  * blocks are returned without their parents, so this is the only thing that
  * gives "Module › Lesson › <block>" context.
  */
  path: string78().array(),
  /**
  * Archived content is still listed rather than hidden — live rules reference
  * archived items (rule 4 targets an archived forum), and dropping them would
  * make an existing condition invisible and unremovable. The table renders
  * these muted with a chip.
  */
  isArchived: boolean17(),
  /**
  * Id of this row's parent in the SPACES content tree, or null for a top-level
  * row. A lesson points at its module (null when it hangs directly off the
  * container), a content block points at its lesson; modules, forums and forms
  * are always top-level. Lets the tree view nest rows without re-deriving the
  * hierarchy from `sort_path`. Omitted for FIT / RYC / PROGRAMS, which are flat.
  */
  parentId: string78().nullish()
});

// src/analytics/be-content-ref-schema.ts
import { z as z172 } from "zod";
var FitContentRefSchemaBE = z172.object({
  source: z172.literal("FIT"),
  contentType: z172.enum([
    "content",
    "playlist"
  ]),
  contentId: z172.string().min(1, "Select a content item")
});
var RycContentRefSchemaBE = z172.object({
  source: z172.literal("RYC"),
  contentId: z172.string().min(1, "Select a content item")
});
var AddonContentRefSchemaBE = z172.object({
  source: z172.literal("PROGRAMS"),
  contentId: z172.string().min(1, "Select a content item")
});
var SpacesContentRefSchemaBE = z172.object({
  source: z172.literal("SPACES"),
  // The target depends on the condition's event (see SpacesEventTargetKind):
  // forum → feed space id; content_block → block id; lesson → lesson id;
  // space → sub-space id; form → form id; quiz → quiz id.
  targetKind: z172.enum([
    "forum",
    "content_block",
    "lesson",
    "space",
    "form",
    "quiz"
  ]),
  targetId: z172.string().uuid("Select a target")
});
var AnalyticsContentRefSchemaBE = z172.discriminatedUnion("source", [
  FitContentRefSchemaBE,
  RycContentRefSchemaBE,
  AddonContentRefSchemaBE,
  SpacesContentRefSchemaBE
]);

// src/analytics/be-node-schema.ts
import { number as number31, object as object102, z as z173 } from "zod";
var AnalyticsOperatorValues = [
  "AND",
  "OR"
];
var AnalyticsOperatorEnumObj = z173.enum(AnalyticsOperatorValues);
var EAnalyticsOperatorEnum = AnalyticsOperatorEnumObj.enum;
var AnalyticsConditionSchemaBE = object102({
  type: z173.literal("condition"),
  contentRef: AnalyticsContentRefSchemaBE,
  event: UserLogActionEnumObj,
  requiredCount: number31().int().min(1),
  /**
  * Optional due date (YYYY-MM-DD). When set, the event only counts toward this
  * condition if the user did it on or before the end of that day — someone who
  * completes the content later does not satisfy the rule. Unset = any time.
  */
  dueDate: z173.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Due date must be YYYY-MM-DD").optional()
});
var AnalyticsRuleRefSchemaBE = object102({
  type: z173.literal("rule"),
  ruleId: number31().int().positive("Select a rule")
});
var AnalyticsGroupSchemaBE = z173.lazy(() => object102({
  type: z173.literal("group"),
  operator: AnalyticsOperatorEnumObj,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  children: z173.array(AnalyticsNodeSchemaBE)
}));
var AnalyticsNodeSchemaBE = z173.lazy(() => z173.union([
  AnalyticsGroupSchemaBE,
  AnalyticsConditionSchemaBE,
  AnalyticsRuleRefSchemaBE
]));

// src/analytics/be-request-schema.ts
import { z as z175 } from "zod";

// src/analytics/be-schema.ts
import { boolean as boolean18, number as number32, object as object103, string as string79, z as z174 } from "zod";
var AnalyticsRuleSchemaBE = object103({
  id: number32().positive().int().min(1),
  name: string79().min(1),
  // The user population: members of this app (from Supabase user_access).
  audienceApp: string79().min(1, "Audience app is required"),
  // The app whose activity is measured (resolved to tracking_id from Supabase apps).
  trackingApp: string79().min(1, "Tracking app is required"),
  source: AnalyticsSourceEnumObj,
  // Rule-level space (only used when source is SPACES) — content rules pick a
  // lesson / content block within this space.
  spaceId: string79().uuid().nullable().optional(),
  // User groups whose members are excluded from this rule's audience.
  excludedUserGroupIds: z174.array(number32().int().positive()).optional(),
  // User groups to restrict the audience to — when non-empty, only members of
  // these groups are included (still limited to the audience app, and exclusions
  // apply on top). Empty/unset means no restriction.
  includedUserGroupIds: z174.array(number32().int().positive()).optional(),
  isActive: boolean18().optional(),
  contentTree: AnalyticsGroupSchemaBE,
  createdBy: string79().nullable(),
  updatedBy: string79().nullable(),
  createdAt: string79(),
  updatedAt: string79()
});
var AnalyticsRuleResponseSchemaBE = AnalyticsRuleSchemaBE;

// src/analytics/be-request-schema.ts
var MAX_TREE_DEPTH = 12;
var validateNode = /* @__PURE__ */ __name((node, source, ctx, path, depth) => {
  if (depth > MAX_TREE_DEPTH) {
    ctx.addIssue({
      code: z175.ZodIssueCode.custom,
      path,
      message: "Grouping is nested too deeply"
    });
    return;
  }
  if (node.type === "group") {
    node.children.forEach((child, index) => validateNode(child, source, ctx, [
      ...path,
      "children",
      index
    ], depth + 1));
    return;
  }
  if (node.type === "rule") {
    return;
  }
  if (node.contentRef.source !== source) {
    ctx.addIssue({
      code: z175.ZodIssueCode.custom,
      path: [
        ...path,
        "contentRef",
        "source"
      ],
      message: `Content reference source "${node.contentRef.source}" does not match rule source "${source}"`
    });
  }
  if (!isActionAllowedForSource(source, node.event)) {
    ctx.addIssue({
      code: z175.ZodIssueCode.custom,
      path: [
        ...path,
        "event"
      ],
      message: `Event "${node.event}" is not allowed for source "${source}"`
    });
  }
  if (source === "SPACES" && node.contentRef.source === "SPACES") {
    const allowed = allowedTargetKindsForEvent(node.event);
    if (!allowed.includes(node.contentRef.targetKind)) {
      ctx.addIssue({
        code: z175.ZodIssueCode.custom,
        path: [
          ...path,
          "contentRef",
          "targetKind"
        ],
        message: `Target kind "${node.contentRef.targetKind}" does not match event "${node.event}" (expected "${allowed.join('" or "')}")`
      });
    }
  }
}, "validateNode");
var CreateAnalyticsRuleSchemaBE = AnalyticsRuleSchemaBE.pick({
  name: true,
  audienceApp: true,
  trackingApp: true,
  source: true,
  spaceId: true,
  excludedUserGroupIds: true,
  includedUserGroupIds: true,
  isActive: true,
  contentTree: true
}).superRefine((data, ctx) => {
  if (data.source === "SPACES" && !data.spaceId) {
    ctx.addIssue({
      code: z175.ZodIssueCode.custom,
      path: [
        "spaceId"
      ],
      message: "Select a space"
    });
  }
  validateNode(data.contentTree, data.source, ctx, [
    "contentTree"
  ], 0);
});
var UpdateAnalyticsRuleSchemaBE = CreateAnalyticsRuleSchemaBE;

// src/analytics/be-snapshot-schema.ts
import { number as number33, object as object104, record as record2, string as string80, z as z176 } from "zod";
var AnalyticsRunStatusValues = [
  "pending",
  "computing",
  "completed",
  "failed"
];
var AnalyticsRunStatusEnumObj = z176.enum(AnalyticsRunStatusValues);
var EAnalyticsRunStatusEnum = AnalyticsRunStatusEnumObj.enum;
var AnalyticsUserStatusValues = [
  "completed",
  "partial",
  "not_started"
];
var AnalyticsUserStatusEnumObj = z176.enum(AnalyticsUserStatusValues);
var EAnalyticsUserStatusEnum = AnalyticsUserStatusEnumObj.enum;
var AnalyticsColumnKindValues = [
  "overall",
  "condition",
  "rule"
];
var AnalyticsColumnKindEnumObj = z176.enum(AnalyticsColumnKindValues);
var AnalyticsColumnSchemaBE = object104({
  key: string80(),
  label: string80(),
  kind: AnalyticsColumnKindEnumObj,
  ruleId: number33().int().positive().optional(),
  /**
  * The tracked action this column counts — set when kind = 'condition'. The
  * label is the content name, which alone doesn't say what was measured.
  * Optional because snapshots computed before this field existed lack it.
  */
  event: string80().optional(),
  /**
  * Due date (YYYY-MM-DD) applied to this condition, when set. The event only
  * counted for users who did it on or before this date. Rendered on its own
  * line in the View header. Optional — most conditions have no due date.
  */
  dueDate: string80().optional(),
  /**
  * The module (sub-space) this condition's content belongs to — set for SPACES
  * rules so the View can group/filter conditions by module. Undefined for
  * items that sit directly under the space, for non-SPACES sources, and for
  * snapshots computed before this field existed.
  */
  module: string80().optional()
});
var AnalyticsJobStateValues = [
  "waiting",
  "active",
  "delayed",
  "failed",
  "completed",
  "unknown"
];
var AnalyticsJobStateEnumObj = z176.enum(AnalyticsJobStateValues);
var AnalyticsJobStatusSchemaBE = object104({
  state: AnalyticsJobStateEnumObj,
  attemptsMade: number33().int().nonnegative(),
  failedReason: string80().nullable()
});
var AnalyticsRuleSnapshotSchemaBE = object104({
  id: number33().int().positive(),
  ruleId: number33().int().positive(),
  status: AnalyticsRunStatusEnumObj,
  totalUsers: number33().int().nonnegative(),
  matchedCount: number33().int().nonnegative(),
  computedAt: string80().nullable(),
  createdAt: string80(),
  error: string80().nullable(),
  columns: AnalyticsColumnSchemaBE.array(),
  /** Live queue state, when a job for this rule still exists. */
  job: AnalyticsJobStatusSchemaBE.nullable().optional(),
  /**
  * The snapshot says it is running but the queue has no live job for it — the
  * worker died or the job was dropped. Without this the row polls forever and
  * looks identical to "queued".
  */
  isStuck: z176.boolean().optional()
});
var AnalyticsSnapshotListItemSchemaBE = object104({
  id: number33().int().positive(),
  status: AnalyticsRunStatusEnumObj,
  totalUsers: number33().int().nonnegative(),
  matchedCount: number33().int().nonnegative(),
  computedAt: string80().nullable(),
  createdAt: string80(),
  error: string80().nullable(),
  /** Enqueue → finish, in ms. Null while still running. */
  durationMs: number33().int().nonnegative().nullable(),
  /** True for the run whose per-user results are still retained. */
  isCurrent: z176.boolean()
});
var AnalyticsCellSchemaBE = object104({
  value: number33().int().nonnegative(),
  target: number33().int().nonnegative()
});
var AnalyticsResultRowSchemaBE = object104({
  userId: string80(),
  // profile.user_uuid — the key admin notes attach to. Resolved from the row's
  // auth id at read time (not stored on the results), so it works for any snapshot.
  userUuid: string80().nullable(),
  name: string80().nullable(),
  email: string80().nullable(),
  cells: record2(string80(), AnalyticsCellSchemaBE)
});
var AnalyticsAggregateSchemaBE = object104({
  matched: number33().int().nonnegative(),
  total: number33().int().nonnegative()
});

// src/analytics/content-key.ts
var analyticsContentKey = /* @__PURE__ */ __name((ref) => {
  switch (ref.source) {
    case "FIT": {
      return `FIT:${ref.contentType}:${ref.contentId}`;
    }
    case "RYC": {
      return `RYC:${ref.contentId}`;
    }
    case "PROGRAMS": {
      return `PROGRAMS:${ref.contentId}`;
    }
    case "SPACES": {
      return `SPACES:${ref.targetId}`;
    }
  }
}, "analyticsContentKey");
var analyticsCatalogKey = /* @__PURE__ */ __name((source, id2, fitContentType = "content") => source === "FIT" ? `FIT:${fitContentType}:${id2}` : `${source}:${id2}`, "analyticsCatalogKey");

// src/analytics/export-schema.ts
import { array as array28, boolean as boolean19, number as number34, object as object105, string as string81 } from "zod";
var AnalyticsRuleExportItemSchemaBE = object105({
  originalId: number34().int().positive().optional(),
  name: string81().min(1),
  audienceApp: string81().min(1),
  trackingApp: string81().min(1),
  source: AnalyticsSourceEnumObj,
  spaceId: string81().uuid().nullable().optional(),
  excludedUserGroupIds: array28(number34().int().positive()).optional(),
  includedUserGroupIds: array28(number34().int().positive()).optional(),
  isActive: boolean19().optional(),
  contentTree: AnalyticsGroupSchemaBE
});
var AnalyticsRulesExportSchemaBE = object105({
  version: number34().int(),
  exportedAt: string81(),
  rules: array28(AnalyticsRuleExportItemSchemaBE)
});
var AnalyticsRulesImportSchemaBE = object105({
  version: number34().int().optional(),
  rules: array28(AnalyticsRuleExportItemSchemaBE).min(1, "The file has no rules to import")
});

// src/analytics/flatten.ts
var collect = /* @__PURE__ */ __name((node, rootOperator, acc, isRoot) => {
  if (node.type !== "group") {
    acc.leaves.push(node);
    return;
  }
  if (!isRoot) {
    acc.hadNesting = true;
    if (node.operator !== rootOperator) {
      acc.mixedOperators = true;
    }
  }
  node.children.forEach((child) => collect(child, rootOperator, acc, false));
}, "collect");
var flattenContentTree = /* @__PURE__ */ __name((root) => {
  const acc = {
    leaves: [],
    hadNesting: false,
    mixedOperators: false
  };
  collect(root, root.operator, acc, true);
  const seenContent = /* @__PURE__ */ new Set();
  const seenRules = /* @__PURE__ */ new Set();
  const conditions = [];
  const ruleRefs = [];
  let droppedDuplicates = 0;
  acc.leaves.forEach((leaf) => {
    if (leaf.type === "condition") {
      const key = analyticsContentKey(leaf.contentRef);
      if (seenContent.has(key)) {
        droppedDuplicates += 1;
        return;
      }
      seenContent.add(key);
      conditions.push(leaf);
      return;
    }
    if (seenRules.has(leaf.ruleId)) {
      droppedDuplicates += 1;
      return;
    }
    seenRules.add(leaf.ruleId);
    ruleRefs.push(leaf);
  });
  return {
    tree: {
      type: "group",
      operator: root.operator,
      children: [
        ...conditions,
        ...ruleRefs
      ]
    },
    changed: acc.mixedOperators || droppedDuplicates > 0,
    hadNesting: acc.hadNesting,
    mixedOperators: acc.mixedOperators,
    droppedDuplicates
  };
}, "flattenContentTree");

// src/vimeo/search.ts
import { array as array29, number as number35, object as object106, string as string82 } from "zod";
var VimeoSearchResultItemSchema = object106({
  id: string82(),
  name: string82(),
  /**
  * Duration in seconds, present when the row came from the account's video listing (which
  * returns it inline). Absent for results resolved by a direct id lookup. Optional so the
  * dashboard picker, which only reads id/name, is unaffected.
  */
  duration: number35().optional()
});
var VimeoSearchResultsSchema = array29(VimeoSearchResultItemSchema);

// src/vimeo/video-info.ts
import { nullable, number as number36, object as object107, record as record3, string as string83 } from "zod";
var VimeoVideoInfoSchema = object107({
  uri: string83(),
  name: string83(),
  description: nullable(string83()).optional(),
  duration: number36()
});
var VimeoVideoDurationsSchema = record3(string83(), number36());

// src/notes/entity.ts
import { z as z177 } from "zod";
var NOTE_ENTITY_TYPE = {
  USER: "user"
};
var NoteAuthorSchema = z177.object({
  profileId: z177.string(),
  userUUID: z177.string().nullable(),
  name: z177.string().nullable(),
  avatar: z177.string().nullable()
}).nullable();
var NoteSchema = z177.object({
  id: z177.string().uuid(),
  entityType: z177.string().min(1, "An entity type is required"),
  entityId: z177.string(),
  body: z177.string(),
  createdBy: z177.string().nullable(),
  updatedBy: z177.string().nullable(),
  createdAt: z177.string(),
  updatedAt: z177.string(),
  author: NoteAuthorSchema
});
var CreateNoteSchema = z177.object({
  entityType: z177.string().min(1, "An entity type is required"),
  entityId: z177.string().min(1, "A target is required"),
  body: z177.string().min(1, "A note body is required")
});
var UpdateNoteSchema = z177.object({
  body: z177.string().min(1, "A note body is required")
});
export {
  ADMIN_ONLY_POST_TYPES,
  ATTACHMENT_TYPES,
  AUTH_PROVIDER_HEADER,
  AcceptSpaceTermsSchema,
  AccessConfigEntrySchema,
  AccessConfigRoleSchema,
  ActiveCampaignTagConfigSchema,
  ActiveCampaignTagSchema,
  AddPermissionToRoleSchema,
  AddUserGroupMemberSchema,
  AddonAllStatusContentSchema,
  AddonCategoryEnum,
  AddonCategoryEnumObj,
  AddonCategoryEnumValues,
  AddonCategoryLabels,
  AddonContent,
  AddonContentAndTrashContentUnion,
  AddonContentBaseSchema,
  AddonContentFindAllResponseSchema,
  AddonContentRefSchemaBE,
  AddonContentTypeObject,
  AddonContentWithRatingFlagSchema,
  AddonCreateContentSchemaBE,
  AddonDashboardCreateContentSchemaFE,
  AddonDashboardCreateContentSchemaFEWithoutValidation,
  AddonDashboardUpdateContentSchemaFE,
  AddonTrashContentSchema,
  AddonUpdateContentSchemaBE,
  AddonUserTotalWatchedByCategory,
  AdminCommentRowSchema,
  AdminListPostsQuerySchema,
  AdminReplyDtoSchema,
  AdminSetPasswordSchema,
  AfterPurchaseRequestDtoBe,
  AllStatusContentSchema,
  AnalyticsAggregateSchemaBE,
  AnalyticsCatalogItemSchemaBE,
  AnalyticsCellSchemaBE,
  AnalyticsColumnKindEnumObj,
  AnalyticsColumnKindValues,
  AnalyticsColumnSchemaBE,
  AnalyticsConditionSchemaBE,
  AnalyticsContentRefSchemaBE,
  AnalyticsGroupSchemaBE,
  AnalyticsJobStateEnumObj,
  AnalyticsJobStateValues,
  AnalyticsJobStatusSchemaBE,
  AnalyticsNodeSchemaBE,
  AnalyticsOperatorEnumObj,
  AnalyticsOperatorValues,
  AnalyticsResultRowSchemaBE,
  AnalyticsRuleExportItemSchemaBE,
  AnalyticsRuleRefSchemaBE,
  AnalyticsRuleResponseSchemaBE,
  AnalyticsRuleSchemaBE,
  AnalyticsRuleSnapshotSchemaBE,
  AnalyticsRulesExportSchemaBE,
  AnalyticsRulesImportSchemaBE,
  AnalyticsRunStatusEnumObj,
  AnalyticsRunStatusValues,
  AnalyticsSnapshotListItemSchemaBE,
  AnalyticsSourceEnumObj,
  AnalyticsSourceLabels,
  AnalyticsSourceValues,
  AnalyticsSpacesTargetKindEnumObj,
  AnalyticsSpacesTargetKindValues,
  AnalyticsUserStatusEnumObj,
  AnalyticsUserStatusValues,
  AppAccessConfigSchema,
  AppKeySchema,
  AppNameEnumObj,
  AppNameValues,
  ApproveProDirectoryRevisionSchema,
  ArticleStatusEnumObj,
  ArticleStatusValues,
  AssignFeatureFlagRequestSchema,
  AssignPromoBannerSchema,
  AssignRoleSchema,
  AssignTicketSchema,
  AttachmentSchema,
  AttemptStatus,
  AttemptStatusSchema,
  AuthExceptionEnumObj,
  AuthExceptionValues,
  AuthProviderEnum,
  AuthProviderEnumObj,
  AuthorInfoSchema,
  AvailableTagSchema,
  BULK_POST_TAGS_MODE,
  BadgeMetaSchemaBE,
  BadgeNameEnum,
  BadgeSchema,
  BadgeTypeArray,
  BadgeTypeEnumObject,
  BadgeTypeNameSchema,
  BadgeWeightEnum,
  BadgesResponseSchema,
  BareContent,
  BaseAddonUserProgressSchema,
  BaseCommentSchema,
  BaseEventSchema,
  BaseFitChallengeContentSchema,
  BaseFitChallengeSchema,
  BaseFitOnboardingSchema,
  BaseFitUserProgressSchema,
  BaseHelpCenterArticleSchema,
  BaseJournalSchema,
  BaseJourneySchema,
  BaseOnboardingSchema,
  BaseRYCContentSchema,
  BaseRYCContentWitMetaInformation,
  BaseRuleConditionSchema,
  BaseSettingSchema,
  BaseSlideshowSchema,
  BaseSlideshowSchemaWithoutUnion,
  BaseStepContentSchema,
  BaseStepContentSchemaWithContentInfo,
  BaseStepDaySchema,
  BaseStepDayWithContentsSchema,
  BaseStepSchema,
  BaseStepSchemaWithBonusVideos,
  BaseStepSchemaWithContents,
  BaseTaxonomySchema,
  BaseTopicTaxonomySchema,
  BaseUserProgressSchema,
  BaseUserSchema,
  BasicRuleSchema,
  BillingSubscriptionSchema,
  BonusSchemaWithContent,
  BulkAssignFeatureFlagRequestSchema,
  BulkAssignFeatureFlagResultSchema,
  BulkCreateCommunityTagsSchema,
  BulkGrantUserAccessByAppSchema,
  BulkGrantUserAccessSchema,
  BulkNotificationBatchStatusSchema,
  BulkPostTagsModeSchema,
  BulkUpdateCommunityTagsSchema,
  BulkUpdatePostsResultSchema,
  BulkUpdatePostsSchema,
  CODPayloadItem,
  COMMENT_ACTIVITY_ACTION_LABELS,
  COMMENT_REJECT_REASON_LABELS,
  COMMUNITY_UPDATES_MAX_ITEMS,
  CalendarStateResponse,
  CancelEmailChangeSchema,
  CategoryEnum,
  CategoryEnumObj,
  CategoryEnumValues,
  ChCommentReactionConditionSchema,
  ChCommentReplyConditionSchema,
  ChMentionConditionSchema,
  ChNewPostConditionSchema,
  ChPostCommentConditionSchema,
  ChPostReactionConditionSchema,
  ChallengeBadgeNameArray,
  ChallengeBadgeNameEnumObject,
  ChallengeBadgeSchema,
  ChallengeBannerSettingSchema,
  ChallengeCompletionStatusSchema,
  ChallengePageSettingSchema,
  ChangePasswordApiSchema,
  ChangePasswordSchema,
  CheckInSchema,
  CitySchema,
  ClassOfTheDayTheme,
  ClassOfTheDayThemeSchemaFE,
  CoerceBoolean,
  CommentActivityActionEnum,
  CommentActivityActionValues,
  CommentActivitySchema,
  CommentAnalyticsByInstructorSchema,
  CommentAnalyticsFiltersSchema,
  CommentAnalyticsGranularityEnum,
  CommentAnalyticsInstructorRowSchema,
  CommentAnalyticsOverviewSchema,
  CommentAnalyticsRejectionReasonSchema,
  CommentAnalyticsRejectionReasonsSchema,
  CommentAnalyticsReviewerSchema,
  CommentAnalyticsReviewersSchema,
  CommentAnalyticsTimelineFiltersSchema,
  CommentAnalyticsTimelinePointSchema,
  CommentAnalyticsTimelineSchema,
  CommentAttachmentSchema,
  CommentBaseSchema,
  CommentRejectReasonEnum,
  CommentRejectReasonValues,
  CommentSchema,
  CommentStatus,
  CommentStatusSchema,
  CommentWithAuthorBaseSchema,
  CommentWithAuthorSchema,
  CommentWithRepliesSchema,
  CommentsResponseSchema,
  CommonContentFields,
  CommonCustomDateSchema,
  CommunityActivityResponseSchema,
  CommunityActivitySchema,
  CommunityActivityTypeEnum,
  CommunityStatsSchema,
  CommunityTagAdminRowSchema,
  CommunityTagType,
  CommunityTagTypeSchema,
  CommunityUpdatesEventPattern,
  CommunityUpdatesNamespace,
  CompleteContentActionEnumObject,
  CompleteContentRequestSchema,
  ConfirmEmailChangeSchema,
  Constants,
  ConsumeOttSchema,
  ContactFormSettingSchema,
  ContactFormSettingSchemaBE,
  ContactFormSettingSchemaFE,
  Content,
  ContentAndTrashContentUnion,
  ContentBlockBaseSchema,
  ContentBlockContentCategory,
  ContentBlockContentCategorySchema,
  ContentBlockResourceType,
  ContentBlockResourceTypeSchema,
  ContentBlockType,
  ContentBlockTypeEvents,
  ContentBlockTypeSchema,
  ContentByDate,
  ContentByDateResponseSchema,
  ContentFilterTypeEnum,
  ContentFilterTypeObj,
  ContentFilterTypeValues,
  ContentFindAllResponseSchema,
  ContentFindByIdsResponseSchema,
  ContentRating,
  ContentRatingResponse,
  ContentRequestBESchema,
  ContentRequestSchema,
  ContentResponseSchema,
  ContentScheduleItem,
  ContentScheduleItemWithContent,
  ContentScheduleResponseSchema,
  ContentStatusSchema,
  ContentTypeEnum,
  ContentTypeEnumObj,
  ContentTypeEnumValues,
  ContentWithRatingFlagSchema,
  ContentWithWatchedDate,
  ConversationBaseSchema,
  ConversationType,
  ConversationTypeSchema,
  CountrySchema,
  CreateAnalyticsRuleSchemaBE,
  CreateArticleSchemaBE,
  CreateBadgeSchema,
  CreateBulkNotificationResponseSchema,
  CreateBulkNotificationSchema,
  CreateCODThemeSchemaBE,
  CreateChallengeBadgeSchema,
  CreateCommentDtoSchema,
  CreateCommentSchema,
  CreateCommunityTagSchema,
  CreateContentBasicSchemaFE,
  CreateContentBlockSchema,
  CreateContentSchemaBE,
  CreateContentSchemaFE,
  CreateContentSchemaFEWithoutValidation,
  CreateContentVideoSchemaFE,
  CreateConversationSchema,
  CreateEquipmentRequest,
  CreateEventSchemaBE,
  CreateEventSchemaFE,
  CreateFeatureFlagRequestSchema,
  CreateFeatureSeriesContentSchemaBE,
  CreateFeatureSeriesContentSchemaFE,
  CreateFeatureSeriesSchemaBE,
  CreateFeatureSeriesSchemaFE,
  CreateFitChallengeSchemaBE,
  CreateFitChallengeSchemaFE,
  CreateFitOnboardingSchemaBE,
  CreateFitOnboardingStepSchemaBE,
  CreateFormOptionSchema,
  CreateFormQuestionGroupSchema,
  CreateFormQuestionSchema,
  CreateFormSchema,
  CreateHelpCenterArticleSchemaBE,
  CreateHelpCenterCategoryTaxonomySchemaBE,
  CreateHelpCenterTopicTaxonomySchemaBE,
  CreateInstructionSchema,
  CreateIssueCategorySchema,
  CreateJournalSchemaBE,
  CreateLessonCategorySchema,
  CreateLessonSchema,
  CreateMediaFileSchema,
  CreateMilestoneBadgeSchema,
  CreateNoteSchema,
  CreateNotificationRuleObjectSchemaBE,
  CreateNotificationRuleSchemaBE,
  CreateOnboardingSchemaBE,
  CreateOnboardingStepSchemaBE,
  CreateOnboardingVideoSchemaBE,
  CreateOptionSchema,
  CreatePermissionSchema,
  CreatePlanRequestSchemaBE,
  CreatePlanSchemaBE,
  CreatePlanSchemaFE,
  CreatePlaylistBeRequestSchema,
  CreatePlaylistRequestSchema,
  CreatePlaylistSchema,
  CreatePollOptionSchema,
  CreatePollSchema,
  CreatePostSchema,
  CreateProductSchema,
  CreateProgramFormSchemaFE,
  CreateProgramRequestSchemaBE,
  CreateProgramSchemaBE,
  CreateProgramSchemaFE,
  CreatePromoBannerSchema,
  CreatePurchaseLogSchemaBE,
  CreateQuestionSchema,
  CreateQuizSchema,
  CreateRYCContentRequestWithMetaSchema,
  CreateRYCContentSchemaBE,
  CreateRYCContentSchemaFE,
  CreateRYCContentWithMetaSchemaBE,
  CreateReportSchema,
  CreateRoleSchema,
  CreateSeriesRequestSchemaBE,
  CreateSeriesSchemaBE,
  CreateSeriesSchemaFE,
  CreateSlideshowSchemaFE,
  CreateSpaceSchema,
  CreateStepSchemaFE,
  CreateSubSpaceSchema,
  CreateTemplateSchema,
  CreateTermsSchema,
  CreateTicketCommentSchema,
  CreateTicketSchema,
  CreateUserGroupSchema,
  CreateUserLogSchemaBE,
  CreateWatchHistoryBeSchema,
  CreateZoomEventSchema,
  CronNotificationEventTypeValues,
  CurrentJourneyFiltersSchema,
  CustomDateTimeSchema,
  CustomLuxonDateSchema,
  CustomNotificationConditionSchema,
  DEFAULT_AI_SYSTEM_PROMPT,
  DEFAULT_ARTICLE_SYSTEM_PROMPT,
  DateRangeQuerySchema,
  DeleteContentFromPlaylistBeRequestSchema,
  DeleteContentFromPlaylistRequestSchema,
  DeleteWatchHistoryBeSchema,
  DeviceTokenRegisterPayloadSchemaBE,
  DeviceTokenUnregisterPayloadSchemaBE,
  DownloadPdfRequestBESchema,
  EAddonContentType,
  EAnalyticsOperatorEnum,
  EAnalyticsRunStatusEnum,
  EAnalyticsSourceEnum,
  EAnalyticsSpacesTargetKindEnum,
  EAnalyticsUserStatusEnum,
  EAppNameEnum,
  EArticleStatus,
  EAuthExceptionEnum,
  EAuthType,
  EBadgeType,
  EChallengeBadgeName,
  ECommentActivityAction,
  ECommentRejectReason,
  ECompleteContentAction,
  EContentStatus,
  EEmailSentReason,
  EEmailSentStatus,
  EEngagementEntityType,
  EEventTypeEnum,
  EFeatureFlagSlug,
  EFitChallengeContentType,
  EFitOnboardingStep,
  EFormType,
  EHelpCenterAppNameEnum,
  EImageVariant,
  EImmediateAfterPurchaseSchema,
  EMediaFileStatus,
  EMediaProcessingKind,
  EMilestoneBadgeName,
  ENotificationChannel,
  ENotificationRuleStatus,
  ENotificationRulesType,
  ENotificationStatus,
  ENotificationType,
  ENovuEmailTemplateNameEnum,
  ENovuTenantIdentifierEnum,
  ENovuWorkflowsEnum,
  EOnboardingStep,
  EProSpecialtyEnum,
  EProSpecialtyValues,
  EProfileFieldKind,
  EPurchaseStatusEnum,
  EQuestionInputType,
  EQuipmentEnum,
  EQuipmentObj,
  ERYCContentMetaSeries,
  ERYCContentMetaType,
  ERYCContentPath,
  ERYCContentType,
  ERealtimeNotificationMessageType,
  ERolesEnum,
  ESlideBadgeImagePositionEnum,
  ESlideshowAppEnum,
  ESlideshowTypeEnum,
  EStagesEnum,
  EStepTypeEnum,
  EStepsEnum,
  EStorageSortField,
  EStorageSortOrder,
  ETargetApp,
  ETiersEnum,
  EUserActivityTypeEnum,
  EUserGroupImportSource,
  EUserLogActionEnum,
  EUserOnlinePubSub,
  EUserOnlineTopicEnum,
  EmailChangeConfirmedConditionSchema,
  EmailChangeSearchParamsSchema,
  EmailChangeSecurityAlertConditionSchema,
  EmailChangeVerifyConditionSchema,
  EmailListConfigSchema,
  EmailLoginSchema,
  EmailMetaSchema,
  EmailResponse,
  EmailReturnResponse,
  EmailSendReasonObj,
  EmailSentReasonValues,
  EmailSentStatusObj,
  EmailSentStatusValues,
  EngagementCountSchema,
  EngagementEntityTypeEnumObj,
  EngagementEntityTypeValues,
  EngagementGroupTreatmentEnumObj,
  EngagementGroupTreatmentValues,
  EngagementLessonSchema,
  EngagementLogItemSchema,
  EngagementLogsQuerySchema,
  EngagementLogsResponseSchema,
  EngagementMemberSchema,
  EngagementMembersQuerySchema,
  EngagementMembersResponseSchema,
  EngagementMembersSortEnumObj,
  EngagementMembersSortValues,
  EngagementReportingGroupSchema,
  EngagementRowTagSchema,
  EngagementSubSpaceSchema,
  EngagementSummaryQuerySchema,
  EngagementSummaryResponseSchema,
  EngagementTimelineGranularityEnumObj,
  EngagementTimelineGranularityValues,
  EngagementTimelineMetricEnumObj,
  EngagementTimelineMetricValues,
  EngagementTimelineQuerySchema,
  EngagementTimelineResponseSchema,
  EngagementTimelineSeriesSchema,
  EngagementTopContentItemSchema,
  EngagementTopContentQuerySchema,
  EngagementTopContentResponseSchema,
  EngagementUserSchema,
  EngagementUsersQuerySchema,
  EnumRuleConditionJsonColumnObject,
  Equipment,
  EquipmentsValues,
  ErrorSchema,
  EventAttendanceBaseSchema,
  EventBaseSchema,
  EventContentSchema,
  EventMessagePayloadSchema,
  EventMessageSchema,
  EventMessageSchemaWithReplies,
  EventMessageUserInfoSchema,
  EventReactionSchema,
  EventStatus,
  EventStatusEnum,
  EventStatusEnumObj,
  EventStatusEnumValues,
  EventStatusSchema,
  EventType,
  EventTypeObj,
  EventTypeSchema,
  EventTypeValues,
  ExpertiseItemSchema,
  ExportAdminCommentsDtoSchema,
  FEATURE_FLAGS_STORAGE_KEY,
  FITBareContent,
  FITCommonContentFields,
  FITContent,
  FITContentAndTrashContentUnion,
  FITContentByDate,
  FITContentByDateResponseSchema,
  FITContentFindAllResponseSchema,
  FITContentResponseSchema,
  FITContentWithRatingFlagSchema,
  FITContentWithWatchedDate,
  FITDashboardCreateContentSchemaFE,
  FITDashboardCreateContentSchemaFEWithoutValidation,
  FITDashboardUpdateContentSchemaFE,
  FITDateRangeQuerySchema,
  FITTrashContentSchema,
  FITUserContentRatingResponse,
  FITWatchedFilterEnum,
  FITWatchedStatusEnumObj,
  FITWatchedStatusEnumValues,
  FeatureFlagAssignmentSchema,
  FeatureFlagAudienceTypeEnumObject,
  FeatureFlagMapSchema,
  FeatureFlagSchema,
  FeaturedSeriesSettingSchema,
  FeedSpaceItemSchema,
  FindAllByContentIdBeSchema,
  FindAllWatchHistoryBeSchema,
  FindOneUserLogSchemaBe,
  FindOneWatchHistoryBeSchema,
  FindUserLogSchemaBe,
  FindVideoTagsRequestSchema,
  FitChallengeContentTypeEnumObject,
  FitChallengeContentTypeValues,
  FitChallengeMaintainedBySchema,
  FitCommentLikeConditionSchema,
  FitCommentMentionConditionSchema,
  FitContentRefSchemaBE,
  FitInstructorCommentConditionSchema,
  FitOnboardingStepEnumObject,
  FitOnboardingStepSchema,
  FitOnboardingStepValues,
  FitVideoCommentConditionSchema,
  FitWelcomeConditionSchema,
  ForgotPasswordSchema,
  FormAnalyticsSchema,
  FormAnalyticsSubmissionByDateSchema,
  FormAnalyticsUserSchema,
  FormBaseSchema,
  FormQuestionGroupSchema,
  FormStatus,
  FormStatusSchema,
  FormTypeSchema,
  FromToDateORSchema,
  GCS_MEDIA_TYPE_PRESETS,
  GcsAllowedMediaType,
  GcsAllowedMediaTypeSchema,
  GcsUploadReportRowSchema,
  GcsUploadRowSchema,
  GcsUploadStatus,
  GcsUploadStatusSchema,
  GenerateOttSchema,
  GenerateOttUserSchema,
  GenerateSubscriberIdWithTenantSchema,
  GeographyCacheEntryDetailSchema,
  GeographyCacheEntrySchema,
  GeographyCacheStatusSchema,
  GetActivityDatesByMonthBeSchema,
  GetAdminCommentsDtoSchema,
  GetAssignedInstructorsWidthUserIdsBESchema,
  GetBadgesQuerySchema,
  GetCommentsDtoSchema,
  GetContentRatingsSchema,
  GetContentsByCommentsDateRangeSchema,
  GetEventAttendeesSchemaBe,
  GetFavoriteContentBeRequestSchema,
  GetNotificationLogsRequestSchema,
  GetNotificationLogsResponseSchema,
  GetNotificationUsersRequestBESchema,
  GetOrdersSchema,
  GetPlaylistsBeRequestSchema,
  GetPlaylistsRequestSchema,
  GetSinglePlaylistBeRequestSchema,
  GetSinglePlaylistRequestSchema,
  GetSpacePostsQuerySchema,
  GetSubscribedUsersRequestBESchema,
  GetUserBadgesParamsSchema,
  GetUserIdsBESchema,
  GetUsersRequestBESchema,
  GlobalCacheKeyEnum,
  GlobalSearchRequestSchema,
  GlobalSearchResultSchema,
  GlobalSettingBEResponseSchema,
  GlobalSettingsSchema,
  GlobalSettingsTypeEnum,
  GlobalSettingsTypeEnumObj,
  GlobalSettingsTypeEnumValues,
  GlobalSettingsValue,
  GrantUserAccessByAppSchema,
  GrantUserAccessSchema,
  GrantUserGroupAccessByAppSchema,
  GrantUserGroupAccessResultSchema,
  GrantUserGroupAccessSchema,
  HeartbeatResponseSchema,
  HelpCenterAppNameEnumObj,
  HelpCenterAppNameValues,
  HelpCenterArticle,
  HelpCenterArticleCategory,
  HelpCenterArticleCreationPayloadSchema,
  HelpCenterArticleDetails,
  HelpCenterArticleEditHistoryDataSchema,
  HelpCenterArticleEditHistoryListSchema,
  HelpCenterArticleEditHistorySchema,
  HelpCenterArticleSearchResponse,
  HelpCenterArticleTopic,
  HelpCenterArticleTopicWithCategory,
  HelpCenterArticlesFiltersSchema,
  ImportNotificationRulesSchemaBE,
  InactivityRuleConditionJsonSchemaBE,
  IndicateorsEnumValues,
  IndicatorEnum,
  IndicatorsEnumObj,
  InsertContentInPlaylistBeRequestSchema,
  InsertContentInPlaylistRequestSchema,
  Instructor,
  InstructorProfilePictureSchema,
  InstructorRequestSchema,
  InstructorTypeEnum,
  InstructorTypeEnumObj,
  InstructorTypeEnumValues,
  InstructorsByIdsRequestSchema,
  IssueCategorySchema,
  JournalEntryDatesRequestSchema,
  JourneyAlreadyClaimedBonusValues,
  JourneyFiltersSchema,
  JourneyUserActivitiesSchema,
  JourniesUserActivitiesSchema,
  JwtExceptionEnumObj,
  LC_SSO_CONTEXT_QUERY,
  LC_SSO_CONTEXT_VALUE,
  LeaderBoardRequestSchema,
  LeaderBoardSchema,
  LeaderBoardTypeEnum,
  LeaderBoardTypeEnumObj,
  LeaderBoardTypeEnumValues,
  LessonBaseSchema,
  LessonCategoryBaseSchema,
  LessonColorScheme,
  LessonColorSchemeSchema,
  LessonIconScheme,
  LessonIconSchemeSchema,
  LessonProgressBaseSchema,
  LessonProgressStatus,
  LessonProgressStatusSchema,
  LessonRefSchema,
  LessonStatus,
  LessonStatusSchema,
  LessonTemplateType,
  LessonTemplateTypeSchema,
  LikeResponseSchema,
  ListCommunityTagsQuerySchema,
  ListProDirectoryRevisionsQuerySchema,
  ListProQuerySchema,
  ListProQueryWithSearchSchema,
  LoginSchema,
  MANAGEMENT_ROLES,
  MAPPABLE_PROFILE_FIELDS,
  MAX_BULK_RECIPIENT_IDENTIFIERS,
  MagicLinkEmailSchema,
  MagicLinkLoginConditionSchema,
  ManualCompleteContentRequestSchema,
  MarkAsReadSchema,
  MarkNotificationsAsReadSchema,
  MediaCdnUrlsSchema,
  MediaFileBaseSchema,
  MediaFileFiltersSchema,
  MediaFilePageSchema,
  MediaMonthlyStatSchema,
  MediaTypeEnum,
  MediaTypeEnumObj,
  MediaTypeEnumValues,
  MediaUploadLimitSchema,
  MediaUserStatsSchema,
  MembersLoginSchema,
  MentionUserCacheSchema,
  MentionUserSchema,
  MessageBaseSchema,
  MessageType,
  MessageTypeSchema,
  MetaSchema,
  MilestoneBadgeNameArray,
  MilestoneBadgeNameEnumObject,
  MilestoneBadgeSchema,
  MiniProgramCatalogItemSchema,
  ModuleProgressSchema,
  MovePlaylistContentRequestSchema,
  MovePlaylistContentRequestSchemaBE,
  MyFeatureFlagSchema,
  NOTE_ENTITY_TYPE,
  NoteAuthorSchema,
  NoteSchema,
  NotificationChannelEnumObject,
  NotificationChannelValues,
  NotificationFindAllRequestQuerySchema,
  NotificationLogFindAllRequestQuerySchema,
  NotificationLogMetadataSchema,
  NotificationLogResponseSchemaBE,
  NotificationLogSchema,
  NotificationRuleExportItemSchemaBE,
  NotificationRuleExportQuerySchema,
  NotificationRuleExportSchemaBE,
  NotificationRuleImportResultSchemaBE,
  NotificationRuleResponseSchemaBE,
  NotificationRuleSchema,
  NotificationRuleSchemaBE,
  NotificationRuleStatusEnumObject,
  NotificationRulesTypeEnumObject,
  NotificationStatusEnumObject,
  NotificationTemplateSchemaBE,
  NotificationType,
  NotificationTypeEnumObject,
  NotificationTypeSchema,
  NotificationTypeValues,
  NovuEmailTemplateNameEnumObject,
  NovuEmailTemplateNameValues,
  NovuTenantIdentifierEnumObject,
  NovuTenantIdentifierValues,
  NovuWorkflowTemplateSchema,
  NovuWorkflowValues,
  NovuWorkflowsEnumObject,
  OTP_LOGIN_CODE_LENGTH,
  OnboardingSettingSchema,
  OnboardingSettingSchemaBE,
  OnboardingSettingSchemaFE,
  OnboardingStepEnumObject,
  OnboardingStepSchema,
  OnboardingStepValues,
  OnboardingVideoSchema,
  OnlineUserSchema,
  OnlineUsersResponseSchema,
  OrderProductSchema,
  OrderSchema,
  OrdersResponseSchema,
  OtpLoginConditionSchema,
  POLL_MAX_OPTIONS,
  POLL_MIN_OPTIONS,
  POST_SORT,
  POST_SORT_DEFINITIONS,
  POST_TYPE,
  POST_TYPE_DEFINITIONS,
  PasswordChangeConditionSchema,
  PasswordResetConditionSchema,
  PaymentPlanSchema,
  PaymentPlansResponseSchema,
  PermissionBaseSchema,
  PermissionWithUsageSchema,
  Permissions,
  Plan,
  PlanItem,
  PlanItemContent,
  PlanItemReorder,
  PlanItemsRequestSchemaFE,
  PlanResponseSchema,
  PlanTypeEnum,
  PlanTypeObj,
  PlanTypeValues,
  PlansResponseSchema,
  Playlist,
  PlaylistFormSchema,
  PlaylistItem,
  PlaylistItemReorder,
  PlaylistResponseSchema,
  PlaylistSettingsSchema,
  PlaylistStatusEnum,
  PlaylistStatusEnumObj,
  PlaylistStatusEnumValues,
  PlaylistTypeEnum,
  PlaylistTypeObj,
  PlaylistTypeValues,
  PlaylistsResponseSchema,
  PollOptionSchema,
  PollOptionVotersSchema,
  PollSchema,
  PollVotersSchema,
  PostAttachmentSchema,
  PostBaseSchema,
  PostSortSchema,
  PostStatus,
  PostStatusSchema,
  PostTagInputSchema,
  PostTypeDefinitionSchema,
  PostTypeSchema,
  PostWithAuthorSchema,
  PresignedUploadResultSchema,
  ProDirectoryApprovedConditionSchema,
  ProDirectoryListResponseSchema,
  ProDirectoryPaginationSchema,
  ProDirectoryRejectedConditionSchema,
  ProDirectoryRevisionRowSchema,
  ProDirectoryRevisionSchema,
  ProDirectoryRevisionStatusSchema,
  ProDirectoryRevisionWithProSchema,
  ProDirectoryRowSchema,
  ProDirectorySchema,
  ProDirectorySubmissionConfirmedConditionSchema,
  ProDirectorySubmittedConditionSchema,
  ProPublicProfileSchema,
  ProductFiltersSchema,
  ProductSchema,
  ProfessionSchema,
  ProfileFieldKeySchema,
  ProfileFormSchema,
  ProfileMetaSchema,
  ProfilePicture,
  ProfileSchema,
  Program,
  ProgramListResponseSchema,
  ProgramResponseSchema,
  ProgramSectionInput,
  ProgramSectionResponse,
  PromoBannerAnalyticsSchema,
  PromoBannerBaseSchema,
  PromoBannerEntityQuerySchema,
  PromoBannerEntityType,
  PromoBannerEntityTypeLabels,
  PromoBannerEntityTypeSchema,
  PromoBannerForEntitySchema,
  PromoBannerIconScheme,
  PromoBannerIconSchemeSchema,
  PromoBannerPlacementInfoSchema,
  PromoBannerPlacementSchema,
  PromoBannerPosition,
  PromoBannerPositionSchema,
  PromoBannerType,
  PromoBannerTypeLabels,
  PromoBannerTypeSchema,
  PubSubEventsEnum,
  PubSubEventsEnumObj,
  PubSubEventsEnumValues,
  PurchaseRequestSchema,
  PurchaseStatusEnum,
  QuestionInputTypeSchema,
  QuestionType,
  QuestionTypeSchema,
  QuizBaseSchema,
  QuizStatus,
  QuizStatusSchema,
  REACTION_EMOJIS,
  RULE_EXPORT_VERSION,
  RYCContent,
  RYCContentCategoryResponseSchema,
  RYCContentCategorySchema,
  RYCContentMeTypeEnumValues,
  RYCContentMetaInformationBaseSchema,
  RYCContentMetaInfromationSchema,
  RYCContentMetaSeriesEnumObject,
  RYCContentMetaSeriesEnumValues,
  RYCContentMetaTypeEnumObject,
  RYCContentPathEnumObject,
  RYCContentPathValues,
  RYCContentRequestBESchema,
  RYCContentTypeEnumObject,
  RYCContentTypeValues,
  RYCDashboardCreateContentSchemaFE,
  RYCDashboardCreateContentSchemaFEWithoutValidation,
  RYCDashboardUpdateContentSchemaFE,
  RYCJournalRequestBESchema,
  RateContentSchema,
  RatingIndicator,
  ReactToEventMessageSchema,
  ReactionBaseSchema,
  ReactionTargetType,
  ReactionTargetTypeSchema,
  RealTimeNotificationEventTypeValues,
  RealtimeNotificationBePayloadSchemaBE,
  RealtimeNotificationMessageTypeEnumObject,
  RealtimeNotificationMessageTypeValues,
  RecordEventLeaveSchema,
  RefreshTokenSchema,
  RegisterDeviceTokenRequestSchema,
  RejectProDirectoryRevisionSchema,
  RemovePlaylistBeRequestSchema,
  RemovePlaylistRequestSchema,
  ReorderPlaylistRequestSchema,
  ReorderPlaylistRequestSchemaBE,
  RepliesSchema,
  RequestEmailChangeSchema,
  RequestMagicLinkSchema,
  RequestOtpLoginSchema,
  RequestSchema,
  ResetPasswordSchema,
  ResetPasswordSearchParamsSchema,
  ResolveBulkRecipientsResponseSchema,
  ResolveBulkRecipientsSchema,
  ResolvedBulkRecipientSchema,
  RoleBaseSchema,
  RoleValues,
  RoleWithPermissionsSchema,
  RolesEnumObj,
  RuleConditionJsonColumnObject,
  RuleConditionJsonColumnValues,
  RuleConditionJsonSchemaBE,
  RuleConditionTypeSchema,
  RuleEvaluationRequestSchema,
  RuleEvaluationResponseSchema,
  RuleMatchResultSchema,
  RycContentRefSchemaBE,
  SLUG_PATTERN,
  SLUG_PATTERN_MESSAGE,
  SSO_CONTEXT_PARAM,
  SaveFormProgressSchema,
  SearchCategoryItemSchema,
  SearchContentItemSchema,
  SearchInstructorItemSchema,
  SearchProQuerySchema,
  SearchTextItemSchema,
  SelectBonusContentRequestSchema,
  SelectElectiveContentsSchema,
  SendEmailSchema,
  SendEventMessageRequestSchema,
  SendMessageSchema,
  SendPasswordResetSchema,
  SendStepAndDayCompletionSchema,
  SendTransactionalEmailSchema,
  Series,
  SeriesItemsRequestSchemaFE,
  SeriesListResponseSchema,
  SeriesResponseSchema,
  SeriesTypeEnum,
  SeriesTypeObj,
  SeriesTypeValues,
  ServiceResponseDescriminatedUnionSchema,
  ServiceResponseErrorSchema,
  SetPasswordWithTokenSchema,
  SetPasswordWithWpTokenSchema,
  SettingBEResponseSchema,
  SettingsSchema,
  SettingsTypeEnum,
  SettingsTypeEnumObj,
  SettingsTypeEnumValues,
  SingleContentSchedule,
  SinglePlan,
  SingleProgram,
  SingleSeries,
  SingleUserSchema,
  SkipJournalSchemaBE,
  SlackNotificationEventEnum,
  SlackNotificationEventValues,
  SlideBadgeImagePositionEnumObj,
  SlideBadgeImagePositionValues,
  SlideBadgeSchema,
  SlideshowAppEnumObj,
  SlideshowAppValues,
  SlideshowFiltersSchema,
  SlideshowTypeEnumObj,
  SlideshowTypeValues,
  SlugSchema,
  SocketEventTypeEnum,
  SocketEventTypeEnumObj,
  SocketEventTypeEnumValues,
  SourceAllowedActions,
  SpaceBaseSchema,
  SpaceRefSchema,
  SpaceReportingConfigSchema,
  SpaceReportingGroupTreatmentSchema,
  SpaceStatus,
  SpaceStatusSchema,
  SpaceType,
  SpaceTypeSchema,
  SpacesContentRefSchemaBE,
  SpacesEventTargetKind,
  SpacesTargetKindEvents,
  Stages,
  StagesEnumObject,
  StartGcsUploadResultSchema,
  StartGcsUploadSchema,
  StateSchema,
  StatusEnum,
  StatusEnumObj,
  StatusEnumValues,
  StepType,
  StepTypeEnumObject,
  Steps,
  StepsEnumObject,
  StorageAnalyticsFiltersSchema,
  StorageAnalyticsResponseSchema,
  StorageAnalyticsSummarySchema,
  StorageAnalyticsUserRowSchema,
  StringToBooleanSchema,
  SubmissionStatus,
  SubmissionStatusSchema,
  SubmitAnswerSchema,
  SubmitFormAnswerSchema,
  SubmitFormSchema,
  SubmitQuizAttemptSchema,
  SubscribedUserResponseSchema,
  SubscribedUserSchema,
  Subscription,
  SubscriptionAddon,
  SubscriptionObjectSchema,
  SubscriptionsResponseSchema,
  SupabaseJwtPayloadSchema,
  SupabaseLoginSchema,
  SupabaseMentionableProfileRowSchema,
  SupabaseMentionableProfileSchema,
  SupabaseProfileSchema,
  SupabaseRowProfileSchema,
  SupportNewTicketConditionSchema,
  SupportPermissionKeyEnum,
  SupportPermissionKeyValues,
  SupportRoleSchema,
  SupportSettingsSchema,
  SupportStaffMemberSchema,
  SupportTicketReplyConditionSchema,
  TagRefSchema,
  TargetAppEnum,
  TeachingFormatSchema,
  TemplateResponseSchema,
  TemplateVariables,
  TermsAcceptanceResponseSchema,
  TermsBaseSchema,
  TicketCommentSchema,
  TicketEventSchema,
  TicketEventTypeEnum,
  TicketEventTypeValues,
  TicketFiltersSchema,
  TicketSchema,
  TicketStatusEnum,
  TicketStatusValues,
  TierValues,
  TiersEnumObject,
  TimePeriodEnum,
  TimePeriodEnumObj,
  TimePeriodEnumValues,
  TodaysWorkoutSchemaFE,
  ToggleProgramPublishSchema,
  TogglePromoBannerSchema,
  ToggleReactionSchema,
  ToggleRejectDtoSchema,
  TopContributorSchema,
  TopContributorsResponseSchema,
  TranscodeJobSchema,
  TranscodeResultEventSchema,
  TranscodeResultSchema,
  TrashContentSchema,
  TrashContentVimeoVideo,
  TrendingTagSchema,
  TrendingTagsResponseSchema,
  USERNAME_REGEX,
  USER_ONLINE_REDIS_CHANNEL,
  UnsignedIDSchema,
  UpcomingLiveBannerSettingSchema,
  UpcomingLiveBannerSettingSchemaBE,
  UpcomingLiveBannerSettingSchemaFE,
  UpdateAddonProgramRequestSchemaFE,
  UpdateAnalyticsRuleSchemaBE,
  UpdateCODThemeSchemaBE,
  UpdateCommentDtoSchema,
  UpdateCommentSchema,
  UpdateCommunityTagSchema,
  UpdateContentBlockSchema,
  UpdateContentScheduleSettingsFE,
  UpdateContentScheduleSettingsSchemaBE,
  UpdateContentSchemaBE,
  UpdateContentSchemaFE,
  UpdateEquipmentRequest,
  UpdateEventSchemaBE,
  UpdateEventSchemaFE,
  UpdateFeatureFlagRequestSchema,
  UpdateFitOnboardingStepSchemaBE,
  UpdateFormOptionSchema,
  UpdateFormQuestionGroupSchema,
  UpdateFormQuestionSchema,
  UpdateFormSchema,
  UpdateHelpCenterArticleSchemaBE,
  UpdateHelpCenterCategoryTaxonomySchemaBE,
  UpdateHelpCenterTopicTaxonomySchemaBE,
  UpdateInstructionSchema,
  UpdateIssueCategorySchema,
  UpdateLessonCategorySchema,
  UpdateLessonSchema,
  UpdateMediaFileSchema,
  UpdateMediaUploadLimitSchema,
  UpdateMessageSchema,
  UpdateNoteSchema,
  UpdateNotificationPreferencesSchema,
  UpdateNotificationRuleSchemaBE,
  UpdateOnboardingStepVideoWatchedSchemaBE,
  UpdateOptionSchema,
  UpdatePermissionSchema,
  UpdatePlanRequestSchemaFE,
  UpdatePlaylistBeRequestSchema,
  UpdatePlaylistRequestSchema,
  UpdatePlaylistSchema,
  UpdatePostSchema,
  UpdateProDirectorySchema,
  UpdateProfileSchema,
  UpdateProgressSchema,
  UpdatePromoBannerSchema,
  UpdateQuestionSchema,
  UpdateQuizSchema,
  UpdateRYCContentRequestWithMetaSchema,
  UpdateRYCContentSchemaBE,
  UpdateRYCContentWithMetaSchemaBE,
  UpdateReportStatusSchema,
  UpdateRoleSchema,
  UpdateSeriesRequestSchemaFE,
  UpdateSlideshowSchemaFE,
  UpdateSpaceSchema,
  UpdateStepContentSchemaBE,
  UpdateStepContentSchemaFE,
  UpdateStepContentsSchemaBE,
  UpdateStepDaySchemaBE,
  UpdateStepSchemaBE,
  UpdateStepSchemaFE,
  UpdateSupportSettingsSchema,
  UpdateTermsSchema,
  UpdateTicketStatusSchema,
  UpdateTimezoneSchema,
  UpdateUserGroupSchema,
  UpdateUserPrivacyBESchema,
  UpdateUserSchema,
  UpdateWatchHistoryBeSchema,
  UpdateZoomEventSchema,
  UploadedFileSchema,
  UserAccessItemSchema,
  UserAccessMapSchema,
  UserAccessPermissionSchema,
  UserActivitiesTypeEnum,
  UserActivitiesTypeObj,
  UserActivitiesTypeValues,
  UserActivityItemSchema,
  UserActivityQuerySchema,
  UserActivitySchema,
  UserActivityTypeEnumObject,
  UserActivityTypeValues,
  UserCheckInSchemaBe,
  UserContentRatingResponse,
  UserDataSchema,
  UserDayChangeSchemaBe,
  UserGroupBaseSchema,
  UserGroupGrantJobSchema,
  UserGroupGrantJobStatusSchema,
  UserGroupGrantPreviewAppSchema,
  UserGroupGrantPreviewSchema,
  UserGroupGrantResultItemSchema,
  UserGroupGrantResultStatusSchema,
  UserGroupImportJobSchema,
  UserGroupImportJobStatusSchema,
  UserGroupImportModeSchema,
  UserGroupImportPreviewSchema,
  UserGroupImportRequestSchema,
  UserGroupImportSourceSchema,
  UserGroupMemberBaseSchema,
  UserGroupSourceConfigSchema,
  UserGroupStatus,
  UserGroupStatusSchema,
  UserJwtSchema,
  UserLastCheckInSchemaBe,
  UserLogActionEnumObj,
  UserLogActionValues,
  UserLogBaseSchema,
  UserLogBaseSchemaWithFullContent,
  UserLogFilterDtoBe,
  UserManageItemTypeEnum,
  UserManageItemTypeObj,
  UserManageItemTypeValues,
  UserMetaSchema,
  UserOnlineLastWatchedContentSchema,
  UserOnlineNamespace,
  UserOnlinePubSubSchema,
  UserOnlinePubSubSchemaStringifiedSchema,
  UserOnlinePubSubValues,
  UserOnlineTopicEnumObject,
  UserOnlineTopicValues,
  UserPrivacyRedisSchemaBE,
  UserPrivacySchemaBE,
  UserResponseSchema,
  UserSchema,
  UserSourceEnum,
  UserTotalWatchedByCategory,
  UserWatchHistoryDates,
  UserWatchedAContentSchema,
  UsernameSchema,
  ValidateOttSchema,
  VerifyOtpLoginSchema,
  VersionInfoSchema,
  VideoWatchCountsSchema,
  VimeoSearchResultItemSchema,
  VimeoSearchResultsSchema,
  VimeoVideo,
  VimeoVideoDurationsSchema,
  VimeoVideoInfoSchema,
  VimeoVideoInput,
  VotePollSchema,
  WPSubscriptionArraySchema,
  WatchHistoryBaseSchema,
  WatchedFilterEnum,
  WatchedStatusEnumObj,
  WatchedStatusEnumValues,
  WelcomeNotificationPayloadSchemaBE,
  WpLoginSchema,
  WpProductDetailResponseSchema,
  WpProductSchema,
  WpProductSearchResponseSchema,
  WsUrl,
  YouMayLikeRequestFilterSchema,
  ZoomSignatureResponseSchema,
  allowedTargetKindsForEvent,
  analyticsCatalogKey,
  analyticsContentKey,
  contentFilterDefaultValues,
  contentFilterEmptyDefaultValues,
  defaultAddonContentSchemaValues,
  defaultBadgeMetaValuesBE,
  defaultClassOfTheDayThemeSchemaValues,
  defaultContactFormSettingValues,
  defaultContentSchemaValues,
  defaultEventSchemaValues,
  defaultFeatureSeriesContentValues,
  defaultFitChallengeValues,
  defaultHelpCenterSchemaValues,
  defaultOnboardingSettingValues,
  defaultPlanSchemaValues,
  defaultProgramSchemaValues,
  defaultRYCContentSchemaValues,
  defaultSeriesSchemaValues,
  defaultSettingsValues,
  defaultSlideshowSchemaValues,
  defaultUpcomingLiveBannerSettingValues,
  eventsForBlockType,
  eventsForTargetKinds,
  findRejectedAttachment,
  flattenContentTree,
  getAcceptButtonLabel,
  getAcceptCheckboxLabel,
  getAddonProgramViewPermission,
  getDropdownOptions,
  getMappableProfileFieldsForQuestionType,
  getPermissionIdSetFromAccessMap,
  getProfileFieldByKey,
  getQuestionAnswerShape,
  getQuestionInputType,
  hasFeatureFlag,
  hasPermissionForApp,
  hasPermissionInAccessMap,
  instructionSchema,
  isActionAllowedForSource,
  isContentManagerForApp,
  isGcsFileAllowed,
  isPdfAttachment,
  isQuestionTypeMappableToFieldKind,
  isQuestionTypeMappableToProfileFieldKey,
  isShortAnswerValueValid,
  parseAllowedMediaTypes,
  parseGcsFilenamePrefix,
  passesPermissionRestriction,
  resolveProcessingKind,
  rycContentFilterDefaultValues,
  rycContentFilterEmptyDefaultValues,
  rycJournalFilterDefaultValues,
  sanitizeAppName,
  spacesTargetKindForEvent,
  stringifyUserOnlinePubSubSchema,
  timezoneSchema,
  transformSubscriptionArrayToObject,
  validateComment,
  validateCommentsResponse,
  validateCreateComment,
  validateGetComments,
  validateGetContentsByCommentsDateRange,
  validateLikeResponse,
  validateRuleChannels,
  validateRuleConditions,
  validateUpdateComment
};
//# sourceMappingURL=index.mjs.map